
// File: ..\core\js\ab-native_website_rel.js
const abWeb_BuildType = 'rel';

const abNative_Base = '/';
const abNative_Platform = 'web';

const abNative_ApiUri = 'https://agpokrycia.pl/api/v1/';

// File: ..\dev\node_modules\js-libs-web\js\js-libs.js
const jsLibs = (() => {
class jsLibs_Class {
    #pkgs                            


    constructor() {
        this.#pkgs = {};
    }

    exportScript(pkgName        , scriptPath        , exportDefines               ,
            scriptInitFn              ) {
        if (!(pkgName in this.#pkgs))
            this.#pkgs[pkgName] = new Package(pkgName);

        this.#pkgs[pkgName].addScript(scriptPath, exportDefines, scriptInitFn);
    }

    import(pkgName        , importName         = "default", importAlias              = null,
            importPath              = null, sourceScript              = null)                 {
        let pkg = this.#pkgs[pkgName];
        if (pkg === undefined)
            throw new Error(`Package '${pkgName}'` + 
                    (importPath === null ? "" : `(${importPath})`) + 
                    ` does not exist.`);

        return pkg.importScript("./index", importName, importAlias, importPath);
    }

    importScript(pkgName        , scriptPath        , importName        , 
            importAlias              = null, importPath              = null, 
            sourceScript              = null)                 {
        let pkg = this.#pkgs[pkgName];
        if (pkg === undefined) {
            throw new Error(`Package '${pkgName}'` + 
                    (importPath === null ? "" : `(${importPath})`) + 
                    ` does not exist.`);
        }

        return pkg.importScript(scriptPath, importName, importAlias, importPath,
                sourceScript);
    }

    validateScript(pkgName        , scriptPath        , importName        , 
            importAlias              = null, importPath              = null)       {
        let pkg = this.#pkgs[pkgName];
        if (pkg === undefined) {
            throw new Error(`Package '${pkgName}'` + 
                    (importPath === null ? "" : `(${importPath})`) + 
                    ` does not exist.`);
        }

        pkg.validateScript(scriptPath, importName, importAlias, importPath);
    }
}
const jsLibs = new jsLibs_Class();


class Package {
    #scripts                           ;
    #name        ;


    get name()         { 
        return this.#name;
    }


    constructor(pkgName        ) {
        this.#name = pkgName;

        this.#scripts = {};
    }

    addScript(scriptPath        , exportDefines               ,
            scriptInitFn              ) {
        this.#scripts[scriptPath] = new Script(this, scriptPath, exportDefines,
                scriptInitFn);
    }

    importScript(scriptPath        , importName        , importAlias              = null,
            importPath              = null, sourceScript              = null)                 {
        let script = this.#scripts[scriptPath];
        if (script !== undefined) {
            if (importName === "*")
                return script.getInstance();

            return script.importName(importName, importAlias, importPath, 
                    sourceScript);
        }

        throw new Error(`Script '${scriptPath}' in package '${this.#name}'` + 
                ` does not exist.`);
    }

    validateScript(scriptPath        , importName        , importAlias              = null,
            importPath              = null)       {
        let script = this.#scripts[scriptPath];
        if (script !== undefined) {
            if (importName === "*")
                return;

            script.validateImportName(importName, importAlias);
            return;
        }

        throw new Error(`Script '${scriptPath}' in package '${this.#name}'` + 
                ` does not exist.`);
    }
}


class Script {
    #exportDefines               ;
    #initFn              ;
    #initialized         ;
    #instance                     ;
    #instanceExports                             ;
    #scriptJSLib             ;
    #scriptPath        ;
    #pkg         ;


    get initialized()          {
        return this.#initialized;
    }

    get scriptJSLib()              {
        return this.#scriptJSLib;
    }

    get pkg()          {
        return this.#pkg;
    }

    get scriptPath()         {
        return this.#scriptPath;
    }

    constructor(pkg         , scriptPath        , exportDefines               ,
            initFn              ) {
        this.#pkg = pkg;
        this.#scriptPath = scriptPath;
        this.#exportDefines = exportDefines;
        this.#initFn = initFn;

        this.#scriptJSLib = new ScriptJSLib(this);
        this.#instance = null;
        this.#instanceExports = {};
        this.#initialized = false;

        for (let exportDefine of this.#exportDefines)
            this.#instanceExports[exportDefine] = exportNotInitialized;
    }

    getInstance()                 {
        if (this.#instance === null) {
            let instance = {};

            for (let exportDefine of this.#exportDefines) {
                Object.defineProperty(instance, exportDefine, {
                    get: () => {
                        if (this.#instanceExports[exportDefine] === exportNotInitialized) {
                            throw new Error(`'${exportDefine}' in package` + 
                                    ` '${this.#pkg.name}' not initialized.`);
                        }

                        return this.#instanceExports[exportDefine];
                    },
                    enumerable: true,
                });
            }

            this.#instance = instance;

            this.#initFn(this.#scriptJSLib);
        }

        return this.#instance;
    }

    importName(importName        , importAlias              = null, 
            importPath              = null, sourceScript              = null) {
        let _ = this.getInstance();

        let value = this.#instanceExports[importName];
        if (value === exportNotInitialized) {
            let errorMessage = importAlias === null ? 
                    `'${importName}'` : `'${importAlias} (${importName})'`;
            errorMessage += ` in package '${this.#pkg.name}' not initialized.`
            if (importPath !== null && sourceScript === null)
                errorMessage += ` Importing '${importPath}'.`;
            else if (sourceScript !== null) {
                errorMessage += ` Importing`
                if (importPath !== null)
                    errorMessage += ` '${importPath}'`;
                errorMessage += ` from: '${sourceScript?.pkg.name}:${sourceScript?.scriptPath}'`;
            }

            throw new Error(errorMessage);
        }

        return this.#instanceExports[importName];
    }

    validateImportName(importName        , importAlias              = null,
            sourceScript              = null)       {
        if (!(importName in this.#instanceExports)) {
            let errorMessage = `The requested module '${this.#scriptPath}'` +
                        ` does not provide export name`;
            errorMessage += importAlias === null ?
                    ` '${importName}'` : ` '${importAlias} (${importName})'`;
            errorMessage += ` in lib '${this.#pkg.name}'.`;

            throw new Error(errorMessage);
        }
    }

    setExport(exportName        , value     ) {
        this.#instanceExports[exportName] = value;
    }
}


class ScriptJSLib {
    #script        ;

    constructor(script        ) {
        this.#script = script;
    }

    export(exportName        , value     ) {
        this.#script.setExport(exportName, value);
    }

    import(pkgName        , scriptPath        , importName        , 
            importAlias              = null, importPath        ) {
        return jsLibs.importScript(pkgName, scriptPath, importName, importAlias, 
                importPath, this.#script);
    }

    importDeclaration(pkgName        , scriptPath        , 
            importedDefines                     , importPath        ) {
        for (let importedDefine of importedDefines) {
            jsLibs.validateScript(pkgName, scriptPath, importedDefine.name, 
                    importedDefine.alias, importPath);
        }
    }
}

;                    
                 
                  
  
;                                                  
;                                                

const exportNotInitialized = Symbol("jsLibs_ExportNotInitialized");return jsLibs;})();

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-cookies\index.js
jsLibs.exportScript("ab-cookies", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class abCookies_Class {
    delete(name) {

    }

    exists(name) {
        return this.getString(name) !== null;
    }

    get(name, defaultValue = undefined) {   
        let cookieStr = this.getString(name);
        if (cookieStr === null) {
            if (typeof defaultValue !== undefined)
                return defaultValue;

            throw new Error(`Cookie '${name}' does not exist.`)
        }
        try {
            let cookieJSON = JSON.parse(decodeURIComponent(cookieStr));

            return cookieJSON.value;
        } catch (err) {
            console.error(err);
            throw new Error('AB Cookie not properly formatted.');
        }
    }

    getString(name) {
        var cookieName = name + "=";
        var cookieStrsArr = document.cookie.split(';');
        console.log(cookieStrsArr);
        for (let cookieStr of cookieStrsArr) {
            while (cookieStr.charAt(0) === ' ')
                cookieStr = cookieStr.substring(1);
            if (cookieStr.indexOf(name) !== 0)
                continue;

            return cookieStr.substring(name.length + 1, cookieStr.length);
        }

        return null;
    }

    set(name, value, settings = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', null, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(settings, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            expires: [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
            domain: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
            path: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('/'), ],
        }));

        let cookieStr = '';
        /* Value */
        cookieStr += name + '=' + encodeURIComponent(JSON.stringify({ value: value })) + '; ';
        /* Path */
        cookieStr += `path=` + settings.path + '; ';
        /* Expires */
        if (settings.expires !== null) {
            let expiresTime = Math.round((new Date()).getTime() / 1000) + settings.expires;
            cookieStr += 'expires=' + (new Date(expiresTime * 1000)).toUTCString() + '; ';
        }

        /* Domain */
        if (settings.domain !== null) {
            cookieStr += 'domain=' + settings.domain + '; ';
        }

        document.cookie = cookieStr;
    }
}
const abCookies = new abCookies_Class();
/* export default */ abCookies;


/* JSLib Exports */
_jsLib.export("default", abCookies); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-strings\index.js
jsLibs.exportScript("ab-strings", "./index", [ "abStrings_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export */ class abStrings_Class {

    escapeFromUnallowedChars(string, unallowedCharacters) {
        let regexp = new RegExp(`[${unallowedCharacters}]`, 'g');

        return string.replace(regexp, '');
    }

    escapeHtml(html) {
        return html
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    escapeLangChars(string) {
        let replaceFrom = [ 'ą', 'ć', 'ę', 'ł', 'ń', 'ó', 'ś', 'ź', 'ż',
                'Ą', 'Ć', 'Ę', 'Ł', 'Ń', 'Ó', 'Ś', 'Ź', 'Ż' ];
        let replaceTo = [ 'a', 'c', 'e', 'l', 'n', 'o', 's', 'z', 'z',
                'A', 'C', 'E', 'L', 'N', 'O', 'S', 'Z', 'Z' ];
    
        let regexp = new RegExp(replaceFrom.join('|'), 'g');
    
        return string.replace(regexp, (match) => {
            return replaceTo[replaceFrom.indexOf(match)];
        });
    }
    
    escapeToAllowedChars(string, allowedCharacters) {
        let regexp = new RegExp(`[^${allowedCharacters}]`, 'g');

        return string.replace(regexp, '');
    }

    escapeRegExpChars(string) {
        return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    getCharsRegExp(types = [], extra = '', langs = null) {
        for (let type of types) {
            if (!types.includes(type))
                throw new Error(`Unknown chars type '${type}'.`);
        }

        let chars = '';

        if (types.includes('digits'))
            chars += '0-9';
        if (types.includes('letters'))
            chars += 'a-zA-Z' + this.getLangsSpecialCharacters();
        if (types.includes('special')) {
            chars += ' `!@#%&_=/<>:;",\'' +
                '\\\\' + '\\^' + '\\$' + '\\.' + '\\[' + '\\]' + '\\|' +
                '\\(' + '\\)' + '\\?' + '\\*' + '\\+' + '\\{' + '\\}' +
                '\\-';
        }

        return chars + this.escapeRegExpChars(extra);
    }

    getCharsRegExp_Basic(extra = '') {
        return this.getCharsRegExp([ 'digits', 'letters', 'special' ], extra);
    }

    getLangsSpecialCharacters(langs = null) {
        if (langs === null)
            langs = [ 'pl' ];

        let chars = '';
        if (langs.includes('pl'))
            chars += 'ąćęłńóśźż' + 'ĄĆĘŁŃÓŚŹŻ';

        return chars;
    }

    pad(str, pad, size) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int);

        str = str + ``;
        while (str.length < size) 
            str = pad + str;
        return str.substr(0, size);
    }
    
    removeDoubles(string, char) {
        let regexp = new RegExp(`${char}${char}`, 'g');
        while (string.match(regexp))
            string = string.replace(regexp, char);

        return string;
    }

}
const abStrings = new abStrings_Class();
/* export default */ abStrings;

/* JSLib Exports */
_jsLib.export("abStrings_Class", abStrings_Class);
_jsLib.export("default", abStrings); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text\index.js
jsLibs.exportScript("ab-text", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class abText_Class {
    constructor() {
        this._texts = {};
        this._langAlias = null;
    }

    $(text, args = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (this._langAlias === null) {
            console.warn('Lang alias not set.', new Error());
            return this.get(this._langAlias, text, args);
        }

        return this.get(this._langAlias, text, args);
    }

    add(langPrefix, texts) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        let langPrefix_Arr = langPrefix.split('.');
        let langAlias = langPrefix_Arr[0];
        let textPrefix_Arr = langPrefix_Arr.slice(1);
        let textPrefix = textPrefix_Arr.join('.');
        if (textPrefix !== '') {
            textPrefix += '.';
        }

        if (!(langAlias in this._texts)) {
            this._texts[langAlias] = {};
        }

        for (let text in texts) {
            this._texts[langAlias][textPrefix + text] = texts[text];
        }

        return this;
    }

    get(langAlias, text, args = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 'string' ], 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let translation = null;

        if (langAlias in this._texts) {
            if (text in this._texts[langAlias])
                translation = this._texts[langAlias][text];
        }

        if (translation === null) {
            if (args === null) {
                return `#${text}#`;
            } else if (Object.keys(args).length === 0) {
                return `#${text}#`;
            } else {
                let args_Arr = [];
                for (let argName in args) {
                    args_Arr.push(`${argName} => ${args[argName]}`);
                }
                return '#' + text + '(' + args_Arr.join(', ') + ')';
            }
        }

        for (let argName in args) {
            translation = translation.replace(new RegExp(`{${argName}}`, 'gm'), 
                    args[argName]);
        }

        return translation;
    }

    setLang(langAlias) {
        this._langAlias = langAlias;
    }

}
const abText = new abText_Class();
/* export default */ abText;

/* JSLib Exports */
_jsLib.export("default", abText); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\Array.js
jsLibs.exportScript("js0", "./Array", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "./index");

/* export default */ class js0_Array {
    get itemType() {
        
    }

    get length() {
        return this._array.length;
    }

    constructor(itemType = null) {
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "./index")).ArgType, (_jsLib.import("js0", "./index", "default", "js0", "./index")).Default ]);
        Object.defineProperties(this, {
            itemType: { value: itemType },
            _array: { value: [] }
        });
    }

    get(index) {
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).args(arguments, 'int');
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).rtn(this.itemType, () => {
        return this._array[index];
    })}

    pop() {
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).args(arguments);
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).rtn(this.itemType, () => {
        return this._array.pop();
    })}

    push(item) {
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).args(arguments, this.itemType);

        this._array.push(item);
    }
}

/* JSLib Exports */
_jsLib.export("default", js0_Array); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\AsyncCallable.js
jsLibs.exportScript("js0", "./AsyncCallable", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "./index.js");

/* export default */ class AsyncCallable {
    constructor(...args) { return (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).fn(arguments,
        
    '', () => {
        throw new Error('Not implemented yet.');
        // base it on Callable

        this._fn = null;
        this._argTypes = null;
        this._rtnType = null;
        
        this._rtnType = args.length > 0 ? args[args.length - 1] : 'undefined';
        if (rtnType === '' || rtnType === 'void')
            this._rtnType = 'undefined';

        if (args.length > 1) {
            this._argTypes = [ args[0] ];
            for (let i = 1; i < args.length - 1; i++)
                fnArgs.push(args[i]);

            (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).args.apply(this, fnArgs);
        }
        
        return (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).rtn(rtnType, rtnFn());
    })}

    call(...args) { return (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).fn(arguments,
    null, () => {
        let callArgs = [ args ];
        for (let i = 0; i < this._argTypes.length; i++) 
            callArgs.push(this._argTypes[i]);
        (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).args.apply(this, callArgs);

        return (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).rtn(this._rtnType, this._fn.apply(null, args));
    })}

    set(fn) { return (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).fn(arguments,
    'function',
    '', () => {
        this._fn = fn;  
    })}
}

/* JSLib Exports */
_jsLib.export("default", AsyncCallable); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\Callable.js
jsLibs.exportScript("js0", "./Callable", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "./index");

/* export default */ class Callable {
    constructor(...args) { return (_jsLib.import("js0", "./index", "default", "js0", "./index")).fn(arguments,
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).ExtraArgs,
    '', () => {
        this._fn = null;
        this._argTypes = null;
        this._rtnType = null;
        
        this._rtnType = args.length > 0 ? args[args.length - 1] : 'undefined';
        if (this._rtnType === '' || this._rtnType === 'void')
            this._rtnType = 'undefined';

        this._argTypes = [];
        for (let i = 0; i < args.length - 1; i++)
            this._argTypes.push(args[i]);
    })}

    call(...args) { return (_jsLib.import("js0", "./index", "default", "js0", "./index")).fn(arguments,
    (_jsLib.import("js0", "./index", "default", "js0", "./index")).ExtraArgs,
    null, () => {
        let callArgs = [ args ];
        for (let i = 0; i < this._argTypes.length; i++) 
            callArgs.push(this._argTypes[i]);
        (_jsLib.import("js0", "./index", "default", "js0", "./index")).args.apply((_jsLib.import("js0", "./index", "default", "js0", "./index")), callArgs);

        return (_jsLib.import("js0", "./index", "default", "js0", "./index")).rtn(this._rtnType, this._fn.apply(null, args));
    })}

    set(fn) { return (_jsLib.import("js0", "./index", "default", "js0", "./index")).fn(arguments,
    'function',
    Callable, () => {
        this._fn = fn;  
        return this;
    })}
}

/* JSLib Exports */
_jsLib.export("default", Callable); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\Delay.js
jsLibs.exportScript("js0", "./Delay", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "./index");

/* export default */ class Delay {
    constructor() {
        this._delays = [];
    }

    delay(identification, alias, fn, time) {
        (_jsLib.import("js0", "./index", "default", "js0", "./index")).args(arguments, null, 'string', 'function');

        let delay = this._getDelay(identification, alias);
        if (delay === null) {
            delay = {
                identificator: identificator,
                alias: alias,
                timeout: null,
            };
        } else
            clearTimeout(delay.timeout);

        delay.timeout = setTimeout(() => {
            fn();
            this._removeDelay(identificator, alias);
        }, time);
    }


    _getDelay(identificator, alias) {
        for (let delay of this._delays) {
            if (delay.identificator !== identificator)
                continue;
            if (delay.alias !== alias)
                continue;

            return delay;
        }

        return null;
    }

    _removeDelay(identificator, alias) {
        for (let i = 0; i < this._delays.length; i++) {
            let delay = this._delays[i];
            if (delay.identificator !== identificator)
                continue;
            if (delay.alias !== alias)
                continue;

            this._delays.splice(i, 1);
            return;
        }
    }

}

/* JSLib Exports */
_jsLib.export("default", Delay); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\index.js
jsLibs.exportScript("js0", "./index", [ "js0_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./Array", [ { name: "default", alias: "TS0Array" } ], "./Array");
_jsLib.importDeclaration("js0", "./AsyncCallable", [ { name: "default", alias: "AsyncCallable" } ], "./AsyncCallable");
_jsLib.importDeclaration("js0", "./Callable", [ { name: "default", alias: "Callable" } ], "./Callable");
_jsLib.importDeclaration("js0", "./List", [ { name: "default", alias: "TS0List" } ], "./List");
_jsLib.importDeclaration("js0", "./TimeSpan", [ { name: "default", alias: "TimeSpan" } ], "./TimeSpan");

/* export */ class js0_Class {
    get Array() {
        return (_jsLib.import("js0", "./Array", "default", "TS0Array", "./Array"));
    }

    get AsyncCallable() {
        return (_jsLib.import("js0", "./AsyncCallable", "default", "AsyncCallable", "./AsyncCallable")).js;
    }

    get Callable() {
        return (_jsLib.import("js0", "./Callable", "default", "Callable", "./Callable")).js;
    }

    get List() {
        return (_jsLib.import("js0", "./List", "default", "TS0List", "./List"));
    }

    get TimeSpan() {
        return (_jsLib.import("js0", "./TimeSpan", "default", "TimeSpan", "./TimeSpan"));
    }

    constructor() {
        this._proxyHandler = {
            get(target, prop, receiver) {
                if (!(prop in target))
                    throw new Error(`Property '${prop}' does not exist in object of class '${target.constructor.name}'.`)

                return target[prop];
            }
        }
    }

    TArray(itemType) {
        return this.Array_Type(itemType);
    }

    get TArgType() {
        // Not implemented yet.
        return null;
    }

    get TArrayItems() {
        return this.ArrayItems_Type;
    }

    get TNull() {
        return this.Null;
    }

    get TPreset() {
        return this.Preset_Type;
    }

    get TRawObject() {
        return this.RawObject;
    }

    Create(classObject) {
        js0.args(arguments, 'object');

        return new Proxy(classObject, this._proxyHandler);
    }

    args(args, ...types) {
        if (types[types.length - 1] === this.ExtraArgs) 
            types.pop();
        else {
            if (args.length > types.length) {
                console.warn(new Error());
                throw new Error('Too many arguments in function.');
            }
        }

        for (let i = 0; i < types.length; i++) {
            try {
                let errors = [];
                if (!this.type(args[i], types[i], errors, true)) {
                    console.error(`Error: Argument ${i} -> `, errors);
                    console.warn(new Error());
                    throw new this.TypeError('Wrong argument type.');
                }
            } catch (e) {
                throw new Error(`Error thrown for argument ${i} -> ` + 
                        e.message);
            }
        }
    }

    argsC(args, ...types) {
        for (let i = 0; i < types.length; i++) {
            if (!this.type(args[i], types[i]))
                return false;
        }

        return true;
    }

    assert(value, message = '') {
        if (!value) {
            console.warn(new Error());
            throw new this.AssertionError(message);
        }
    }

    copyArray(arr) {
        this.args(arguments, Array);

        // let valueTypes = [
        //     'undefined',
        //     'boolean',
        //     'number',
        //     'string',
        // ];

        let arr_New = new Array();
        for (let val of arr) {
            // if (this.type(val, valueTypes)) {
            //     arr_New.push(val);
            //     continue;
            // }

            if (this.type(val, js0.Null)) {
                arr.push(null);
                continue;
            }

            if (this.type(val, this.RawObject)) {
                arr_New.push(this.copyRawObject(val));
                continue;
            }

            if (this.type(val, Array)) {
                arr_New.push(this.copyArray(val));
                continue;
            }

            arr_New.push(val);
        }

        return arr_New;
    }

    copyRawObject(obj) {
        this.args(arguments, js0.RawObject);

        // let valueTypes = [
        //     'undefined',
        //     'boolean',
        //     'number',
        //     'string',
        // ];

        let obj_New = {};
        for (let prop in obj) {
            // if (this.type(obj[prop], valueTypes)) {
            //     obj_New[prop] = obj;
            //     continue;
            // }
            if (this.type(obj[prop], js0.Null)) {
                obj_New[prop] = null;
                continue;
            }

            if (this.type(obj[prop], 'symbol')) {
                obj_New[prop] = obj[prop];
                continue;
            }

            if (this.type(obj[prop], js0.RawObject)) {
                obj_New[prop] = this.copyRawObject(obj[prop]);
                continue;
            }

            if (this.type(obj[prop], Array)) {
                obj_New[prop] = this.copyArray(obj[prop]);
                continue;
            }

            obj_New[prop] = obj[prop];
        }

        return obj_New;
    }

    def(object, propertyInfos) {
        js0.args(arguments, 'object', js0.ObjectItems(
            js0.ArrayItems([ null, null ]),
        ));

        for (let propertyName in propertyInfos) {
            let propertyInfo = propertyInfos[propertyName];

            let propertyType = propertyInfo[0];
            let propertyValue = propertyInfo[1];

            this.typeE(propertyValue, propertyType);
            
            Object.defineProperty(object, propertyName, {
                get() {
                    return propertyValue;
                },
                set(value) {
                    js0.typeE(value, propertyType);
                    propertyValue = value;
                },
            });
        }
    }

    // implement(mainObject, propClass, ...propArgs)
    // {
    //     this.prop(mainObject, propClass, ...propArgs);
    // }

    // implements(object, propClass)
    // {
    //     return this.type(object, this.Prop(propClass));
    // }

    fn(...args) {
        if (args.length === 0)
            throw new Error(`'js0.fn' requires at least return function argument.`);

        let rtnFn = args[args.length - 1];
        js0.typeE(rtnFn, 'function');
        
        let rtnType = args.length > 1 ? args[args.length - 2] : 'undefined';
        if (rtnType === '' || rtnType === 'void')
            rtnType = 'undefined';

        if (args.length > 2) {
            let fnArgs = [ args[0] ];
            for (let i = 1; i < args.length - 2; i++)
                fnArgs.push(args[i]);

            js0.args.apply(this, fnArgs);
        }
        
        return js0.rtn(rtnType, rtnFn());
    }

    async fnAsync(...args) {
        if (args.length === 0)
            throw new Error(`'js0.fn' requires at least return function argument.`);

        let rtnFn = args[args.length - 1];
        js0.typeE(rtnFn, 'function');
        
        let rtnType = args.length > 1 ? args[args.length - 2] : 'undefined';
        if (rtnType === '' || rtnType === 'void')
            rtnType = 'undefined';

        if (args.length > 2) {
            let fnArgs = [ args[0] ];
            for (let i = 1; i < args.length - 2; i++)
                fnArgs.push(args[i]);

            js0.args.apply(this, fnArgs);
        }
        
        return js0.rtn(rtnType, await rtnFn());
    }

    prop(mainObject, propClass, ...propArgs) {
        this.args(arguments, 'object', 'function', js0.ExtraArgs);

        if (!('Property' in propClass)) {
            console.warn(new Error());
            throw new Error(`\`${propClass}\` is not a \`Property\` ` +
                    `(no \`Property\` in object prototype).`);
        }
        if (typeof propClass.Property !== 'string') {
            console.warn(new Error());
            throw new Error(`\`${propClass}\` is not a \`Property\` ` +
                    `(\`Property\` is not a string).`);
        }

        propArgs.splice(0, 0, null);
        let prop = new (Function.prototype.bind.apply(propClass, propArgs))();
        Object.defineProperty(mainObject, propClass.Property, {
            get: () => { return prop; },
        });
    }

    implements(mainObject, ...interfaceClasses) {

    }

    rtn(valueType, value) {
        this.typeE(value, valueType, 'Wrong return value.');
        return value;
    }

    rtnFn(valueType, valueFn = this.NotSet) {
        if (typeof valueFn === 'function') {
            let value = valueFn();
            if (value instanceof Promise) {
                return value
                    .then((resultValue) => {
                        this.typeE(resultValue, valueType);
                        return value;
                    });
            }

            this.typeE(value, valueType);
            return value;
        }

        throw new Error(`'valueFn' is not a function.`);
    }

    type(value, valueType, errors = [], args = false) {
        if (valueType === null) {
            if (args && typeof value === 'undefined') {
                errors.push('Arg not set.');
                return false;
            }

            return true;
        }

        let typeofValue = typeof value;

        /* Special Types */
        // if (valueType === this.ArrayItems) {
        //     if (value === null || typeof value !== 'object') {                
        //         errors.push(`\`${value}\` is not an instance of \`Array\`.`);
        //         return false;
        //     }

        //     if (!(value instanceof Array)) {
        //         errors.push(`\`${value}\` is not an instance of \`Array\`.`);
        //         return false;
        //     }

        //     return true;
        if (valueType === this.Default) {
            if (typeof value === 'undefined')
                return true;

            return false;
        } else if (valueType === this.Int) {
            return this.type(value, 'int', errors);
        } else if (valueType === this.Iterable) {
            if (value === null || typeof value !== 'object') {                
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            if (typeof value[Symbol.iterator] !== 'function') {
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.Long) {
            return this.type(value, 'bigint', errors);
        } else if (valueType === this.Object) {
            return this.type(value, 'object', errors);
        } else if (valueType === this.RawObject) {
            if (value === null) {
                errors.push(`RawObject cannot be \`null\`.`);
                return false;
            }

            if (typeofValue === 'undefined') {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            // if (!(typeof value !== 'object')) {
            //     console.log(typeof value);
            //     errors.push(`'${value}' is not an RawObject.`);
            //     return false;
            // }

            if (Object.getPrototypeOf(value) !== Object.prototype) {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            return true;
        } else if (valueType === this.NotNull) {
            if (value === null) {
                errors.push(`\`${value}\` cannot be \`null\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.Null) {
            if (value === null)
                return true;

            return false;
        } else if (valueType instanceof this.Array_Type) {
            if (!this.type(value, Array)) {
                errors.push(`Value must be an instance of 'js0.Array'. Found: ${typeofValue}.`);
                return false;
            }

            if (valueType.itemType !== value.itemType) {
                errors.push(`Wrong 'js0.Array' item type.`);
                return false;
            }

            return valid;
        } else if (valueType instanceof this.ArrayItems_Type) {
            if (!this.type(value, Array)) {
                errors.push(`Value must be an instance of Array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            let i = 0;
            for (let itemValue of value) {
                let itemErrors = [];
                if (!this.type(itemValue, valueType.itemType, itemErrors)) {
                    let itemKey = value.keys()[i];
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
                i++;
            }

            return valid;
        } else if (valueType instanceof this.Enum_Type) {
            for (let value_Enum of valueType.values) {
                if (value === value_Enum)
                    return true;
            }

            errors.push(`Enum value '${value}' not found in '` + 
                    valueType.values.join(', ') + `'.`);
            return false;
        } else if (valueType instanceof this.Default_Type) {
            return false;
        } else if (valueType instanceof this.Iterable_Type) {
            if (!this.type(value, this.Iterable)) {
                errors.push(`Preset must be Iterable. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let i = 0; i < value.length; i++) {
                let itemValue = value[i];
                let itemErrors = [];
                if (!this.type(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof this.ObjectItems_Type) {
            if (!this.type(value, this.RawObject)) {
                errors.push(`Value must be an instance of RawObject. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let itemKey in value) {
                let itemValue = value[itemKey];
                let itemErrors = [];
                if (!this.type(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof this.Preset_Type) {
            if (args) {
                console.warn(new Error());
                throw new Error('Preset type cannot be used in function arguments.');
            }

            if (typeofValue === 'undefined' && typeof 
                    valueType.defaultValue !== 'undefined') {
                value = valueType.defaultValue;
                typeofValue = typeof value;
            }

            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (typeofValue !== 'object') {
                errors.push(`Preset must be an object. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;

            if (!valueType.hasExtras) {
                for (let key in value) {
                    if (!(key in valueType.presets)) {
                        errors.push(`Unknown key \`${key}\`.`);
                        valid = false;
                    }
                }
            }

            for (let key in valueType.presets) {
                let newErrors = [];
                
                if (typeof value[key] === 'undefined') {
                    if (valueType.presets[key] instanceof Array) {
                        for (let propValueType of valueType.presets[key]) {
                            if (propValueType instanceof this.Default_Type)
                                value[key] = propValueType.defaultValue;
                        }
                    }
                } 

                try {
                    if (this.type(value[key], valueType.presets[key], newErrors))
                        continue;
                } catch (err) {
                    newErrors.push(err.toString());
                }

                for (let newError of newErrors)
                    errors.push(`${key} -> ${newError}`);

                valid = false;
            }

            // console.log('WTF', value, valid, errors);

            return valid;
        } else if (valueType instanceof this.PresetArray_Type) {
            if (typeofValue === 'undefined' && typeof 
                    valueType.defaultValue !== 'undefined') {
                value = valueType.defaultValue;
                typeofValue = typeof value;
            }

            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (!(value instanceof Array)) {
                errors.push(`PresetArray must be an array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            
            if (value.length !== valueType.presets.length) {
                errors.push(`Wrong PresetArray length. Required: '${valueType.presets.length}'.`);
                    valid = false;
            }

            for (let i = 0; i < valueType.presets.length; i++) {
                let newErrors = [];
                
                if (typeof value[i] === 'undefined') {
                    if (valueType.presets[i] instanceof Array) {
                        for (let propValueType of valueType.presets[i]) {
                            if (propValueType instanceof this.Default_Type)
                                value[i] = propValueType.defaultValue;
                        }
                    }
                } 

                if (this.type(value[i], valueType.presets[i], newErrors))
                    continue;

                for (let newError of newErrors)
                    errors.push(`${i} -> ${newError}`);

                valid = false;
            }

            return valid;
        } else if (valueType instanceof this.Prop_Type) {
            let propClass = valueType._propClass;
            if (typeof value !== 'object') {
                errors.push(`\`${value}\` does not implement \`${propClass}\` ` +
                        ` (not an object).`);
                return false;
            }

            if (!(propClass.Property in value)) {
                errors.push(`\`${value}\` does not implement \`${propClass}\` ` +
                        ` (property not in object).`);
                return false;
            }

            if (!(value[propClass.Property] instanceof propClass)) {
                errors.push(`\`${value}\` does not implement \`${propClass}\`. ` +
                        ` (wrong property type).`);
                return false;
            }

            return true;
        } else if (valueType === this.PropClass) {
            if (typeof value !== 'function') {
                errors.push(`\`${value}\` is not a \`Property\`.`);
                return false;
            }

            if (!('Property' in value)) {
                errors.push(`\`${value}\` is not a \`Property\`.`);
                return false;
            }

            return true;
        }
        //  else if (valueType instanceof this.Object_Type) {
        //     if (!this.type(value, this.Object)) {
        //         errors.push(`Preset must be an Object. Found: ${typeofValue}.`);
        //         return false;
        //     }

        //     let valid = true;
        //     for (let itemKey in value) {
        //         let itemErrors = [];
        //         if (!this.type(value[itemKey], valueType.itemType, itemErrors)) {
        //             valid = false;
        //             errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
        //         }
        //     }

        //     return valid;
        // } else if (valueType instanceof this.RawObject_Type) {
        //     if (!this.type(value, this.RawObject)) {
        //         errors.push(`Preset must be a RawObject. Found: ${typeofValue}.`);
        //         return false;
        //     }

        //     let valid = true;
        //     for (let itemKey in value) {
        //         let itemErrors = [];
        //         if (!this.type(value[itemKey], valueType.itemType, itemErrors)) {
        //             valid = false;
        //             errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
        //         }
        //     }

        //     return valid;
        // }
        /* / Special Types */

        let typeofValueType = typeof valueType;

        /* Basic Types */
        if (typeofValueType === 'string') {
            let result = true;
            if (this.Types_Basic.has(valueType)) {
                result = typeof value === valueType;
            } else if (this.Types_Extended.has(valueType)) {
                switch(valueType) {
                    case 'bool':
                        result = typeofValue === 'boolean';
                        break;
                    case 'int':
                        result = Number.isInteger(value);
                        break;
                    case 'finite':
                        result = Number.isFinite(value);
                        break;
                    case 'nan':
                        result = Number.isNaN(value);
                        break;
                    case 'void':
                        result = typeofValue === 'undefined';
                        break;
                }
            } else {
                errors.push(`Unknown type '${valueType}'.`);
                return false;
            }

            if (!result) {
                let typeof_value = typeof value;
                let value_Str = String(value);
                errors.push(`Variable \`${value_Str}\` of type \`${typeof_value}\`` +
                    ` should be of type \`${valueType}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'object') {
            /* Multiple Types */
            if (valueType instanceof Array) {
                if (value === null) {
                    for (let i = 0; i < valueType.length; i++) {
                        if (valueType[i] === this.NotNull) {
                            errors.push(`\`${value}\` cannot be \`null\`.`);
                            return false;
                        }
                    }
                }

                for (let i = 0; i < valueType.length; i++) {
                    if (this.type(value, valueType[i], errors))
                        return true;
                }

                return false;
            }

            console.warn(new Error());
            console.warn('Value type: ', valueType);
            throw new Error(`Unknown 'valueType': ${typeofValueType}`);
        }

        if (typeofValueType === 'function') {
            // /* Property */
            // if ('Property' in valueType) {
            //     if (!this.implements(value, valueType)) {
            //
            //         errors.push(`Variable does not implement property
            //                 \`${valueType.constructor}\`.`);
            //         return false;
            //     }
            //
            //     return true;
            // }

            /* Class */
            if (!(value instanceof valueType)) {
                let valueStr = String(value);
                errors.push(`Variable \`${valueStr}\` is not an instance of` +
                        ` \`${valueType.name}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'symbol') {
            if (value !== valueType) {
                let value_Str = String(value);
                let valueType_Str = String(valueType);
                errors.push(`Variable '${value_Str}' is not ${valueType_Str}.`);
                return false;
            }

            return true;
        }

        console.warn(new Error());
        throw new Error(`Unknown 'valueType': ${typeofValueType}`);
    }

    typeE(value, valueType, extraErrorInfo = null) {
        let errors = [];
        if (this.type(value, valueType, errors))
            return;

        if (extraErrorInfo !== null)
            errors.splice(0, 0, extraErrorInfo);

        console.error('Error:', errors);
        console.warn(new Error());
        throw new this.TypeError('Wrong variable type.');
    }

    virtual(object = null) {
        if (object === null) {
            console.warn(new Error());
            throw new this.NotImplementedError();
        }

        console.warn(new Error());
        throw new this.NotImplementedError(`Method not implemented in:` +
                ` \`${object.constructor.name}\`.`);
    }

}
const js0 = new js0_Class();
/* export default */ js0;

Object.defineProperties(js0_Class.prototype, {

    /* Errors */
    AssertionError: { value:
    class js0_AssertionError extends Error {
        constructor(...args) {
            super(...args);
        }

    }},

    NotImplementedError: { value:
    class js0_NotImplementedError extends Error {
        constructor(...args) {
            super(...args);
        }

    }},


    TypeError: { value:
    class js0_TypeError extends Error {
        constructor(...args) {
            super(...args);

            // let stack = this.stack;
            // let stack_array = stack.split('\n');
            // stack_array.splice(1, 3);
            // this.stack = stack_array.join('\n');
        }

    }},
    /* / Errors */

    /* Types */
    Types_Basic: { value:
    new Set([
        'undefined',
        // 'object', /* null */
        'boolean',
        'number',
        'string',
        'symbol',
        'function',
        'object'
    ])},

    Types_Extended: { value:
    new Set([
        'bigint',
        'bool',
        'finite',
        'int',
        'nan',
        'void'
    ])},

    /* Types Special */
    ArrayItems: { value: (itemType) => {
        return new js0.ArrayItems_Type(itemType);
    }},
    Default: { value: (defaultValue) => {
        return new js0.Default_Type(defaultValue);
    }},
    Enum: { value: (values) => {
        return new js0.Enum_Type(values);
    }},
    ExtraArgs: { value: Symbol('js0_ExtraArgs'), },
    Int: { value: Symbol('js0_Int'), },
    Iterable: { value: (itemType) => {
        return new js0.Iterable_Type(itemType);
    }},
    Long: { value: Symbol('js0_Long'), },
    NotNull: { value: Symbol('js0_NotNull'), },
    NotSet: { value: Symbol('js0_NotSet'), },
    Null: { value: Symbol('js0_Null'), },
    Preset: { value: (presets, hasExtras = false) => {
        return new js0.Preset_Type(presets, hasExtras);
    }},
    PresetArray: { value: (presets) => {
        return new js0.PresetArray_Type(presets);
    }},
    Prop: { value: (property) => {
        return new js0.Prop_Type(property);
    }},
    PropClass: { value: Symbol('js0_PropClass'), },
    Object: { value: Symbol('js0_Object'), },
    ObjectItems: { value: (itemType) => {
        return new js0.ObjectItems_Type(itemType);
    }},
    RawObject: { value: Symbol('js0_RawObject'), },

    And_Type: { value:
    class js0_And_Type  {
        constructor(valueTypes) {
            js0.args(arguments, js0.PropClass);

            Object.defineProperties(this, {
                _valueTypes: { value: valueTypes, },
            });
        }

    }},

    Array_Type: { value:
    class js0_Array_Type {
        constructor(itemType) {
            this.itemType = itemType;
        }
    }},

    ArrayItems_Type: { value:
    class js0_ArrayItems_Type {
        constructor(itemType) {
            this.itemType = itemType;
        }

    }},

    Default_Type: { value:
    class js0_Default_Type {
        constructor(defaultValue = undefined) {
            this.defaultValue = defaultValue;
        }

    }},

    Enum_Type: { value:
        class js0_Enum_Type {
    
            constructor(values = [])
            {
                if (!(values instanceof Array)) {
                    console.warn(new Error());
                    throw new Error(`'js0.Enum' values must be an Array.`);
                }

                this.values = values;
            }
    
        }},

    Iterable_Type: { value:
    class js0_Iterable_Type {
        constructor(itemType) {
            this.itemType = itemType;
        }

    }},

    ObjectItems_Type: { value:
    class js0_ObjectItems_Type {
        constructor(itemType) {
            this.itemType = itemType;
        }

    }},

    // Or_Type: { value:
    // class js0_Or_Type
    // {
    //     constructor(propClass)
    //     {
    //         js0.argsE(arguments, js0.PropClass);
    //
    //         Object.defineProperties(this, {
    //             _propClass: { value: propClass, },
    //         });
    //     }
    // }},

    Preset_Type: { value:
    class js0_Preset_Type {
        
        constructor(presets, hasExtras = false) {
            js0.args(arguments, js0.RawObject, [ 'boolean', js0.Default ]);

            this.presets = presets;
            this.hasExtras = hasExtras;
            // this.defaultValue = defaultValue;
        }

    }},

    PresetArray_Type: { value:
    class js0_PresetArray_Type {
        
        constructor(presets) {
            js0.args(arguments, Array);

            this.presets = presets;
        }

    }},

    Prop_Type: { value:
    class js0_Prop_Type {
        constructor(propClass) {
            js0.args(arguments, js0.PropClass);

            Object.defineProperties(this, {
                _propClass: { value: propClass, },
            });
        }

    }},

    // Object_Type: { value:
    // class js0_Object_Type {

    //     constructor(itemType)
    //     {
    //         this.itemType = itemType;
    //     }

    // }},

    // RawObject_Type: { value:
    // class js0_RawObject_Type {

    //     constructor(itemType)
    //     {
    //         this.itemType = itemType;
    //     }

    // }},
    /* / Types */

});


/* JSLib Exports */
_jsLib.export("js0_Class", js0_Class);
_jsLib.export("default", js0); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\Info.js
jsLibs.exportScript("js0", "./Info", [  ], (_jsLib) => { "use strict"; // import js0 from "js0";


// export default class Info
// {

//     construct(class_object)
//     {
//         this._object = class_object;

//         this._abstractClassInterfaces = [];

//         this._implemented = [];
//     }

//     abstract(class_object, interface_class)
//     {
//         js0.args(arguments, 'object', js0.Interface);

//         this._abstractClassInterfaces.push(interface_class);
//     }

//     implements(class_objects)
//     {

//     }

// }


/* JSLib Exports */ });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\js0Class.js
jsLibs.exportScript("js0", "./js0Class", [ "default" ], (_jsLib) => { "use strict"; /* export default */ class js0Class {
    constructor() {
        this._proxyHandler = {
            get(target, prop, receiver) {
                console.log('prop get', prop);
                if (!(prop in target))
                    throw new Error(`Property '${prop}' does not exist in object of class '${target.constructor.name}'.`)

                return target[prop];
            },

            set(target, prop, value) {
                console.log('prop set', prop);
                if (!(prop in target))
                    throw new Error(`Property '${prop}' does not exist in object of class '${target.constructor.name}'.`)

                return target[prop];
            }
        }
    }
}

/* JSLib Exports */
_jsLib.export("default", js0Class); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\List.js
jsLibs.exportScript("js0", "./List", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "./index.js");

/* export default */ class js0_List {
    get size() {
        return this._values.length;
    }


    constructor(iterable = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).Iterable, (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).Default ]);

        this._keys = [];
        this._values = [];

        if (iterable !== null) {
            for (let item of iterable) {
                if (item instanceof Array) {
                    if (item.length === 2) {
                        this.set(item[0], item[1]);
                        continue;
                    }
                }

                this.add(item);
            }
        }
    }

    [Symbol.iterator]() {
        return new js0_List.Iterator(this);
    }

    add(...values) {
        let index = 0;
        for (let value of values) {
            while(this._keys.includes(index))
                index++;

            this.set(index, value);
        }
    }

    addAll(values) {
        (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "./index.js")).Iterable);

        let index = 0;
        for (let value of values) {
            while(this._keys.includes(index))
                index++;

            this.set(index, value);
        }
    }

    addAt(index, key, value) {
        if (index < 0 || index > this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        if (this._values.length === index) {
            this._keys.push(key);
            this._values.push(value);
        } else {
            this._keys.splice(index, 0, key);
            this._values.splice(index, 0, value);
        }

    }

    clear() {
        this._keys = [];
        this._values = [];
    }

    delete(key) {
        let index = this._getIndexE(key);
        this.deleteAt(index);
    }

    deleteAt(index) {
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
    }

    get(key) {
        let index = this._getIndexE(key);

        return this._values[index];
    }

    getAt(index) {
        if (index < 0 || index >= this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        return this._values[index];
    }

    getKeyAt(index) {
        if (index < 0 || index >= this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        return this._keys[index];
    }

    getKeys() {
        return this._keys.slice();
    }

    getValues() {
        return this._values.slice();
    }

    has(key) {
        return this._keys.includes(key);
    }

    includes(value) {
        return this._values.includes(value);
    }

    indexOf(value) {
        return this._values.indexOf(value);
    }

    keys() {
        return this._keys.slice();
    }

    remove(value) {
        for (let i = this.size - 1; i >= 0; i--) {
            if (this.getAt(i) === value) {
                this.deleteAt(i);
                return;
            }
        }     

        throw new Error(`Value '${value}' does not exist in js0_List.`);
    }

    set(key, value) {
        let index = this._keys.indexOf(key);
        if (index === -1)
            index = this._values.length;

        this.setAt(index, key, value);
    }

    setAt(index, key, value) {
        if (index < 0 || index > this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        if (index === this._values.length) {
            this._keys.push(key);
            this._values.push(value);
        } else {
            this._keys[index] = key;
            this._values[index] = value;
        }
    }

    slice() {

    }

    sort(compareFn) {
        let newKeys = this._keys.slice();
        newKeys.sort((aKey, bKey) => {
            return compareFn({ key: aKey, value: this.get(aKey) },
                    { key: bKey, value: this.get(bKey) });
        });

        let newValues = [];
        for (let i = 0; i < this.size; i++)
            newValues.push(this.get(newKeys[i]));

        this._keys = newKeys;
        this._values = newValues;
    }

    values() {
        return this._values.slice();
    }


    _getIndexE(key) {
        let index = this._keys.indexOf(key);
        if (index === -1)
            throw new Error(`Key \`${key}\` does not exist in \`js0_List\`.`);

        return index;
    }

}


Object.defineProperties(js0_List, {

    Iterator: { value:
    class js0_List_Iterator {

        constructor(list)
        {
            this._list = list;
            this._iterator = list._keys[Symbol.iterator]();
        }

        next()
        {
            let keyItem = this._iterator.next();

            if (keyItem.done)
                return { value: undefined, done: true, };

            return {
                value: [ keyItem.value, this._list.get(keyItem.value), ],
                done: false,
            };
        }

    }},

});


/* JSLib Exports */
_jsLib.export("default", js0_List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\js0\TimeSpan.js
jsLibs.exportScript("js0", "./TimeSpan", [ "default" ], (_jsLib) => { "use strict"; /* export default */ class TimeSpan {
    static GetInstance(instanceAlias) {
        if (!(instanceAlias in TimeSpan.Instances))
            throw new Error(`TimeSpan instance '${instanceAlias}' does not exist.`);

        return TimeSpan.Instances[instanceAlias];
    }

    static MarkStart(instanceAlias, markAlias) {
        if (!(instanceAlias in TimeSpan.Instances))
            TimeSpan.Instances[instanceAlias] = new TimeSpan();
        let instance = TimeSpan.Instances[instanceAlias];

        return instance.markStart(markAlias);
    }


    constructor() {
        this._start = (new Date()).getTime();
        this._marks = [];
    }

    getDiffs() {
        let diffs = [];
        for (let mark of this._marks) {
            diffs.push([ mark.alias, mark.timeEnd === null ? null : 
                    mark.timeEnd - mark.timeStart ]);
        }

        return diffs;
    }

    markStart(markAlias) {
        this._marks.push({
            alias: markAlias,
            timeStart: (new Date()).getTime(),
            timeEnd: null,
        });

        return new TimeSpan_Mark(this, this._marks.length - 1);
    }

}
TimeSpan.Instances = {};

class TimeSpan_Mark {
    constructor(instance, index) {
        this._instance = instance;
        this._index = index;
    }

    end() {
        this._instance._marks[this._index].timeEnd = (new Date()).getTime();
    }
}

/* JSLib Exports */
_jsLib.export("default", TimeSpan); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\web-ab-api\index.js
jsLibs.exportScript("web-ab-api", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("web-ab-api", "./Result", [ { name: "default", alias: "Result" } ], "./Result");

class abApi_Class {
    get Result() {
        return (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result"));
    }

    get debug() {
        return this._debug;
    }

    get requestTimeout() {
        return this._requestTimeout;
    }

    constructor() {
        this._debug = false;
        this._requestTimeout = 0;
    }

    json(uri, json, fn, timeout = null)  {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, 'function', 
                [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        var json_string = JSON.stringify(json);
        if (json_string === null)
            throw new Error('Cannot parse json.');

        this.post(uri, { json: json_string }, fn, timeout);
    }

    async json_Async(uri, json, timeout = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return new Promise((resolve, reject) => {
            this.json(uri, json, (result) => {
                resolve(result);
            }, timeout);
        });
    }

    post(uri, fields, fn, timeout = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, 'function', 
                [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        timeout = timeout === null ? this.requestTimeout : timeout;

        var form_data = new FormData();
        for (var field_name in fields)
            form_data.append(field_name, fields[field_name]);

        var request = new XMLHttpRequest();
        request.open('POST', uri, true);
        request.timeout = timeout;
        request.onerror = (evt) => {
            let result = (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).Error(request, 
                    `Http request error.`, 
                    (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).ErrorResults_Other);
            fn(result);
        };
        request.ontimeout = () => {
            let result = (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).Error(request, 
                   `Http request error: connection timeout`, 
                    (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).ErrorResults_HttpTimeoutError);
            fn(result);
        };
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                var result = (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).Parse(request, request.responseText, uri, 
                        this.debug);

                if (this.debug)
                    console.log('webABApi', uri, fields, result);

                fn(result);
            } else {
                let result = (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).Error(request,
                        `Http request error: ${request.status} -> ` +
                        request.responseText, 
                        (_jsLib.import("web-ab-api", "./Result", "default", "Result", "./Result")).ErrorResults_HttpRequestError);
                
                fn(result);
            }
        };
        request.send(form_data);
    }

    setDebug(debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');
        this._debug = debug;
    }

    setRequestTimeout(timeout) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');
        this._requestTimeout = timeout;

        console.log(this._requestTimeout);
    }

    upload(uri, json, files, fn, timeout = null) {
        var fields = {};
        for (var file_name in files) {
            if (files[file_name] === null) {
                json[file_name] = null;
            } else {
                fields[file_name] = files[file_name];
            }
        }

        var json_string = JSON.stringify(json);
        if (json_string === null)
            throw new Error('Cannot parse json.');
        fields.json = json_string;

        this.post(uri, fields, fn, timeout);
    }

    async upload_Async(uri, json, files, timeout = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return new Promise((resolve, reject) => {
            this.upload(uri, json, files, (result) => {
                resolve(result);
            }, timeout);
        });
    }

}
const webABApi = new abApi_Class();
/* export default */ webABApi;

/* JSLib Exports */
_jsLib.export("default", webABApi); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\web-ab-api\Result.js
jsLibs.exportScript("web-ab-api", "./Result", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "./index.js");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");

/* export default */ class Result
{

    static get ErrorResults_Other() {
        return 2;
    }

    static get ErrorResults_HttpRequestError() {
        return 3;
    }

    static get ErrorResults_HttpTimeoutError() {
        return 4;
    }

    static get ErrorResults_CannotParseJSON() {
        return 5;
    }

    static get ErrorResults_WrongResultFormat() {
        return 6;
    }
    

    static Error(request, message, errorResultId = 2) {
        var result = new Result(request);
        result.result = errorResultId;
        result.message = message;
        result.data = {};

        return result;
    }

    static Parse(request, dataString, uri, debug = false) {
        var data = null;
        try {
            data = JSON.parse(dataString);
        } catch (err) {
            // data = null;
        }

        if (data === null) {
            var result = Result.Error(request,
                    'Cannot parse json data from: ' + uri,
                    Result.ErrorResults_CannotParseJSON);
            result.data.data = dataString;

            if (debug)
                console.error(dataString);

            return result;
        }

        if (typeof data !== 'object') {
            var result = Result.Error(request,
                    'Cannot parse json data from: ' + uri,
                    Result.ErrorResults_CannotParseJSON);
            result.data.data = dataString;

            if (debug)
                console.error(dataString);

            return result;
        }

        var result = new Result(request);

        if (!('result' in data)) {
            result.result = Result.ErrorResults_WrongResultFormat;
            result.message = 'No result info in json data.';
        } else {
            result.result = data.result;
            if ('message' in data)
                result.message = data.message;
            result.data = data;
        }

        return result;
    }


    constructor(request) {
        this._request = request;
        this.result = -1;
        this.message = '';
        this.data = null;
    }

    getErrorInfo() {
        if (this.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "./index.js")).Result.ErrorResults_Other) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_Other'),
                message: this.getResponseUrl() + ' -> ' + this.message,
            }
        } else if (this.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "./index.js")).Result.ErrorResults_HttpRequestError) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_HttpRequestError'),
                message: this.getResponseUrl() + ' -> ' + this.message,
            };
        } else if (this.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "./index.js")).Result.ErrorResults_HttpTimeoutError) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_HttpTimeoutError'),
                message: '',
            };
        } else if (this.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "./index.js")).Result.ErrorResults_CannotParseJSON) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_CannotParseJSON'),
                message: this.getResponseUrl() + ' -> ' + this.data.data,
            };
        } else if (this.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "./index.js")).Result.ErrorResults_WrongResultFormat) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_WrongResultFormat'),
                message: this.getResponseUrl(),
            };
        }

        return null;
    }

    getResponseUrl() {
        return this._request.responseURL;
    }

    getResult() {
        return this.result;
    }

    isSuccess() {
        return this.result === 0;
    }

    isFailure() {
        return this.result === 1;
    }

    isError() {
        return this.result >= 2;
    }
    
};

/* JSLib Exports */
_jsLib.export("default", Result); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\DatabaseInfo.js
jsLibs.exportScript("ab-data", "./DatabaseInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./FieldInfo", [ { name: "default", alias: "FieldInfo" } ], "./FieldInfo.js");
_jsLib.importDeclaration("ab-data", "./TableInfo", [ { name: "default", alias: "TableInfo" } ], "./TableInfo.js");
_jsLib.importDeclaration("ab-data", "./DataScheme", [ { name: "default", alias: "DataScheme" } ], "./DataScheme.js");
_jsLib.importDeclaration("ab-data", "./TableDef", [ { name: "default", alias: "TableDef" } ], "./TableDef.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./fields/ABDField.js");
_jsLib.importDeclaration("ab-data", "./TableInfo", [  ], "./TableInfo.js");
_jsLib.importDeclaration("ab-data", "./FieldInfo", [  ], "./FieldInfo.js");
_jsLib.importDeclaration("ab-data", "./TableDef", [  ], "./TableDef.js");
_jsLib.importDeclaration("ab-data", "./DatabaseVersion", [ { name: "default", alias: "DatabaseVersion" } ], "./DatabaseVersion.js");

class DatabaseInfo {
    static Compare(scheme, db_Info) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js")), DatabaseInfo);

        let ignored_TableNames_LC = scheme.getIgnored_TableNames();
        for (let i = 0; i < ignored_TableNames_LC.length; i++)
            ignored_TableNames_LC[i] = ignored_TableNames_LC[i].toLowerCase();

        let actions = {
            tables: {
                delete: [],
                create: [],
                alter: [],
            },
        };

        for (let db_TableInfo of db_Info.tableInfos) {
            if (ignored_TableNames_LC.includes(db_TableInfo.name.toLowerCase())) {
                console.warn(`Ignoring deleting '${tableName}'.`);
                continue;
            }

            if (!scheme.hasTable(db_TableInfo.name)) {
                actions.tables.delete.push(db_TableInfo.name);
                continue;
            }
        }

        for (let tableName of scheme.tableNames) {
            if (ignored_TableNames_LC.includes(tableName.toLowerCase())) {
                console.warn(`Ignoring creating '${tableName}'.`);
                continue;
            }

            let db_TableInfo = db_Info.getTableInfo_ByName(tableName);
            if (db_TableInfo === null) {
                actions.tables.create.push(scheme.getTableDef(tableName));
                continue;
            }

            let scheme_TableDef = scheme.getTableDef(tableName);
            let actions_Table = DatabaseInfo.Compare_Tables(scheme, scheme_TableDef, 
                    db_Info, db_TableInfo);
            if (actions_Table.delete.length > 0 || 
                    actions_Table.create.length > 0 ||
                    actions_Table.change.length > 0) {
                actions.tables.alter.push(actions_Table);
            }

            // if (actions_Table.change.length > 0) {
            //     actions.tables.delete.push(db_TableInfo.name);
            //     actions.tables.create.push(scheme_TableDef);

            //     actions_Table.delete = [];
            //     actions_Table.create = [];
            //     actions_Table.change = [];
            // }
        }

        return actions;
    }

    static CompareIndexes(scheme, db_Info) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js")), DatabaseInfo);

        let ignored_TableNames_LC = scheme.getIgnored_TableNames();
        for (let i = 0; i < ignored_TableNames_LC.length; i++)
            ignored_TableNames_LC[i] = ignored_TableNames_LC[i].toLowerCase();

        let actions = {
            tables: {
                alter: [],
            },
        };

        for (let db_TableInfo of db_Info.tableInfos) {
            if (ignored_TableNames_LC.includes(db_TableInfo.name.toLowerCase())) {
                console.warn(`Ignoring deleting '${tableName}'.`);
                continue;
            }

            if (!scheme.hasTable(db_TableInfo.name))
                continue;

            let scheme_TableDef = scheme.getTableDef(db_TableInfo.name);
            let actions_Table = DatabaseInfo.Compare_TableIndexes(scheme, 
                    scheme_TableDef, db_Info, db_TableInfo);
            if (actions_Table.pks_Delete ||
                    actions_Table.pks_Create ||
                    actions_Table.indexes_Delete.length > 0 ||
                    Object.keys(actions_Table.indexes_Create).length > 0)
                actions.tables.alter.push(actions_Table);
        }

        return actions;
    }

    static Compare_Fields(columnName, scheme, scheme_TableDef, scheme_Field, 
            db_Info, tableInfo__DB, db_FieldInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js")), (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js")), (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./fields/ABDField.js")), DatabaseInfo, 
                (_jsLib.import("ab-data", "./TableInfo", "default", "TableInfo", "./TableInfo.js")), (_jsLib.import("ab-data", "./FieldInfo", "default", "FieldInfo", "./FieldInfo.js")));
        // console.log('DB', db_FieldInfo);
        // console.log('Info', fieldInfo_Scheme);
        // console.log('###');

        if (!(_jsLib.import("ab-data", "./FieldInfo", "default", "FieldInfo", "./FieldInfo.js")).CompareDBType(scheme_Field, db_Info.dbVersion, 
                db_FieldInfo.dbType, db_FieldInfo.dbExtra)) {
            console.log(db_FieldInfo, scheme_Field);
            console.log(`# Table '${scheme_TableDef.name}'.` +
                  ` DB type '${db_FieldInfo.dbType}' does not match for column '${columnName}'.`);
            return true;
        }

        if (scheme_Field.notNull !== db_FieldInfo.notNull) {
            console.log(`# Table '${scheme_TableDef.name}'.` +
                  `'notNull' value '${db_FieldInfo.notNull}' does not match for` +
                  ` column '${columnName}'.`);
            return true;
        }

        // if (!FieldInfo.CompareDBExtra(scheme_Field, db_Info.dbVersion, 
        //         db_FieldInfo.dbExtra)) {
        //     console.log(`# Table '${scheme_TableDef.name}'.` +
        //           `DB extra '${db_FieldInfo.dbExtra}' does not match for column '${columnName}'.`);
        //     return true;
        // }

        return false;
    }

    static Compare_Tables(scheme, scheme_TableDef, db_Info, db_TableInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js")), (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js")), DatabaseInfo, (_jsLib.import("ab-data", "./TableInfo", "default", "TableInfo", "./TableInfo.js")));

        let actions = {
            tableDef: scheme_TableDef,

            delete: [],
            create: [],
            change: [],
        };

        for (let db_FieldInfo of db_TableInfo.fieldInfos) {
            if (!scheme_TableDef.hasColumn(db_FieldInfo.name)) {
                console.log(`# Table '${scheme_TableDef.name}' field '${db_FieldInfo.name}'` +
                        ` does not exist in scheme.`);
                actions.delete.push(db_FieldInfo.name);
                continue;
            }
        }

        for (let [ columnName, column ] of scheme_TableDef.columns) {
            let db_FieldInfo = db_TableInfo.getFieldInfo_ByName(columnName);
            if (db_FieldInfo === null) {
                console.log(`# Table '${scheme_TableDef.name}' column '${columnName}'` +
                        ` does not exist in database.`);
                actions.create.push({
                    name: columnName,
                    field: column.field,
                });
                continue;
            }

            let scheme_Field = column.field;
            let actions_Fields = DatabaseInfo.Compare_Fields(columnName, scheme, 
                    scheme_TableDef, scheme_Field, db_Info, db_TableInfo, db_FieldInfo);
            if (actions_Fields) {
                actions.change.push({
                    name: columnName,
                    field: column.field,
                });
            }
        }

        return actions;
    }

    static Compare_TableIndexes(scheme, scheme_TableDef, db_Info, db_TableInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js")), (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js")), DatabaseInfo, (_jsLib.import("ab-data", "./TableInfo", "default", "TableInfo", "./TableInfo.js")));

        let actions = {
            tableDef: scheme_TableDef,
            
            pks_Delete: false,
            pks_Create: false,

            indexes_Delete: [],
            indexes_Create: {},
        };

        if (db_TableInfo.pks.length === scheme_TableDef.pks.length) {
            for (let i = 0; i < scheme_TableDef.pks.length; i++) {
                if (db_TableInfo.pks[i] !== scheme_TableDef.pks[i]) {
                    let scheme_PKs = scheme_TableDef.pks.join(', ');
                    let db_PKs = db_TableInfo.pks.join(', ');

                    console.log(`# Table '${scheme_TableDef.name}' pks '${db_PKs}'` +
                        ` do not match scheme pks '${scheme_PKs}'.`);
                    actions.pks_Delete = true;
                    actions.pks_Create = true;
                    break;
                }
            }
        } else {
            console.log(`# Table '${scheme_TableDef.name}' pks count` +
                    ` does not match.`);
            if (db_TableInfo.pks.length > 0)
                actions.pks_Delete = true;
            actions.pks_Create = true;
        }

        let db_IndexInfos = db_TableInfo.indexInfos;
        let scheme_Indexes = scheme_TableDef.indexes;

        /* Delete */
        for (let indexName in db_IndexInfos) {
            let db_IndexInfo = db_IndexInfos[indexName];
            
            if (!Object.keys(scheme_Indexes).includes(indexName)) {
                console.log(`# Table '${scheme_TableDef.name}' index '${indexName}'` +
                        ` does not exist in scheme. Deleting...`);
                actions.indexes_Delete.push(indexName);
                delete db_IndexInfos[indexName];
                continue; 
            }

            if (db_IndexInfo.columnInfos.length !== 
                    scheme_Indexes[indexName].length) {
                console.log(`# Table '${scheme_TableDef.name}' index '${index}'` +
                        ` does not match columns count in scheme. Deleting...`);
                actions.indexes_Delete.push(indexName);
                delete db_IndexInfos[indexName];
                continue; 
            }

            let deleting = false;
            for (let db_indexColumnInfo of db_IndexInfos[indexName].columnInfos) {
                // if (scheme_Indexes[indexName].length >=
                //         db_indexColumnInfo.position) {
                //     console.log(`# Table '${scheme_TableDef.name}' index '${indexName}'` +
                //             ` does not match columns count in the data scheme.`);
                //     console.log('A', indexName);   
                //     actions.indexes_Delete.push(indexName);
                //     delete db_IndexInfos[indexName];
                //     deleting = true;
                //     break;
                // }

                if (db_indexColumnInfo.name !== 
                        scheme_Indexes[indexName][db_indexColumnInfo.position].name) {
                    console.log(`# Table '${scheme_TableDef.name}' index '${indexName}'` +
                            ` at ${db_indexColumnInfo.position} does not match name ` +
                            ` of '${db_indexColumnInfo.name}'. Deleting...`);
                    actions.indexes_Delete.push(indexName);
                    delete db_IndexInfos[indexName];
                    deleting = true;
                    break;
                }

                if (db_indexColumnInfo.desc !== 
                        scheme_Indexes[indexName][db_indexColumnInfo.position].desc) {
                    console.log(`# Table '${scheme_TableDef.name}' index '${indexName}'` +
                            ` at ${db_indexColumnInfo.position} does not match 'desc'` +
                             ` of '${db_indexColumnInfo.name}'. Deleting...`);
                    actions.indexes_Delete.push(indexName);
                    delete db_IndexInfos[indexName];
                    deleting = true;
                    break;
                }
            }
            if (deleting)
                continue;
        }

        /* Create */
        for (let indexName in scheme_Indexes) {
            if (!Object.keys(db_IndexInfos).includes(indexName)) {
                console.log(`# Table '${scheme_TableDef.name}' in db does not` +
                        ` contain index '${indexName}'. Creating...`);
                actions.indexes_Create[indexName] = scheme_Indexes[indexName];
                continue; 
            }
        }

        return actions;
    }

    // static Create_FromConfig(database)
    // {
    //     let databaseInfo = new DatabaseInfo();

    //     for (let table of database.tables) {
    //         let tableInfo = new TableInfo(table.name);
    //         for (let [ fieldName, field ] of table.columns) {
    //             let fieldInfo = new FieldInfo(
    //                 fieldName,
    //                 FieldInfo.GetType_FromField(field),
    //                 '',
    //                 field.properties.notNull,
    //             );
    //             tableInfo.addFieldInfo(fieldInfo);
    //         }
    //         databaseInfo.addTableInfo(tableInfo);
    //     }

    //     return databaseInfo;
    // }

    // static async CreateFrom_DB_Async(db)
    // {
    //     let results = null;

    //     let databaseInfo = new DatabaseInfo();

    //     results = await db.query_SelectAsync('SHOW TABLES;');
    //     for (let row of results) {
    //         let tableName = row[Object.keys(row)[0]];

    //         let tableInfo = new TableInfo(tableName);

    //         results = await db.query_SelectAsync(`DESC \`${tableInfo.name}\`;`);
    //         for (let row of results) {
    //             tableInfo.addFieldInfo(new FieldInfo(
    //                 row.Field,
    //                 row.Type,
    //                 row.Key,
    //                 row.Null,
    //             ));
    //         }

    //         databaseInfo.addTableInfo(tableInfo);
    //     }

        

    //     return databaseInfo;
    // }


    get dbVersion() {
        return this._dbVersion;
    }

    get tableInfos() {
        return this._tableInfos;
    }


    constructor(dbVersion) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "./DatabaseVersion.js")));

        this._dbVersion = dbVersion;
        this._tableInfos = [];
    }

    addTableInfo(tableInfo) {
        this._tableInfos.push(tableInfo);
    }

    // compare(dbInfo_Scheme, queries)
    // {
    //     for (let tableInfo of this.tableInfos) {
    //         let tableInfo_Scheme = dbInfo_Scheme.getTableInfo_ByName(tableInfo.name);
    //         if (tableInfo_Scheme === null) {
    //             // console.log('Table', tableInfo.name, 'DELETE');
    //             continue;
    //         }
    //     }

    //     for (let tableInfo_Scheme of dbInfo_Scheme.tableInfos) {
    //         let tableInfo = this.getTableInfo_ByName(tableInfo_Scheme.name);
    //         if (tableInfo === null) {
    //             // console.log('Table', tableInfo_Scheme.name, 'CREATE');
    //             queries.create.push(tableInfo_Scheme.getQuery_Create());
    //             continue;
    //         }

    //         this.compare_Tables(tableInfo, tableInfo_Scheme);
    //     }

    // }

    // compare_Fields(fieldInfo, fieldInfo_Scheme)
    // {
    //     // console.log(fieldInfo.name, fieldInfo.type === fieldInfo_Scheme.type,
    //     //         fieldInfo.key === fieldInfo_Scheme.key, 
    //     //         fieldInfo.notNull === fieldInfo_Scheme.notNull);
    // }

    // compare_Tables(tableInfo, tableInfo_Scheme, queries)
    // {
    //     // console.log('Comparing', tableInfo.name);

    //     let actions = false;

    //     for (let fieldInfo of tableInfo.fieldInfos) {
    //         let fieldInfo_Scheme = tableInfo_Scheme.getFieldInfo_ByName(fieldInfo.name);
    //         if (fieldInfo_Scheme === null) {
    //             actions = true;
    //             // console.log('Field', fieldInfo.name, 'DELETE');
    //             continue;
    //         }
    //     }

    //     for (let fieldInfo_Scheme of tableInfo_Scheme.fieldInfos) {
    //         let fieldInfo = tableInfo.getFieldInfo_ByName(fieldInfo_Scheme.name);
    //         if (fieldInfo === null) {
    //             actions = true
    //             // console.log('Field', fieldInfo_Scheme.name, 'CREATE');
    //             continue;
    //         }

    //         this.compare_Fields(fieldInfo, fieldInfo_Scheme);
    //     }

    //     if (actions === true) 
    //         queries.delete.push(tableInfo_Scheme.getQuery_Delete());
    //         queries.create.push(tableInfo_Scheme.getQuery_Create());
    //     }
    // }

    getTableInfo_ByName(tableName) {
        for (let tableInfo of this.tableInfos) {
            if (tableInfo.name.toLowerCase() === tableName.toLowerCase())
                return tableInfo;
        }

        return null;
    }
}
/* export default */ DatabaseInfo;

/* JSLib Exports */
_jsLib.export("default", DatabaseInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\DatabaseVersion.js
jsLibs.exportScript("ab-data", "./DatabaseVersion", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class DatabaseVersion {
    get type() {
        return this._type;
    }

    get version() {
        return this._version;
    }

    constructor(type, version) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'scheme', 'mysql', 'sqlite' ]),
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'int', 'int', 'int' ]));
        this._type = type,
        this._version = version;
    }
}
/* export default */ DatabaseVersion;

/* JSLib Exports */
_jsLib.export("default", DatabaseVersion); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\DataScheme.js
jsLibs.exportScript("ab-data", "./DataScheme", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./RequestDef", [ { name: "default", alias: "RequestDef" } ], "./RequestDef.js");
_jsLib.importDeclaration("ab-data", "./TableDef", [ { name: "default", alias: "TableDef" } ], "./TableDef");

class DataScheme {
    static get Version() {
        return [ 0, 0, 1 ];
    }


    get tableNames() {
        return this._tableDefs.keys();
    }

    get version() {
        return this._version;
    }


    constructor(version) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');

        this._version = version;
        this._requests = new Map();
        this._tableDefs = new Map();

        this._ignored_TableNames = [];
    }

    defR(requestName, requestDef) {
        this.defRequest(requestName, requestDef);

        return this;
    }

    defRequest(requestName, requestDef) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-data", "./RequestDef", "default", "RequestDef", "./RequestDef.js")));

        if (this._requests.has(requestName))
            throw new Error(`Request '${requestName}' already exists.`);

        this._requests.set(requestName, requestDef);

        return this;
    }

    defT(tableDef) {
        if (tableDef.pks === null)
            throw new Error(`Table '${tableDef.name}' PKs not set.`);

        this.defTable(tableDef);

        return this;
    }

    defTable(tableDef) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef")));

        this._validateTableId(tableDef.getTableId());

        if (this._tableDefs.has(tableDef.name))
            throw new Error(`Table '${tableName}' already exists.`);

        this._tableDefs.set(tableDef.name, tableDef);

        return this;
    }

    getIgnored_TableNames() {
        return this._ignored_TableNames;
    }

    getRequestDef(requestName) {
        if (!this.hasRequestDef(requestName))
            throw new Error(`RequestDef '${requestName}' does not exist.`);

        return this._requests.get(requestName);
    }

    getTableDef(tableName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        for (let [ tableDefName, tableDef ] of this._tableDefs) {
            if (tableName.toLowerCase() === tableDefName.toLowerCase())
                return tableDef;
        }

        throw new Error(`Table definition '${tableName}' does not exist.`);
    }

    getTableDef_ById(tableId) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');

        for (let [ tableDefName, tableDef ] of this._tableDefs) {
            if (tableDef.getTableId() === tableId)
                return tableDef;
        }

        throw new Error(`Table definition with id '${tableId}' does not exist.`);
    }

    getTableIds() {
        let tableIds = {};
        for (let tableName of this.tableNames) {
            let tableDef = this.getTableDef(tableName);
            tableIds[tableName] = tableDef.getTableId();
        }

        return tableIds;
    }

    getValidatorInfos() {
        let validatorInfos = {};
        for (let tableName of this.tableNames) {
            let table = this.getTable(tableName);
            validatorInfos[tableName] = table.getValidatorInfos();
        }

        return validatorInfos;
    }
    
    hasTable(tableName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        for (let [ tableDefName, tableDef ] of this._tableDefs) {
            if (tableName.toLowerCase() === tableDefName.toLowerCase())
                return true;
        }

        return false;
    }

    hasTable_ById(tableId) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');

        for (let [ tableDefName, tableDef ] of this._tableDefs) {
            if (tableDef.getTableId() === tableId)
                return true;
        }

        return false;
    }

    hasRequestDef(requestName) {
        return this._requests.has(requestName);
    }

    ignoreT(tableNames) {   
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable('string'));

        this._ignored_TableNames = tableNames;

        return this;
    }  
    
    validateResponse(response, request) {
        if (response === null)
            return;

        let requestId = request[0];
        let requestName = request[1];
        let actionName = request[2];
        let actionArgs = request[3];

        let requestDef = this.getRequestDef(requestName);
        let actionDef = requestDef.getActionDef(actionName);

        if (!(requestId in response))
            throw new Error(`Result '${requestId}' not found in response.`);

        let errors = [];
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(response[requestId], (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionDef.resultDef), errors)) {
            console.error(`Result errors:`, errors);
            throw new Error(`Request action '${requestName}:${actionName}' result error.`);
        }
    }

    validateResult(request, result) {
        let requestId = request[0];
        let requestName = request[1];
        let actionName = request[2];
        let actionArgs = request[3];

        let requestDef = this.getRequestDef(requestName);
        let actionDef = requestDef.getActionDef(actionName);

        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(result, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject)) {
            console.error(`'${requestName}:${actionName}' result:`, result);
            throw new Error(`Result of '${requestName}:${actionName}' must be a 'RawObject'.`);
        }

        let errors = [];
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(result, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionDef.resultDef), errors)) {
            console.error(`'${requestName}:${actionName}' result:`, result);
            console.error(`Result errors:`, errors);``
            throw new Error(`Request action '${requestName}:${actionName}' result error.`);
        }
    }

    validateRequest(request) {
        let requestId = request[0];
        let requestName = request[1];
        let actionName = request[2];
        let actionArgs = request[3];

        if (!this.hasRequestDef(requestName))
            throw new Error(`Request '${requestName}' not defined.`);
        
        let requestDef = this.getRequestDef(requestName);

        if (!requestDef.hasActionDef(actionName))
            throw new Error(`Action '${requestName}:${actionName}' not defined.`);

        let actionDef = requestDef.getActionDef(actionName);
        let errors = [];
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(actionArgs, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionDef.argsDef), errors)) {
            console.error(`Args errors:`, errors);
            throw new Error(`Request action '${requestName}:${actionName}' args error.`);
        }
    }


    _validateTableId(tableId) {
        for (let [ tableName, table ] of this._tableDefs) {
            if (table.getTableId() === tableId)
                throw new Error(`Table with id '${tableId}' already exists ('${tableName}')`);
        }
    }

}
/* export default */ DataScheme;

/* JSLib Exports */
_jsLib.export("default", DataScheme); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\DataStore.js
jsLibs.exportScript("ab-data", "./DataStore", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "./index.js");
_jsLib.importDeclaration("ab-data", "./Response", [ { name: "default", alias: "Response" } ], "./Response.js");
_jsLib.importDeclaration("ab-data", "./RequestProcessor", [ { name: "default", alias: "RequestProcessor" } ], "./RequestProcessor");

/* export default */ class DataStore {
    get device() {
        return this._requestProcessor.device;
    }

    get lastId() {
        return this._device.lastId;
    }

    get requestProcessor() {
        return this._requestProcessor;
    }

    get scheme() {
        return this._scheme;
    }


    constructor(requestProcessor) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./RequestProcessor", "default", "RequestProcessor", "./RequestProcessor")));

        this._requestProcessor = requestProcessor;
        this._scheme = requestProcessor.scheme;
    }

    nextId() {
        return this.device.nextId();
    }

    async request_Async(requestName, actionName, actionArgs, 
            transactionId = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ],
                [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        try {
            this.scheme.validateRequest([ 'request', requestName, actionName, 
                    actionArgs ]);
        } catch (err) {
            if ((_jsLib.import("ab-data", "./index", "default", "abData", "./index.js")).debug)
                console.error(err);

            return (_jsLib.import("ab-data", "./index", "default", "abData", "./index.js")).Response.Create({
                actionErrors: {
                    request: err.toString(),
                },
                errorMessage: `Action '${requestName}:${actionName}' error.`,
                info: {},
                requestIds: [],
                results: {},
                type: (_jsLib.import("ab-data", "./Response", "default", "Response", "./Response.js")).Types_ActionError,
            });
        }

        let response = await this._requestProcessor.processRequest_Async(
                requestName, actionName, actionArgs, transactionId);

        // this._validateResults([ result ]);

        return response;
    }

    async requestB_Async(requests, transactionId = null) {
        return await this.requestBatch_Async(requests, transactionId);
    }

    async requestBatch_Async(requests, transactionId = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems((_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', 'string', 
                'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject ])), [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        for (let request of requests) {
            try {
                this.scheme.validateRequest(request)
            } catch(err) {
                return {
                    actionErrors: {
                        [request[0]]: err.toString(),
                    },
                    errorMessage: `Action '${request[0]}:${request[1]}' error.`,
                    info: {},
                    requestIds: [],
                    results: {},
                    type: (_jsLib.import("ab-data", "./Response", "default", "Response", "./Response.js")).Types_ActionError,
                };
            }
        }

        let response = await this._requestProcessor.processRequestBatch_Async(
                requests, transactionId);

        for (let request of requests)
            this.scheme.validateRequestResponse(response, request);

        return response;
    }

}

/* JSLib Exports */
_jsLib.export("default", DataStore); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\Device.js
jsLibs.exportScript("ab-data", "./Device", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class Device {

    static get Devices_Offset() {
        return 100000000;
    }


    static GetIdInfo(id) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        let deviceId = Math.floor(id / Device.Devices_Offset);

        return {
            id: id,
            deviceId: deviceId,
            itemId: id - deviceId * Device.Devices_Offset,
        };
    }


    get declaredItemIds() {
        return this._itemIds_Declared;
    }

    get hash() {
        return this._hash;
    }

    get id() {
        return this._id;
    }

    get lastItemId() {
        return this._lastItemId;
    }

    get lastUpdate() {
        return this._lastUpdate;
    }


    constructor(deviceId, deviceHash, lastUpdate, lastItemId, declaredItemIds = []) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this._id = deviceId;
        this._hash = deviceHash;
        this._lastItemId = lastItemId;
        this._lastUpdate = lastUpdate;

        this._itemIds_Declared = declaredItemIds;

        this._locks = [];
        this._locks_Next = 0;
    }

    isNewId(id) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        let idInfo = Device.GetIdInfo(id);

        if (this._isNewId_Device(idInfo))
            return true;

        // if (this._isNewId_SystemDevice(idInfo))
        //     return true;

        return false;
    }

    lock() {
        this._locks.push(this._locks_Next++);
    }

    nextId() {
        let nextId = this._id * Device.Devices_Offset + (++this._lastItemId);
        this._itemIds_Declared.push(this._lastItemId);

        return nextId;
    }

    // setDeclaredItemIds(declaredItemIds)
    // {
    //     js0.args(arguments, Array);

    //     this._itemIds_Declared = declaredItemIds;
    // }

    setLastUpdate(lastUpdate) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long);

        this._lastUpdate = lastUpdate;
    }

    unlock(lock) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');

        for (let i = 0; i < this._locks.length; i++) {
            if (this._locks[i] === lock) {
                this._locks.splice(i, 1);
                return;
            }
        }

        throw new Error(`Lock '${lock}' does not exist.`);
    }

    update(lastUpdate, lastItemId) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long);

        this._lastUpdate = lastUpdate;
        this._lastItemId = lastItemId;
    }

    
    _checkLock() {
        if (this._locks.length > 0) 
            throw new Error('Device locked.');
    }

    _isNewId_Device(idInfo) {
        if (idInfo['deviceId'] !== this._id)
            return false;

        if (idInfo['itemId'] <= this._itemIds_Last)
            return false;

        if (this._itemIds_Declared.includes(idInfo['itemId']))
            return true;

        return false;
    }

}
/* export default */ Device;

/* JSLib Exports */
_jsLib.export("default", Device); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\FieldInfo.js
jsLibs.exportScript("ab-data", "./FieldInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./fields/ABDField.js");
_jsLib.importDeclaration("ab-data", "./DatabaseVersion", [ { name: "default", alias: "DatabaseVersion" } ], "./DatabaseVersion.js");

/* export default */ class FieldInfo {
    static CompareDBType(field, dbInfo, dbType, dbExtra) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./fields/ABDField.js")), (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "./DatabaseVersion.js")), 'string', 'string');
        return field.compareDBType(dbInfo, dbType, dbExtra);
    }


    constructor(name, dbType, notNull, dbExtra) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', 'boolean', 'string');

        this.name = name;
        this.dbType = dbType === null ? null : dbType.toLowerCase();
        this.notNull = notNull;
        this.dbExtra = dbExtra;
    }
}

/* JSLib Exports */
_jsLib.export("default", FieldInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\helper.js
jsLibs.exportScript("ab-data", "./helper", [ "default" ], (_jsLib) => { "use strict"; 
class helper_Class {
    constructor() {

    }

    escapeString(str) {
        return str.replace(/\'/g, '\'\'');
    }

    unescapeString(str) {
        return str;
    }

    quote(str) {
        return str
            .replace(/\\/g, "\\\\")
            .replace(/\'/g, "\\\'")
            .replace(/\"/g, "\\\"")
            .replace(/\n/g, "\\\n")
            .replace(/\r/g, "\\\r")
            .replace(/\x00/g, "\\\x00")
            .replace(/\x1a/g, "\\\x1a");
    }
}
const helper = new helper_Class();
/* export default */ helper;

/* JSLib Exports */
_jsLib.export("default", helper); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\index.js
jsLibs.exportScript("ab-data", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./DatabaseInfo", [ { name: "default", alias: "DatabaseInfo" } ], "./DatabaseInfo.js");
_jsLib.importDeclaration("ab-data", "./fields/index", [ { name: "default", alias: "fields" } ], "./fields/index.js");
_jsLib.importDeclaration("ab-data", "./validators/index", [ { name: "default", alias: "validators" } ], "./validators/index.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./fields/ABDField.js");
_jsLib.importDeclaration("ab-data", "./Device", [ { name: "default", alias: "Device" } ], "./Device.js");
_jsLib.importDeclaration("ab-data", "./DataScheme", [ { name: "default", alias: "DataScheme" } ], "./DataScheme.js");
_jsLib.importDeclaration("ab-data", "./DataStore", [ { name: "default", alias: "DataStore" } ], "./DataStore.js");
_jsLib.importDeclaration("ab-data", "./DatabaseInfo", [  ], "./DatabaseInfo.js");
_jsLib.importDeclaration("ab-data", "./DatabaseVersion", [ { name: "default", alias: "DatabaseVersion" } ], "./DatabaseVersion.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "Field" } ], "./fields/ABDField.js");
_jsLib.importDeclaration("ab-data", "./FieldInfo", [ { name: "default", alias: "FieldInfo" } ], "./FieldInfo.js");
_jsLib.importDeclaration("ab-data", "./IndexInfo", [ { name: "default", alias: "IndexInfo" } ], "./IndexInfo.js");
_jsLib.importDeclaration("ab-data", "./Response", [ { name: "default", alias: "Response" } ], "./Response.js");
_jsLib.importDeclaration("ab-data", "./Result", [ { name: "default", alias: "Result" } ], "./Result.js");
_jsLib.importDeclaration("ab-data", "./RequestDef", [ { name: "default", alias: "RequestDef" } ], "./RequestDef.js");
_jsLib.importDeclaration("ab-data", "./RequestProcessor", [ { name: "default", alias: "RequestProcessor" } ], "./RequestProcessor.js");
_jsLib.importDeclaration("ab-data", "./RTableDef", [ { name: "default", alias: "RTableDef" } ], "./RTableDef.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "./SelectColumnType.js");
_jsLib.importDeclaration("ab-data", "./TableDef", [ { name: "default", alias: "TableDef" } ], "./TableDef.js");
_jsLib.importDeclaration("ab-data", "./TableInfo", [ { name: "default", alias: "TableInfo" } ], "./TableInfo.js");
_jsLib.importDeclaration("ab-data", "./TableRequestDef", [ { name: "default", alias: "TableRequestDef" } ], "./TableRequestDef.js");
_jsLib.importDeclaration("ab-data", "./Validator", [ { name: "default", alias: "Validator" } ], "./Validator.js");
_jsLib.importDeclaration("ab-data", "./languages/pl.ab-data", [ { name: "default", alias: "lang_PL_ABData" } ], "./languages/pl.ab-data.js");

class abData_Class {

    get debug() {
        return this._debug;
    }

    get fields() {
        return (_jsLib.import("ab-data", "./fields/index", "default", "fields", "./fields/index.js"));
    }

    get validators() {
        return (_jsLib.import("ab-data", "./validators/index", "default", "validators", "./validators/index.js"));
    }

    get ABDField() {
        return (_jsLib.import("ab-data", "./fields/index", "default", "fields", "./fields/index.js"))/(_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./fields/ABDField.js"));
    }

    get Device() {
        return (_jsLib.import("ab-data", "./Device", "default", "Device", "./Device.js"));
    }

    get DataScheme() {
        return (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js"));
    }

    get DataStore() {
        return (_jsLib.import("ab-data", "./DataStore", "default", "DataStore", "./DataStore.js"));
    }

    get DatabaseInfo() {
        return (_jsLib.import("ab-data", "./DatabaseInfo", "default", "DatabaseInfo", "./DatabaseInfo.js"));
    }

    get DatabaseVersion() {
        return (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "./DatabaseVersion.js"));
    }

    get Field() {
        return (_jsLib.import("ab-data", "./fields/ABDField", "default", "Field", "./fields/ABDField.js"));
    }

    get FieldInfo() {
        return (_jsLib.import("ab-data", "./FieldInfo", "default", "FieldInfo", "./FieldInfo.js"));
    }

    get IndexInfo() {
        return (_jsLib.import("ab-data", "./IndexInfo", "default", "IndexInfo", "./IndexInfo.js"));
    }

    get Response() {
        return (_jsLib.import("ab-data", "./Response", "default", "Response", "./Response.js"));
    }

    get Result() {
        return (_jsLib.import("ab-data", "./Result", "default", "Result", "./Result.js"));
    }

    get RequestDef() {
        return (_jsLib.import("ab-data", "./RequestDef", "default", "RequestDef", "./RequestDef.js"));
    }

    get RequestProcessor() {
        return (_jsLib.import("ab-data", "./RequestProcessor", "default", "RequestProcessor", "./RequestProcessor.js"));
    }

    get RTableDef() {
        return (_jsLib.import("ab-data", "./RTableDef", "default", "RTableDef", "./RTableDef.js"));
    }

    get SelectColumnType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "./SelectColumnType.js"));
    }

    get TableDef() {
        return (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js"));
    }

    get TableInfo() {
        return (_jsLib.import("ab-data", "./TableInfo", "default", "TableInfo", "./TableInfo.js"));
    }

    get TableRequestDef() {
        return (_jsLib.import("ab-data", "./TableRequestDef", "default", "TableRequestDef", "./TableRequestDef.js"));
    }

    get Validator() {
        return (_jsLib.import("ab-data", "./Validator", "default", "Validator", "./Validator.js"));
    }


    constructor() {
        this._debug = false;

        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).add('pl.abData', (_jsLib.import("ab-data", "./languages/pl.ab-data", "default", "lang_PL_ABData", "./languages/pl.ab-data.js")));
    }

    error(errorTitle, error) {
        if (!this.debug)
            return;

        console.error(errorTitle, error);
    }

    setDebug(debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');
        this._debug = debug;
    }
}
const abData = new abData_Class();
/* export default */ abData;

/* JSLib Exports */
_jsLib.export("default", abData); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\IndexInfo.js
jsLibs.exportScript("ab-data", "./IndexInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class IndexInfo {
    get columnInfos() {
        let columnInfos_Sorted = this._columnInfos.toSorted((a, b) => {
            b.position - a.position;
        });

        let columnInfos = [];
        for (let i = 0; i < columnInfos_Sorted.length; i++) {
            columnInfos.push({
                position: i,
                name: columnInfos_Sorted[i].name,
                desc: columnInfos_Sorted[i].desc,
            });
        }

        return columnInfos;
    }


    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);

        this._columnInfos = [];
    }

    addColumnInfo(seq, columnName, desc) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'boolean');

        for (let columnInfo of this._columnInfos) {
            if (seq === columnInfo.seq) {
                throw new Error(`Position '${seq}' already exists in` +
                        ` index '${this.name}'.`);
            }

            if (columnName === columnInfo.name) {
                throw new Error(`Index column '${columnName}' already exists in` +
                        ` index '${this.name}'.`);
            }
        }

        this._columnInfos.push({
            seq: seq,
            name: columnName,
            desc: desc,
        });
    }

    hasColumn(columnName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        for (let columnInfo of this._columnInfos) {
            if (columnInfo.columnName === columnName)
                return true;
        }

        return false;
    }
}
/* export default */ IndexInfo;

/* JSLib Exports */
_jsLib.export("default", IndexInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\RequestDef.js
jsLibs.exportScript("ab-data", "./RequestDef", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class RequestDef {

    static ExtendDef(def, extDef) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        let newDef = {};

        for (let argName in def)
            newDef[argName] = def[argName];

        for (let argName in extDef)
            newDef[argName] = extDef;

        return newDef;
    }

    constructor() {
        this._actionDefs = {};
    }

    defA(actionName, actionType, argsDef, resultDef) {
        this.defAction(actionName, actionType, argsDef, resultDef);

        return this;
    }

    defAction(actionName, actionType, argsDef, resultDef) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'r', 'w' ]), 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        resultDef._type = 'int';
        resultDef._message = 'string';

        // if (actionType === 'w') {
            // if (!('success' in resultDef))
            //     throw new Error(`No 'success' in action result definition.`);

            // if (resultDef.success !== 'boolean')
            //     throw new Error(`'success' part in action result must be a 'boolean'.`);
        // }

        this._actionDefs[actionName] = {
            type: actionType,
            argsDef: argsDef,
            resultDef: resultDef,
        };

        return this;
    }

    getADef(actionName) {
        return this.getActionDef(actionName);
    }

    getActionDef(actionName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (!(actionName in this._actionDefs))
            throw new Error(`Action '${actionName}' does not exist.`);

        return this._actionDefs[actionName];
    }

    hasActionDef(actionName) {
        return actionName in this._actionDefs;
    }

    undefA(actionName) {
        this.undefAction(actionName);

        return this;
    }

    undefAction(actionName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (!(actionName in this._actionDefs))
            throw new Error(`Action '${actionName}' does not exist.`);

        delete this._actionDefs[actionName];

        return this;
    }

}
/* export default */ RequestDef;

/* JSLib Exports */
_jsLib.export("default", RequestDef); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\RequestProcessor.js
jsLibs.exportScript("ab-data", "./RequestProcessor", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./DataScheme", [ { name: "default", alias: "DataScheme" } ], "./DataScheme.js");
_jsLib.importDeclaration("ab-data", "./Device", [ { name: "default", alias: "Device" } ], "./Device.js");
_jsLib.importDeclaration("ab-data", "./Response", [ { name: "default", alias: "Response" } ], "./Response");

class RequestProcessor {

    get device() {
        return this._device;
    }

    get scheme() {
        return this._scheme;
    }


    constructor(dataScheme, device) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DataScheme", "default", "DataScheme", "./DataScheme.js")), [ (_jsLib.import("ab-data", "./Device", "default", "Device", "./Device.js")), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        this._scheme = dataScheme;
        this._device = device;

        this._processingQueue = [];
        this._nextProcessingId = 0;
    }

    async processRequest_Async(requestName, actionName, actionArgs, 
            transactionId = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, [ 'int', 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let response = await this.processRequestBatch_Async([
            [ 'request', requestName, actionName, actionArgs, this.scheme.version ],
        ]);

        if (response === null)
            return null;

        return response;
    }

    async processRequestBatch_Async(requests, transactionId = null) { 
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let processingId = this._nextProcessingId;
        this._nextProcessingId++;

        this._processingQueue.push({
            processingId: processingId,
            requests: requests,
            transactionId: transactionId,
        });

        let response = await this._processRequestBatchHelper_Async(processingId, 
                requests, transactionId);

        // let response = await this.__processRequestBatch_Async(requests, 
        //         transactionId);

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(response, (_jsLib.import("ab-data", "./Response", "default", "Response", "./Response")));

        return response;
    }


   _processRequestBatchHelper_Async(processingId, requests, transactionId) {
        return new Promise((resolve, reject) => {
            if (this._processingQueue[0].processingId === processingId) {
                this.__processRequestBatch_Async(requests, transactionId)
                        .then((response) => {
                    this._processingQueue.splice(0, 1);
                    resolve(response);
                });
                return;
            }

            setTimeout(() => {
                resolve(this._processRequestBatchHelper_Async(processingId,
                        requests, transactionId));
            }, 50);
        });
    }


    async __processRequestBatch_Async(requests, transactioId) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

}
/* export default */ RequestProcessor;

/* JSLib Exports */
_jsLib.export("default", RequestProcessor); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\Response.js
jsLibs.exportScript("ab-data", "./Response", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "./index.js");
_jsLib.importDeclaration("ab-data", "./Result", [ { name: "default", alias: "Result" } ], "./Result.js");

class Response {
    static get ResultTypes_Success() {
        return 0;
    }

    static get ResultTypes_Failure() {
        return 1;
    }

    static get ResultTypes_Error() {
        return 2;
    }

    static get Types_Success() {
        return 0;
    }

    static get Types_ResultFailure() {
        return 1;
    }

    static get Types_ResultError() {
        return 2;
    }

    static get Types_ActionError() {
        return 3;
    }

    static get Types_Error() {
        return 4;
    }


    static Create(response) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        let r = new Response();
        r.parseRawObject(response);

        return r;
    }


    constructor() {
        this.actionErrors = {};
        this.type = Response.Types_Success;
        this.errorMessage = null;
        this.info = {};
        this.results = {};
        this.requestIds = [];
    }

    getErrorInfo() {
        if ('webResult' in this.info) {
            let webResult = this.info.webResult;

            let webResultError = webResult.getErrorInfo();
            if (webResultError !== null)
                return webResultError;
        }

        if (this.type === (_jsLib.import("ab-data", "./index", "default", "abData", "./index.js")).Response.Types_Error) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Errors_Response_Other'),
                message: this.errorMessage,
            };
        } else if (this.type === (_jsLib.import("ab-data", "./index", "default", "abData", "./index.js")).Response.Types_ActionError) {
            let actionErrors = [];
            for (let actionName in this.actionErrors) {
                actionErrors.push('[ ' + actionName + ' -> ' + 
                        this.actionErrors[actionName] + ' ]');
            }

            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Errors_Response_ActionError'),
                message: actionErrors.length === 0 ? 
                        this.errorMessage : actionErrors.join(', '),
            };
        }

        return null;
    }

    getMessage() {
        return this.errorMessage;
    }

    getResult(actionName = (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (this.type >= 3)
            return new (_jsLib.import("ab-data", "./Result", "default", "Result", "./Result.js"))(this, null);

        if (actionName === (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet) {
            let resultsCount = 0;
            for (let actionName in this.results) {
                if (actionName[0] !== '_')
                    resultsCount++;
            }
            if (resultsCount > 1)
                throw new Error(`You must specify 'actionName' in batch request.`);

            actionName = 'request';
        }

        if (!(actionName in this.results)) {
            if (actionName in this.actionErrors)
                return new (_jsLib.import("ab-data", "./Result", "default", "Result", "./Result.js"))(this, null, this.actionErrors[actionName]);

            return new (_jsLib.import("ab-data", "./Result", "default", "Result", "./Result.js"))(this, null, null);
        }

        return new (_jsLib.import("ab-data", "./Result", "default", "Result", "./Result.js"))(this, this.results[actionName], null);
    }

    isSuccess() {
        return this.type < 2;
    }

    parseRawObject(response) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        this.actionErrors = response.actionErrors;
        this.type = response.type;
        this.errorMessage = response.errorMessage;
        this.info = response.info;
        this.results = response.results;
        this.requestIds = response.requestIds;
    }
}
/* export default */ Response;

/* JSLib Exports */
_jsLib.export("default", Response); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\Result.js
jsLibs.exportScript("ab-data", "./Result", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./Response", [ { name: "default", alias: "Response" } ], "./Response.js");

/* export default */ class Result {
    static get Types_Success() {
        return 0;
    }

    static get Types_Failure() {
        return 1;
    }

    static get Types_Error() {
        return 2;
    }


    get data() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TRawObject, () => {
        return this._data;
    })}

    get message() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    'string', () => {
        return this._data === null ? 
                this._response.message : this._data._message;
    })}


    constructor(response, resultData, actionError) { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    (_jsLib.import("ab-data", "./Response", "default", "Response", "./Response.js")), [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).TRawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
    '', () => {
        if (resultData !== null) {
            (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(resultData, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                _type: 'int',
                _message: 'string',
            }, true));
        }

        this._response = response;
        this._data = resultData;
    })}

    getErrorInfo() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({ title: 'string', message: 'string' }), () => {
        if (!this._response.isSuccess())
            return this._response.getErrorInfo();

        return {
             title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Errors_Result_Error'),
             message: this.data._message,
        };
    })}

    isError() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    'boolean', () => {
        if (this._data === null)
            return true;

        return this._data._type === Result.Types_Error;
    })}

    isFailure() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    'boolean', () => {
        if (this._data === null)
            return false;

        return this._data._type === Result.Types_Failure;
    })}

    isSuccess() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    'boolean', () => {
        if (this._data === null)
            return false;

        return this._data._type === Result.Types_Success;
    })}
}

/* JSLib Exports */
_jsLib.export("default", Result); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\RTableDef.js
jsLibs.exportScript("ab-data", "./RTableDef", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/index", [ { name: "default", alias: "f" } ], "./fields/index.js");

_jsLib.importDeclaration("ab-data", "./TableDef", [ { name: "default", alias: "TableDef" } ], "./TableDef.js");

class RTableDef extends (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js")) {

    constructor(id, name, alias, columns) {   
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', Array);

        if (name[0] !== '_') {
            columns = [
                [ '_Id', (_jsLib.import("ab-data", "./fields/index", "default", "f", "./fields/index.js")).Id({ notNull: true, }) ],
                [ '_Modified_DateTime', (_jsLib.import("ab-data", "./fields/index", "default", "f", "./fields/index.js")).Long({ notNull: false, }) ],
                // [ '_Modified_DeviceId', fields.Long({}) ],
            ].concat(columns);
        }

        super(id, name, alias, columns);

        this.setPKs([ '_Id' ]);

        // this.addIndex('_Modified_DateTime', '_Modified_DateTime DESC');
    }

}
/* export default */ RTableDef;

/* JSLib Exports */
_jsLib.export("default", RTableDef); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\SelectColumnType.js
jsLibs.exportScript("ab-data", "./SelectColumnType", [ "default" ], (_jsLib) => { "use strict"; class SelectColumnType {
    static get $Values() {
        return [
            SelectColumnType.Bool,
            SelectColumnType.Float,
            SelectColumnType.Int,
            SelectColumnType.Long,
            SelectColumnType.JSON,
            SelectColumnType.String,
        ];
    }

    static get Bool() { return 0; }
    static get Float() { return 1; }
    static get Int() { return 2; }
    static get Long() { return 3; }
    static get JSON() { return 4; }
    static get String() { return 5; }
}
/* export default */ SelectColumnType;

/* JSLib Exports */
_jsLib.export("default", SelectColumnType); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\TableDef.js
jsLibs.exportScript("ab-data", "./TableDef", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./fields/index", [ { name: "default", alias: "f" } ], "./fields/index.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./validators/ABDFieldValidator.js");
_jsLib.importDeclaration("ab-data", "./Validator", [ { name: "default", alias: "Validator" } ], "./Validator.js");

class Table {
    get alias() {
        return this._alias;
    }

    get autoIncrement() {
        return this._autoIncrement !== null;
    }

    get columns() {
        return this._columns;
    }

    get indexes() {
        return this._indexes;
    }

    get name() {
        return this._name;
    }

    get pks() {
        if (this._autoIncrementColumn !== null)
            return [ this._autoIncrementColumn ];

        return this._primaryKeys;
    }

    constructor(id, name, alias, columns) {   
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', Array);

        this._id = id;
        this._name = name;
        this._alias = alias;
        this._primaryKeys = null;
        this._autoIncrementColumn = null;
        this._columns = null;
        this._columnValidators = {};
        this._indexes = {};

        this._columns = new (_jsLib.import("js0", "./index", "default", "js0", "js0")).List();
        for (let column of columns) {
            let name = column[0];
            let field = column[1];
            let fieldValidatorInfo = column.length > 2 ? column[2] : {};

            this._columns.set(name, {
                field: field,
                fieldValidator: field.getFieldValidator(fieldValidatorInfo),
                index: this._columns.size,
                select: name,
            });

            if (field instanceof (_jsLib.import("ab-data", "./fields/index", "default", "f", "./fields/index.js")).ABDAutoIncrementId) {
                this._autoIncrementColumn = name;
                this._primaryKeys = null;
            }
        }
    }

    addColumnValidator(columnName, fieldValidator) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./validators/ABDFieldValidator.js")));

        if (!this.hasColumn(columnName))
            throw new Error(`Column '${columnName}' does not exist.`);

        if (!(columnName in this._columnValidators))
            this._columnValidators[columnName] = [];

        this._columnValidators[columnName].push(fieldValidator);

        return this;
    }

    getColumn(columnName) {
        if (!this._columns.has(columnName))
            throw new Error(`Column '${columnName}' does not exist.`);

        return this._columns.get(columnName);
    }

    getColumn_Field(columnName) {
        return this.getColumn(columnName).field;
    }

    getColumnIndex(columnName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return this.getColumn(columnName).index;
    }

    getColumnNames() {
        return this._columns.keys();
    }

    getColumnValidators(columnName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        let column = this.getColumn(columnName);
        let validators = [ column.fieldValidator ];
        if (!(columnName in this._columnValidators))
            return validators;

        for (let columnValidator of this._columnValidators(columnName))
            validators.push(columnValidator);

        return validators;
    }

    getSelectColumnInfo(columnName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        let column = this.getColumn(columnName);

        return [ column.select, column.field ];
    }

    getTableId() {
        return this._id;
    }

    getTableName() {
        return this._name;
    }

    getValidatorInfos() {
        let validatorInfo = {};
        for (let [ columnName, column ] of this._columns) {
            validatorInfo[columnName] = {
                field: {
                    type: column.fieldValidator.getType(),
                    args: column.fieldValidator.args,
                },
                validators: [],
            };

            if (columnName in this._columnValidators) {
                for (let columnValidator of this._columnValidators[columnName]) {
                    validatorInfo[columnName].validators.push({
                        type: columnValidator.getType(),
                        args: columnValidator.args,
                    });
                }
            }
        }

        return validatorInfo;
    }
    
    hasColumn(columnName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return this._columns.has(columnName);
    }

    setIndexes(indexes) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).ObjectItems((_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems(
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', 'boolean' ]))));
        
        for (let indexName in indexes) {
            for (let indexColumn of indexes[indexName]) {
                let columnName = indexColumn[0];
                if (!this.hasColumn(columnName))
                        throw new Error(`Index column '${columnName}' does not exist.`);
            }
        }
        
        this._indexes = [];
        for (let indexName in indexes) {
            this._indexes[this.name + '-' + indexName] = [];
            for (let indexColumn of indexes[indexName]) {
                this._indexes[this.name + '-' + indexName].push({
                    name: indexColumn[0], 
                    desc: indexColumn[1],
                });
            }
        }

        return this;
    }

    setPKs(primaryKeys) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems('string'));

        if (this._autoIncrementColumn !== null)
            throw new Error(`Cannot set PKs for the table with 'ABDAutoIncrement' column.`);

        for (let columnName of primaryKeys) {
            if (!this.hasColumn(columnName))
                throw new Error(`Cannot set PKs. Column '${columnName}' does not exist.`);
            if (!this._columns.get(columnName).field.notNull)
                throw new Error(`Primary Key '${columnName}' must be 'notNull'.`);
        }

        this._autoIncrementColumn = null;
        this._primaryKeys = primaryKeys;

        return this;
    }

    setRowParser(parserFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._rowParser = parserFn;
    }

    validateColumn(validator, validatorFieldName, columnName, value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./Validator", "default", "Validator", "./Validator.js")), 'string', 'string', null);

        validator.addField(validatorFieldName, value);

        let column = this.getColumn(columnName);
        // let column_ValidatorField = column.field.getFieldValidator(
        //         column.fieldValidatorInfo);

        validator.addFieldValidator(validatorFieldName, column.fieldValidator);
        if (columnName in this._columnValidators) {
            for (let fieldValidator of this._columnValidators[columnName])
                validator.addFieldValidator(validatorFieldName, fieldValidator);
        }
    }

    validateRow(validator, row, columns = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./Validator", "default", "Validator", "./Validator.js")), (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default() ]);

        if (columns === null) {
            columns = {};
            for (let [ columnName, column ] of this.columns)
                columns[columnName] = columnName;
        }

        for (let columnName in columns) {
            if (!(columnName in row))
                throw new Error(`Column '${columnName}' not set in row.`);
            if (typeof row[columnName] === 'undefined')
                throw new Error(`Column '${columnName}' is 'undefined' in row.`);

            this.validateColumn(validator, columns[columnName], columnName,
                    row[columnName]);
        }
    }

    validateRow_Default(validator, row, ignoreColumns = []) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./Validator", "default", "Validator", "./Validator.js")), (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default() ]);

        let columns = {};
        for (let [ columnName, column ] of this.columns) {
            if (columnName === '_Modified_DateTime')
                continue;

            if (!ignoreColumns.includes(columnName))
                columns[columnName] = columnName;
        }

        this.validateRow(validator, row, columns);
    }

    validateRow_Default_Columns(validator, row, columnNames = []) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./Validator", "default", "Validator", "./Validator.js")), (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default() ]);

        let columns = {};
        for (let columnName of columnNames) {
            if (!this.hasColumn(columnName))
                throw new Error(`Column '${columnName}' does not exist.`);

            columns[columnName] = columnName;
        }

        this.validateRow(validator, row, columns);
    }
}
/* export default */ Table;

/* JSLib Exports */
_jsLib.export("default", Table); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\TableInfo.js
jsLibs.exportScript("ab-data", "./TableInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./fields/ABDAutoIncrementId", [  ], "./fields/ABDAutoIncrementId.js");
_jsLib.importDeclaration("ab-data", "./DatabaseVersion", [ { name: "default", alias: "DatabaseVersiob" } ], "./DatabaseVersion.js");
_jsLib.importDeclaration("ab-data", "./TableDef", [ { name: "default", alias: "TableDef" } ], "./TableDef.js");
_jsLib.importDeclaration("ab-data", "./FieldInfo", [ { name: "default", alias: "FieldInfo" } ], "./FieldInfo.js");
_jsLib.importDeclaration("ab-data", "./IndexInfo", [ { name: "default", alias: "IndexInfo" } ], "./IndexInfo.js");

class TableInfo {
    static GetQuery_Create(dbVersion, tableDef) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersiob", "./DatabaseVersion.js")), (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js")));

        let query = `CREATE TABLE \`${tableDef.name}\` (`;
        let fields = [];
        
        for (let [ columnName, column ] of tableDef.columns) {
            let field = column.field;
            let field_DBExtra = field.getDBExtra(dbVersion);
            fields.push(`\`${columnName}\` ` + field.getDBType(dbVersion) + 
                    (field.notNull ? ' NOT NULL' : ' NULL') +
                    (field_DBExtra === '' ? '' : ` ${field_DBExtra}`));
        }

        query += fields.join(', ');

        // let createPrimaryKeys = true;
        // console.log('Test', dbVersion);
        // if (dbVersion.type === 'sqlite') {
        //     for (let [ columnName, column ] of tableDef.columns) {
        //         console.log(column.field.__getType());
        //         if (column.field instanceof ABDAutoIncrementId) {
        //             console.log('False');
        //             createPrimaryKeys = false;
        //             break;
        //         }
        //     }
        // }
        // if (createPrimaryKeys)
        query += `, PRIMARY KEY (` + tableDef.pks.join(', ') + `)`;
        
        query += `)`;

        return query;
    }


    get fieldInfos() {
        return this._fieldInfos;
    }

    get indexInfos() {
        return this._indexInfos;
    }

    get name() {
        return this._name;
    }

    get pks() {
        return this._primaryKeys;
    }


    constructor(name) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        this._name = name;
        this._fieldInfos = [];
        this._indexInfos = {};
        this._primaryKeys = null;
        this._charset = 'utf8';
        this._collation = 'utf8_general_ci';
    }

    addFieldInfo(fieldInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./FieldInfo", "default", "FieldInfo", "./FieldInfo.js")));

        this._fieldInfos.push(fieldInfo);
    }

    addIndexInfo(indexName, indexInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-data", "./IndexInfo", "default", "IndexInfo", "./IndexInfo.js")));

        this._indexInfos[indexName] = indexInfo;
    }

    getFieldInfo_ByName(fieldName) {
        for (let fieldInfo of this.fieldInfos) {
            if (fieldInfo.name === fieldName)
                return fieldInfo;
        }

        return null;
    }

    // setIndexes(indexes) {
    //     js0.args(arguments, js0.ObjectItems(js0.ArrayItems(
    //             js0.PresetArray([ 'string', 'boolean' ]))));

    //     this._indexInfos = new IndexInfos();
    //     for (let indexName in indexes) {
    //         for (let i = 0; i < indexes[indexName].length; i++) {
    //             let columnName = indexes[indexName][i][0];
    //             let desc = indexes[indexName][i][1];

    //             this.indexInfos.add(indexName, i, columnName, desc);
    //         }
    //     }
    // }

    setPKs(pks) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems('string'));

        for (let pk of pks) {
            let pkFound = false;
            for (let fieldInfo of this._fieldInfos) {
                if (fieldInfo.name === pk) {
                    pkFound = true;
                    break;
                }
            }

            if (!pkFound)
                throw new Error(`PK '${pk}' does not exist in field infos.`);
        }

        this._primaryKeys = pks;

        return this;
    }

}
/* export default */ TableInfo;

/* JSLib Exports */
_jsLib.export("default", TableInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\TableRequestDef.js
jsLibs.exportScript("ab-data", "./TableRequestDef", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./fields/ABDField.js");
_jsLib.importDeclaration("ab-data", "./RequestDef", [ { name: "default", alias: "RequestDef" } ], "./RequestDef.js");
_jsLib.importDeclaration("ab-data", "./TableDef", [ { name: "default", alias: "TableDef" } ], "./TableDef.js");

class TableRequestDef extends (_jsLib.import("ab-data", "./RequestDef", "default", "RequestDef", "./RequestDef.js")) {
    static Args_Delete() {
        return {
            where: [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
        };
    }

    static Args_Select() {
        return {
            assoc: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            selectColumns: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray(
                    [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./fields/ABDField.js")) ]) ])), 
                    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            selectColumnNames: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems('string'), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            where: [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
            orderBy: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', 'boolean' ])), 
                    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
            groupBy: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable('string'), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            limit: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int ]), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 
                    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            join: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                selectColumns: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray(
                        [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./fields/ABDField.js")) ]) ])), 
                        (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
                selectColumnNames: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems('string'), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
                type: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'left', 'inner' ]), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('left') ],
                prefix: 'string',
                tableDef: (_jsLib.import("ab-data", "./TableDef", "default", "TableDef", "./TableDef.js")),
                on: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', 'string' ])),
                where: [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
                orderBy: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', 'boolean' ])), 
                        (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
                groupBy: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable('string'), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
                    })), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
                query_OrderBy: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
                // query_Where: [ 'string', js0.Null, js0.Default(null) ],
        };
    }


    constructor(readOnly = false) {
        super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
   
        this
            .defA('row', 'r',
                TableRequestDef.Args_Select(), {
                row: [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                
                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            })
            .defA('select', 'r',
                TableRequestDef.Args_Select(), {
                rows: [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],

                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            })

        if (!readOnly) {
            this
                .defA('delete', 'w', {
                    where: (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems(Array),
                }, {
                    success: 'boolean',
                    error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                })
                .defA('set', 'w', {
                    row: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                }, {
                    success: 'boolean',
                    error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                })
                .defA('update', 'w', {
                    rows: (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems((_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject),
                    keys: [ '_Id' ],
                }, {
                    success: 'boolean',
                    error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                });
        }
    }
}
/* export default */ TableRequestDef;

/* JSLib Exports */
_jsLib.export("default", TableRequestDef); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\test.js
jsLibs.exportScript("ab-data", "./test", [  ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("..js", "./index", [ { name: "default", alias: "abData" } ], "..js");

    f = (_jsLib.import("..js", "./index", "default", "abData", "..js")).fields,
    s = (_jsLib.import("..js", "./index", "default", "abData", "..js")).scheme


let tSys_Bulls = new (_jsLib.import("..js", "./index", "default", "abData", "..js")).Table('Sys_Bulls', 's_b', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],

    [ 'Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'FullName', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Nr', f.String(20, { notNull: true, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'ManufacturerNr', f.String(9, { notNull: true, }), {
        required: false,
    }],
    [ 'Race', f.String(2, { notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.DateTime({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(64, { notNull: true, }) ],
]);

let v = new (_jsLib.import("..js", "./index", "default", "abData", "..js")).Validator();

// tSys_Bulls.validateColumn(v, 'Nr', 'Nr', 'AB123456789012');
tSys_Bulls.validateRow(v, {
    'Nr': 'AB123456789012',
}, {
    'Nr': 'Nr',
});

if (!v.isValid()) {
    for (let fieldName in v.getInfo().fields) {
        if (!v.getInfo().fields.valid)
            console.log(fieldName, v.getInfo().fields[fieldName].errors);
    }
} else
    console.log('Valid!');


// let v = new abData.Validator();

// v.addField('test1', 'My test string');
// v.addFieldValidator('test1', abData.validators.String());

// v.addField('test2', '5');
// v.addFieldValidator('test2', abData.validators.Int({
//     minValue: 1,
//     maxValue: 10,
// }));

// console.log(v.isValid());

// if (!v.isValid()) {
//     console.log(v.getInfo().fields['test1'].errors);
//     console.log(v.getInfo().fields['test2'].errors);
// }

// console.log(v.getInfo());

/* JSLib Exports */ });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\Validator.js
jsLibs.exportScript("ab-data", "./Validator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./validators/ABDFieldValidator.js");

/* export default */ class Validator {
    constructor() {
        this._info =  {
            'valid': true,
            'fields': {},
            'state': '',
            'errors': [],
        };
    }

    addField(fieldName, fieldValue) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', null);

        this._fields_Add(fieldName, fieldValue);
    }

    addFieldValidator(fieldName, fieldValidator) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./validators/ABDFieldValidator.js")));

        if (!this.hasField(fieldName))
            throw new Error(`Field '${fieldName}' does not exist.`);

        fieldValidator.validate(this, fieldName, this._info.fields[fieldName].value);
    }

    getFieldInfo(fieldName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (!fieldName in this._info['fields'])
            throw new Error(`Field '${fieldName}' does not exist.`);

        return this._info['fields'][fieldName];
    }

    getInfo() {
        return this._info;
    }

    error(message) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        this._info['valid'] = false;
        this._info['errors'].push(message);
    }

    fieldError(fieldName, message) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        let field = this._fields_Get(fieldName);

        this._info['valid'] = false;
        this._info['state'] = 'error';

        field['valid'] = false;
        field['errors'].push(message);
    }

    hasField(fieldName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return fieldName in this._info['fields'];
    }

    isFieldValid(fieldName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return this.getFieldInfo(fieldName).valid;
    }

    isValid() {
        return this._info['valid'];
    }


    _fields_Add(fieldName, fieldValue) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', null);

        this._info['fields'][fieldName] = {
            'valid': true,
            'value': fieldValue,
            'state': '',
            'errors': [],
            'warnings': [],
            'successes': [],
        };

        return this._info['fields'][fieldName];
    }

    _fields_Get(fieldName) {
        if (!this.hasField(fieldName))
            throw new Error(`Field '${fieldName}' does not exist.`);

        return this._info.fields[fieldName];
    }

    // _fields_Exists(fieldName)
    // {
    //     return fieldName in this._info['fields'];
    // }
}

/* JSLib Exports */
_jsLib.export("default", Validator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDArray_WIP.js
jsLibs.exportScript("ab-data", "./fields/ABDArray_WIP", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");


class ABDArray extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    constructor(properties) {
        super([], properties);
    }

    
    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array);

        return value;
    }

}
/* export default */ ABDArray;


/* JSLib Exports */
_jsLib.export("default", ABDArray); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDBlob.js
jsLibs.exportScript("ab-data", "./fields/ABDBlob", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

_jsLib.importDeclaration("ab-data", "./helper", [ { name: "default", alias: "helper" } ], "../helper.js");

class ABDBlob extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    get type() {
        return this._type;
    }

    get _typeSizes() {
        return {
            tiny:       256,
            regular:    65535,
            medium:     16777215,
        };
    }

    constructor(type, properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'tiny', 'regular', 'medium' ]), 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        super([ type ], properties);

        this._type = type;
    }


    __compareDBType(dbVersion, dbType) {
        if (this.type === 'tiny')
            return dbType === 'tinyblob';
        if (this.type === 'regular')
            return dbType === 'blob';
        if (this.type === 'medium')
            return dbType === 'mediumblob';

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(false, `Unknown 'text' field type.`);
    }

    __getDBExtra() {
        return '';
    }

    __getDBType(dbVersion) {
        if (this.type === 'tiny')
            return 'tinyblob';
        if (this.type === 'regular')
            return 'blob';
        if (this.type === 'medium')
            return 'mediumblob';

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(false, `Unknown 'text' field type.`);
    }

    __getDefaultValue() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        if (!('maxLength' in fieldValidatorInfo))
            fieldValidatorInfo['maxLength'] = this._typeSizes[this.type];

        return new ABDStringValidator(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).String;
    }

    __getType() {
        return 'Text';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return (_jsLib.import("ab-data", "./helper", "default", "helper", "../helper.js")).escapeString(value);
    }

    __unescape(value) {
        return value;
    }

}
/* export default */ ABDBlob;


/* JSLib Exports */
_jsLib.export("default", ABDBlob); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDAutoIncrementId.js
jsLibs.exportScript("ab-data", "./fields/ABDAutoIncrementId", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDIntValidator", [ { name: "default", alias: "ABDIntValidator" } ], "../validators/ABDIntValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

class ABDAutoIncrementId extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {
    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);
        super([], { notNull: true, });
    }


    __compareDBType(dbVersion, dbType, dbExtra) {
         if (dbVersion.type === 'sqlite')
            return dbType === 'integer';

        if (dbExtra !== 'auto_increment')
            return false;

        return dbType === 'int';        
    }

    __getDBType(dbVersion) {
        if (dbVersion.type === 'sqlite')
            return 'integer';

        return 'int';
    }

    __getDefaultValue() {
        return 0;
    }

    __getDBExtra(dbVersion) {
        if (dbVersion.type === 'sqlite')
            return '';

        return 'auto_increment';
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDIntValidator", "default", "ABDIntValidator", "../validators/ABDIntValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Int;
    }

    __getType() {
        return 'AutoIncrementId';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return String(Math.round(value));
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return Math.round(value);
    }

    __unescape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, null);
            
        return parseInt(value);
    }
}
/* export default */ ABDAutoIncrementId;


/* JSLib Exports */
_jsLib.export("default", ABDAutoIncrementId); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDBool.js
jsLibs.exportScript("ab-data", "./fields/ABDBool", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDBoolValidator", [ { name: "default", alias: "ABDBoolValidator" } ], "../validators/ABDBoolValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");


class ABDBool extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    constructor(properties) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return dbType === 'tinyint(1)' || dbType === 'bool';
    }

    __getDBType(dbVersion) {
        return 'tinyint(1)'
    }

    __getDefaultValue() {
        return false;
    }

     __getDBExtra(dbVersion) {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDBoolValidator", "default", "ABDBoolValidator", "../validators/ABDBoolValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Bool;
    }

    __getDBType() {
        return 'Bool';
    }

    __getType() {
        return 'Bool';
    }

    __getValidatorType() {
        return 'bool';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        if (this.__parse(value))
            return '1';

        return '0';
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        if (value)
            return true;

        return false;
    }

    __unescape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        return value ? true : false;
    }

}
/* export default */ ABDBool;


/* JSLib Exports */
_jsLib.export("default", ABDBool); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDData_WIP.js
jsLibs.exportScript("ab-data", "./fields/ABDData_WIP", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField");

/* export default */ class ABDData extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField")) {

    constructor(properties) {
        super([], properties);
    }

}


/* JSLib Exports */
_jsLib.export("default", ABDData); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDDate.js
jsLibs.exportScript("ab-data", "./fields/ABDDate", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDStringValidator", [ { name: "default", alias: "ABDStringValidator" } ], "../validators/ABDStringValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

_jsLib.importDeclaration("ab-data", "./helper", [ { name: "default", alias: "helper" } ], "../helper.js");

class ABDDate extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {
    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return dbType === 'datetime';
    }

    __getDBType(dbVersion) {
        return 'datetime'
    }

    __getDefaultValue() {
        return '0000-00-00'; // length: 10
    }

    __getDBExtra() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        // if (!('maxLength' in fieldValidatorInfo))
        //     fieldValidatorInfo['maxLength'] = this.size;

        return new (_jsLib.import("ab-data", "./validators/ABDStringValidator", "default", "ABDStringValidator", "../validators/ABDStringValidator.js"))({ maxLength: 10 });
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).String;
    }

    __getType() {
        return 'String';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return (_jsLib.import("ab-data", "./helper", "default", "helper", "../helper.js")).escapeString(value);
    }

    __unescape(value) {
        return value;
    }
}
/* export default */ ABDDate;


/* JSLib Exports */
_jsLib.export("default", ABDDate); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDDateTime.js
jsLibs.exportScript("ab-data", "./fields/ABDDateTime", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDStringValidator", [ { name: "default", alias: "ABDStringValidator" } ], "../validators/ABDStringValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

_jsLib.importDeclaration("ab-data", "./helper", [ { name: "default", alias: "helper" } ], "../helper.js");

class ABDDateTime extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {
    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return dbType === 'datetime';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __getDBType(dbVersion) {
        return 'datetime'
    }

    __getDefaultValue() {
        return '0000-00-00 00:00:00'; // length: 19
    }

    __getDBExtra() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        // if (!('maxLength' in fieldValidatorInfo))
        //     fieldValidatorInfo['maxLength'] = this.size;

        return new (_jsLib.import("ab-data", "./validators/ABDStringValidator", "default", "ABDStringValidator", "../validators/ABDStringValidator.js"))({ maxLength: 19 });
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).String;
    }

    __getType() {
        return 'String';
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return (_jsLib.import("ab-data", "./helper", "default", "helper", "../helper.js")).escapeString(value);
    }

    __unescape(value) {
        return value;
    }
}
/* export default */ ABDDateTime;


/* JSLib Exports */
_jsLib.export("default", ABDDateTime); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDField.js
jsLibs.exportScript("ab-data", "./fields/ABDField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");
_jsLib.importDeclaration("ab-data", "./DatabaseVersion", [ { name: "default", alias: "DatabaseVersion" } ], "../DatabaseVersion.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "../validators/ABDFieldValidator.js");

class ABDField {
    get args() {
        return this._args;
    }

    get defaultValue() {
        return this._properties.defaultValue === (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet ? 
                (this._properties.notNull ? this.__getDefaultValue() : null) :
                this._properties.defaultValue;
    }

    get notNull() {
        return this._properties.notNull;
    }

    get properties() {
        return this._properties;
    }


    constructor(args, properties) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(properties, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            notNull: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(false) ],
            defaultValue: [ null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet) ],
        }));

        this._args = args;
        this._properties = properties;
    }

    compareDBType(dbVersion, dbType, dbExtra) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "../DatabaseVersion.js")), 'string', 'string');
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn('boolean', this.__compareDBType(dbVersion, dbType, dbExtra));
    }

    getDBType(dbVersion) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "../DatabaseVersion.js")));
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn('string', this.__getDBType(dbVersion));
    }

    getDBExtra(dbVersion) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "../DatabaseVersion.js")));
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn('string', this.__getDBExtra(dbVersion));
    }

    getSelectType() {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum((_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).$Values), 
                this.__getSelectType());
    }

    getQuery_Column(dbVersion, columnName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./DatabaseVersion", "default", "DatabaseVersion", "../DatabaseVersion.js")), 'string');

        let dbExtra = this.getDBExtra(dbVersion);
        return `\`${columnName}\` ` + this.getDBType(dbVersion) + (this.notNull ? 
                ' NOT NULL' : ' NULL') + (dbExtra === '' ? '' : ` ${dbExtra}`);
    }

    escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, null);

        if (value === null)
            return 'NULL';

        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn('string', this.__escape(value));
    }

    escapeArray(arr) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array);

        let arr_Escaped = [];
        for (let val of arr)
            arr_Escaped.push(this.escape(val));

        return '(' + arr_Escaped.join(',') + ')';
    }

    getFieldValidator(fieldValidatorInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        if (!('notNull' in fieldValidatorInfo))
            fieldValidatorInfo['notNull'] = this.properties['notNull'];

        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "../validators/ABDFieldValidator.js")), this.__getFieldValidator(fieldValidatorInfo));
    }

    parse(value) {
        if (value === null)
            return null;

        return this.__parse(value);
    }

    unescape(value) {
        if (value === null)
            return null;

        return this.__unescape(value);
    }


    __unescape(value) { 
        return value;
    }
    

    __compareDBType(dbVersion, dbType, dbExtra) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getDBExtra(dbVersion) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getDBType(dbVersion) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getDefaultValue() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getFieldValidator(fieldValidatorInfo) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getSelectType() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getType(dbVersion) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __escape(value) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __parse(value) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

}
/* export default */ ABDField;


/* JSLib Exports */
_jsLib.export("default", ABDField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDFloat.js
jsLibs.exportScript("ab-data", "./fields/ABDFloat", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDFloatValidator", [ { name: "default", alias: "ABDFloatValidator" } ], "../validators/ABDFloatValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

class ABDFloat extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    constructor(properties) {
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return dbType === 'float';
    }

    __getDefaultValue() {
        return 0.0;
    }

    __getDBExtra(dbVersion) {
        return '';
    }

    __getDBType(dbVersion) {
        return 'float';
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDFloatValidator", "default", "ABDFloatValidator", "../validators/ABDFloatValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Float;
    }

    __getType() {
        return 'Float';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return String(this.__parse(value));
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return value;
    }

    __unescape(value) {
        return parseFloat(value);
    }

}
/* export default */ ABDFloat;

/* JSLib Exports */
_jsLib.export("default", ABDFloat); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDId.js
jsLibs.exportScript("ab-data", "./fields/ABDId", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDLongValidator", [ { name: "default", alias: "ABDLongValidator" } ], "../validators/ABDLongValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

class ABDId extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return [ 'bigint', 'bigint(20)' ].includes(dbType);
    }

    __getDBExtra() {
        return '';
    }

    __getDBType(dbVersion) {
        return 'bigint';
    }

    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDLongValidator", "default", "ABDLongValidator", "../validators/ABDLongValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Long;
    }

    __getType() {
        return 'Id';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long);

        return String(this.__parse(value));
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long);

        return value;
    }

    __unescape(value) {
        return Number(value);
    }

}
/* export default */ ABDId;


/* JSLib Exports */
_jsLib.export("default", ABDId); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDInt.js
jsLibs.exportScript("ab-data", "./fields/ABDInt", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDIntValidator", [ { name: "default", alias: "ABDIntValidator" } ], "../validators/ABDIntValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");


class ABDInt extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {
    get unsigned() {
        return this._unsigned;
    }

    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let unsigned = false;
        if ('unsigned' in properties) {
            (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(properties.unsigned, 'boolean');
            unsigned = properties.unsigned;
            delete properties.unsigned;
        }

        super([ unsigned ], properties);

        this._unsigned = unsigned;
    }


    __getDBExtra(dbVersion) {
        return '';
    }

    __getDBType(dbVersion) {
        if (dbVersion.type === 'mysql')
            return 'int' + (this.unsigned ? ' unsigned' : '');

        return 'int';
    }

    __compareDBType(dbVersion, dbType) {
        let unsigned = this.unsigned ? ' unsigned' : '';
        return [ `int${unsigned}`, `int(11)${unsigned}` ].includes(dbType);
    }

    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDIntValidator", "default", "ABDIntValidator", "../validators/ABDIntValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Int;
    }

    __getType() {
        return 'Int';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return String(this.__parse(value));
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return Math.round(value);
    }

    __unescape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, null);
            
        return parseInt(value);
    }

}
/* export default */ ABDInt;


/* JSLib Exports */
_jsLib.export("default", ABDInt); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDJSON.js
jsLibs.exportScript("ab-data", "./fields/ABDJSON", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDJSONValidator", [ { name: "default", alias: "ABDJSONValidator" } ], "../validators/ABDJSONValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

_jsLib.importDeclaration("ab-data", "./helper", [ { name: "default", alias: "helper" } ], "../helper.js");

class ABDJSON extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    get size() {
        return this._size;
    }

    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([], properties);
    }


    __getDBType(dbVersion) {
        return 'mediumtext'
    }

    __compareDBType(dbVersion, dbType) {
        return dbType === 'mediumtext';
    }

    __getDefaultValue() {
        return null;
    }

    __getDBExtra(dbVersion) {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDJSONValidator", "default", "ABDJSONValidator", "../validators/ABDJSONValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).JSON;
    }

    __getType() {
        return 'JSON';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        let jsonValue = value.value;

        return (_jsLib.import("ab-data", "./helper", "default", "helper", "../helper.js")).escapeString(JSON.stringify({ value: jsonValue, }));
    }

    __unescape(value) {
        return value;
    }

}
/* export default */ ABDJSON;

/* JSLib Exports */
_jsLib.export("default", ABDJSON); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDLong.js
jsLibs.exportScript("ab-data", "./fields/ABDLong", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDLongValidator", [ { name: "default", alias: "ABDLongValidator" } ], "../validators/ABDLongValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

class ABDLong extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return dbType === 'bigint';
    }

    __getDBExtra(dbVersion) {
        return '';
    }

    __getDBType(dbVersion) {
        return 'bigint';
    }

    __getDefaultValue() {
        return 0;
    }

    __getDBExtra(dbVersion) {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDLongValidator", "default", "ABDLongValidator", "../validators/ABDLongValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Long;
    }

    __getType() {
        return 'Long';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long);

        return String(value);
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long);

        return value;
    }

    __unescape(value) {
        return Number(value);
    }

}
/* export default */ ABDLong;


/* JSLib Exports */
_jsLib.export("default", ABDLong); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDObject_WIP.js
jsLibs.exportScript("ab-data", "./fields/ABDObject_WIP", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField");
_jsLib.importDeclaration("ab-data", "./fields/ABDLong", [ { name: "default", alias: "ABDLong" } ], "./ABDLong");

class ABDObject extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField")) {

    get fields() {
        return this._fields;
    }

    get name() {
        return this._name;
    }

    get objectStructs() {
        return this._objectStructs;
    }

    constructor(properties = {}) {
        super([], properties);

        this._initialized = false;
        this._name = null;

        this._fields = new (_jsLib.import("js0", "./index", "default", "js0", "js0")).List();
        this._objectStructs = new (_jsLib.import("js0", "./index", "default", "js0", "js0")).List();
    }

    addObjectStruct(objectStructName, objectField) {
        this._objectStructs.set(objectStructName, objectField);
    }

    initialize(name) {
        if (this._initialized)
            return;
        this._initialized = true;

        this._name = name;

        let fields = this.properties.$;
        fields.Id = new (_jsLib.import("ab-data", "./fields/ABDLong", "default", "ABDLong", "./ABDLong"))();
        
        for (let fieldName in fields) {
            let field = fields[fieldName];

            if (!(field instanceof (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField"))))
                throw new Error(`Object fields must be instancec of 'ABDField'.`);

            this._fields.set(fieldName, field);
        }
    }

    // setName(name)
    // {
    //     this._name = name;
    // }

}
/* export default */ ABDObject;


/* JSLib Exports */
_jsLib.export("default", ABDObject); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDString.js
jsLibs.exportScript("ab-data", "./fields/ABDString", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDStringValidator", [ { name: "default", alias: "ABDStringValidator" } ], "../validators/ABDStringValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

_jsLib.importDeclaration("ab-data", "./helper", [ { name: "default", alias: "helper" } ], "../helper.js");

class ABDString extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {
    get size() {
        return this._size;
    }

    constructor(size, properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([ size ], properties);

        this._size = size;
    }


    __compareDBType(dbVersion, dbType) {
        return dbType === `varchar(${this.size})`;
    }

    __getDBType(dbVersion) {
        return `varchar(${this.size})`;
    }

    __getDefaultValue() {
        return '';
    }

    __getDBExtra(dbVersion) {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        if (!('maxLength' in fieldValidatorInfo))
            fieldValidatorInfo['maxLength'] = this.size;

        return new (_jsLib.import("ab-data", "./validators/ABDStringValidator", "default", "ABDStringValidator", "../validators/ABDStringValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).String;
    }

    __getType() {
        return 'String';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return (_jsLib.import("ab-data", "./helper", "default", "helper", "../helper.js")).escapeString(value);
    }

    __unescape(value) {
        return value;
    }
}
/* export default */ ABDString;


/* JSLib Exports */
_jsLib.export("default", ABDString); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDText.js
jsLibs.exportScript("ab-data", "./fields/ABDText", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDStringValidator", [ { name: "default", alias: "ABDStringValidator" } ], "../validators/ABDStringValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

_jsLib.importDeclaration("ab-data", "./helper", [ { name: "default", alias: "helper" } ], "../helper.js");

class ABDString extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    get type() {
        return this._type;
    }

    get _typeSizes() {
        return {
            tiny:       256,
            regular:    65535,
            medium:     16777215,
        };
    }

    constructor(type, properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'tiny', 'regular', 'medium' ]), 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        super([ type ], properties);

        this._type = type;
    }


    __compareDBType(dbVersion, dbType) {
        if (this.type === 'tiny')
            return dbType === 'tinytext';
        if (this.type === 'regular')
            return dbType === 'text';
        if (this.type === 'medium')
            return dbType === 'mediumtext';

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(false, `Unknown 'text' field type.`);
    }

    __getDBType(dbVersion) {
        if (this.type === 'tiny')
            return 'tinytext';
        if (this.type === 'regular')
            return 'text';
        if (this.type === 'medium')
            return 'mediumtext';

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(false, `Unknown 'text' field type.`);
    }

    __getDefaultValue() {
        return '';
    }

    __getDBExtra() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        if (!('maxLength' in fieldValidatorInfo))
            fieldValidatorInfo['maxLength'] = this._typeSizes[this.type];

        return new (_jsLib.import("ab-data", "./validators/ABDStringValidator", "default", "ABDStringValidator", "../validators/ABDStringValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).String;
    }

    __getType() {
        return 'Text';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return (_jsLib.import("ab-data", "./helper", "default", "helper", "../helper.js")).escapeString(value);
    }

    __unescape(value) {
        return value;
    }

}
/* export default */ ABDString;


/* JSLib Exports */
_jsLib.export("default", ABDString); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\languages\pl.ab-data.js
jsLibs.exportScript("ab-data", "./languages/pl.ab-data", [ "default" ], (_jsLib) => { "use strict"; const lang_PL_ABData = {
    NotChecked: 'To pole musi zostać zaznaczone.',
    NotSet: 'To pole musi zostać wypełnione.',
    NotNull: 'To pole nie może mieć wartości "null".',

    Date_WrongFormat: 'Nieprawidłowy format daty.',
    Date_BelowMinDate: 'Data nie może być wcześniejsza niż {date}.',
    Date_AboveMaxDate: 'Data nie może być późniejsza niż {date}.',

    Email_WrongFormat: 'Nieprawidłowy adres email.',

    Errors_AboveMaxLength: 'Zbyt długi ciąg znaków. Maksymalna długość: {maxLength}.',
    Errors_BelowMinLength: 'Minimalna ilość znaków w tym polu to: {minLength}.',
    Errors_NotAllowedCharacters: 'Pole zawiera niedozwolone znaki: {notAllowedChars}',
    Errors_WrongFormat: 'Nieprawidłowy ciąg znaków. Poprawny format to: {format}',

    Int_NotANumber: 'W tym polu powinna znaleźć się wartość numeryczna.',
    Int_NotAnInt: 'W tym polu powinna znaleźć się liczba całkowita.',
    Int_BelowMin: 'Wartość w tym polu nie może być mniejsza niż {minValue}.',
    Int_AboveMax: 'Wartość w tym polu nie być większa niż {maxValue}.',

    Long_NotANumber: 'W tym polu powinna znaleźć się wartość numeryczna.',
    Long_NotAnInt: 'W tym polu powinna znaleźć się liczba całkowita.',
    Long_BelowMin: 'Wartość w tym polu nie może być mniejsza niż {minValue}.',
    Long_AboveMax: 'Wartość w tym polu nie być większa niż {maxValue}.',

    Radio_WrongValue: 'Nieprawidłowa wartość pola.',  
};
/* export default */ lang_PL_ABData;

/* JSLib Exports */
_jsLib.export("default", lang_PL_ABData); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDTime.js
jsLibs.exportScript("ab-data", "./fields/ABDTime", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
    
_jsLib.importDeclaration("ab-data", "./fields/ABDField", [ { name: "default", alias: "ABDField" } ], "./ABDField.js");

_jsLib.importDeclaration("ab-data", "./validators/ABDTimeValidator", [ { name: "default", alias: "ABDTimeValidator" } ], "../validators/ABDTimeValidator.js");
_jsLib.importDeclaration("ab-data", "./SelectColumnType", [ { name: "default", alias: "SelectColumnType" } ], "../SelectColumnType.js");

class ABDTime extends (_jsLib.import("ab-data", "./fields/ABDField", "default", "ABDField", "./ABDField.js")) {

    constructor(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        super([], properties);
    }


    __compareDBType(dbVersion, dbType) {
        return [ 'bigint', 'bigint(20)' ].includes(dbType);
    }

    __getDBType(dbVersion) {
        return 'bigint';
    }

    __getDefaultValue() {
        return 0;
    }

    __getDBExtra() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new (_jsLib.import("ab-data", "./validators/ABDTimeValidator", "default", "ABDTimeValidator", "../validators/ABDTimeValidator.js"))(fieldValidatorInfo);
    }

    __getSelectType() {
        return (_jsLib.import("ab-data", "./SelectColumnType", "default", "SelectColumnType", "../SelectColumnType.js")).Long;
    }

    __getType() {
        return 'Time';
    }

    __escape(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return String(this.__parse(value));
    }

    __parse(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number');

        return value;
    }

    __unescape(value) {
        return Number(value);
    }

}
/* export default */ ABDTime;


/* JSLib Exports */
_jsLib.export("default", ABDTime); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\fields\index.js
jsLibs.exportScript("ab-data", "./fields/index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./fields/ABDAutoIncrementId", [ { name: "default", alias: "ABDAutoIncrementId" } ], "./ABDAutoIncrementId.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDBlob", [ { name: "default", alias: "ABDBlob" } ], "./ABDBlob.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDBool", [ { name: "default", alias: "ABDBool" } ], "./ABDBool.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDDate", [ { name: "default", alias: "ABDDate" } ], "./ABDDate.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDDateTime", [ { name: "default", alias: "ABDDateTime" } ], "./ABDDateTime.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDFloat", [ { name: "default", alias: "ABDFloat" } ], "./ABDFloat.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDId", [ { name: "default", alias: "ABDId" } ], "./ABDId.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDInt", [ { name: "default", alias: "ABDInt" } ], "./ABDInt.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDJSON", [ { name: "default", alias: "ABDJSON" } ], "./ABDJSON.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDLong", [ { name: "default", alias: "ABDLong" } ], "./ABDLong.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDString", [ { name: "default", alias: "ABDString" } ], "./ABDString.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDText", [ { name: "default", alias: "ABDText" } ], "./ABDText.js");
_jsLib.importDeclaration("ab-data", "./fields/ABDTime", [ { name: "default", alias: "ABDTime" } ], "./ABDTime.js");


class fields_Class {

    // get ABDArray() { return ABDArray; };
    get ABDAutoIncrementId() { return (_jsLib.import("ab-data", "./fields/ABDAutoIncrementId", "default", "ABDAutoIncrementId", "./ABDAutoIncrementId.js")); };
    get ABDBlob() { return (_jsLib.import("ab-data", "./fields/ABDBlob", "default", "ABDBlob", "./ABDBlob.js")); };
    get ABDBool() { return (_jsLib.import("ab-data", "./fields/ABDBool", "default", "ABDBool", "./ABDBool.js")); };
    // get ABDData() { return ABDData; }
    get ABDDate() { return (_jsLib.import("ab-data", "./fields/ABDDate", "default", "ABDDate", "./ABDDate.js")); }
    get ABDDateTime() { return (_jsLib.import("ab-data", "./fields/ABDDateTime", "default", "ABDDateTime", "./ABDDateTime.js")); }
    // get ABDDouble() { return ABDDouble; };
    get ABDFloat() { return (_jsLib.import("ab-data", "./fields/ABDFloat", "default", "ABDFloat", "./ABDFloat.js")); };
    get ABDId() { return (_jsLib.import("ab-data", "./fields/ABDId", "default", "ABDId", "./ABDId.js")); };
    get ABDInt() { return (_jsLib.import("ab-data", "./fields/ABDInt", "default", "ABDInt", "./ABDInt.js")); };
    get ABDJSON() { return (_jsLib.import("ab-data", "./fields/ABDJSON", "default", "ABDJSON", "./ABDJSON.js")); };
    get ABDLong() { return (_jsLib.import("ab-data", "./fields/ABDLong", "default", "ABDLong", "./ABDLong.js")); };
    // get ABDObject() { return ABDObject; };
    get ABDString() { return (_jsLib.import("ab-data", "./fields/ABDString", "default", "ABDString", "./ABDString.js")); };
    get ABDTime() { return (_jsLib.import("ab-data", "./fields/ABDTime", "default", "ABDTime", "./ABDTime.js")); };
    get ABDText() { return (_jsLib.import("ab-data", "./fields/ABDText", "default", "ABDText", "./ABDText.js")); };


    // Array(properties = {})
    // {
    //     return new ABDArray(properties);
    // }

    AutoIncrementId() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);
        return new (_jsLib.import("ab-data", "./fields/ABDAutoIncrementId", "default", "ABDAutoIncrementId", "./ABDAutoIncrementId.js"))();
    }

    Blob(properties = {})  {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDBlob", "default", "ABDBlob", "./ABDBlob.js"))(properties);
    }

    Bool(properties = {})  {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDBool", "default", "ABDBool", "./ABDBool.js"))(properties);
    }

    Date(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new ABDData(properties);
    }

    Date(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDDate", "default", "ABDDate", "./ABDDate.js"))(properties);
    }

    DateTime(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDDateTime", "default", "ABDDateTime", "./ABDDateTime.js"))(properties);
    }

    // Double(properties = {})
    // {
    //     return new ABDDouble(properties);
    // }

    Float(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDFloat", "default", "ABDFloat", "./ABDFloat.js"))(properties);
    }

    Id(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDId", "default", "ABDId", "./ABDId.js"))(properties);
    }

    Int(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDInt", "default", "ABDInt", "./ABDInt.js"))(properties);
    }

    JSON(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDJSON", "default", "ABDJSON", "./ABDJSON.js"))(properties);
    }

    Long(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDLong", "default", "ABDLong", "./ABDLong.js"))(properties);
    }

    // Object(properties = {})
    // {
    //     return new ABDObject(properties);
    // }

    String(size, properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDString", "default", "ABDString", "./ABDString.js"))(size, properties);
    }

    Time(properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDTime", "default", "ABDTime", "./ABDTime.js"))(properties);
    }

    Text(type, properties = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'tiny', 'regular', 'medium' ]), 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        return new (_jsLib.import("ab-data", "./fields/ABDText", "default", "ABDText", "./ABDText.js"))(type, properties);
    }

}
const fields = new fields_Class();
/* export default */ fields;


/* JSLib Exports */
_jsLib.export("default", fields); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDBlobValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDBlobValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDStringValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'Blob';
    }


    __validate(validator, fieldName, value) {
        if (value.length === 0) {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));

            return;
        }
    }

}
/* export default */ ABDStringValidator;

/* JSLib Exports */
_jsLib.export("default", ABDStringValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDBoolValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDBoolValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDBoolValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject)
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'Bool';
    }


    __validate(validator, fieldName, value) {
        if (!value) {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotChecked'));
        }
    }

}
/* export default */ ABDBoolValidator;

/* JSLib Exports */
_jsLib.export("default", ABDBoolValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDEmailValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDEmailValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDStringValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'Email';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));

            return;
        } 

        let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (!re.test(String(value).toLowerCase()))
            validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));
    }

}
/* export default */ ABDStringValidator;

/* JSLib Exports */
_jsLib.export("default", ABDStringValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDFloatValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDFloatValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDFloatValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'minValue': [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'maxValue': [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Float';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                this.fieldError(validator, fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));

            return;
        }

        if (!this.args['required'] && value === '')
            return;

        if (isNaN(value))
            validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Int_NotANumber'));
        else {
            let number = Number(value);
            if (this.args['minValue'] !== null) {
                if (number < this.args['minValue']) {
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                            'abData.Int_BelowMin',  { minValue: this.args['minValue'] }));
                }
            }

            if (this.args['maxValue']) {
                if (number > this.args['maxValue']) {
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                            'abData.Int_AboveMax', { maxValue: this.args['maxValue'] }));
                }
            }
        }
    }

}
/* export default */ ABDFloatValidator;

/* JSLib Exports */
_jsLib.export("default", ABDFloatValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDFieldValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDFieldValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-data", "./Validator", [ { name: "default", alias: "Validator" } ], "../Validator.js");

class ABDFieldValidator {

    get args() {
        return this._args;
    }


    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        this._args = args;
    }

    validate(validator, fieldName, value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./Validator", "default", "Validator", "../Validator.js")), 'string', null);

        if (value === null) {
            if (this.args['notNull']) {
                if (this.args['required'])
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));
                else
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotNull'));
            }
        } else
            this.__validate(validator, fieldName, value);
    }


    getType() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __validate(value) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

}
/* export default */ ABDFieldValidator;

/* JSLib Exports */
_jsLib.export("default", ABDFieldValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDJSONValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDJSONValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDJSONValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'JSON';
    }


    __validate(validator, fieldName, value) {
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(value, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            value: null,
                }))) {
            validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                    'abData.Errors_WrongJSONFieldFormat'));
        }
    }

}
/* export default */ ABDJSONValidator;

/* JSLib Exports */
_jsLib.export("default", ABDJSONValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDIntValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDIntValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDIntValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'minValue': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'maxValue': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Int';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));

            return;
        }

        if (!this.args['required'] && value === '')
            return;

        if (isNaN(value))
            validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Int_NotANumber'));
        else {
            let number = Number(value);
            if (!Number.isInteger(number))
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Int_NotAnInt'));
            else {
                if (this.args['minValue'] !== null) {
                    if (number < this.args['minValue']) {
                        validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'abData.Int_BelowMin',  { minValue: this.args['minValue'] }));
                    }
                }

                if (this.args['maxValue']) {
                    if (number > this.args['maxValue']) {
                        validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'abData.Int_AboveMax', { maxValue: this.args['maxValue'] }));
                    }
                }
            }
        }
    }

}
/* export default */ ABDIntValidator;

/* JSLib Exports */
_jsLib.export("default", ABDIntValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDLongValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDLongValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDLongValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'minValue': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'maxValue': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Long';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));

            return;
        }

        if (!this.args['required'] && value === '')
            return;

        if (isNaN(value))
            validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Int_NotANumber'));
        else {
            let number = Number(value);            
            if (number % 1 !== 0)
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Int_NotAnInt'));
            else {
                if (this.args['minValue'] !== null) {
                    if (number < this.args['minValue']) {
                        validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'abData.Int_BelowMin',  { minValue: this.args['minValue'] }));
                    }
                }

                if (this.args['maxValue']) {
                    if (number > this.args['maxValue']) {
                        validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'abData.Int_AboveMax', { maxValue: this.args['maxValue'] }));
                    }
                }
            }
        }
    }

}
/* export default */ ABDLongValidator;

/* JSLib Exports */
_jsLib.export("default", ABDLongValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDTimeValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDTimeValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDTimeValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'type': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'dateTime', 'date', 'time' ]), 
                    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('dateTime') ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'minTime': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'maxTime': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Time';
    }


    __validate(validator, fieldName, value) {
        if (value === null) {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));
            else
                return;
        } else {
            if (isNaN(value)) {
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Date_WrongFormat'));
                return;
            }

            value = Number.parseInt(value);

            if (this.args['minDate'] !== null) {
                if (value < this.args['minDate']) {
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Date_BelowMinDate',
                            abDate.format_DateTime((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Date_Format'), 
                            this.args['minDate'])));
                }
            }

            if (this.args['maxDate'] !== null) {
                if (value > this.args['maxDate']) {
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Date_AboveMaxDate', { 
                        maxDate: abDate.format_DateTime((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'abData.Format_DateTime'), this.args['maxDate']),
                    }));
                }
            }
        }
    }

}
/* export default */ ABDTimeValidator;

/* JSLib Exports */
_jsLib.export("default", ABDTimeValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDStringValidator.js
jsLibs.exportScript("ab-data", "./validators/ABDStringValidator", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [ { name: "default", alias: "abStrings" } ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-data", "./validators/ABDFieldValidator", [ { name: "default", alias: "ABDFieldValidator" } ], "./ABDFieldValidator.js");

class ABDStringValidator extends (_jsLib.import("ab-data", "./validators/ABDFieldValidator", "default", "ABDFieldValidator", "./ABDFieldValidator.js")) {

    constructor(args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            'notNull': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'required': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
            'minLength': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'maxLength': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Int, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'regexp': [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).PresetArray([ 'string', 'string' ]), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 
                    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            'trim': [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(false) ],
            'chars': [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).getCharsRegExp_Basic()) ],
        }));

        super(args);
    }

    getType() {
        return 'String';
    }


    __validate(validator, fieldName, value) {
        if (this.args['trim'])
            value = value.trim();

        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.NotSet'));

            return;
        } else {
            if (this.args['minLength'] !== null) {
                if (value.length < this.args['minLength']) {
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                            'abData.Errors_BelowMinLength', 
                            { minLength: this.args['minLength'] }));
                }
            }

            if (this.args['maxLength'] !== null) {
                if (this.args['maxLength'] > 0) {
                    if (value.length > this.args['maxLength']) {
                        validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'abData.Errors_AboveMaxLength', 
                                { maxLength: this.args['maxLength'] }));
                    }
                }
            }

            if (this.args['regexp'] !== null) {
                // regexp = str_replace('#', '\\#', this.args['regexp'][0]);
                let regexp = this.args['regexp'][0];

                if (!(new RegExp(`${regexp}`)).test(value)) {
                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('abData.Errors_WrongFormat',
                        { format: this.args['regexp'][1] }));
                }
            }

            if (this.args['chars'] !== null) {
                let chars_Escaped =  this.args['chars']; //abStrings.escapeRegExpChars(this.args['chars']);
                // value = ' hello ';
                // echo '#' . chars . '#' . value . '#';

                if (!(new RegExp(`^[${chars_Escaped}]*$`)).test(value)) {
                    let notAllowedChars = [];
                    let re = new RegExp(`[^${chars_Escaped}]`, 'g');

                    while (true) {
                        let match = re.exec(value);
                        if (!match)
                            break;

                        notAllowedChars.push(match[0]);
                    }

                    let notAllowedChars_Str = notAllowedChars.join(', ');

                    // not_allowed_chars = str_replace('\\\\', '&#92;', not_allowed_chars);
                    // not_allowed_chars = str_replace('\\', '', not_allowed_chars);
                    // not_allowed_chars = str_replace('&#92;', '\\', not_allowed_chars);

                    validator.fieldError(fieldName, (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                            'abData.Errors_NotAllowedCharacters',
                            { notAllowedChars: notAllowedChars_Str }));
                }
            }
        }
    }

}
/* export default */ ABDStringValidator;

/* JSLib Exports */
_jsLib.export("default", ABDStringValidator); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data\validators\index.js
jsLibs.exportScript("ab-data", "./validators/index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./validators/ABDBoolValidator", [ { name: "default", alias: "ABDBoolValidator" } ], "./ABDBoolValidator.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDEmailValidator", [ { name: "default", alias: "ABDEmailValidator" } ], "./ABDEmailValidator.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDIntValidator", [ { name: "default", alias: "ABDIntValidator" } ], "./ABDIntValidator.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDJSONValidator", [ { name: "default", alias: "ABDJSONValidator" } ], "./ABDJSONValidator.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDFloatValidator", [ { name: "default", alias: "ABDFloatValidator" } ], "./ABDFloatValidator.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDLongValidator", [ { name: "default", alias: "ABDLongValidator" } ], "./ABDLongValidator.js");
_jsLib.importDeclaration("ab-data", "./validators/ABDStringValidator", [ { name: "default", alias: "ABDStringValidator" } ], "./ABDStringValidator.js");

class validators_Class {
    get ABDBoolValidator() { return (_jsLib.import("ab-data", "./validators/ABDBoolValidator", "default", "ABDBoolValidator", "./ABDBoolValidator.js")); }
    get ABDEmailValidator() { return (_jsLib.import("ab-data", "./validators/ABDEmailValidator", "default", "ABDEmailValidator", "./ABDEmailValidator.js")); };
    get ABDIntValidator() { return (_jsLib.import("ab-data", "./validators/ABDIntValidator", "default", "ABDIntValidator", "./ABDIntValidator.js")); };    
    get ABDJSONValidator() { return (_jsLib.import("ab-data", "./validators/ABDJSONValidator", "default", "ABDJSONValidator", "./ABDJSONValidator.js")); };
    get ABDFloatValidator() { return (_jsLib.import("ab-data", "./validators/ABDFloatValidator", "default", "ABDFloatValidator", "./ABDFloatValidator.js")); };
    get ABDLongValidator() { return (_jsLib.import("ab-data", "./validators/ABDLongValidator", "default", "ABDLongValidator", "./ABDLongValidator.js")); };
    get ABDStringValidator() { return (_jsLib.import("ab-data", "./validators/ABDStringValidator", "default", "ABDStringValidator", "./ABDStringValidator.js")); };


    Bool(args = {}) {
        return new this.ABDBoolValidator(args);
    }

    Email(args = {}) {
        return new this.ABDEmailValidator(args);
    }

    Int(args = {}) {
        return new this.ABDIntValidator(args);
    }

    JSON(args = {}) {
        return new this.ABDJSONValidator(args);
    }

    Float(args = {}) {
        return new this.ABDFloatValidator(args);
    }

    Long(args = {}) {
        return new this.ABDLongValidator(args);
    }

    String(args = {}) {
        return new this.ABDStringValidator(args);
    }

}
const validators = new validators_Class();
/* export default */ validators;


/* JSLib Exports */
_jsLib.export("default", validators); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-date\index.js
jsLibs.exportScript("ab-date", "./index", [ "abDate_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("moment-timezone", "./index", [ { name: "default", alias: "moment" } ], "moment-timezone");

/* export */ class abDate_Class {
    get utcOffset() {
        throw new Error(`'abDate.utcOffset' is deprecated.`);
    }


    constructor() {
        this.span_Minute = 60;
        this.span_Hour = 60 * 60;
        this.span_Day = 24 * 60 * 60;

        this.formats_Date = 'DD.MM.YYYY';
        this.formats_DateTime = 'DD.MM.YYYY HH:mm';
        this.formats_Time = 'HH:mm';
        this.formats_Time_WithSeconds = 'HH:mm:ss';

        this._timezone = null;
        this.setTimezone('UTC');
    }

    format(time, format, timezone = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 'string', [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ])
        
        if (time === null)
            return '-';

        return (_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).tz(time * 1000, timezone === null ? 
            this._timezone : timezone).format(format);
    }

    format_Date(time, timezone = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return this.format(time, this.formats_Date, timezone);
    }

    format_Date_UTC(time) {
        return this.format_Date(time, 'UTC');
    }

    format_DateTime(time, timezone = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return this.format(time, this.formats_DateTime, timezone);
    }

    format_DateTime_UTC(time) {
        return this.format_DateTime(time, 'UTC');
    }

    format_Time(time, withSeconds = false, timezone = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ],
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return this.format(time, withSeconds ? 
                this.formats_Time_WithSeconds : this.formats_Time, timezone);
    }

    format_UTC(time, format) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number', 'string');

        return this.format(time, format, 'UTC');
    }

    getDate(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            return new Date();
            
        return new Date(time * 1000);
    }

    getDay(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();

        return this.getDay_UTC(time + this.getUTCOffset_Time(time)) - 
                this.getUTCOffset_Time(time);
    }

    getDay_UTC(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();

        // return Math.floor(time / this.span_Day) * this.span_Day;
        return time - time % this.span_Day;
    }

    getDayOfWeek(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getDayOfWeek_UTC(time);
    }

    getDayOfWeek_UTC(time) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let date = new Date(time * 1000);

        return date.getUTCDay();
    }

    getDayNr(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getDayNr_UTC(time);
    }

    getDayNr_UTC(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();

        return this.getDate(time).getUTCDate() - 1;
    }

    getDaysCountInMonth(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getDaysCountInMonth_UTC(time);
    }

    getDaysCountInMonth_UTC(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = abDate.getTime();

        let year = this.getYearNr_UTC(time);
        let month = this.getMonthNr_UTC(time);

        return (new Date(year, month + 1, 0)).getDate();

    }

    getMonth(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return this.getDay(time) - this.getDayNr(time) * this.span_Day;
    }

    getMonth_UTC(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return this.getDay_UTC(time) - this.getDayNr_UTC(time) * this.span_Day;
    }

    getMonthNr(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getMonthNr_UTC(time);
    }
    
    getMonthNr_UTC(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();

        return this.getDate(time).getUTCMonth();
    }

    getTime(date = new Date()) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ Date, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return Math.floor(date.getTime() / 1000);
    }

    getTime_Rel(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();

        return time - this.getUTCOffset_Time(time);
    }

    getUTCOffset(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return -(_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).tz.zone(this._timezone).utcOffset(time === null ?
                this.getTime() : time) / 60;
    }

    getUTCOffset_Time(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return this.getUTCOffset(time) * this.span_Hour;
    }

    getYearNr(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getYearNr_UTC(time);
    }

    getYearNr_UTC(time = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (time === null)
            time = abDate.getTime();

        return this.getDate(time).getUTCFullYear();
    }

    setTimezone(timezone) {
        if ((_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).tz.zone(timezone) === null)
            throw new Error(`Cannot find timezone: ${timezone}.`);
        
        this._timezone = timezone;
    }

    strToTime(str, timeFormat) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        console.log((_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).tz(str, timeFormat, this._timezone).isValid());
        return (_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).tz(str, timeFormat, this._timezone).toDate()
                .getTime() / 1000;
    }

    strToTime_UTC(str, timeFormat) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        return (_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).utc(str, timeFormat).toDate().getTime() / 1000;
    }

    strToTime_Date(str) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime(str, this.formats_Date);
    }

    strToTime_Date_UTC(str) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime_UTC(str, this.formats_Date);
    }

    strToTime_DateTime(str) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime(str, this.formats_DateTime);
    }

    strToTime_DateTime_UTC(str) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime_UTC(str, this.formats_DateTime);
    }

    strToTime_Time(str, withSeconds = false) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (str === '')
            return null;

        var timestamp = (_jsLib.import("moment-timezone", "./index", "default", "moment", "moment-timezone")).utc(str, withSeconds ? 
                this.formats_Time_WithSeconds : this.formats_Time)
                .toDate().getTime() / 1000;

        return timestamp % this.span_Day;
    }

}
const abDate = new abDate_Class();
/* export default */ abDate;


/* JSLib Exports */
_jsLib.export("abDate_Class", abDate_Class);
_jsLib.export("default", abDate); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\moment\index.js
jsLibs.exportScript("moment", "./index", [ "default" ], (_jsLib) => { "use strict"; /* export default */ moment;

/* JSLib Exports */
_jsLib.export("default", moment); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\moment-timezone\index.js
jsLibs.exportScript("moment-timezone", "./index", [ "default" ], (_jsLib) => { "use strict"; /* export default */ moment;

/* JSLib Exports */
_jsLib.export("default", moment); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-lock\index.js
jsLibs.exportScript("ab-lock", "./index", [ "abLock_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-lock", "./Lock", [ { name: "default", alias: "Lock" } ], "./Lock.js");

/* export */ class abLock_Class {
    constructor() {
        this._lock = new (_jsLib.import("ab-lock", "./Lock", "default", "Lock", "./Lock.js"))();
    }

    async sync(obj, fn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, null, 'function');

        await this._lock.sync(obj, fn);
    }

}
const abLock = new abLock_Class();
/* export default */ abLock;

/* JSLib Exports */
_jsLib.export("abLock_Class", abLock_Class);
_jsLib.export("default", abLock); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-lock\Lock.js
jsLibs.exportScript("ab-lock", "./Lock", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class Lock
{

    constructor() {
        this._queue = [];
    }

    async sync(obj, fn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, null, 'function');

        let subqueue = this._getSubqueue(obj);
        if (subqueue === null)
            subqueue = this._createQueue(obj);

        subqueue.push(fn);
        
        if (subqueue.length === 1)
            await this._executeNextFn(obj);
    }


    _createQueue(obj) {
        let subqueue = [];
        this._queue.push([ obj, subqueue ]);

        return subqueue;
    }

    _getSubqueue(obj) {
        for (let subqueue of this._queue) {
            if (subqueue[0] === obj)
                return subqueue[1];
        }

        return null;
    }

    async _executeNextFn(obj) {
        let subqueue = this._getSubqueue(obj);
        if (subqueue.length === 0)
            return;

        let fn = subqueue[0];
        subqueue.shift();

        await fn();
        this._executeNextFn(obj);
    }

}
/* export default */ Lock;

/* JSLib Exports */
_jsLib.export("default", Lock); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\ActionsSetDef.js
jsLibs.exportScript("ab-native", "./ActionsSetDef", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("..js", "./index", [  ], "..js");

/* export default */ class ActionsSetDef
{

    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);

        this._actions_Native = {};
        this._actions_Web = {};
    }

    addNative(actionName, actionArgs, resultArgs) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        this._actions_Native[actionName] = {
            name: actionName,
            actionArgs: actionArgs,
            resultArgs: resultArgs,
        };

        return this;
    }

    addWeb(actionName, actionArgs, resultArgs, fn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 'function');

        this._actions_Web[actionName] = {
            name: actionName,
            actionArgs: actionArgs,
            resultArgs: resultArgs,
            fn: fn,  
        };

        return this;
    }

    // callNative(actionsSetName, actionName, actionArgs = {}, callbackFn = null)
    // {
    //     abNative.callNative(actionsSetName, actionName, actionArgs, callbackFn);
    // }

    // callNative_Async(actionName, actionArgs = {})
    // {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             this.callNative(actionName, actionArgs, (result) => {
    //                 resolve(result);
    //             });
    //         } catch (e) {
    //             reject(e);
    //         }
    //     });
    // }

    getNativeInfo(actionName) {
        if (!(actionName in this._actions_Native))
            throw new Error(`Action '${actionName}' does not exist.`);

        return this._actions_Native[actionName];
    }

    getWebInfo(actionName) {
        if (!(actionName in this._actions_Web))
            throw new Error(`Action '${actionName}' does not exist.`);

        return this._actions_Web[actionName];
    }

    hasNative(actionName) {
        return actionName in this._actions_Native;
    }

    // init()
    // {
    //     abNative.init(this);
    // }

}

/* JSLib Exports */
_jsLib.export("default", ActionsSetDef); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\index.js
jsLibs.exportScript("ab-native", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-native", "./NativeActionsSet", [ { name: "default", alias: "NativeActionsSet" } ], "./NativeActionsSet.js");
_jsLib.importDeclaration("ab-native", "./ActionsSetDef", [ { name: "default", alias: "ActionsSetDef" } ], "./ActionsSetDef.js");
_jsLib.importDeclaration("ab-native", "./NativeApp_Web", [ { name: "default", alias: "NativeApp_Web" } ], "./NativeApp_Web.js");
_jsLib.importDeclaration("ab-native", "./NativeApp_Android", [ { name: "default", alias: "NativeApp_Android" } ], "./NativeApp_Android.js");
_jsLib.importDeclaration("ab-native", "./NativeApp_IOS", [ { name: "default", alias: "NativeApp_IOS" } ], "./NativeApp_IOS.js");

class abNative_Class {
    get ActionsSetDef() {
        return (_jsLib.import("ab-native", "./ActionsSetDef", "default", "ActionsSetDef", "./ActionsSetDef.js"));
    }


    constructor() {
        this.nativeApp = null;

        this._actionsSets = {};
        this._initialized = false;

        this._actionId_Next = 0;
        this._onResultInfos = {};
    }

    addActionsSet(actionsSetName, actionsSet) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-native", "./ActionsSetDef", "default", "ActionsSetDef", "./ActionsSetDef.js")));

        if (this._initialized)
            throw new Error('Cannot add action set after initialization.');

        let nativeActionsSet = new (_jsLib.import("ab-native", "./NativeActionsSet", "default", "NativeActionsSet", "./NativeActionsSet.js"))(actionsSetName, actionsSet);

        this._actionsSets[actionsSetName] = actionsSet;

        return nativeActionsSet;
    }

    // createActionsSet(actionsSetName)
    // {
    //     js0.args(arguments, 'string');

    //     return new NativeActionsSet(name);
    // }

    callNative_Async(actionsSetName, actionName, actionArgs = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (!this._initialized)
            throw new Error(`'abNative' has not been initialized.`);

        if (this.nativeApp === null)
            throw new Error('Platform not set.');

        if (!this._initialized)
            throw new Error(`'abNative' has not been initialized.`);

        if (!this.getActionsSet(actionsSetName).hasNative(actionName)) {
            throw new Error(`Action '${actionName}' does not exist in Actions Set '${actionsSetName}'.`);
        }
        let actionInfo = this.getActionsSet(actionsSetName)
                .getNativeInfo(actionName);

        let actionId = this._actionId_Next;
        this._actionId_Next++;

        return new Promise((resolve, reject) => {
            this._onResultInfos[actionId] = {
                actionInfo: actionInfo,
                onResultFn: (result) => { resolve(result); },
                onErrorFn: (err) => { reject(err); },
            };

            this.nativeApp.callNative(actionId, actionsSetName, actionInfo, 
                actionArgs);
        });
    }

    callWeb(actionId, actionsSetName, actionName, actionArgs) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        if (this.nativeApp === null)
            throw new Error('Platform not set.');

        if (!this._initialized)
            throw new Error(`'abNative' has not been initialized.`);

        this.nativeApp.callWeb(actionId, actionsSetName, actionName, 
                actionArgs);
    }

    errorNative(message) {
        console.error('Native error:', message);
    }

    // getActionInfo(actionsSetName, actionName) {
    //     if (!(actionName in nativeActions.actions_Web))
    //         throw new Error(`Action '${actionsSetName}:${actionName}' does not exist.`);
    // }

    getActionsSet(actionsSetName) {
        if (!(actionsSetName in this._actionsSets))
            throw new Error(`Actions Set '${actionsSetName}' does not exist.`);

        return this._actionsSets[actionsSetName];
    }

    init(platform) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'web', 'android', 'ios' ]));

        if (this._initialized)
            throw new Error(`'abNative' was already initialized.`);
        this._initialized = true;

        if (platform === 'web')
            this.nativeApp = new (_jsLib.import("ab-native", "./NativeApp_Web", "default", "NativeApp_Web", "./NativeApp_Web.js"))();
        else if (platform === 'android')
            this.nativeApp = new (_jsLib.import("ab-native", "./NativeApp_Android", "default", "NativeApp_Android", "./NativeApp_Android.js"))();
        else if (platform === 'ios')
            this.nativeApp = new (_jsLib.import("ab-native", "./NativeApp_IOS", "default", "NativeApp_IOS", "./NativeApp_IOS.js"))();

        this.nativeApp.init();
    }

    onNativeResult(actionId, result, error) {
        if (!(actionId in this._onResultInfos))
            throw new Error(`Action '${actionId}' does not exist.`);

        let actionInfo = this._onResultInfos[actionId].actionInfo;

        if (error !== null)
            this._onResultInfos[actionId].onErrorFn(error);
        else { 
            if (actionInfo.resultArgs !== null) {
                let errors = [];
                if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(result, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionInfo.resultArgs), errors)) {
                    console.error('Result:', result);
                    console.error(errors);
                    this._onResultInfos[actionId].onErrorFn(
                            `Wrong action '${actionInfo.name}' result.`);
                    delete this._onResultInfos[actionId];
                    return;
                }
            }

            this._onResultInfos[actionId].onResultFn(result);
        }

        delete this._onResultInfos[actionId];

        // let parseResultFn = (result) => {
        //     console.log(actionInfo, result);
        //     if (actionInfo.resultArgs !== null) {
        //         let errors = [];
        //         if (!js0.type(result, js0.Preset(actionInfo.resultArgs), errors)) {
        //             console.error('Result:', result);
        //             console.error(errors);
        //             throw new Error(`Wrong action '${actionInfo.name}' result.`);
        //         }
        //     }
    
        //     if (this._onResultInfos[actionId].callbackFn !== null)
        //         this._onResultInfos[actionId].callbackFn(result);
        //     delete this._onResultInfos[actionId];
        // };

        // if (result instanceof Promise) {
        //     result
        //         .then((result) => {
        //             parseResultFn(result);
        //         })
        //         .catch((e) => {
        //             console.error('Cannot parse native result promise:');
        //             console.error(e);
        //         });
        // } else 
        //     parseResultFn(result);
    }

    // setPlatform(platform)
    // {
    //     js0.args(arguments, js0.Enum([ 'web', 'android', 'ios' ]));

    //     console.log('Platform set: ' + platform);

    //     this.init(platform);
    // }


    // _callNative(actionsSetName, actionName, actionArgs, onResultFn, onErrorFn) {
    //     js0.args(arguments, 'string', 'string', [ js0.RawObject, 
    //             js0.Null ], 'function', 'function');

    //     if (this.nativeApp === null)
    //         throw new Error('Platform not set.');

    //     if (!this._initialized)
    //         throw new Error(`'abNative' has not been initialized.`);

    //     if (!this.getActionsSet(actionsSetName).hasNative(actionName)) {
    //         throw new Error(`Action '${actionName}' does not exist in Actions Set '${actionsSetName}'.`);
    //     }
    //     let actionInfo = this.getActionsSet(actionsSetName)
    //             .getNativeInfo(actionName);

    //     let actionId = this._actionId_Next;
    //     this._actionId_Next++;

    //     this._onResultInfos[actionId] = {
    //         actionInfo: actionInfo,
    //         onResultFn: onResultFn,
    //         onErrorFn: onErrorFn,
    //     };

    //     this.nativeApp.callNative(actionId, actionsSetName, actionInfo, 
    //             actionArgs);
    // }

}
const abNative = new abNative_Class();
/* export default */ abNative;

/* JSLib Exports */
_jsLib.export("default", abNative); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\NativeActionsSet.js
jsLibs.exportScript("ab-native", "./NativeActionsSet", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-native", "./index", [ { name: "default", alias: "abNative" } ], "./index.js");
_jsLib.importDeclaration("ab-native", "./ActionsSetDef", [ { name: "default", alias: "ActionsSetDef" } ], "./ActionsSetDef.js");

/* export default */ class NativeActionsSet {
    constructor(name, actionsSet) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', (_jsLib.import("ab-native", "./ActionsSetDef", "default", "ActionsSetDef", "./ActionsSetDef.js")));

        this.name = name;
        this.actionsSet = actionsSet;
    }

    async callNative_Async(actionName, actionArgs = null) {
        return await (_jsLib.import("ab-native", "./index", "default", "abNative", "./index.js")).callNative_Async(this.name, actionName, actionArgs);
    }
}

/* JSLib Exports */
_jsLib.export("default", NativeActionsSet); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp.js
jsLibs.exportScript("ab-native", "./NativeApp", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-native", "./index", [ { name: "default", alias: "abNative" } ], "./index.js");

/* export default */ class NativeApp
{

    constructor() {
        
    }

    callNative(actionId, actionsSetName, actionInfo, args = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let errors = [];
        if (actionInfo.actionArgs === null) {
            if (args !== null) {
                console.error('Action takes no arguments.');
                throw new Error(`Wrong action '${actionsSetName}:${actionInfo.name}' args.`);
            }
        } else {
            if (args === null) {
                console.error('Action takes arguments, none given.');
                throw new Error(`Wrong action '${actionsSetName}:${actionInfo.name}' args.`);
            }

            if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(args, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionInfo.actionArgs), errors)) {
                console.error(errors);
                throw new Error(`Wrong action '${actionsSetName}:${actionInfo.name}' args.`);
            }
        }
        
        this.__callNative(actionId, actionsSetName, actionInfo.name, args);
    }

    callWeb(actionId, actionsSetName, actionName, actionArgs = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        let actionInfo = null;
        try {
            actionInfo = (_jsLib.import("ab-native", "./index", "default", "abNative", "./index.js")).getActionsSet(actionsSetName)
                    .getWebInfo(actionName);
        } catch (err) {
            console.error(err);
            this.__onWebResult(actionId, null, err.toString());
            return;
        }

        if (actionInfo.actionArgs === null) {
            if (actionArgs !== null) {
                let errorMessage = `Wrong action '${actionsSetName}:${actionInfo.name}' args:` +
                        ' Action takes no arguments some given.';
                console.error(errorMessage);
                this.__onWebResult(actionId, null, errorMessage);
                return;
            }
        } else {
            let errors = [];
            if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(actionArgs, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionInfo.actionArgs), errors)) {
                let errorMessage = `Wrong action '${actionsSetName}:${actionInfo.name}'` +
                        ' args:';
                console.error(errorMessage, errors);
                this.__onWebResult(actionId, null, errorMessage +  '\r\n' +
                        errors.join('\r\n'));
                return;
            }
        }

        let fnResult = actionInfo.fn(actionArgs);
        if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(fnResult, Promise)) {
            fnResult
                .then((result) => {
                    this._callWeb_ParseResult(actionId, actionInfo, result);
                })
                .catch((err) => {
                    console.error(err);
                    this.__onWebResult(actionId, null, err.toString());
                });
        } else {
            try {
                this._callWeb_ParseResult(actionId, actionInfo, fnResult);
            } catch (err) {
                console.error(err);
                this.__onWebResult(actionId, null, err.toString());
                return;
            }
        }

        // this.__onWebResult(actionId, result);
    }

    init() {
        this.__init();
    }

    
    _callWeb_ParseResult(actionId, actionInfo, result) {
        let errors = [];
        if (actionInfo.resultArgs === null) {
            if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(result, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 'undefined' ]))
                throw new Error(`Wrong action '${actionInfo.name}' result. Expected: none.`);
            result = null;
        } else if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(result, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset(actionInfo.resultArgs), errors)) {
            console.error(errors);
            throw new Error(`Wrong action '${actionInfo.name}' result. Expected: ` + 
                    actionInfo.resultArgs);
        }

        this.__onWebResult(actionId, result, null);
    }

    _getNextActionId() {
        return ++this.actionId_Last;
    }


    __callNative(actionId, actionsSetName, actionName, actionArgs) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this);
    }

    __init() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this);
    }

    __onWebResult(actionId, result, error) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this);
    }

}

/* JSLib Exports */
_jsLib.export("default", NativeApp); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp_Android.js
jsLibs.exportScript("ab-native", "./NativeApp_Android", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-native", "./NativeApp", [ { name: "default", alias: "NativeApp" } ], "./NativeApp.js");

/* export default */ class NativeApp_Android extends (_jsLib.import("ab-native", "./NativeApp", "default", "NativeApp", "./NativeApp.js"))
{

    constructor() {
        super();
    }


    /* NativeApp */
    __callNative(actionId, actionsSetName, actionName, args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ] );
        
        if (typeof abNative_Android === 'undefined')
            throw new Error('Native module not initialized.');

        abNative_Android.callNative(actionId, actionsSetName, actionName, 
                args === null ? null : JSON.stringify(args));
    }

    __init() {
        if (typeof abNative_Android === 'undefined')
            throw new Error('Native module not initialized.');

        abNative_Android.webViewInitialized();
    }

    __onWebResult(actionId, result, error) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        if (typeof abNative_Android === 'undefined')
            throw new Error('Native module not initialized.');

        console.log('Calling on web result', actionId, new Error());

        abNative_Android.onWebResult(actionId, result === null ? 
                null : JSON.stringify(result), error);
    }
    /* / NativeApp */

}

/* JSLib Exports */
_jsLib.export("default", NativeApp_Android); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp_IOS.js
jsLibs.exportScript("ab-native", "./NativeApp_IOS", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-native", "./NativeApp", [ { name: "default", alias: "NativeApp" } ], "./NativeApp.js");

/* export default */ class NativeApp_IOS extends (_jsLib.import("ab-native", "./NativeApp", "default", "NativeApp", "./NativeApp.js"))
{

    constructor() {
        super();
    }


    /* NativeApp */
    __callNative(actionId, actionsSetName, actionName, actionArgs) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null] );
        
        window.webkit.messageHandlers.abNative_IOS.postMessage({
            messageType: 'callNative',
            actionId: actionId, 
            actionsSetName: actionsSetName, 
            actionName: actionName, 
            actionArgs: actionArgs,
        });
    }

    __init() {
        if (typeof window.webkit === 'undefined')
            throw new Error('Native module not initialized.');
        if (typeof window.webkit.messageHandlers === 'undefined')
            throw new Error('Native module not initialized.');
        if (typeof window.webkit.messageHandlers.abNative_IOS === 'undefined')
            throw new Error('Native module not initialized.');

        window.webkit.messageHandlers.abNative_IOS.postMessage({
            messageType: 'webViewInitialized'
        });
    }

    __onWebResult(actionId, result, error) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        window.webkit.messageHandlers.abNative_IOS.postMessage({
            messageType: 'onWebResult',
            actionId: actionId,
            result: result,
            error: error,
        });
    }
    /* / NativeApp */

}

/* JSLib Exports */
_jsLib.export("default", NativeApp_IOS); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp_Web.js
jsLibs.exportScript("ab-native", "./NativeApp_Web", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-native", "./NativeApp", [ { name: "default", alias: "NativeApp" } ], "./NativeApp.js");

/* export default */ class NativeApp_Web extends (_jsLib.import("ab-native", "./NativeApp", "default", "NativeApp", "./NativeApp.js")) 
{

    constructor() {
        super();
    }

    
    /* NativeApp */
    __callNative(actionId, actionsSetName, actionName, args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int', 'string', 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        abNative_WebApp.callNative(actionId, actionsSetName, actionName, args);
    }

    __init() {
        
    }

    // __onWebResult(actionId, result)
    // {
    //     abNative_WebApp.onWebResult(actionId, result);
    // }
    /* / NativeApp */
}

/* JSLib Exports */
_jsLib.export("default", NativeApp_Web); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\index.js
jsLibs.exportScript("ab-fields", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-fields", "./definitions/Definition", [ { name: "default", alias: "Definition" } ], "./definitions/Definition");
_jsLib.importDeclaration("ab-fields", "./fields/Field", [ { name: "default", alias: "Field" } ], "./fields/Field");

_jsLib.importDeclaration("ab-fields", "./definitions/ListDefinition", [ { name: "default", alias: "ListDefinition" } ], "./definitions/ListDefinition");
_jsLib.importDeclaration("ab-fields", "./fields/ListField", [ { name: "default", alias: "ListField" } ], "./fields/ListField");

_jsLib.importDeclaration("ab-fields", "./definitions/ObjectDefinition", [ { name: "default", alias: "ObjectDefinition" } ], "./definitions/ObjectDefinition");
_jsLib.importDeclaration("ab-fields", "./fields/ObjectField", [ { name: "default", alias: "ObjectField" } ], "./fields/ObjectField");

_jsLib.importDeclaration("ab-fields", "./definitions/VarDefinition", [ { name: "default", alias: "VarDefinition" } ], "./definitions/VarDefinition");
_jsLib.importDeclaration("ab-fields", "./fields/VarField", [ { name: "default", alias: "VarField" } ], "./fields/VarField");

class abFields_Class {
    get Definition() {
        return (_jsLib.import("ab-fields", "./definitions/Definition", "default", "Definition", "./definitions/Definition"));
    }
    get Field() {
        return (_jsLib.import("ab-fields", "./fields/Field", "default", "Field", "./fields/Field"));
    }

    get ListDefinition() {
        return (_jsLib.import("ab-fields", "./definitions/ListDefinition", "default", "ListDefinition", "./definitions/ListDefinition"));
    }
    get ListField() {
        return (_jsLib.import("ab-fields", "./fields/ListField", "default", "ListField", "./fields/ListField"));
    }

    get ObjectDefinition() {
        return (_jsLib.import("ab-fields", "./definitions/ObjectDefinition", "default", "ObjectDefinition", "./definitions/ObjectDefinition"));
    }
    get ObjectField() {
        return (_jsLib.import("ab-fields", "./fields/ObjectField", "default", "ObjectField", "./fields/ObjectField"));
    }

    get VarDefinition() {
        return (_jsLib.import("ab-fields", "./definitions/VarDefinition", "default", "VarDefinition", "./definitions/VarDefinition"));
    }
    get VarField() {
        return (_jsLib.import("ab-fields", "./fields/VarField", "default", "VarField", "./fields/VarField"));
    }

    get debug() {
        return this._debug;
    }


    constructor() {
        this._debug = false;
    }

    define() {
        return new (_jsLib.import("ab-fields", "./definitions/ObjectDefinition", "default", "ObjectDefinition", "./definitions/ObjectDefinition"))();
    }

    setDebug(debug) {
        this._debug = debug;
    }
}
const abFields = new abFields_Class();
/* export default */ abFields;

/* JSLib Exports */
_jsLib.export("default", abFields); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\Definition.js
jsLibs.exportScript("ab-fields", "./definitions/Definition", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export default */ class Definition {
    get listeners() {
        return this._listeners;
    }


    constructor() {
        this._listeners = [];
    }

    addListener(listener) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'object');

        this._listeners.push(listener);
    }


    create(keys = [], root = null, fieldName = null) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
}

/* JSLib Exports */
_jsLib.export("default", Definition); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\ObjectDefinition.js
jsLibs.exportScript("ab-fields", "./definitions/ObjectDefinition", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-fields", "./fields/ObjectField", [ { name: "default", alias: "ObjectField" } ], "../fields/ObjectField");

_jsLib.importDeclaration("ab-fields", "./definitions/Definition", [ { name: "default", alias: "Definition" } ], "./Definition");
_jsLib.importDeclaration("ab-fields", "./definitions/ListDefinition", [ { name: "default", alias: "ListDefinition" } ], "./ListDefinition");
_jsLib.importDeclaration("ab-fields", "./definitions/VarDefinition", [ { name: "default", alias: "VarDefinition" } ], "./VarDefinition");

/* export default */ class ObjectDefinition extends (_jsLib.import("ab-fields", "./definitions/Definition", "default", "Definition", "./Definition")) {
    get fields() {
        return this._fieldDefinitions;
    }


    constructor() { super();

        this._fieldDefinitions = {};
    }

    exists(fieldName) {
        return fieldName in this._fieldDefinitions;
    }

    get(fieldName) {
        if (!this.exists(fieldName))
            throw new Error(`Field definition '${fieldName}' does not exist.`);

        return this._fieldDefinitions[fieldName];
    }

    list(fieldName, overwrite = false) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        if (fieldName in this._fieldDefinitions) {
            let def = this._fieldDefinitions[fieldName];

            if (!overwrite) {
                if (!(def instanceof (_jsLib.import("ab-fields", "./definitions/ListDefinition", "default", "ListDefinition", "./ListDefinition"))))
                    throw new Error(`Field '${fieldName}' already defined not as 'List'.`);

                return def;
            } else {
                if (def instanceof (_jsLib.import("ab-fields", "./definitions/ListDefinition", "default", "ListDefinition", "./ListDefinition")))
                    return def;
            }
        }

        let def = new (_jsLib.import("ab-fields", "./definitions/ListDefinition", "default", "ListDefinition", "./ListDefinition"))();
        this._fieldDefinitions[fieldName] = def;

        return def;
    }

    object(fieldName, overwrite = false) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (fieldName in this._fieldDefinitions) {
            let def = this._fieldDefinitions[fieldName];

            if (!overwrite) {
                if (!(def instanceof ObjectDefinition))
                    throw new Error(`Field '${fieldName}' already defined not as 'Object'.`);
                return def;
            } else {
                if (def instanceof ObjectDefinition)
                    return def;
            }
        }

        let def = new ObjectDefinition();
        this._fieldDefinitions[fieldName] = def;

        return def;
    }

    var(fieldName, overwrite = false) {   
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (fieldName in this._fieldDefinitions) {
            let def = this._fieldDefinitions[fieldName];

            if (!overwrite) {
                if (!(def instanceof (_jsLib.import("ab-fields", "./definitions/VarDefinition", "default", "VarDefinition", "./VarDefinition"))))
                    throw new Error(`Field '${fieldName}' already defined not as 'Var'.`);
                return def;
            } else {
                if (def instanceof (_jsLib.import("ab-fields", "./definitions/VarDefinition", "default", "VarDefinition", "./VarDefinition")))
                    return def;
            }
        }

        let def = new (_jsLib.import("ab-fields", "./definitions/VarDefinition", "default", "VarDefinition", "./VarDefinition"))();
        this._fieldDefinitions[fieldName] = def;

        return def;
    }

    /* Definition Overrides */
    create(keys = [], root = null, fieldName = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, Array ], [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'object' ], 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'string' ]);

        let field = new (_jsLib.import("ab-fields", "./fields/ObjectField", "default", "ObjectField", "../fields/ObjectField"))(this, keys);

        if (root !== null && fieldName !== null) {
            Object.defineProperty(root, fieldName, {
                get: () => {
                    return field.$value;
                },
                set: (value) => {
                    try {
                        field.$value = value;   
                    } catch (err) {
                        console.error('ABFields Stack: ', fieldName);
                        throw err;
                    }
                },
                enumerable: true,
            });
        }

        return field;
    }
    /* / Definition Overrides */
}

/* JSLib Exports */
_jsLib.export("default", ObjectDefinition); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\ListDefinition.js
jsLibs.exportScript("ab-fields", "./definitions/ListDefinition", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-fields", "./fields/ListField", [ { name: "default", alias: "ListField" } ], "../fields/ListField");

_jsLib.importDeclaration("ab-fields", "./definitions/Definition", [ { name: "default", alias: "Definition" } ], "./Definition");
_jsLib.importDeclaration("ab-fields", "./definitions/VarDefinition", [ { name: "default", alias: "VarDefinition" } ], "./VarDefinition");

/* export default */ class ListDefinition extends (_jsLib.import("ab-fields", "./definitions/Definition", "default", "Definition", "./Definition")) {
    constructor() { super();
        this._itemDefinition = null;
    }

    item(itemDefinitionClass = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'function' ]);

        if (this._itemDefinition === null) {
            if (itemDefinitionClass === null)
                itemDefinitionClass = (_jsLib.import("ab-fields", "./definitions/VarDefinition", "default", "VarDefinition", "./VarDefinition"));
            
            this._itemDefinition = new itemDefinitionClass();
            return this._itemDefinition;
        }

        if (itemDefinitionClass !== null) {
            if (!(this._itemDefinition instanceof itemDefinitionClass)) {
                throw new Error(`List items definition class already declared as 
                        '${this._itemDefinition.constructor.name}'.`);
            }
        }

        return this._itemDefinition;
    }


    /* Definition Overrides */
    create(keys = [], root = null, fieldName = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, Array ], [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'object' ], 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'string' ]);

        let field = new (_jsLib.import("ab-fields", "./fields/ListField", "default", "ListField", "../fields/ListField"))(this, keys);

        if (root !== null && fieldName !== null) {
            Object.defineProperty(root, fieldName, {
                get: () => {
                    return field.$value;
                },
                set: (value) => {
                    field.$value = value;
                },
                enumerable: true,
            });
        }

        return field;
    }
    /* / Definition Overrides */
}

/* JSLib Exports */
_jsLib.export("default", ListDefinition); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\VarDefinition.js
jsLibs.exportScript("ab-fields", "./definitions/VarDefinition", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-fields", "./fields/VarField", [ { name: "default", alias: "VarField" } ], "../fields/VarField");
_jsLib.importDeclaration("ab-fields", "./definitions/Definition", [ { name: "default", alias: "Definition" } ], "./Definition");

/* export default */ class VarDefinition extends (_jsLib.import("ab-fields", "./definitions/Definition", "default", "Definition", "./Definition")) {
    constructor() { super();

    }

    /* Definition Overrides */
    create(keys = [], root = null, fieldName = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, Array ], [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'object' ], 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, 'string' ]);

        let field = new (_jsLib.import("ab-fields", "./fields/VarField", "default", "VarField", "../fields/VarField"))(this, keys);

        if (root !== null && fieldName !== null) {
            Object.defineProperty(root, fieldName, {
                get: () => {
                    return field.$value;
                },
                set: (value) => {
                    field.$value = value;
                },
                enumerable: true,
            });
        }

        return field;
    }
    /* / Definition Overrides */
}

/* JSLib Exports */
_jsLib.export("default", VarDefinition); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\Field.js
jsLibs.exportScript("ab-fields", "./fields/Field", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-fields", "./definitions/Definition", [ { name: "default", alias: "Definition" } ], "../definitions/Definition");

/* export default */ class Field {
    get $value() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    set $value(value) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }


    constructor(definition, keys) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-fields", "./definitions/Definition", "default", "Definition", "../definitions/Definition")), Array);

        this.__definition = definition;
        this.__keys = keys;
    }
}

/* JSLib Exports */
_jsLib.export("default", Field); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\ListField.js
jsLibs.exportScript("ab-fields", "./fields/ListField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-fields", "./fields/Field", [ { name: "default", alias: "Field" } ], "./Field");
_jsLib.importDeclaration("ab-fields", "./definitions/ListDefinition", [ { name: "default", alias: "ListDefinition" } ], "../definitions/ListDefinition");

/* export default */ class ListField extends (_jsLib.import("ab-fields", "./fields/Field", "default", "Field", "./Field")) {
    get $size() {
        return this._items.size;
    }

    get $value() {
        let self = this;
        return function() {
            let hasKey = arguments.length > 0;
            let hasValue = arguments.length > 1;

            if (arguments.length > 0) {
                let key = arguments[0];
                if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(key, [ 'number', 'string' ]))
                    throw new Error(`List 'key' must be a number or string.`);

                if (!self.$has(key))
                    self.$add(key);

                if (arguments.length > 1) {
                    self.$get(key).$value = arguments[1];
                    return undefined;
                }

                return self.$get(key).$value;
            }
            
            return self;
        }
    }
    set $value(value) {
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(value, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable ]))
            throw new Error('List value must be an iterable or null.');

        if (value === null)
            return;

        let oldKeys = this.$keys();

        if (value instanceof Array) {
            for (let key of oldKeys) {
                if (!Number.isInteger(key)) {
                    this.$delete(key);
                    continue;
                }

                if (key < 0 || key >= value.length)
                    this.$delete(key);
            }

            for (let i = 0; i < value.length; i++)
                this.$set(i, value[i]);
        } else {
            for (let key of oldKeys) {
                if (!value.has(key))
                    this.$delete(key);
            }
            
            for (let [ key, item ] of value)
                this.$set(key, item);
        }
    }

    constructor(definition, keys) { super(definition, keys);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-fields", "./definitions/ListDefinition", "default", "ListDefinition", "../definitions/ListDefinition")), Array);

        this._root = {};
        this._items = new (_jsLib.import("js0", "./index", "default", "js0", "js0")).List();
    }   

    [Symbol.iterator]() {
        return new ListField.Iterator(this);
    }

    $add(key, value = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', 'string' ], [ null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this.$addAt(this.$size, key, value);

        // if (this._items.has(key))
        //     throw new Error(`Key '${key}' already exists in list.`);

        // let keys = this.__keys.slice();
        // keys.push(key);

        // let itemField = this.__definition.item().create(keys);
        // this._items.set(key, itemField);

        // for (let listener of this.__definition.listeners) {
        //     if ('add' in listener)
        //         listener.add(key, this.__keys);
        // }

        // this.$get(key).$value = value;
    }

    $addAt(index, key, value = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number', [ 'number', 'string' ], null);

        if (this._items.has(key))
            throw new Error(`Key '${key}' already exists in list.`);

        if (index < 0)
            throw new Error(`Index '${index}' cannot be lower than 0.`);
        if (index > this.$size)
            throw new Error(`Index '${index}' cannot be higher than list size '${this.$size}'.`);

        let keys = this.__keys.slice();
        keys.push(key);
        // keys.splice(index, 0, key);

        let itemField = this.__definition.item().create(keys);
        this._items.addAt(index, key, itemField);

        for (let listener of this.__definition.listeners) {
            if ('add' in listener)
                listener.add(index, key, this.__keys);
            if ('change' in listener)
                listener.change(value, this.__keys);
        }

        this.$get(key).$value = value;
    }

    $delete(key) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', 'string' ]);

        if (!this.$has(key))
            throw new Error(`Key '${key}' does not exist in 'ListField'.`);

        this._items.delete(key);

        for (let listener of this.__definition._listeners) {
            if ('delete' in listener)
                listener.delete(key, this.__keys);
            if ('change' in listener)
                listener.change(value, this.__keys);
        }
    }

    $deleteAt(index) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', ]);

        if (index < 0)
            throw new Error(`Index '${index}' cannot be lower than 0.`);

        if (index >= this.$size)
            throw new Error(`Index '${index}' is higher than list size '${this.$size}.`);

        let key = this._items.getKeyAt(index);
        this.$delete(key);
    }

    $get(key) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', 'string' ]);

        if (!(this._items.has(key)))
            throw new Error(`Item with key '${key}' does not exist in list.`);

        return this._items.get(key);
    }

    $has(key) {
        return this._items.has(key);
    }

    $index(key) {
        let keys = this.$keys();
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] === key)
                return i;
        }

        return -1;
    }

    $keys() {
        return this._items.keys();
    }

    $push(value = null) {
        let index = 0;

        if (this._items.size > 0) {
            let lastKey = this._items.getKeyAt(this._items.size - 1);
            if (Number.isInteger(lastKey))
                index = lastKey + 1;
        }

        while (this.$has(index))
            index++;

        this.$add(index, value);
        this.$get(index).$value = value;
    }

    $set(key, value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', 'string' ], null);

        if (!this.$has(key))
            this.$add(key, value);
        else
            this.$get(key).$value = value;
    }
}


Object.defineProperties(ListField, {

    Iterator: { value:
    class ListField_Iterator {

        constructor(listField)
        {
            this._list = listField;
            this._iterator = listField._items[Symbol.iterator]();
        }

        next()
        {
            let iteratorItem = this._iterator.next();

            if (iteratorItem.done)
                return { value: undefined, done: true, };

            return {
                value: [ iteratorItem.value[0], this._list.$get(iteratorItem.value[0]), ],
                done: false,
            };
        }

    }},

});

/* JSLib Exports */
_jsLib.export("default", ListField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\ObjectField.js
jsLibs.exportScript("ab-fields", "./fields/ObjectField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-fields", "./index", [ { name: "default", alias: "abFields" } ], "../index");
_jsLib.importDeclaration("ab-fields", "./fields/Field", [ { name: "default", alias: "Field" } ], "./Field");
_jsLib.importDeclaration("ab-fields", "./definitions/ObjectDefinition", [ { name: "default", alias: "ObjectDefinition" } ], "../definitions/ObjectDefinition");

/* export default */ class ObjectField extends (_jsLib.import("ab-fields", "./fields/Field", "default", "Field", "./Field")) {
    get $value() {
        return this._root;
    }
    set $value(value) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        if (value === null) {
            for (let key in this._fields)
                this._fields[key].$value = null;

            return;
        }

        for (let key in value) {
            if (key in this._fields) {
                try {
                    this._fields[key].$value = value[key];
                } catch (err) {
                    console.error('ABFields Stack: ', key);
                    throw err;
                }
            } else if ((_jsLib.import("ab-fields", "./index", "default", "abFields", "../index")).Debug)
                console.warn(new Error(`Field '${key}' not defined in Object.`));
        }
    }


    constructor(definition, keys) { super(definition, keys);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-fields", "./definitions/ObjectDefinition", "default", "ObjectDefinition", "../definitions/ObjectDefinition")), Array);

        this._root = {};
        this._fields = {};
        
        for (let fieldName in this.__definition.fields) {
            let fieldDef = this.__definition.fields[fieldName];
            let field = fieldDef.create(keys, this._root, fieldName);
            this._fields[fieldName] = field;
        }
    }   

    $delete(key) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'number', 'string' ]);

        if (!(key in this._fields))
            throw new Error(`Key '${key}' does not exist.`);

        delete fields[key];

        for (let listener of this._listeners) {
            if ('delete' in listener)
                listener.delete(key, this._parentFields._keys);
            if ('change' in listener)
                listener.change(value, this._parentFields._keys);
        }
    }

    $get(fieldName) {
        if (!this.$exists(fieldName))
            throw new Error(`Field '${fieldName}' does not exist in object.`);

        return this._fields[fieldName];
    }

    $exists(fieldName) {
        return fieldName in this._fields;
    }

}

/* JSLib Exports */
_jsLib.export("default", ObjectField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\VarField.js
jsLibs.exportScript("ab-fields", "./fields/VarField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-fields", "./fields/Field", [ { name: "default", alias: "Field" } ], "./Field");
_jsLib.importDeclaration("ab-fields", "./definitions/VarDefinition", [ { name: "default", alias: "VarDefinition" } ], "../definitions/VarDefinition");

/* export default */ class VarField extends (_jsLib.import("ab-fields", "./fields/Field", "default", "Field", "./Field")) {
    get $value() {
        return this._value;
    }
    set $value(value) {
        this._value = value;

        for (let listener of this.__definition.listeners) {
            if ('change' in listener)
                listener.change(value, this.__keys);
        }
    }

    constructor(definition, keys) { super(definition, keys);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-fields", "./definitions/VarDefinition", "default", "VarDefinition", "../definitions/VarDefinition")), Array);

        this._value = undefined;
    }

}

/* JSLib Exports */
_jsLib.export("default", VarField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-layouts\index.js
jsLibs.exportScript("ab-layouts", "./index", [ "abLayouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-layouts", "./LayoutNode", [ { name: "default", alias: "LayoutNode" } ], "./LayoutNode");
_jsLib.importDeclaration("ab-layouts", "./Parser", [ { name: "default", alias: "Parser" } ], "./Parser");

/* export */ class abLayouts_Class {
    get LayoutNode() {
        return (_jsLib.import("ab-layouts", "./LayoutNode", "default", "LayoutNode", "./LayoutNode"));
    }

    get Parser() {
        return (_jsLib.import("ab-layouts", "./Parser", "default", "Parser", "./Parser"));
    }
}
const abLayouts = new abLayouts_Class();
/* export default */ abLayouts;


/* JSLib Exports */
_jsLib.export("abLayouts_Class", abLayouts_Class);
_jsLib.export("default", abLayouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-layouts\LayoutNode.js
jsLibs.exportScript("ab-layouts", "./LayoutNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export default */ class LayoutNode extends (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node {
    constructor()
    { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, LayoutNode.PChildren, this);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, LayoutNode.PCopyable, this, arguments);

        // this._idNodes = {};
    }

    // setIds(id_nodes)
    // {
    //     js0.argsE(arguments, 'object');
    //
    //     this._idNodes = id_nodes;
    // }


    /* Node */
    __isDisplayed()
    {
        return this.parentNode.displayed && this.active;
    }

    __onActivate()
    {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement()
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        return this.pChildren.length === 0 ?
                null : this.pChildren.get(0).firstHtmlElement;
    }
    /* / Node */

}


Object.defineProperties(LayoutNode, {
    PChildren: { value:
    class LayoutNode_PChildren extends (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node.PChildren
    {

        constructor(node)
        {
            super(node);
        }
        
        __onAddChild(childNode, next_node)
        {
            if (next_node === null)
                childNode._nextNode = this._nextNode;

            if (this.node.active)
                childNode.activate();
        }

        __getNext(childNode)
        {
            let next_node = this.findNext(childNode);
            if (next_node !== null)
                return next_node;

            return this.node.nextNode;
        }

        __getNextHtmlElement()
        {
            return this.node.nextHtmlElement;
        }

    }},

    PCopyable: { value:
    class LayoutNode_PCopyable extends (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node.PCopyable
    {
        constructor(node, args)
        {
            super(node, args);
        }

        __createCopy(deepCopy, nodeInstances)
        {
            return new LayoutNode(this.__args[0]);
        }

        __deleteCopy(instanceKeys) {
            
        }
    }},
});


/* JSLib Exports */
_jsLib.export("default", LayoutNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-layouts\Parser.js
jsLibs.exportScript("ab-layouts", "./Parser", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-layouts", "./LayoutNode", [ { name: "default", alias: "LayoutNode" } ], "./LayoutNode");

/* export default */ class Parser {
    get __elementsStack() {
        return this._elementsStack;
    }


    constructor(layoutContent)
    {
        this._elementsStack = null;
        this._extendFns = [];
    }

    extend(fn)
    {
        this._extendFns.push(fn);
    }

    parse(layoutContent)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array);

        this.__beforeParse();

        let layoutNode = new (_jsLib.import("ab-layouts", "./LayoutNode", "default", "LayoutNode", "./LayoutNode"))();

        let parentsStack = [{
            node: null,
            nodeContent: layoutContent,
            elements: [],
        }];

        while (parentsStack.length > 0) {
            let parent = parentsStack.pop();

            for (let i = 0; i < parent.nodeContent.length; i++) {
                let nodeInfo = this._parseNodeInfo(parent.nodeContent[i]);

                let element = this.__createElement(nodeInfo, parent.elements);
                if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(element, Parser.Element)) {
                    throw new Error(`\`__createNode\` must return` +
                            ` \`abLayout.Parser.Element\` object.`);
                }

                // if ('_id' in nodeInfo.attribs) {
                //     if (nodeInfo.attribs._id in id_nodes) {
                //         console.warn('Node with id `' + nodeInfo.attribs._id +
                //                 '` already exists.');
                //     }
                //     // id_nodes[nodeInfo.attribs._id] = node;
                // }

                if (parent.node === null)
                    layoutNode.pChildren.add(element.topNode);
                else
                    parent.node.pChildren.add(element.topNode);

                if (nodeInfo.type === '_content')
                    continue;

                if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(element.bottomNode, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node.PChildren))) {
                    parentsStack.push({
                        node: element.bottomNode,
                        nodeContent: nodeInfo.content,
                        elements: parent.elements.concat([ element ]),
                    });
                }
            }

            // parentNodesStack.pop();
            // parent.nodeContentsStack.pop();
            // return;
        }

        // layoutNode.setIds(id_nodes);

        this.__afterParse();

        return layoutNode;
    }


    _execExtendFns(element)
    {
        for (let extendFn of this._extendFns)
            extendFn(element);
    }

    _parseNodeInfo(nodeInfo)
    {
        /* Validate */
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).argsC(arguments, [ Array, 'string' ]) || nodeInfo === null) {
            console.error('Error info:', nodeInfo)
            throw new Error(`Node info must be an \`Array\` or \`string\`.`);
        }
        /* / Validate */
        if (nodeInfo instanceof Array) {
            if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(nodeInfo[0], 'string')) {
                console.error('Error info:', nodeInfo);
                throw new Error('First element of node info array must be a string.');
            }

            let nodeType = nodeInfo[0];
            let nodeAttribs = {};
            let nodeContent = [];
            for (let i = 1; i < nodeInfo.length; i++) {
                /* Parse Args */
                if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(nodeInfo[i], (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject)) {
                    for (let attribName in nodeInfo[i]) {
                        let attribValue = nodeInfo[i][attribName];

                        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(attribValue, [ 'string', Array ]) ||
                                attribValue === null) {
                            console.error('Error info: ', nodeInfo[i]);
                            throw new Error(`Node attrib must be \`string\` or \`Array\`.`);
                        }

                        if (!(attribName in nodeAttribs))
                            nodeAttribs[attribName] = [];

                        if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(attribValue, 'string'))
                            nodeAttribs[attribName].push(attribValue);
                        else
                            nodeAttribs[attribName] = nodeAttribs[attribName]
                                    .concat(attribValue);
                    }
                /* Parse Node */
                } else
                    nodeContent.push(nodeInfo[i]);
            }

            let element = {
                type: nodeType,
                attribs: nodeAttribs,
                content: nodeContent,
            };

            this._execExtendFns(element);

            return element;
        } else {
            let element = {
                type: '_content',
                attribs: {},
                content: nodeInfo,
            }

            this._execExtendFns(element);

            return element;
        }

        // let nodeType = nodeInfo_keys[0];
        // let nodeContent = nodeInfo[nodeType];
        // this._validateNodeContent(nodeContent);
        //
        // let nodeAttribs = this._parseNodeAttrs(nodeType, nodeContent);
        // if (nodeAttribs !== null)
        //     nodeContent.splice(0, 1);
        //
    }

    _parseNodeAttrs(nodeType, nodeContent)
    {
        if (nodeContent === null)
            return null;
        if (nodeContent.length === 0)
            return null;
        if (Object.keys(nodeContent[0]).length === 0)
            return {};

        let attribs = null;
        for (let attribName in nodeContent[0]) {
            if (attribName[0] !== '_') {
                if (attribs !== null) {
                    console.error('Error info:', { nodeType:  nodeContent });
                    new Error('Only attribs are allowed in first content element.');
                }

                continue;
            }

            if (attribs === null)
                attribs = {};

            attribs[attribName] = nodeContent[0][attribName];
        }

        return attribs;
    }

    // _validateNodeContent(nodeType, nodeContent)
    // {
    //     if (nodeContent !== null) {
    //         if (!(nodeContent instanceof Array)) {
    //             console.error('Error info:', nodeType, nodeContent);
    //             throw new Error('Node content must be `null` or `Array`.');
    //         }
    //     }
    // }


    __afterParse()
    {

    }

    __beforeParse()
    {

    }


    __createElement(nodeInfo) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

}


Object.defineProperties(Parser, {
    Element: { value:
    class
    {

        constructor(topNode, bottomNode, info)
        {
            this.topNode = topNode;
            this.bottomNode = bottomNode;
            this.info = info;
        }

    }},
});


/* JSLib Exports */
_jsLib.export("default", Parser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\HtmlElement.js
jsLibs.exportScript("ab-nodes", "./HtmlElement", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "./index");

/* export default */ class HtmlElement {
    static AddChild(parentHtmlElement, htmlElement, nextHtmlElement = null) {
        try {
            if (nextHtmlElement === null)
                parentHtmlElement.appendChild(htmlElement);
            else
                parentHtmlElement.insertBefore(htmlElement, nextHtmlElement);
        } catch (e) {
            if ((_jsLib.import("ab-nodes", "./index", "default", "abNodes", "./index")).debug)
                console.warn(e);
        }
    }

    static ClearChildren(htmlElement) {
        while (htmlElement.firstChild)
            htmlElement.removeChild(htmlElement.firstChild);
    }

    static RemoveChild(parentHtmlElement, htmlElement) {
        try {
            parentHtmlElement.removeChild(htmlElement);
        } catch (e) {
            if ((_jsLib.import("ab-nodes", "./index", "default", "abNodes", "./index")).debug)
                console.warn(e);
        }
    }
}


/* JSLib Exports */
_jsLib.export("default", HtmlElement); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\index.js
jsLibs.exportScript("ab-nodes", "./index", [ "abNodes_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./nodes/HideNode", [ { name: "default", alias: "HideNode" } ], "./nodes/HideNode");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "./Node");
_jsLib.importDeclaration("ab-nodes", "./nodes/RepeatNode", [ { name: "default", alias: "RepeatNode" } ], "./nodes/RepeatNode");
_jsLib.importDeclaration("ab-nodes", "./nodes/RootNode", [ { name: "default", alias: "RootNode" } ], "./nodes/RootNode");
_jsLib.importDeclaration("ab-nodes", "./nodes/ShowNode", [ { name: "default", alias: "ShowNode" } ], "./nodes/ShowNode");
_jsLib.importDeclaration("ab-nodes", "./nodes/SingleNode", [ { name: "default", alias: "SingleNode" } ], "./nodes/SingleNode");
_jsLib.importDeclaration("ab-nodes", "./nodes/TextNode", [ { name: "default", alias: "TextNode" } ], "./nodes/TextNode");

/* export */ class abNodes_Class {
    get HideNode() {
        return (_jsLib.import("ab-nodes", "./nodes/HideNode", "default", "HideNode", "./nodes/HideNode"));
    }

    get Node() {
        return (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node"));
    }

    get RepeatNode() {
        return (_jsLib.import("ab-nodes", "./nodes/RepeatNode", "default", "RepeatNode", "./nodes/RepeatNode"));
    }

    get RootNode() {
        return (_jsLib.import("ab-nodes", "./nodes/RootNode", "default", "RootNode", "./nodes/RootNode"));
    }

    get ShowNode() {
        return (_jsLib.import("ab-nodes", "./nodes/ShowNode", "default", "ShowNode", "./nodes/ShowNode"));
    }

    get SingleNode() {
        return (_jsLib.import("ab-nodes", "./nodes/SingleNode", "default", "SingleNode", "./nodes/SingleNode"));
    }

    get TextNode() {
        return (_jsLib.import("ab-nodes", "./nodes/TextNode", "default", "TextNode", "./nodes/TextNode"));
    }


    get debug() {
        return this._debug;
    }
    

    constructor() {
        this._debug = false;
    }

    setDebug(debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._debug = debug;
    }
};
const abNodes = new abNodes_Class();
/* export default */ abNodes;


/* JSLib Exports */
_jsLib.export("abNodes_Class", abNodes_Class);
_jsLib.export("default", abNodes); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\Node.js
jsLibs.exportScript("ab-nodes", "./Node", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./Node_PChildren", [ { name: "default", alias: "Node_PChildren" } ], "./Node_PChildren");
_jsLib.importDeclaration("ab-nodes", "./Node_PCopyable", [ { name: "default", alias: "Node_PCopyable" } ], "./Node_PCopyable");

/* export default */ class Node {
    static get PChildren() {
        return (_jsLib.import("ab-nodes", "./Node_PChildren", "default", "Node_PChildren", "./Node_PChildren"));
    }

    static get PCopyable() {
        return (_jsLib.import("ab-nodes", "./Node_PCopyable", "default", "Node_PCopyable", "./Node_PCopyable"));
    }

    get active() {
        return this._active;
    }

    get displayed() {
        return this._displayed;
    }

    get firstHtmlElement() {
        let firstHtmlElement = this.__getFirstHtmlElement();
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(firstHtmlElement, [ HTMLElement, Text, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ])) {
            throw new Error(`\`__getFirstHtmlElement\` in \`${this.constructor.name}\`` +
                    `does not return \`HTMLElement\`.`);
        }

        if (firstHtmlElement !== null)
            return firstHtmlElement;

        if (this.hasParent) {
            let nextHtmlElement = this.parentNode.pChildren.findNextHtmlElement(this);
            if (nextHtmlElement === null)
                return null;

            return nextHtmlElement;
        }

        return null;;
    }

    get hasParent() {
        return this._parentNode !== null;
    }

    get htmlElement() {
        let htmlElement = this.__getHtmlElement();
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(htmlElement, HTMLElement)) {
            throw new Error(`\`__getHtmlElement\` in \`${this.constructor.name}\`` +
                    `does not return \`HTMLElement\`.`);
        }

        return htmlElement;
    }

    get nextHtmlElement() {
        if (this.hasParent)
            return this.parentNode.pChildren.findNextHtmlElement(this)

        return null;
    }

    get nextNode() {
        return this.hasParent ? this.parentNode.pChildren.__getNext(this) : null;
    }

    get parentNode() {
        // if (this._parentNode === null)
        //     throw new Error('Parent node not set.');

        return this._parentNode;
    }


    constructor() {
        this._active = false;
        this._displayed = false;
        
        this._parentNode = null;

        this._listeners_OnDisplay = [];
    }

    activate() {
        if (this.active)
            return;
        this._active = true;

        this.__onActivate();
    }

    addListener_OnDisplay(listener) {
        this._listeners_OnDisplay.push(listener);
    }

    deactivate() {
        if (!this.active)
            return;
        this._active = false;

        this.__onDeactivate();
    }

    refreshDisplayed(refreshChildren = false) {
        let displayed = this.__isDisplayed();
        if (this._displayed === displayed)
            return;

        this._displayed = displayed;
        for (let listener of this._listeners_OnDisplay)
            listener(displayed);

        if (refreshChildren) {
            if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(this, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop(Node.PChildren))) {
                for (let i = 0; i < this.pChildren.length; i++)
                    this.pChildren.get(i).refreshDisplayed(true);
            }
        }
    }

    removeListener_OnDisplay(listener) {
        for (let i = this._listeners_OnDisplay.length - 1; i >= 0; i--) {
            if (this._listeners_OnDisplay[i] === listener)
                this._listeners_OnDisplay.splice(i, 1);
        }
    }


    __getHtmlElement() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __getFirstHtmlElement() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

    __isDisplayed() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

    __onActivate() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __onDeactivate() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

}


/* JSLib Exports */
_jsLib.export("default", Node); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\Node_PChildren.js
jsLibs.exportScript("ab-nodes", "./Node_PChildren", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "./Node");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./nodes/RepeatNode", [ { name: "default", alias: "RepeatNode" } ], "./nodes/RepeatNode");

/* export default */ class Node_PChildren {
    static get Property() { return 'pChildren'; }

    get length(){
        return this._children.length;
    }

    get node() {
        return this._node;
    }


    constructor(node) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")));

        this._node = node;
        this._children = [];
    }

    add(childNode, nextNode = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")), [ (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let insertIndex = nextNode === null ?
                this._children.length : this._children.indexOf(nextNode);
        if (insertIndex === -1)
            new Error('`nextNode` does not exist in `childNode` parent.');

        childNode._parentNode = this._node;

        this._children.splice(insertIndex, 0, childNode);

        this.__onAddChild(childNode);
    }

    // addAt(index, childNode)
    // {
    //     js0.args(arguments, 'number', Node);

    //     if (index < 0)
    //         throw new Error(`Index '${index}' cannot be lower than 0.`);
    //     if (index > this._children.length)
    //         throw new Error(`Index '${index}' cannot be higher than children size '${this._children.length}'.`);
        
    //     childNode._parentNode = this._node;

    //     this._children.splice(index, 0, childNode);

    //     this.__onAddChild(childNode);
    // }

    createCopy(topNodeCopy, instanceKeys) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")), Array);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(this._node, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")).PCopyable));

        let nodeCopiesStack = [ topNodeCopy ];

        while(nodeCopiesStack.length > 0) {
            let nodeCopy = nodeCopiesStack.pop();
            let children = nodeCopy.pCopyable.getOriginalNode().pChildren;

            for (let i = 0; i < children.length; i++) {
                let childNodeCopy = children.get(i).pCopyable
                        .createCopy(instanceKeys, false);

                nodeCopy.pChildren.add(childNodeCopy);

                if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(childNodeCopy, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")).PChildren)))
                    continue;

                // /* Copy only first repeat node. */
                // console.log('Test', nodeCopy === top_node);
                if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(childNodeCopy, (_jsLib.import("ab-nodes", "./nodes/RepeatNode", "default", "RepeatNode", "./nodes/RepeatNode"))))
                    continue;

                nodeCopiesStack.push(childNodeCopy);
            }
        }
    }

    deleteCopies(topOriginalNode, instanceKeys) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")), Array);

        let originalNodesStack = [ topOriginalNode ];

        while(originalNodesStack.length > 0) {
            let originalNode = originalNodesStack.pop();
            let children = originalNode.pChildren;

            for (let i = 0; i < children.length; i++) {
                let childNode = children.get(i);

                childNode.pCopyable.deleteCopies(instanceKeys, false);

                if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(childNode, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")).PChildren)))
                    continue;

                originalNodesStack.push(childNode);
            }

            // nodeCopiesStack.shift();
            // children_stack.shift();
        }

        return topOriginalNode;
    }

    findNext(childNode) {
        let childNodeIndex = this._children.indexOf(childNode);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(childNodeIndex !== -1, '`childNode` not found.');

        if (childNodeIndex < this._children.length - 1)
            return this._children[childNodeIndex + 1];

        return null;
    }

    findNextHtmlElement(childNode) {
        let nextHtmlElement = null;
    
        // console.log('Test', this.node, childNode)

        let nextNode = this.findNext(childNode);
        if (nextNode !== null)
            nextHtmlElement = nextNode.firstHtmlElement;

        if (nextHtmlElement !== null)
            return nextHtmlElement;

        nextHtmlElement = this.__getNextHtmlElement();

        // js0.assert(typeof nextHtmlElement !== 'undefined', '???');
        // if (typeof nextHtmlElement === 'undefined')
        //     throw new Error();

        return nextHtmlElement;
    }

    // findNextHtmlElement(childNode)
    // {
    //     let nextHtmlElement = null;
     
    //     let startIndex = null;
    //     for (let i = 0; i < this._children.length; i++) {
    //         if (this._children[i] === childNode) {
    //             startIndex = i + 1;
    //             break;
    //         }
    //     }

    //     if (startIndex === null)
    //         throw new Error(`Node '${childNode}' is not a child of '${this._node}'.`);

    //     for (let i = startIndex; i < this._children.length; i++) {
    //         let nextNode = this._children[i];
    //         let nextHtmlElement = nextNode.__getFirstHtmlElement();
    //         if (!js0.type(nextHtmlElement, [ HTMLElement, Text, js0.Null ])) {
    //             throw new Error(`\`__getFirstHtmlElement\` in \`${this.constructor.name}\`` +
    //                     `does not return \`HTMLElement\`.`);
    //         }

    //         if (nextHtmlElement !== null)
    //             return nextHtmlElement;
            
    //             nextHtmlElement = this.__getNextHtmlElement();
    //         if (nextHtmlElement !== null)
    //             return nextHtmlElement;
    //     }

    //     return null;
    // }

    get(childNodeIndex) {
        return this._children[childNodeIndex];
    }

    remove(childNode) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")));

        for (let i = 0; i < this._children.length; i++) {
            if (this._children[i] === childNode) {
                childNode.refreshDisplayed(true);
                childNode.deactivate();
                this._children.splice(i, 1);
            }
        }
    }

    __getNext(childNode) {
        return this.findNext(childNode);
    }

    __getNextHtmlElement() {
        return null;
    }

    __onAddChild() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

}


/* JSLib Exports */
_jsLib.export("default", Node_PChildren); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\Node_PCopyable.js
jsLibs.exportScript("ab-nodes", "./Node_PCopyable", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "./Node");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./nodes/RepeatNode_InstanceNode", [ { name: "default", alias: "RepeatNode_InstanceNode" } ], "./nodes/RepeatNode_InstanceNode");

/* export default */ class Node_PCopyable {
    static get Property() { return 'pCopyable'; }


    get node() {
        return this._node;
    }

    get sourceNode() {
        return this._source;
    }


    constructor(node, args) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")), null);

        this._node = node;
        this.__args = args;

        this._copies = [];
        this._copies_ByInstanceKeys = {};

        this._source = null;
        this._instanceKeys = [];

        this._listeners_OnCreate = [];
        this._listeners_OnDestroy = [];
    }

    createCopy(instanceKeys, deepCopy = true) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this._source === null, 'Cannot create copy of a copy.');

        // console.log('CREATE NODE', this.node.constructor.name, instanceKeys);

        let nodeCopy = this.__createCopy(instanceKeys);
        nodeCopy.pCopyable._source = this.node;
        for (let instanceKey of instanceKeys)
            nodeCopy.pCopyable._instanceKeys.push(instanceKey);

        if (deepCopy && (_jsLib.import("js0", "./index", "default", "js0", "js0")).type(this.node, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")).PChildren)))
            this.node.pChildren.createCopy(nodeCopy, instanceKeys);

        this._copies_Add(instanceKeys, nodeCopy);
        // this._copies.push(nodeCopy);

        for (let listener of this._listeners_OnCreate)
            listener(nodeCopy, instanceKeys);

        return nodeCopy;
    }

    deleteCopies(instanceKeys, deepDelete = true) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this._source === null, 'Cannot create copy of a copy.');

        let nodeCopies = this._copies_Get(instanceKeys, true);
        for (let nodeCopy of nodeCopies) {
            for (let i = this._copies.length - 1; i >= 0; i--) {
                if (this._copies[i] !== nodeCopy)
                    continue;

                nodeCopy.pCopyable.__deleteCopy(instanceKeys);

                for (let listener_OnDestroy of this._listeners_OnDestroy)
                    listener_OnDestroy(nodeCopy, instanceKeys);

                this._copies.splice(i, 1);

                break;
            }    
        }

        if (deepDelete && (_jsLib.import("js0", "./index", "default", "js0", "js0")).type(this.node, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./Node", "default", "Node", "./Node")).PChildren)))
            this.node.pChildren.deleteCopies(this.node, instanceKeys);
    }

    getInstanceKeys() {
        return this._instanceKeys.slice();
    }

    getNodeCopies(instanceKeys = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        if (instanceKeys === null)
            return this._copies.slice();

        return this._copies_Get(instanceKeys);

        // let nodeCopies = [];
        // for (let nodeCopy of this._copies) {
        //     // console.log('WTF?');
        //     // console.log('Bam', instanceKeys, nodeCopy.pCopyable._instanceKeys);
        //     if (nodeCopy.pCopyable.matchInstanceKeys(instanceKeys))
        //         nodeCopies.push(nodeCopy);
        // }

        // return nodeCopies;
    }

    getOriginalNode() {
        let sourceNode = this.node;
        while (sourceNode.pCopyable._source !== null)
            sourceNode = this._source;

        return sourceNode;
    }

    matchInstanceKeys(instanceKeys, exact = true) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array);

        if (this._source === null)
            throw new Error(`\`matchInstanceKeys\` on node that is not a copy.`);

        if (exact) {
            if (instanceKeys.length !== this._instanceKeys.length)
                return false;
        }

        for (let i = 0; i < instanceKeys.length; i++) {
            if (instanceKeys[i] === null)
                continue;

            if (instanceKeys[i] !== this._instanceKeys[i])
                return false;
        }

        return true;
    }

    onCreate(onCreateListener) {
        this._listeners_OnCreate.push(onCreateListener);
    }

    onDestroy(onDestroyListener) {
        this._listeners_OnDestroy.push(onDestroyListener);
    }


    _copies_Add(instanceKeys, nodeCopy) {
        let copies_Root = this._copies_GetRoot(this._copies_ByInstanceKeys,
                instanceKeys, true);

        if (!('_$nodes' in copies_Root))
            copies_Root._$nodes = [];

        copies_Root._$nodes.push(nodeCopy);
        this._copies.push(nodeCopy);
    }

    _copies_Get(instanceKeys, remove = false) {
        let copies_Root = this._copies_GetRoot(this._copies_ByInstanceKeys,
                instanceKeys, false);
        if (copies_Root === null)
            return [];

        if (!('_$nodes' in copies_Root))
            return [];

        if (remove) {
            let nodeCopies = copies_Root._$nodes;
            copies_Root._$nodes = [];
            return nodeCopies;
        } else
            return copies_Root._$nodes.slice();
    }

    _copies_GetRoot(copies_Current, instanceKeys, create) {
        for (let i = 0; i < instanceKeys.length; i++) {
            if (instanceKeys[i] === null) {
                let copies = {
                    _$nodes: [],
                };
                if ('_$nodes' in copies_Current)
                    copies._$nodes = copies._$nodes.concat(copies_Current._$nodes);

                for (let instanceKey_T in copies_Current) {
                    if (instanceKey_T === '_$nodes')
                        continue;

                    let copies_New = this._copies_GetRoot(copies_Current[instanceKey_T],
                            instanceKeys.slice(i + 1), create);
                    if (copies_New !== null) {
                        if ('_$nodes' in copies_New) {
                            copies._$nodes = copies._$nodes.concat(
                                    copies_New._$nodes);
                        }
                    }
                }

                return copies;
            }
            
            if (!(instanceKeys[i] in copies_Current)) {
                if (create)
                    copies_Current[instanceKeys[i]] = {};
                else
                    return null;
            }

            copies_Current = copies_Current[instanceKeys[i]];
        }

        return copies_Current;
    }

    // _copies_GetRoot(instanceKeys, create)
    // {
    //     let copies_Current = this._copies_ByInstanceKeys;

    //     for (let i = 0; i < instanceKeys.length; i++) {
    //         if (!(instanceKeys[i] in copies_Current)) {
    //             if (create)
    //                 copies_Current[instanceKeys[i]] = {};
    //             else
    //                 return null;
    //         }

    //         copies_Current = copies_Current[instanceKeys[i]];
    //     }

    //     return copies_Current;
    // }

    __addInstance(key, instanceNode) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', 'number' ], (_jsLib.import("ab-nodes", "./nodes/RepeatNode_InstanceNode", "default", "RepeatNode_InstanceNode", "./nodes/RepeatNode_InstanceNode")));

        this._instanceInfos.push({
            key: key,
            instanceNode: instanceNode
        });

        instanceNode.addNodeCopy(this.node);
    }

    // __setSourceNode(sourceNode)
    // {
    //     js0.args(arguments, Node);
    //
    //     this._source = sourceNode;
    // }

    __createCopy(instanceKeys) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __deleteCopy(instanceKeys) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
}


/* JSLib Exports */
_jsLib.export("default", Node_PCopyable); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\HideNode.js
jsLibs.exportScript("ab-nodes", "./nodes/HideNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");

/* export default */ class HideNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {

    get hide() {
        return this._hide;
    }
    set hide(hideValue) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        if (hideValue === this._hide)
            return;
        this._hide = hideValue;

        if (!this.active)
            return;

        if (hideValue) {
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).deactivate();
            this.refreshDisplayed(true);
        } else {
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).activate();
            this.refreshDisplayed(true);
        }
    }


    constructor() { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, HideNode.PChildren, this);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, HideNode.PCopyable, this, arguments);

        this._hide = false;
    }


    /* Node */
    __isDisplayed() {
        if (!this.active || this.hide)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        if (this.hide)
            return;

        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate() {
        if (this.hide)
            return;

        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement() {
        for (let i = 0; i < this.pChildren.length; i++) {
            let childFirstHtmlElement = this.pChildren.get(i).firstHtmlElement;
            if (childFirstHtmlElement !== null)
                return childFirstHtmlElement;
        }

        return null;
    }
    /* / Node */

}


Object.defineProperties(HideNode, {
    PChildren: { value:
    class HideNode_PChildren extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PChildren {

        constructor(node) { super(node);

        }

        __onAddChild(childNode, nextNode) {
            // if (nextNode === null)
            //     childNode._nextNode = this._nextNode;

            if (this.node.active && !this.node.hide)
                childNode.activate();
        }

        __getNext(childNode) {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            return this.node.nextNode;
        }

        __getNextHtmlElement() {
            return this.node.nextHtmlElement;
        }

    }},

});


Object.defineProperties(HideNode, {
    PCopyable: { value:
    class HideNode_PCopyable extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PCopyable {

        constructor(node, args) { super(node, args);

        }

        __createCopy(deepCopy, nodeInstances) {
            return new HideNode();
        }

        __deleteCopy(instanceKeys) {
            
        }

    }},
});

/* JSLib Exports */
_jsLib.export("default", HideNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\RepeatNode.js
jsLibs.exportScript("ab-nodes", "./nodes/RepeatNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");
_jsLib.importDeclaration("ab-nodes", "./nodes/RepeatNode_InstanceNode", [ { name: "default", alias: "RepeatNode_InstanceNode" } ], "./RepeatNode_InstanceNode");

/* export default */ class RepeatNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {
    static get InstanceNode() {
        return (_jsLib.import("ab-nodes", "./nodes/RepeatNode_InstanceNode", "default", "RepeatNode_InstanceNode", "./RepeatNode_InstanceNode"));
    }


    constructor() { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, RepeatNode.PChildren, this);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, RepeatNode.PCopyable, this, arguments);

        this._instances = new (_jsLib.import("js0", "./index", "default", "js0", "js0")).List();
    }

    add(key) {
        if (this._instances.has(key))
            throw new Error(`Instance with key \`${key}\` already exists.`);

        let instance = new RepeatNode.InstanceNode(this, key);

        this._instances.set(key, instance);
        let node_Original = this.pCopyable.getOriginalNode();

        let instanceKeys = this.pCopyable._instanceKeys.concat([ key ]);
        for (let i = 0; i < node_Original.pChildren.length; i++) {
            let newChildNode = node_Original.pChildren.get(i).pCopyable
                    .createCopy(instanceKeys);
            instance.pChildren.add(newChildNode);
        }
            
        if (this.active)
            instance.activate();
    }

    addAt(index, key) {
        if (this._instances.has(key))
            throw new Error(`Instance with key \`${key}\` already exists.`);
        if (index < 0)
            throw new Error(`Index '${index}' cannot be lower than 0.`);
        if (index > this._instances.size)
            throw new Error(`Index '${index}' cannot be higher than instances size '${this._instances.size}'.`);

        let instance = new RepeatNode.InstanceNode(this, key);

        this._instances.addAt(index, key, instance);
        let node_Original = this.pCopyable.getOriginalNode();

        let instanceKeys = this.pCopyable._instanceKeys.concat([ key ]);

        for (let i = 0; i < node_Original.pChildren.length; i++) {
            let newChildNode = node_Original.pChildren.get(i).pCopyable
                    .createCopy(instanceKeys);

            instance.pChildren.add(newChildNode);
        }

        if (this.active)
            instance.activate();
    }

    delete(key) {
        if (!this._instances.has(key))
            throw new Error(`Instance with key \`${key}\ does not exist.`);

        let instance = this._instances.get(key);
        this._instances.delete(key);

        let node_Original = this.pCopyable.getOriginalNode();
        let instanceKeys = this.pCopyable._instanceKeys.concat([ key ]);
        for (let i = 0; i < node_Original.pChildren.length; i++)
            node_Original.pChildren.get(i).pCopyable.deleteCopies(instanceKeys);
        
        //
        // for (let i = 0; i < node_Original.pChildren.length; i++) {
        //
        //     let newChildNode = node_Original.pChildren.get(i).pCopyable.createCopy(
        //             true, this.pCopyable._instanceKeys.concat([ key ]));
        //     instance.pChildren.add(newChildNode);
        // }

        if (this.active)
            instance.deactivate();
    }

    getInstanceNodeCopies(sourceNode, key) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")), [ 'string', 'number' ]);

        if (!this._instances.has(key))
            return null;

        let instance = this._instances.get(key);

        let nodeCopies = [];
        for (let nodeCopy of instance._nodeCopies) {
            if (nodeCopy.pCopyable.sourceNode === sourceNode)
                nodeCopies.push(nodeCopy);
        }

        return nodeCopies;
    }

    pop() {
        if (this._instances.size <= 0)
            throw new Error('Cannot `pop` on empty `RepeatNode`.');

        let key = Array.from(this._instances.keys)[this._instances.size - 1];
        let lastInstance = this._instances.get(key);

        if (this.active)
            lastInstance.deactivate();
    }

    push() {
        let index = 0;
        while(this._instances.has(index))
            index++;

        this.add(index);
    }


    /* Node */
    __isDisplayed() {
        if (!this.active)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        for (let i = 0; i < this._instances.size; i++)
            this._instances.getAt(i).activate();
    }

    __onDeactivate() {
        for (let i = this._instances.size - 1; i >= 0; i--)
            this._instances.getAt(i).deactivate();
    }

    __getHtmlElement() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement() {
        return this._instances.size === 0 ?
                null : this._instances.getAt(0).firstHtmlElement;
    }
    /* / Node */
}


Object.defineProperties(RepeatNode, {
    PChildren: { value:
    class extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PChildren {

        constructor(node) {
            super(node);
        }

        __onAddChild(childNode, nextNode) {
            (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(childNode, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PCopyable));
            // js0.args(arguments, js0.Prop(Node.PCopyable), Node);
        }

        __getNext(childNode) {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            return this.nextNode;
        }

        __getNextHtmlElement() {
            if (this.node.hasParent)
                return this.node.parentNode.nextHtmlElement;

            return null;
        }

    }},


    PCopyable: { value:
    class RepeatNode_PCopyable extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PCopyable {

        __createCopy(nodeInstance) {
            return new RepeatNode();
        }

        __deleteCopy(instanceKeys) {
           for (let i = this.node._instances.size - 1; i >= 0; i--)
                this.node.delete(this.node._instances.getKeyAt(i));
        }

    }},
});


/* JSLib Exports */
_jsLib.export("default", RepeatNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\RepeatNode_InstanceNode.js
jsLibs.exportScript("ab-nodes", "./nodes/RepeatNode_InstanceNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./nodes/RepeatNode", [ { name: "default", alias: "RepeatNode" } ], "./RepeatNode");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");

/* export default */ class RepeatNode_InstanceNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {
    get key() {
        return this._key;
    }

    constructor(repeatNode, key) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./nodes/RepeatNode", "default", "RepeatNode", "./RepeatNode")), [ 'number', 'string' ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, (_jsLib.import("ab-nodes", "./nodes/RepeatNode", "default", "RepeatNode", "./RepeatNode")).InstanceNode.PChildren, this);
        // js0.prop(this, RepeatNode.InstanceNode.PCopyable, this);

        this._key = key;

        this._repeatNode = repeatNode;
        this._nodeCopies = [];
    }

    addNodeCopy(nodeCopy) {
        this._nodeCopies.push(nodeCopy);
    }

    getRepeatNode() {
        return this._repeatNode;
    }


    /* Node */
    __isDisplayed() {
        return this._repeatNode.displayed && this.active;
    }

    __onActivate() {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
    }

    __onDeactivate() {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement() {
        return this._repeatNode.htmlElement;
    }

    __getFirstHtmlElement() {
        if (this.pChildren.length > 0)
            return this.pChildren.get(0).firstHtmlElement;

        return null;
    }
    /* / Node */

}


Object.defineProperties(RepeatNode_InstanceNode, {
    PChildren: { value:
    class RepeatNode_InstanceNode_PChildren extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PChildren {

        constructor(node) { 
            super(node);
        }

        __onAddChild(childNode, nextNode) {
            if (this.node.active)
                childNode.activate();
        }

        __getNext(childNode) {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            let instanceIndex = this.node._repeatNode._instances.indexOf(
                    this.node);
            (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(instanceIndex !== -1, 'Instance not in repeat node.');

            if (instanceIndex === this.node._repeatNode._instances.size - 1)
                return this.node._repeatNode.nextNode;

            return this.node._repeatNode._instances.getAt(instanceIndex + 1);
        }

        __getNextHtmlElement() {   
            /* Not Sure */
            if (!this.node._repeatNode.active)
                return this.node._repeatNode.nextHtmlElement;
            /* / Not Sure */

            let startIndex = this.node._repeatNode._instances.indexOf(this.node) + 1;
            for (let i = startIndex; i < this.node._repeatNode._instances.size; i++) {
                let instance = this.node._repeatNode._instances.getAt(i);
                if (instance.pChildren.length > 0)
                    return instance.pChildren.get(0).firstHtmlElement;
            }

            return this.node._repeatNode.nextHtmlElement;
        }
    }},


    // PCopyable: { value:
    // class RepeatNode_InstanceNode_PCopyable extends Node.PCopyable
    // {
    //
    //     __createCopy(instance_nodes)
    //     {
    //         throw new Error('To do.');
    //         // return new RepeatNode.InstanceNode(this.__args[0]);
    //     }
    //
    // }},
});


/* JSLib Exports */
_jsLib.export("default", RepeatNode_InstanceNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\RootNode.js
jsLibs.exportScript("ab-nodes", "./nodes/RootNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./HtmlElement", [ { name: "default", alias: "HtmlElement" } ], "../HtmlElement");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");

/* export default */ class RootNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {
    constructor(htmlElement) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, HTMLElement);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, RootNode.PChildren, this);

        this._htmlElement = htmlElement;
    }


    /* Node.IListener */
    __getHtmlElement() {
        return this._htmlElement;
    }

    __getFirstHtmlElement() {
        return this._htmlElement;
    }

    __isDisplayed() {
        return this.active;
    }

    __onActivate() {
        (_jsLib.import("ab-nodes", "./HtmlElement", "default", "HtmlElement", "../HtmlElement")).ClearChildren(this._htmlElement);

        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate() {
        this.refreshDisplayed(true);
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).deactivate();
    }
    /* / Node.IListener */
}


Object.defineProperties(RootNode, {
    PChildren: { value:
    class RootNode_PChildren extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PChildren {

        constructor(node) {
            super(node);
        }

        __onAddChild(childNode) {
            if (this.node.active)
                childNode.activate();
        }

    }},
});


/* JSLib Exports */
_jsLib.export("default", RootNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\ShowNode.js
jsLibs.exportScript("ab-nodes", "./nodes/ShowNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");

/* export default */ class ShowNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {
    get show() {
        return this._show;
    }
    set show(showValue) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        if (showValue === this._show)
            return;
        this._show = showValue;

        if (!this.active)
            return;

        if (showValue) {
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).activate();
            this.refreshDisplayed(true);
        } else {
            this.refreshDisplayed(true);
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).deactivate();
        }
    }


    constructor() { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, ShowNode.PChildren, this);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, ShowNode.PCopyable, this, arguments);

        this._show = false;
    }


    /* Node */
    __isDisplayed() {
        if (!this.active || !this.show)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        if (!this.show)
            return;

        this.refreshDisplayed(true);
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
    }

    __onDeactivate() {
        if (!this.show)
            return;

        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement() {
        for (let i = 0; i < this.pChildren.length; i++) {
            let childFirstHtmlElement = this.pChildren.get(i).firstHtmlElement;
            if (childFirstHtmlElement !== null)
                return childFirstHtmlElement;
        }

        return null;
    }
    /* / Node */

}


Object.defineProperties(ShowNode, {
    PChildren: { value:
    class ShowNode_PChildren extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PChildren {

        constructor(node) { super(node);

        }

        __onAddChild(childNode, nextNode) {
            // if (nextNode === null)
            //     childNode._nextNode = this._nextNode;

            if (this.node.active && this.node.show)
                childNode.activate();
        }

        __getNext(childNode) {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            return this.node.nextNode;
            // if (nextNode !== null)
            //     return nextNode;

            // console.log('Null!');
            // return null;
        }

        __getNextHtmlElement() {
            return this.node.nextHtmlElement;
        }

    }},
});


Object.defineProperties(ShowNode, {
    PCopyable: { value:
    class ShowNode_PCopyable extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PCopyable {

        constructor(node, args) { super(node, args);

        }

        __createCopy(deepCopy, nodeInstances) {
            return new ShowNode();
        }

        __deleteCopy(instanceKeys) {
            
        }

    }},
});

/* JSLib Exports */
_jsLib.export("default", ShowNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\SingleNode.js
jsLibs.exportScript("ab-nodes", "./nodes/SingleNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-nodes", "./HtmlElement", [ { name: "default", alias: "HtmlElement" } ], "../HtmlElement");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");


/* export default */ class SingleNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {
    constructor(htmlElementType) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, SingleNode.PChildren, this);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, SingleNode.PCopyable, this, arguments);

        this._htmlElement = document.createElement(htmlElementType);
    }


    /* Node */
    __isDisplayed() {
        if (!this.active)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        (_jsLib.import("ab-nodes", "./HtmlElement", "default", "HtmlElement", "../HtmlElement")).AddChild(this.parentNode.htmlElement, this._htmlElement,
                this.nextHtmlElement);

        // for (let i = 0; i < this.pChildren.length; i++)
        //     this.pChildren.get(i).refreshDisplayed(true);
        this.refreshDisplayed(true);
    }

    __onDeactivate() {
        this.refreshDisplayed(true);
        // for (let i = this.pChildren.length - 1; i >= 0; i--)
        //     this.pChildren.get(i).refreshDisplayed(true);

        (_jsLib.import("ab-nodes", "./HtmlElement", "default", "HtmlElement", "../HtmlElement")).RemoveChild(this.parentNode.htmlElement, this._htmlElement);
    }

    __getHtmlElement() {
        return this._htmlElement;
    }

    __getFirstHtmlElement() {
        if (!this.active)
            return null;

        return this._htmlElement;
    }
    /* / Node */

}

Object.defineProperties(SingleNode, {

    PChildren: { value:
    class SingleNode_PChildren extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PChildren {

        constructor(node) {
            super(node);
        }

        __onAddChild(childNode, next_node) {
            childNode.activate();
        }

    }},


    PCopyable: { value:
    class SingleNode_PCopyable extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PCopyable {
        constructor(node, args) {
            super(node, args);
        }

        __createCopy(deepCopy, nodeInstances) {
            return new SingleNode(this.__args[0]);
        }

        __deleteCopy(instanceKeys) {
            
        }
    }},
});


/* JSLib Exports */
_jsLib.export("default", SingleNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\TextNode.js
jsLibs.exportScript("ab-nodes", "./nodes/TextNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-nodes", "./HtmlElement", [ { name: "default", alias: "HtmlElement" } ], "../HtmlElement");
_jsLib.importDeclaration("ab-nodes", "./Node", [ { name: "default", alias: "Node" } ], "../Node");

/* export default */ class TextNode extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")) {
    get text() {
        return this._htmlElement.nodeValue;
    }
    set text(value) {
        this._htmlElement.nodeValue = value;
    }


    constructor(text) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, TextNode.PCopyable, this, arguments);

        this._text = text;
        this._htmlElement = document.createTextNode(text);
    }


    /* Node */
    __isDisplayed() {
        if (!this.active)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        (_jsLib.import("ab-nodes", "./HtmlElement", "default", "HtmlElement", "../HtmlElement")).AddChild(this.parentNode.htmlElement, this._htmlElement,
                this.nextHtmlElement);
        this.refreshDisplayed(true);
    }

    __onDeactivate() {
        this.refreshDisplayed(true);
        (_jsLib.import("ab-nodes", "./HtmlElement", "default", "HtmlElement", "../HtmlElement")).RemoveChild(this.parentNode.htmlElement, this._htmlElement);
    }

    __getHtmlElement() {
        return this._htmlElement;
    }

    __getFirstHtmlElement() {
        if (!this.active)
            return null;

        return this._htmlElement;
    }
    /* / Node */

}


Object.defineProperties(TextNode, {
    PCopyable: { value:
    class TextNode_PCopyable extends (_jsLib.import("ab-nodes", "./Node", "default", "Node", "../Node")).PCopyable {

        constructor(node, args) {
            super(node, args);
        }

        __createCopy() {
            return new TextNode(this.__args[0]);
        }

        __deleteCopy(instanceKeys) {
            
        }

    }},
});


/* JSLib Exports */
_jsLib.export("default", TextNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\VirtualNode.js
jsLibs.exportScript("ab-nodes", "./nodes/VirtualNode", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export default */ class VirtualNode extends (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node {
    constructor() { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, VirtualNode.PChildren, this);

        // this._idNodes = {};
    }

    // setIds(id_nodes)
    // {
    //     js0.argsE(arguments, 'object');
    //
    //     this._idNodes = id_nodes;
    // }


    /* Node */
    __isDisplayed() {
        return this.parentNode.displayed && this.active;
    }

    __onActivate() {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate() {
        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement() {
        return this.pChildren.length === 0 ?
                null : this.pChildren.get(0).firstHtmlElement;
    }
    /* / Node */

}


Object.defineProperties(VirtualNode, {
    PChildren: { value:
    class VirtualNode_PChildren extends (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node.PChildren {

        constructor(node) {
            super(node);
        }
        
        __onAddChild(childNode, next_node) {
            if (next_node === null)
                childNode._nextNode = this._nextNode;

            if (this.node.active)
                childNode.activate();
        }

        __getNext(childNode) {
            let next_node = this.findNext(childNode);
            if (next_node !== null)
                return next_node;

            return this.node.nextNode;
        }

    }}
});


/* JSLib Exports */
_jsLib.export("default", VirtualNode); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\index.js
jsLibs.exportScript("ab-text-parser", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text-parser", "./Text", [ { name: "default", alias: "Text" } ], "./Text");

class abTextParser_Class {
    constructor() {

    }

    parse(text, ignoreLeadingSpaces = true) {
        let t = new (_jsLib.import("ab-text-parser", "./Text", "default", "Text", "./Text"))(text, ignoreLeadingSpaces);

        return t.parts;
    }
}
const abTextParser = new abTextParser_Class();
/* export default */ abTextParser;

/* JSLib Exports */
_jsLib.export("default", abTextParser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\Parser.js
jsLibs.exportScript("ab-text-parser", "./Parser", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-text-parser", "./Text", [ { name: "default", alias: "Text" } ], "./Text");

/* export default */ class Parser {
    constructor(text) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Text", "default", "Text", "./Text")));

        this.text = text;
    }

    error(message, line) {
        throw new Error('Line: ' + line + '. ' + message);
    }

    finish() {
        this.text.finishParser(this);
    }

    read(c, i, line) {
        return this.__read(c, i, line);
    }


    __check(c, i, line) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __read(c, i, line) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
}

/* JSLib Exports */
_jsLib.export("default", Parser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\Text.js
jsLibs.exportScript("ab-text-parser", "./Text", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-text-parser", "./parsers/TextParser", [ { name: "default", alias: "TextParser" } ], "./parsers/TextParser");
_jsLib.importDeclaration("ab-text-parser", "./Parser", [ { name: "default", alias: "Parser" } ], "./Parser");

/* export default */ class Text {
    constructor(content, ignoreLeadingSpaces = true) {
        this.content = content;
        this.ignoreLeadingSpaces = ignoreLeadingSpaces;
        this.parsers = [
            new (_jsLib.import("ab-text-parser", "./parsers/TextParser", "default", "TextParser", "./parsers/TextParser"))(this),
        ];

        this.parts = [];

        if (content !== '')
            this.parse();
    }

    addPart(part) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        this.parts.push(part);
    }

    error(message, line) {
        throw new Error('Line: ' + line + '. ' + message);
    }

    finishParser(parser) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "./Parser")));

        this.parsers.pop();
    }

    parse() {
        let i = 0;
        let line = 1;
        while(true) {
            let c = this.content[i];
            let step = 0;

            let activeParser = this.parsers[this.parsers.length - 1];
            step = activeParser.read(c, i, line);
            
            if (step === 0 && this.parsers[this.parsers.length - 1] === activeParser)
                throw new Error(`Parser '${activeParser.constructor.name}' with step 0 created infinite loop.`);

            i += step;
            if (c === '\n')
                line++;

            if (i >= this.content.length)
                break;
        }

        // if (this.parts.length > 1)
        //     throw new Error(`Part '${this.parts[this.elems.length - 1].name}' not closed.`);
    }

    startParser(parser) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "./Parser")));

        this.parsers.push(parser);
    }

}

/* JSLib Exports */
_jsLib.export("default", Text); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\ExprParser.js
jsLibs.exportScript("ab-text-parser", "./parsers/ExprParser", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-text-parser", "./Parser", [ { name: "default", alias: "Parser" } ], "../Parser");
_jsLib.importDeclaration("ab-text-parser", "./Text", [ { name: "default", alias: "Text" } ], "../Text");
_jsLib.importDeclaration("ab-text-parser", "./Parser", [  ], "../Parser");
_jsLib.importDeclaration("ab-text-parser", "./parsers/TextParser", [ { name: "default", alias: "TextParser" } ], "./TextParser");

/* export default */ class ExprParser extends (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "../Parser")) {
    static IsStart(content, i)
    {
        if (content.length > i + 1) {
            if (content[i] !== '?')
                return 0;
            if (content[i + 1] !== '(')
                return 0;
            if (content[i - 1] === '\\')
                return 0;

            return 2;
        }

        return 0;
    }


    constructor(text, parser) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Text", "default", "Text", "../Text")), (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "../Parser")));
        super(text);

        this.parentParser = parser;
        this.parentParser_Type = null;
        if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(parser, (_jsLib.import("ab-text-parser", "./parsers/TextParser", "default", "TextParser", "./TextParser"))))
            this.parentParser_Type = 'text';
        // else if (js0.type(parser, AttribValueParser))
        //     this.parentParser_Type = 'attrib'; 

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentParser_Type !== null, 
                `Invalid parser type: ${parser.constructor.name}.`);

        this.quoteOpened = null;
        this.quotes = [ '"', '\'', '`' ];
        for (let quote in this.quotes_Opened)
            this.quotes.push(quote);

        this.bracketsOpened = 0;

        this.value = '';
    }

    __read(c, i, line) {
        let step;

        if (this.quoteOpened === null) {
            if (this.quotes.includes(c)) {
                this.quoteOpened = c;
                this.value += c;
                return 1;
            }
        } else {
            if (c === this.quoteOpened && this.text.content[i - 1] !== '\\') {
                this.quoteOpened = null;
                this.value += c;
                return 1;
            }
        }

        if (this.quoteOpened === null) {
            if (c === '(') {
                this.bracketsOpened++;
                this.value += c;
                return 1;
            }

            if (c === ')') {
                if (this.bracketsOpened > 0) {
                    this.bracketsOpened--;
                    this.value += c;
                    return 1;
                }

                if (this.parentParser_Type === 'text') {
                    this.text.addPart('?(' + this.value + ')');
                // } else if (this.parentParser_Type === 'attrib') {
                //     this.parentParser.attribParser.tagParser
                //             .attribs[this.parentParser.attribParser.name].push(
                //             '?(' + this.value + ')');
                }
                this.finish();
                return 1;
            }
        }

        this.value +=c;
        return 1;
    }
}

/* JSLib Exports */
_jsLib.export("default", ExprParser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\FieldArgsParser.js
jsLibs.exportScript("ab-text-parser", "./parsers/FieldArgsParser", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-text-parser", "./Parser", [ { name: "default", alias: "Parser" } ], "../Parser");
_jsLib.importDeclaration("ab-text-parser", "./Text", [ { name: "default", alias: "Text" } ], "../Text");
_jsLib.importDeclaration("ab-text-parser", "./parsers/FieldParser", [ { name: "default", alias: "FieldParser" } ], "./FieldParser");

/* export default */ class FieldArgsParser extends (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "../Parser")) {

    static IsStart(c, i, line) {
        return c === '(' ? 1 : 0;
    }


    constructor(text, fieldParser) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Text", "default", "Text", "../Text")), (_jsLib.import("ab-text-parser", "./parsers/FieldParser", "default", "FieldParser", "./FieldParser")));
        super(text);

        this.fieldParser = fieldParser;

        this.args = '';
    }

    __read(c, i, line) {
        let step;

        if (c === ')') {
            this.fieldParser.args = this.args;
            this.finish();

            if (i + 1 >= this.text.content.length && !this.fieldParser.escaped) {
                if (this.name !== '') {
                    this.fieldParser.finish();
                    this.fieldParser.addField();
                }
            }

            return 1;
        }

        this.args +=c;
        return 1;
    }
}

/* JSLib Exports */
_jsLib.export("default", FieldArgsParser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\FieldParser.js
jsLibs.exportScript("ab-text-parser", "./parsers/FieldParser", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("ab-text-parser", "./Parser", [ { name: "default", alias: "Parser" } ], "../Parser");
_jsLib.importDeclaration("ab-text-parser", "./parsers/FieldArgsParser", [ { name: "default", alias: "FieldArgsParser" } ], "./FieldArgsParser");
_jsLib.importDeclaration("ab-text-parser", "./parsers/TextParser", [ { name: "default", alias: "TextParser" } ], "./TextParser");
_jsLib.importDeclaration("ab-text-parser", "./Text", [ { name: "default", alias: "Text" } ], "../Text");
_jsLib.importDeclaration("ab-text-parser", "./Parser", [  ], "../Parser");

// import AttribValueParser from "./AttributeValueParser";

/* export default */ class FieldParser extends (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "../Parser")) {
    static IsStart(document, c, i, line) {
        if (c !== '$')
            return 0;

        if (i >= 1) {
            if (document.content[i - 1] === '\\')
                return 0;
        }

        return 1;
    }


    constructor(text, parser) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Text", "default", "Text", "../Text")), (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "../Parser")));
        super(text);

        this.parentParser = parser;
        this.parentParser_Type = null;
        if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(parser, (_jsLib.import("ab-text-parser", "./parsers/TextParser", "default", "TextParser", "./TextParser"))))
            this.parentParser_Type = 'text';
        // else if (js0.type(parser, AttribValueParser))
        //     this.parentParser_Type = 'attrib'; 

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(this.parentParser_Type !== null, 
                `Invalid parser type: ${parser.constructor.name}.`);

        this.name = '';
        this.args = null;
        this.bracketsOpened = 0;

        this.escaped = false;
    
        this.regexp = /[a-zA-Z0-9_.]/;
    }

    __read(c, i, line) {
        let step;

        if (this.name === '' && !this.escaped) {
            if (i + 2 < this.text.content.length) {
                if (this.text.content[i + 2] === '{') {
                    this.escaped = true;
                    return 1;
                }
            }

            if (i + 1 < this.text.content.length) {
                if (this.text.content[i + 1] === '{') {
                    this.bracketsOpened++;
                    this.name += '{';
                    return 1;
                }
            }

            if (c === '{') {
                this.escaped = true;
                return 1;
            }
        }

        if (c === '{') {
            this.bracketsOpened++;
            this.name += '{';
            return 1;
        }

        if (c === '}') {
            if (this.bracketsOpened > 0) {
                this.bracketsOpened--;
                this.name += '}';
                return 1;
            }
        }

        if (this.regexp.test(c)) {
            if (this.args !== null) {
                if (this.name !== '') {
                    this.addField();
                    this.finish();
                    return 0;
                }
            }

            this.name += c;

            if (i + 1 >= this.text.content.length && !this.escaped) {
                if (this.name !== '') {
                    this.addField();
                    this.finish();
                }
            }

            return 1;
        }

        if (this.name !== '') {
            if (c === '(') {
                this.text.startParser(new (_jsLib.import("ab-text-parser", "./parsers/FieldArgsParser", "default", "FieldArgsParser", "./FieldArgsParser"))(this.text, this));
                return 1;
            }
        }

        if (this.escaped) {
            if (c !== '}')
                this.error('Wrong field name format.', line);

            this.addField();

            this.finish();
            return 1;
        }

        this.addField();

        this.finish();
        return 0;
    }

    addField() {
        if (this.parentParser_Type === 'text') {
            this.text.addPart(this._getField());
        // } else if (this.parentParser_Type === 'attrib') {
        //     this.parentParser.attribParser.tagParser
        //             .attribs[this.parentParser.attribParser.name].push(
        //             this._getField());
        }
    }


    _getField() {
        return '$' + (this.escaped ? '{' : '') + this.name + 
                (this.args === null ? '' : '(' + this.args + ')') + 
                (this.escaped ? '}' : '');
    }

}

/* JSLib Exports */
_jsLib.export("default", FieldParser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\TextParser.js
jsLibs.exportScript("ab-text-parser", "./parsers/TextParser", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-text-parser", "./Parser", [ { name: "default", alias: "Parser" } ], "../Parser");

_jsLib.importDeclaration("ab-text-parser", "./parsers/ExprParser", [ { name: "default", alias: "ExprParser" } ], "./ExprParser");
_jsLib.importDeclaration("ab-text-parser", "./parsers/FieldParser", [ { name: "default", alias: "FieldParser" } ], "./FieldParser");

_jsLib.importDeclaration("ab-text-parser", "./Text", [ { name: "default", alias: "Text" } ], "../Text");

/* export default */ class TextParser extends (_jsLib.import("ab-text-parser", "./Parser", "default", "Parser", "../Parser")) {
    static IsStart(c, i, line) {
        return c === '<' ? 1 : 0;
    }


    constructor(text) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-text-parser", "./Text", "default", "Text", "../Text")));
        super(text);

        this.value = null;
        // this._htmlEntities = new htmlEntities.AllHtmlEntities();
    }

    __read(c, i, line) {
        let step;

        // step = TagParser.IsStart(c);
        // if (step > 0) {
        //     if (this.value !== null && this.value !== '') {
        //         while ([ ' ', "\r", "\n" ].includes(this.value[this.value.length - 1]))
        //             this.value = this.value.substring(0, this.value.length - 1);
        //         if (this.value !== '') {
        //             this.text.addNode({
        //                 type: 'text',
        //                 value: this._decodeHtml(this.value),
        //             });
        //         }
        //     }
            
        //     this.finish();
        //     return 0;
        // }

        if (this.value === null) {
            if (c === "\r" || c === "\n")
                return 1;
            if (this.text.ignoreLeadingSpaces) {
                if (c === ' ') {
                    return 1;
                }
            }
            
            this.value = '';
        }

        step = (_jsLib.import("ab-text-parser", "./parsers/FieldParser", "default", "FieldParser", "./FieldParser")).IsStart(this.text, c, i, line);
        if (step > 0) {
            if (this.value !== null && this.value !== '') {
                this.text.addPart(this.value);
            }
            this.value = '';

            this.text.startParser(new (_jsLib.import("ab-text-parser", "./parsers/FieldParser", "default", "FieldParser", "./FieldParser"))(this.text, this));
            return step;
        }

        step = (_jsLib.import("ab-text-parser", "./parsers/ExprParser", "default", "ExprParser", "./ExprParser")).IsStart(this.text.content, i);
        if (step > 0) {
            if (this.value !== null && this.value !== '') {
                this.text.addPart(this.value);
            }
            this.value = '';

            this.text.startParser(new (_jsLib.import("ab-text-parser", "./parsers/ExprParser", "default", "ExprParser", "./ExprParser"))(this.text, this));
            return step;
        }

        this.value += c;

        if (i + 1 >= this.text.content.length) {
            this.text.addPart(this.value);
            this.finish();
        }

        return 1;
    }


    _decodeHtml(str) {
        // return this._htmlEntities.decode(str);
    }

}

/* JSLib Exports */
_jsLib.export("default", TextParser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\App.js
jsLibs.exportScript("spocky", "./App", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./AppInstance", [ { name: "default", alias: "AppInstance" } ], "./AppInstance");
_jsLib.importDeclaration("spocky", "./Inits", [ { name: "default", alias: "Inits" } ], "./Inits");
_jsLib.importDeclaration("spocky", "./Layout", [  ], "./Layout");
_jsLib.importDeclaration("spocky", "./Module", [  ], "./Module");

/* export default */ class App {
    constructor() {
        this._initialized = false;
        this._inits = new (_jsLib.import("spocky", "./Inits", "default", "Inits", "./Inits"))();
    }

    app(appInitFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._inits.app.push(appInitFn);

        return this;
    }

    config(configFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        if (this._initialized)
            throw new Error('App already initialized.');

        this._inits.configs.push(configFn);

        return this;
    }

    // ext(ext_initFn)
    // {
    //     js0.args(arguments, 'function');

    //     this._infos.appInits.push({
    //         initFn:ext_initFn,
    //     });
    // }

    init() {
        if (this._initialized)
            throw new Error('`spocky` already initialized.');
        this._initialized = true;

        /* Config */
        new (_jsLib.import("spocky", "./AppInstance", "default", "AppInstance", "./AppInstance"))(this._inits);

        return this;
    }

    // layout(layoutPath, layoutInitFn)
    // {
    //     js0.args(arguments, 'string', 'function');

    //     if (this._initialized)
    //         throw new Error('Cannot define layout after initialization.');

    //     if (layoutPath in this._inits.layout)
    //         throw new Error(`Layout '${layoutPath}' already exists.`);

    //     this._inits.layout[layoutPath] = layoutInitFn;
    // }

    // package(packagePath, packageInitFn)
    // {
    //     js0.args(arguments, 'string', 'function');

    //     if (this._initialized)
    //         throw new Error('Cannot define package after initialization.');

    //     if (!this._inits.package.has(packagePath))
    //         this._inits.package.set(packagePath, []);

    //     this._inits.package.get(packagePath).push(packageInitFn);
    // }


    // _layout(layoutPath, layoutInitPath, raw)
    // {
    //     js0.args(arguments, 'string', 'function', 'boolean');

    //     if (this._initialized)
    //         throw new Error('Cannot define layout after initialization.');

    //     if (layoutPath in this._infos.layouts) {
    //         if (this._$debug)
    //             console.warn('Layout `' + layoutPath + '` already exists. Overwriting.');
    //     }

    //     this._infos.layouts[layoutPath] = {
    //         raw: raw,
    //         path: layoutPath,
    //         initFn: layoutInitPath,
    //     };
    // }

    // _parseUri(uri, push_state)
    // {
    //     let page_info = this._uri.parse(uri);
    //     if (page_info === null)
    //         throw new Error(`No page matches uri \`${uri}\`.`);

    //     this._setPage(page_info.name, page_info.args, push_state);
    // }

};


/* JSLib Exports */
_jsLib.export("default", App); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\AppInstance.js
jsLibs.exportScript("spocky", "./AppInstance", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./Config", [ { name: "default", alias: "Config" } ], "./Config");
_jsLib.importDeclaration("spocky", "./ConfigInfo", [ { name: "default", alias: "ConfigInfo" } ], "./ConfigInfo");
_jsLib.importDeclaration("spocky", "./Inits", [ { name: "default", alias: "Inits" } ], "./Inits");
_jsLib.importDeclaration("spocky", "./Layout", [  ], "./Layout");
_jsLib.importDeclaration("spocky", "./Module", [ { name: "default", alias: "Module" } ], "./Module");
_jsLib.importDeclaration("spocky", "./PathInfo", [  ], "./PathInfo");

/* export default */ class AppInstance {
    constructor(inits) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spocky", "./Inits", "default", "Inits", "./Inits")));

        let config = new (_jsLib.import("spocky", "./ConfigInfo", "default", "ConfigInfo", "./ConfigInfo"))();

        Object.defineProperties(this, {
            _config: { value: new (_jsLib.import("spocky", "./ConfigInfo", "default", "ConfigInfo", "./ConfigInfo"))(), },
            _inits: { value: inits, },
            // _jsLibs: { value: new jsLibs_Class(), },
            _jsLibs: { value: jsLibs, },
        });

        /* Confit Init */
        let cfg = new (_jsLib.import("spocky", "./Config", "default", "Config", "./Config"))(this._config);
        for (let configFn of this._inits.configs)
            configFn(this, cfg);

        /* App Inits */
        for (let initFn of this._inits.app)
            initFn(this);

        /* Containers Init */
        for (let [ containerId, containerInfo ] of this._config.containerInfos) {
            let rootNode = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).RootNode(containerInfo.htmlElement);
            
            let moduleArgs = [ null ];
            for (let arg of containerInfo.moduleArgs)
                moduleArgs.push(arg);
            let module = new (Function.prototype.bind.apply(
                    containerInfo.moduleClass, moduleArgs));            
            if (!(module instanceof (_jsLib.import("spocky", "./Module", "default", "Module", "./Module"))))
                throw new Error(`Containers '${containerId}' class is not a Spocky module.`);

            rootNode.activate();
            module._$viewable.activate(rootNode);
        }
    }

    // $create(fullCreatePath)
    // {
    //     let createPathInfo = new PathInfo(fullCreatePath);

    //     let pkg = this.$import(createPathInfo.packagePath);

    //     return pkg.$create(createPathInfo.name);
    // }
}


/* JSLib Exports */
_jsLib.export("default", AppInstance); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Config.js
jsLibs.exportScript("spocky", "./Config", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./ConfigInfo", [ { name: "default", alias: "ConfigInfo" } ], "./ConfigInfo");
_jsLib.importDeclaration("spocky", "./ContainerInfo", [ { name: "default", alias: "ContainerInfo" } ], "./ContainerInfo");
_jsLib.importDeclaration("spocky", "./Inits", [  ], "./Inits");
_jsLib.importDeclaration("spocky", "./Module", [  ], "./Module");

/* export default */ class Config {
    constructor(configInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spocky", "./ConfigInfo", "default", "ConfigInfo", "./ConfigInfo")));

        this._configInfo = configInfo;
    }

    container(htmlElementId, moduleClass, moduleArgs = []) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'function', [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        /* Validate HTML Element */
        let htmlElement = document.getElementById(htmlElementId);
        if (htmlElement === null)
            throw new Error(`\`HtmlElement\` with id \`${htmlElementId}\` does not exist.`);

        /* Create Container */
        let containerInfo = new (_jsLib.import("spocky", "./ContainerInfo", "default", "ContainerInfo", "./ContainerInfo"))(htmlElementId, htmlElement,
                moduleClass, moduleArgs);

        // /* Validate Module Paths */
        // for (let modulePath of containerInfo.modulePath) {            
        //     if (!(path_configInfo.packagePath in this._infos.packages))
        //         throw new Error(`Module \`${path_configInfo.fullPath}\` package does not exist.`);
        // }

        this._configInfo.containerInfos.set(containerInfo.id, containerInfo);
        /* / Create Container */

        return this;
    }
}


/* JSLib Exports */
_jsLib.export("default", Config); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\ConfigInfo.js
jsLibs.exportScript("spocky", "./ConfigInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [  ], "js0");

_jsLib.importDeclaration("spocky", "./Config", [  ], "./Config");
_jsLib.importDeclaration("spocky", "./Inits", [  ], "./Inits");


/* export default */ class ConfigInfo {
    constructor() {
        Object.defineProperties(this, {
            containerInfos: { value: new Map(), },
        });
    }
}


/* JSLib Exports */
_jsLib.export("default", ConfigInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\ContainerInfo.js
jsLibs.exportScript("spocky", "./ContainerInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export default */ class ContainerInfo {
    constructor(containerId, htmlElement, moduleClass, moduleArgs)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', HTMLElement, 'function', Array);

        Object.defineProperties(this, {
            id: { value: containerId, },
            htmlElement: { value: htmlElement, },
            moduleClass: { value: moduleClass, },
            moduleArgs: { value: moduleArgs, },
        });
    }
}


/* JSLib Exports */
_jsLib.export("default", ContainerInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Ext.js
jsLibs.exportScript("spocky", "./Ext", [ "default" ], (_jsLib) => { "use strict"; /* export default */ class Ext
{

    constructor()
    {

    }

    onParseLayoutNode(layoutNode)
    {
        
    }

}

/* JSLib Exports */
_jsLib.export("default", Ext); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Holder.js
jsLibs.exportScript("spocky", "./Holder", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-layouts", "./index", [ { name: "default", alias: "abLayouts" } ], "ab-layouts");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./Layout", [ { name: "default", alias: "Layout" } ], "./Layout");
_jsLib.importDeclaration("spocky", "./Module", [ { name: "default", alias: "Module" } ], "./Module");

/* export default */ class Holder {
    get $view() {
        if (this._view === null)
            return null;
        
        return this._view;
    }
    set $view(value) {
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(value, [ (_jsLib.import("spocky", "./Layout", "default", "Layout", "./Layout")), (_jsLib.import("spocky", "./Module", "default", "Module", "./Module")), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]))
            throw new Error(`'$view' must be 'Layout', 'Module' or 'Null'.`);

        if (this._$view === null)
            return;

        if (this._view !== null)
            this._view._$viewable.deactivate();

        this._view = value;
        if (this._view !== null)
            this._view._$viewable.activate(this._layoutNode);
    }


    constructor(layoutNode)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-layouts", "./index", "default", "abLayouts", "ab-layouts")).LayoutNode);

        Object.defineProperties(this, {
            _layoutNode: { value: layoutNode, },
            _view: { value: null, writable: true, },
        });
    }

    // _$activate()
    // {
    //     if (this._view !== null)
    //         this._view._$viewable.activate(this._layoutNode);
    // }

}

/* JSLib Exports */
_jsLib.export("default", Holder); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\index.js
jsLibs.exportScript("spocky", "./index", [ "App","Ext","Holder","Layout","Module","Viewable","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("ab-fields", "./index", [ { name: "default", alias: "abFields" } ], "ab-fields");
_jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");

_jsLib.importDeclaration("spocky", "./App", [ { name: "default", alias: "App" } ], "./App");
_jsLib.importDeclaration("spocky", "./Ext", [ { name: "default", alias: "Ext" } ], "./Ext");
_jsLib.importDeclaration("spocky", "./Holder", [ { name: "default", alias: "Holder" } ], "./Holder");
_jsLib.importDeclaration("spocky", "./Layout", [ { name: "default", alias: "Layout" } ], "./Layout");
_jsLib.importDeclaration("spocky", "./Module", [ { name: "default", alias: "Module" } ], "./Module");
_jsLib.importDeclaration("spocky", "./Viewable", [ { name: "default", alias: "Viewable" } ], "./Viewable");

/* export { (_jsLib.import("spocky", "./App", "default", "App", "./App")), (_jsLib.import("spocky", "./Ext", "default", "Ext", "./Ext")), (_jsLib.import("spocky", "./Holder", "default", "Holder", "./Holder")), (_jsLib.import("spocky", "./Layout", "default", "Layout", "./Layout")), (_jsLib.import("spocky", "./Module", "default", "Module", "./Module")), (_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable")) }; */

class spocky_Class {
    get App() {
        return (_jsLib.import("spocky", "./App", "default", "App", "./App"));
    }

    get Ext() {
        return (_jsLib.import("spocky", "./Ext", "default", "Ext", "./Ext"));
    }

    get Holder() {
        return (_jsLib.import("spocky", "./Holder", "default", "Holder", "./Holder"));
    }

    get Layout() {
        return (_jsLib.import("spocky", "./Layout", "default", "Layout", "./Layout"));
    }

    get Module() {
        return (_jsLib.import("spocky", "./Module", "default", "Module", "./Module"));
    }

    get Viewable() {
        return (_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable"));
    }

    get debug() {
        return this._debug;
    }

    constructor() { 
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    '', () => {
        this._debug = false;
        this._exts = [];
    })}

    ext(spockyExt) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spocky", "./Ext", "default", "Ext", "./Ext")));

        (_jsLib.import("spocky", "./Layout", "default", "Layout", "./Layout")).Extensions.push((layoutNode) => {
            spockyExt.onParseLayoutNode(layoutNode);
        });
    }

    setDebug(debug) {
        this._debug = debug;
        (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).setDebug(debug);
        (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).setDebug(debug);
    }
}
const spocky = new spocky_Class();
/* export default */ spocky;

/* JSLib Exports */
_jsLib.export("App", (_jsLib.import("spocky", "./App", "default", "App", "./App")));
_jsLib.export("Ext", (_jsLib.import("spocky", "./Ext", "default", "Ext", "./Ext")));
_jsLib.export("Holder", (_jsLib.import("spocky", "./Holder", "default", "Holder", "./Holder")));
_jsLib.export("Layout", (_jsLib.import("spocky", "./Layout", "default", "Layout", "./Layout")));
_jsLib.export("Module", (_jsLib.import("spocky", "./Module", "default", "Module", "./Module")));
_jsLib.export("Viewable", (_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable")));
_jsLib.export("default", spocky); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Inits.js
jsLibs.exportScript("spocky", "./Inits", [ "default" ], (_jsLib) => { "use strict"; /* export default */ class Inits {
    constructor() {
        Object.defineProperties(this, {
            app: { value: [] },
            configs: { value: [], writable: true, },
            ext: { value: new Map(), },
            layout: { value: new Map(), },
            package: { value: new Map(), },
        });
    }
}


/* JSLib Exports */
_jsLib.export("default", Inits); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Layout.js
jsLibs.exportScript("spocky", "./Layout", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text-parser", "./index", [ { name: "default", alias: "abTextParser" } ], "ab-text-parser");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./LayoutParser", [ { name: "default", alias: "LayoutParser" } ], "./LayoutParser");
_jsLib.importDeclaration("spocky", "./Viewable", [ { name: "default", alias: "Viewable" } ], "./Viewable");

/* export default */ class Layout {
    static Replace(layoutContent, replaceArr) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, Array);

        Layout._Replace_ReplaceInArray(layoutContent, replaceArr);
    }

    static _Replace_ReplaceInArray(array, replaceArr) {
        for (let i = 0; i < array.length; i++) {
            if (typeof array[i] === 'string') {
                let newString = array[i];
                for (let replace of replaceArr) {
                    newString = newString.replace(new RegExp(replace[0], 'g'), 
                            replace[1]);
                }
        
                let newStringArr = (_jsLib.import("ab-text-parser", "./index", "default", "abTextParser", "ab-text-parser")).parse(newString, false);

                array.splice(i, 1);
                for (let j = 0; j < newStringArr.length; j++)
                    array.splice(i + j, 0, newStringArr[j]);
        
                i += newStringArr.length - 1;
            } else if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(array[i], Array))
                Layout._Replace_ReplaceInArray(array[i], replaceArr);
            else if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(array[i], (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject))
                Layout._Replace_ReplaceInObject(array[i], replaceArr);
        }
    }

    static _Replace_ReplaceInObject(object, replaceArr) {
        for (let key in object) {
            if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(object[key], 'string')) {
                let newString = object[key];
                for (let replace of replaceArr) {
                    newString = newString.replace(new RegExp(replace[0], 'g'), 
                            replace[1]);
                }

                object[key] = newString;
            } else if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(object[key], Array))
                Layout._Replace_ReplaceInArray(object[key], replaceArr);
            else if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(object[key], (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject))
                Layout._Replace_ReplaceInObject(object[key], replaceArr);
        }
    }


    constructor(layoutContent, defaultFieldValues = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, Layout.Viewable, this);

        let layoutParser = new (_jsLib.import("spocky", "./LayoutParser", "default", "LayoutParser", "./LayoutParser"))();
        for (let ext of Layout.Extensions)
            layoutParser.extend(ext);
        let layoutNode = layoutParser.parse(layoutContent);        

        this._fields = layoutParser.fields;
        this._$data = layoutParser.data;
        this._$elems = layoutParser.elems;
        this._$holders = layoutParser.holders;

        Object.defineProperties(this, {
            $fields: {
                get: () => {
                    return this._fields.$value;
                },
                set: (value) => {
                    this._fields.$value = value;
                },
            },

            $data: { value: this._$data, },
            $elems: { value: this._$elems, },
            $holders: { value: this._$holders, },

            _$layoutNode: { value: layoutNode, },

            _$listeners_OnDisplay: { value: [], },
        });

        layoutNode.addListener_OnDisplay((display) => {
            for (let listener of this._$listeners_OnDisplay)
                listener(display);
        });

        for (let fieldName in defaultFieldValues) {
            this.$fields[fieldName] = defaultFieldValues[fieldName];
        }
    }

    $onDisplay(listener) {
        if (this._$viewable.active)
            listener();
        this._$listeners_OnDisplay.push(listener);
    }

}


Object.defineProperties(Layout, {

    Extensions: { value: [], },

    Viewable: { value:
    class Layout_Viewable extends (_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable")) {

        constructor(layout) { super();
            this._layout = layout;
        }

        __activate(parentNode) {
            parentNode.pChildren.add(this._layout._$layoutNode);
            // console.log('Adding child:', this._layout._$layoutNode, 'to', parentNode);
            // this._layout._$layoutNode.activate();
        }

        __deactivate(parentNode) {
            parentNode.pChildren.remove(this._layout._$layoutNode);
            // this._layout._$layoutNode.deactivate();
        }

    }},

});


/* JSLib Exports */
_jsLib.export("default", Layout); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.Elems.js
jsLibs.exportScript("spocky", "./LayoutParser.Elems", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export default */ class Elems {
    constructor() {
        this._elemInfos = {};
    }

    $exists(elemName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return elemName in this._elemInfos;
    }

    $get(elemName, keys = []) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', Array);

        if (!(elemName in this._elemInfos))
            throw new Error(`Elem '${elemName}' does not exist.`);

        return this._get(elemName, keys);
    }

    $getAll(elemName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        let elems = [];
        let keysSets = this.$keys(elemName);
        for (let keys of keysSets)
            elems.push(this.$get(elemName, keys));

        return elems;
    }

    $index(elemName, keys) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', Array);

        let keySets = this.$keys();
        for (let i = 0; i < keySets.length; i++) {
            if (this._keysMatch(keySets[i], keys))
                return i;
        }

        return -1;
    }

    $keys(elemName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        if (!this.$exists(elemName))
            throw new Error(`Elem '${elemName}' does not exist.`);

        let keys = [];
        for (let elemInfo of this._elemInfos[elemName]) {
            let keysArr = [];
            for (let key of elemInfo.keys)
                keysArr.push(key);
            keys.push(keysArr);
        }

        return keys;
    }

    _add(elemName, keys, elem) {
        this._elemInfos[elemName].push({
            elem: elem,
            keys: keys,
        });
    }

    _declare(elemName) {
        this._elemInfos[elemName] = [];
    }

    _get(elemName, keys) {
        for (let elemInfo of this._elemInfos[elemName]) {
            if (this._keysMatch(elemInfo.keys, keys))
                return elemInfo.elem;
        }

        throw new Error(`Elem '${elemName}' with keys '` + keys.join(', ') +
            `' does not exist.`);
    }

    _keysMatch(keysA, keysB) {
        if (keysA.length !== keysB.length)
            return false;

        for (let i = 0; i < keysA.length; i++) {
            if (keysA[i] !== keysB[i])
                return false;
        }

        return true;
    }

    _remove(elemName, keys) {
        if (!this.$exists(elemName))
            throw new Error(`Elem '${elemName}' does not exist.`);

        for (let i = 0; i < this._elemInfos[elemName].length; i++) {
            if (this._keysMatch(this._elemInfos[elemName][i].keys, keys)) {
                this._elemInfos[elemName].splice(i, 1);
                return;
            }
        }

        let keysStr = keys.join(', ');
        throw new Error(`Elem '${elemName}' with keys '${keysStr}' does not exist.`);
    }
}

/* JSLib Exports */
_jsLib.export("default", Elems); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.FieldInfo.js
jsLibs.exportScript("spocky", "./LayoutParser.FieldInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-fields", "./index", [ { name: "default", alias: "abFields" } ], "ab-fields");
_jsLib.importDeclaration("ab-strings", "./index", [ { name: "default", alias: "abStrings" } ], "ab-strings");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "./index");

_jsLib.importDeclaration("spocky", "./LayoutParser", [ { name: "FieldsHelper", alias: "FieldsHelper" }, { name: "RepeatInfo", alias: "RepeatInfo" } ], "./LayoutParser.js");

/* export default */ class FieldInfo {
    static get Types() {
        return Types;
    }


    constructor(fieldsHelper, repeatInfo, fieldPath, includesPrefix) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spocky", "./LayoutParser", "FieldsHelper", "FieldsHelper", "./LayoutParser.js")), (_jsLib.import("spocky", "./LayoutParser", "RepeatInfo", "RepeatInfo", "./LayoutParser.js")), 'string', 'boolean');

        this.fieldsHelper = fieldsHelper;
        this.repeatInfo = repeatInfo;

        this.fieldDefinitions = [];

        this.repeatInfo = this.repeatInfo;

        this.type = null;
        /* Field */
        this.field_Path = null;
        this.field_Parts = null;
        this.field_Name = null;
        /* Field Fn */
        this.fieldFn_ArgFields = null;
        this.fieldFn_ArgFieldsStr = null;
        /* Expr */
        this.expr = null;
        this.expr_ArgFields = null;

        if (this.fieldsHelper.isExpression(fieldPath)) {
            this.type = Types.Expression;

            this.expr = fieldPath.substr(2, fieldPath.length - 3);
            this.expr_ArgFields = [];
            let re = new RegExp('\\${(' + this.fieldsHelper.regexpStrs_FieldName + ')}' +
                    '|' + '\\$(' + this.fieldsHelper.regexpStrs_FieldName + ')', 'gi');
            let matches = this.expr.matchAll(re);
            for (let match of matches) {
                let fieldMatch = null;
                if (typeof match[1] !== 'undefined') {
                    fieldMatch = match[1];
                } else {
                    fieldMatch = match[5];
                }

                let expr_ArgFieldInfo = this.fieldsHelper.def(repeatInfo, fieldMatch, 
                        false, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);

                this.expr_ArgFields.push({
                    path: fieldMatch,
                    fieldInfo: expr_ArgFieldInfo,
                });
                
                for (let expr_ArgFieldInfo_FD of expr_ArgFieldInfo.fieldDefinitions)
                    this.fieldDefinitions.push(expr_ArgFieldInfo_FD);
            }
        } else if (this.fieldsHelper.isFieldName(fieldPath, includesPrefix)) {
            fieldPath = this.fieldsHelper.getFieldName(fieldPath, includesPrefix);

            let fieldMatch = this.fieldsHelper.matchField(fieldPath);
            if (typeof fieldMatch[3] === 'undefined') {
                this.type = Types.Field;
            } else {
                this.type = Types.Function;

                this.fieldFn_ArgFields = [];
                this.fieldFn_ArgStrs = fieldMatch[3].split(',');
                for (let argStr of this.fieldFn_ArgStrs) {
                    let re = new RegExp('\\$' + this.fieldsHelper.regexpStrs_FieldName, 'g');
                    let matches = argStr.matchAll(re);
                    for (let match of matches) {
                        let fieldFn_ArgFieldInfo = this.fieldsHelper.def(repeatInfo, match[1], 
                                false, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);
        
                        this.fieldFn_ArgFields.push({
                            path: match[1],
                            fieldInfo: fieldFn_ArgFieldInfo,
                        });

                        for (let fieldFn_ArgFieldInfo_FD of fieldFn_ArgFieldInfo.fieldDefinitions)
                            this.fieldDefinitions.push(fieldFn_ArgFieldInfo_FD);
                    }
                }
            }

            this.field_Parts = fieldMatch[1];
            this.field_Parts = this.field_Parts.split('.');
            this.field_Name = this.field_Parts[this.field_Parts.length - 1];
        } else
            throw new Error(`Unknown 'FieldInfo' type of: ` + fieldPath);
    }

    getEval($evalStr, $argFields, $fields, $keys) {
        // return eval($evalStr);
        return Function('"use strict";return function($argFields, $fields, $keys) {' + 
                'return ' + $evalStr + '}')()($argFields, $fields, $keys);
    }

    getEvalStr(evalStr, argFields, fields, keys) {
        for (let argIndex = 0; argIndex < argFields.length; argIndex++) {
            let value = `$argFields[${argIndex}].fieldInfo.getValue($fields, $keys)`;
            evalStr = evalStr.replace(new RegExp('\\$\\{' + 
                    (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).escapeRegExpChars(argFields[argIndex].path) + '\\}' +
                    '([^a-zA-Z0-9]|$)', 'g'), value + '$1');
            evalStr = evalStr.replace(new RegExp('\\$' + 
                    (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).escapeRegExpChars(argFields[argIndex].path) + 
                    '([^a-zA-Z0-9]|$)', 'g'), value + '$1');
        }

        return evalStr.replace(/([^a-zA-Z0-9]|^)this([^a-zA-Z0-9]|$)/g, '$1undefined$2');
    }
    
    getValue(fields, keys, valueType) {
        if (this.type === Types.Field) {
            let field = this.getField(fields, keys);
            if (field === null)
                return undefined;

            return field.$value;
        } else if (this.type === Types.Function) {
            let field = this.getField(fields, keys);
            if (field === null)
                return undefined;
                
            let fnVal = field.$value;
            if (fnVal === null || typeof fnVal === 'undefined')
                return undefined;

            let argsArr = [];
            for (let argStr of this.fieldFn_ArgStrs) {
                // console.log(new Error());
                let evalStr = this.getEvalStr(argStr, this.fieldFn_ArgFields, 
                        fields, keys);
                try {
                    argsArr.push(this.getEval(evalStr, this.fieldFn_ArgFields, fields, keys));
                } catch (err) {
                    throw new Error(`Error evaluating function '$${this.field_Parts}(${argStr})` +  
                            err);
                }            
                
            }

            return fnVal.apply(null, argsArr);
            // let evalStr_Original = `(${fnVal})(${this.fieldFn_ArgFieldsStr})`;
            // let evalStr = this.getEvalStr(this.fieldFn_ArgFieldsStr,
            //         this.fieldFn_ArgFields, fields, keys);
            // evalStr = `(${fnVal})(${evalStr})`;

            // try {
            //     return this.getEval(evalStr);
            // } catch (err) {
            //     throw new Error(`Error evaluating function '$${this.field_Parts}:${evalStr_Original}': ` +  
            //             err);
            // }    
        } else if (this.type === Types.Expression) {
            let evalStr = this.getEvalStr(this.expr, this.expr_ArgFields, fields, keys);

            try {
                return this.getEval(evalStr, this.expr_ArgFields, fields, keys);
            } catch (err) {
                if ((_jsLib.import("spocky", "./index", "default", "spocky", "./index")).Debug)
                    console.error(evalStr);
                throw new Error(`Error evaluating expression "${this.expr}": ` + err);
            }
        } else
            throw new Error(`Unknown 'FieldInfo' type.`);
    }

    getField(fields, keys) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ObjectField, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null], Array);

        let rawParts = this.getRawParts(this.repeatInfo);
        // keys = this.repeatInfo.getKeys(this, keys);

        let keysOffset = 0;
        let field = fields;
        let fieldPath = '';
        let repeatsOffset = 0;
        for (let part of rawParts) {
            if (field instanceof (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ObjectField) {
                field = field.$get(part);
                fieldPath += (fieldPath !== '' ? '.' : '') + part;
            }

            while (field instanceof (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ListField) {
                let repeatFound = false;
                for (let i = repeatsOffset; i < this.repeatInfo.repeats.length; i++) {
                    if (fieldPath === this.repeatInfo.repeats[i].fieldInfo.getFullPath(
                            this.repeatInfo)) {
                        if (keys[i] === null || typeof keys[i] === 'undefined')
                            throw new Error('Instance keys to lists inconsistency.');

                        field = field.$get(keys[i]);
                        repeatsOffset = i + 1;
                        repeatFound = true;
                        break;
                    }
                }

                if (!repeatFound)
                    break;
                    // throw new Error('Instance keys to lists inconsistency.');
            }
        }

        return field;
    }

    getFullPath(repeatInfo) {
        let rawParts = this.getRawParts(repeatInfo);
        return rawParts.join('.');
    }

    getRawParts(repeatInfo) {
        let rawParts = this.field_Parts.slice();

        /* Get all raw parts. */
        for (let i = repeatInfo.repeats.length - 1; i >= 0; i--) {
            if (rawParts[0] !== repeatInfo.repeats[i].itemName)
                continue;

            rawParts.splice(0, 1);
            rawParts = repeatInfo.repeats[i].fieldInfo.field_Parts.concat(rawParts);
            // rawParts.splice(0, 0, repeatInfo.repeats[i].fieldInfo.parts);
        }

        return rawParts;
    }

}


class Types {
    static get Field()      { return 1; }
    static get Function()   { return 2; }
    static get Expression() { return 3; }

}

class ValueTypes {
    static get Bool()       { return 1; }
    static get Function()   { return 2; }
    static get List()       { return 3; }
    static get Object()     { return 4; }
    static get Text()       { return 5; }

}

/* JSLib Exports */
_jsLib.export("default", FieldInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.FieldsHelper.js
jsLibs.exportScript("spocky", "./LayoutParser.FieldsHelper", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-fields", "./index", [ { name: "default", alias: "abFields" } ], "ab-fields");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./LayoutParser", [ { name: "FieldInfo", alias: "FieldInfo" }, { name: "RepeatInfo", alias: "RepeatInfo" } ], "./LayoutParser.js");

/* export default */ class FieldsHelper {
    static get Types() {
        return Types;
    }


    constructor() {
        this._fieldDefinitions = (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).define();
        this._fieldInfos = [];

        this.regexpStrs_Expression = '\\?\\(((\\s|\\S)+)\\)';
        this.regexpStrs_FieldName = '([a-zA-Z][a-zA-Z0-9._]*)+?(\\((.*?)\\))?';
    }

    def(repeatInfo, fieldPath, includesPrefix, requiredFieldDefinitionClass) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spocky", "./LayoutParser", "RepeatInfo", "RepeatInfo", "./LayoutParser.js")), 'string',
                'boolean', 'function');

        let fieldInfo = new (_jsLib.import("spocky", "./LayoutParser", "FieldInfo", "FieldInfo", "./LayoutParser.js"))(this, repeatInfo, fieldPath, includesPrefix);

        if (fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser", "FieldInfo", "FieldInfo", "./LayoutParser.js")).Types.Field) {
            fieldInfo.fieldDefinitions.push(this._define(fieldInfo, repeatInfo, 
                    requiredFieldDefinitionClass));
        } else if (fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser", "FieldInfo", "FieldInfo", "./LayoutParser.js")).Types.Function) {
            fieldInfo.fieldDefinitions.push(this._define(fieldInfo, repeatInfo, 
                    requiredFieldDefinitionClass));
        } else if (fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser", "FieldInfo", "FieldInfo", "./LayoutParser.js")).Types.Expression) {
            
        }
        
        return fieldInfo;
    }

    getFieldName(fieldPath, includesPrefix) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'boolean');

        if (includesPrefix) {
            if (fieldPath[0] !== '$')
                return null;

            if (fieldPath[1] === '{') {
                if (fieldPath[fieldPath.length - 1] !== '}')
                    return null;

                return fieldPath.substring(2, fieldPath.length - 1);
            }

            return fieldPath.substring(1);
        }

        return fieldPath;
    }

    getType(fieldDefintion) {

    }

    getValue(fieldDefintion, value, keys) {
        let field = this.find(fieldDefintion);
        if (field === null)
            throw Error('Field not defined: ' + fieldDefintion);

        return typeof value === 'function' ? 
                eval(`value(${fieldInfo.args})`) : value;
    }

    find(fieldDefintion) {
        for (let field of this._fields) {
            if (field.definition === fieldDefintion)
                return field;
        }

        return null;
    }

    isFieldName(str, includesPrefix) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'boolean');

        if (includesPrefix) {
            if (str[0] !== '$')
                return false;

            if (str[1] === '{') {
                if (str[str.length - 1] !== '}')
                    return false;

                return str.substring(2, str.length - 1)
                        .match(new RegExp(
                        '^' + this.regexpStrs_FieldName + '$')) !== null;    
            }

            return str.substring(1).match(
                    new RegExp('^' + this.regexpStrs_FieldName + '$')) !== null;
        }

        return str.match(new RegExp('^' + this.regexpStrs_FieldName + '$')) !== null;
    }

    isExpression(str) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return str.match(new RegExp('^' + this.regexpStrs_Expression + '$', 'm')) !== null;
    }

    isValidString(str, includesPrefix) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'boolean');

        return this.isFieldName(str, includesPrefix) || this.isExpression(str);
    }

    matchField(fieldPath) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return fieldPath.match(this.regexpStrs_FieldName);
    }

    validateFieldName(fieldName, includesPrefix) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'boolean');

        if (!this.isFieldName(fieldName, includesPrefix))
            throw new Error(`'${fieldName}' is not a valid field name.`);
    }

    validateProperty(property, includesPrefix) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'boolean');

        if (!this.isValidString(property, includesPrefix))
            throw new Error(`'${property}' is not a valid property.`);
    }

    _add(fieldDefintion, fieldInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).Definition);

        let field = this.find(fieldDefintion);

        if (field === null)
            field = new Field(fieldDefintion);
        
        this._fields.push(field);
    }

    _define(fieldInfo, repeatInfo, newFieldDefinitionClass) {
        let fd = this._fieldDefinitions;
        let repeatOffset = 0;

        /* Check if is list. */
        let firstPart = fieldInfo.field_Parts[0];
        let repeatFound = false;
        for (let i = repeatInfo.repeats.length - 1; i >= repeatOffset; i--) {
            if (firstPart !== repeatInfo.repeats[i].itemName)
                continue;
            repeatFound = true;

            fd = repeatInfo.repeats[i].fieldDefinition;
            if (fieldInfo.field_Parts.length === 1)
                return fd.item(newFieldDefinitionClass);
            
            fd = fd.item((_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ObjectDefinition);
        }

        for (let i = repeatFound ? 1 : 0; i < fieldInfo.field_Parts.length - 1; i++) {
            let part = fieldInfo.field_Parts[i];
            fd = fd.object(part);
        }

        let lastPart = fieldInfo.field_Parts[fieldInfo.field_Parts.length - 1];

        // let field = null;
        // let fieldExists = fd.exists(lastPart);

        // let fieldIsVar = fieldExists ? 
        //         (fd.get(lastPart) instanceof abFields.VarDefinition ? true : false) : 
        //         false;
        // fieldExists = false;
        // fieldIsVar = false;

        if (newFieldDefinitionClass === (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ObjectDefinition)
            return fd.object(lastPart, false);
        else if (newFieldDefinitionClass === (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ListDefinition)
            return fd.list(lastPart, false);
        else if (newFieldDefinitionClass === (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition) {
            // if (fieldExists && !fieldIsVar)
            //     return fd.get(lastPart);

            return fd.var(lastPart);
        } else
           throw new Error(`Unknown 'newFieldDefinitionClass'.`);
    }

}


class Field {
    constructor(fieldDefintion) {
        this.definition = fieldDefintion;
    }

}


class Types {
    static get Var() { return 1; }
    static get Function() { return 2; }
    static get Expression() { return 3; }

}

/* JSLib Exports */
_jsLib.export("default", FieldsHelper); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.js
jsLibs.exportScript("spocky", "./LayoutParser", [ "Elems","FieldInfo","FieldsHelper","Holders","RepeatInfo","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-fields", "./index", [ { name: "default", alias: "abFields" } ], "ab-fields");
_jsLib.importDeclaration("ab-layouts", "./index", [ { name: "default", alias: "abLayouts" } ], "ab-layouts");
_jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");

_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "./index");
_jsLib.importDeclaration("spocky", "./Holder", [ { name: "default", alias: "Holder" } ], "./Holder");

_jsLib.importDeclaration("spocky", "./LayoutParser.Elems", [ { name: "default", alias: "Elems" } ], "./LayoutParser.Elems");
_jsLib.importDeclaration("spocky", "./LayoutParser.FieldInfo", [ { name: "default", alias: "FieldInfo" } ], "./LayoutParser.FieldInfo");
_jsLib.importDeclaration("spocky", "./LayoutParser.FieldsHelper", [ { name: "default", alias: "FieldsHelper" } ], "./LayoutParser.FieldsHelper");
_jsLib.importDeclaration("spocky", "./LayoutParser.Holders", [ { name: "default", alias: "Holders" } ], "./LayoutParser.Holders");
_jsLib.importDeclaration("spocky", "./LayoutParser.RepeatInfo", [ { name: "default", alias: "RepeatInfo" } ], "./LayoutParser.RepeatInfo");

/* export default */ class LayoutParser extends (_jsLib.import("ab-layouts", "./index", "default", "abLayouts", "ab-layouts")).Parser {
    get data() {
        return this._data;
    }

    get elems() {
        return this._elems;
    }

    get fields() {
        return this._fields;
    }

    get holders() {
        return this._holders;
    }


    constructor() {
        super();

        this._fieldsHelper = new (_jsLib.import("spocky", "./LayoutParser.FieldsHelper", "default", "FieldsHelper", "./LayoutParser.FieldsHelper"))();

        this._fields = null;        
        this._elems = new (_jsLib.import("spocky", "./LayoutParser.Elems", "default", "Elems", "./LayoutParser.Elems"))();
        this._holders = new (_jsLib.import("spocky", "./LayoutParser.Holders", "default", "Holders", "./LayoutParser.Holders"))();
        this._data = {};
    }


    _createContentElement(nodeInfo, elementsStack) {
        let node = this._createTextNode(nodeInfo.content, elementsStack);

        return new (_jsLib.import("ab-layouts", "./index", "default", "abLayouts", "ab-layouts")).Parser.Element(node, node, null);
    }

    _createElement(nodeInfo, elementsStack) {
        let element = new (_jsLib.import("ab-layouts", "./index", "default", "abLayouts", "ab-layouts")).Parser.Element(null, null, {});

        this._createElement_AddRepeat(nodeInfo, elementsStack, element);
        let tElementsStack = elementsStack.concat([ element ]);
        this._createElement_AddHide(nodeInfo, tElementsStack, element);
        this._createElement_AddShow(nodeInfo, tElementsStack, element);
        this._createElement_AddSingle(nodeInfo, tElementsStack, element);
        this._createElement_AddField(nodeInfo, tElementsStack, element);
        this._createElement_AddHolder(nodeInfo, tElementsStack, element);
        this._createElement_ParseElem(nodeInfo, tElementsStack, element);
        this._createElement_ParseData(nodeInfo, tElementsStack, element);

        return element;
    }

    _createElement_AddField(nodeInfo, elementsStack, element) {
        if (!('_field' in nodeInfo.attribs))
            return;
        if (nodeInfo.type === '$')
            throw new Error(`'_field' cannot be in virtual node.`);
        this._fieldsHelper.validateProperty(nodeInfo.attribs._field[0], false);

        let node = element.bottomNode;

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeInfo.attribs._field[0],
                false, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);

        /* Default */
        node.innerHTML = fieldInfo.getValue(this._fields, []);

        /* Field Listeners */
        for (let fd of fieldInfo.fieldDefinitions) {
            fd.addListener({
                change: (value, keys) => {
                    this._runOnUIThread(() => {
                        let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                node, keys);
                        for (let nodeInstance of nodeInstances) {
                            let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                            nodeInstance.htmlElement.innerHTML = fieldInfo.getValue(
                                    this._fields, instanceKeys);
                        }
                    });
                },
            });
        }

        /* Virtual */
        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {  
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let value = fieldInfo.getValue(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.htmlElement.innerHTML = value;
                });
            });
        }
    }

    _createElement_AddHide(nodeInfo, elementsStack, element) {
        if (!('_hide' in nodeInfo.attribs))
            return;
            this._fieldsHelper.validateProperty(nodeInfo.attribs._hide[0], false);

        let node = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).HideNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeInfo.attribs._hide[0],
                false, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);
    
        /* Default */
        node.hide = fieldInfo.getValue(this._fields, []) ? true : false;

        /* Field Listeners */
        for (let fd of fieldInfo.fieldDefinitions) {
            fd.addListener({
                change: (value, keys) => {
                    this._runOnUIThread(() => {
                        let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                node, keys);
                        for (let nodeInstance of nodeInstances) {
                            let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                            nodeInstance.hide = fieldInfo.getValue(
                                    this._fields, instanceKeys) ? true : false;
                        }
                    });
                },
            });
        }

        /* Virtual */
        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let value = fieldInfo.getValue(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.hide = value ? true : false;
                });
            });
        }
    }

    _createElement_AddHolder(nodeInfo, elementsStack, element) {
        if (!('_holder' in nodeInfo.attribs))
            return;

        let node = new (_jsLib.import("ab-layouts", "./index", "default", "abLayouts", "ab-layouts")).LayoutNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);

        if (repeatInfo.virtual) {
            element.info.holders_OnCreateFn = null;
            element.info.holders_OnDestroyFn = null;

            // this._elems._declare(elemName);
            node.pCopyable.onCreate((node) => {
                let keys = node.pCopyable.getInstanceKeys();
                
                /* Virtual Node */
                if (keys.length < repeatInfo.repeats.length)
                    return;

                // this._elems._add(elemName, keys, node.htmlElement);

                if (element.info.holders_OnCreateFn !== null) {
                    element.info.holders_OnCreateFn(new (_jsLib.import("spocky", "./Holder", "default", "Holder", "./Holder"))(node), keys);
                }
            });
            node.pCopyable.onDestroy((node) => {
                let keys = node.pCopyable.getInstanceKeys();

                // this._elems._remove(elemName, keys);

                if (element.info.holders_OnDestroyFn !== null) {
                    element.info.holders_OnDestroyFn(keys);
                }
            });

            Object.defineProperty(this._holders, nodeInfo.attribs._holder, {
                get: () => {
                    return (onCreateFn) => {
                        element.info.holders_OnCreateFn = onCreateFn;

                        this._runOnUIThread(() => {
                            let nodeInstances = node.pCopyable.getNodeCopies();
                            for (let nodeInstance of nodeInstances) {
                                let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                                onCreateFn(new (_jsLib.import("spocky", "./Holder", "default", "Holder", "./Holder"))(nodeInstance), instanceKeys);
                            }
                        });
                    };
                }
            });
        } else {
            Object.defineProperty(this._holders, nodeInfo.attribs._holder, {
                value: new (_jsLib.import("spocky", "./Holder", "default", "Holder", "./Holder"))(node), 
                enumerable: true,
            });
        }
    }

    _createElement_AddRepeat(nodeInfo, elementsStack, element) {
        if (!('_repeat' in nodeInfo.attribs))
            return;

        let repeatNameArr = nodeInfo.attribs._repeat[0].split(':');
        if (repeatNameArr.length !== 2)
            throw new Error('Repeat format must be `[fieldName]:[itemFieldName].');

        let fieldName = repeatNameArr[0];
        let itemName = repeatNameArr[1];

        this._fieldsHelper.validateFieldName(fieldName, false);
        this._fieldsHelper.validateFieldName(itemName, false);

        let node = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).RepeatNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, fieldName,
                false, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).ListDefinition);

        let fd = fieldInfo.fieldDefinitions[0];

        element.info.repeat = {
            node: node,
            fieldInfo: fieldInfo,
            itemName: itemName,
            fieldDefinition: fd,
        };
        
        fd.addListener({
            add: (index, key, keys) => {
                this._runOnUIThread(() => {
                    let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                            node, keys);

                    for (let nodeInstance of nodeInstances)
                        nodeInstance.addAt(index, key);
                });
            },
            delete: (key, keys) => {
                this._runOnUIThread(() => {
                    let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                            node, keys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.delete(key);
                });
            },
        });

        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let field = fieldInfo.getField(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances) {
                        for (let [ key, value ] of field)
                            nodeInstance.add(key);
                    }
                });
            });
        }

        // if ('_id' in nodeInfo.attribs)
        //     this._nodes.set(`${nodeInfo.attribs._id}.single`, node);
    }

    _createElement_AddShow(nodeInfo, elementsStack, element) {
        if (!('_show' in nodeInfo.attribs))
            return;
        this._fieldsHelper.validateProperty(nodeInfo.attribs._show[0], false);

        let node = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).ShowNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeInfo.attribs._show[0],
                false, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);

        /* Default */
        node.show = fieldInfo.getValue(this._fields, []) ? true : false;

        /* Field Listeners */
        for (let fd of fieldInfo.fieldDefinitions) {
            fd.addListener({
                change: (value, keys) => {
                    this._runOnUIThread(() => {
                        let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                node, keys);
                        for (let nodeInstance of nodeInstances) {
                            let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                            nodeInstance.show = fieldInfo.getValue(
                                    this._fields, instanceKeys) ? true : false;
                        }
                    });
                },
            });
        }

        /* Virtual */
        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let value = fieldInfo.getValue(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.show = value ? true : false;
                });
            });
        }
    }

    _createElement_AddSingle(nodeInfo, elementsStack, element) {
        if (nodeInfo.type === '$')
            return;

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);

        let node = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).SingleNode(nodeInfo.type);
        this._createElement_UpdateElement(element, node);

        this._createElement_AddSingle_ParseAttribs(repeatInfo, node, nodeInfo.attribs);
    }

    _createElement_AddSingle_ParseAttribs(repeatInfo, node, attribs) {
        for (let attribName in attribs) {
            // if (attribName[0] === '$')
            //     continue;

            let attribArr = attribs[attribName];
            let attribArr_FieldInfos = [];
            for (let attribPart of attribArr) {
                if (!this._fieldsHelper.isValidString(attribPart, true)) {
                    attribArr_FieldInfos.push(null);
                    continue;
                }

                let fieldInfo = this._fieldsHelper.def(repeatInfo, attribPart,
                        true, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);
                attribArr_FieldInfos.push(fieldInfo);

                for (let fd of fieldInfo.fieldDefinitions) {
                    fd.addListener({
                        change: (value, keys) => {
                            this._runOnUIThread(() => {
                                let nodeInstances = this._getNodeInstances(repeatInfo, 
                                        fieldInfo, node, keys);
                                for (let nodeInstance of nodeInstances) {
                                    let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                                    let attrib = this._createElement_AddSingle_GetAttrib(
                                            attribArr, attribArr_FieldInfos, instanceKeys);

                                    if (attribName in nodeInstance.htmlElement)
                                        nodeInstance.htmlElement[attribName] = attrib;
                                    else
                                        nodeInstance.htmlElement.setAttribute(attribName, attrib);
                                }
                            });
                        },
                    });
                }
            }

            /* Default */
            let attrib = this._createElement_AddSingle_GetAttrib(
                    attribArr, attribArr_FieldInfos, []);
            if (attribName in node.htmlElement)
                node.htmlElement[attribName] = attrib;
            else
                node.htmlElement.setAttribute(attribName, attrib);

            /* Virtual */
            if (repeatInfo.virtual) {
                node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                    /* Virtual Node */
                    if (instanceKeys.length < repeatInfo.repeats.length)
                        return;

                    let attrib = this._createElement_AddSingle_GetAttrib(
                            attribArr, attribArr_FieldInfos, instanceKeys);
                    if (attribName in nodeInstance.htmlElement)
                        nodeInstance.htmlElement[attribName] = attrib;
                    else
                        nodeInstance.htmlElement.setAttribute(attribName, attrib);
                });
            }
        }
    }

    _createElement_AddSingle_GetAttrib(attribArr, attribArr_FieldInfos, instanceKeys) {
        let attrib = '';
        for (let i = 0; i < attribArr.length; i++) {
            if (attribArr_FieldInfos[i] !== null) {
                attrib += attribArr_FieldInfos[i].getValue(this._fields, instanceKeys);
            } else
                attrib += attribArr[i];
        }

        return attrib;
    }

    _createElement_ParseData(nodeInfo, elementsStack, element) {
        for (let attribName in nodeInfo.attribs) {
            if (attribName.indexOf('_data-') !== 0)
                continue;

            let attribArr = nodeInfo.attribs[attribName];

            let dataName = attribName.substring(`_data-`.length);
            let data = attribArr[0].replace(/\\"/g, '"');
    
            if (!(dataName in this._data))
                this._data[dataName] = [];
    
            this._data[dataName].push(data);
        }
    }

    _createElement_ParseElem(nodeInfo, elementsStack, element) {
        if (!('_elem' in nodeInfo.attribs))
            return;

        let elemName = nodeInfo.attribs._elem[0];
        if (this._elems.$exists(elemName)) {
            if ((_jsLib.import("spocky", "./index", "default", "spocky", "./index")).Debug) {
                console.warn(`Element '${elemName}' already exist. Skipping in:`, 
                        nodeInfo, new Error());
            }

            return;
        }

        let node = element.bottomNode;

        let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);

        if (repeatInfo.virtual) {
            element.info.elems_OnCreateFn = null;
            element.info.elems_OnDestroyFn = null;

            this._elems._declare(elemName);
            node.pCopyable.onCreate((node) => {
                let keys = node.pCopyable.getInstanceKeys();

                /* Virtual Node */
                if (keys.length < repeatInfo.repeats.length)
                    return;

                this._elems._add(elemName, keys, node.htmlElement);

                if (element.info.elems_OnCreateFn !== null) {
                    element.info.elems_OnCreateFn(node.htmlElement, keys);
                }
            });
            node.pCopyable.onDestroy((node) => {
                let keys = node.pCopyable.getInstanceKeys();

                this._elems._remove(elemName, keys);

                if (element.info.elems_OnDestroyFn !== null) {
                    element.info.elems_OnDestroyFn(node.htmlElement, keys);
                }
            });

            Object.defineProperty(this._elems, nodeInfo.attribs._elem, {
                get: () => {
                    return (onCreateFn) => {
                        element.info.elems_OnCreateFn = onCreateFn;
                        
                        this._runOnUIThread(() => {
                            let nodeInstances = node.pCopyable.getNodeCopies();
                            for (let nodeInstance of nodeInstances) {
                                let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                                onCreateFn(nodeInstance.htmlElement, instanceKeys);
                            }
                        });
                    };
                }
            });
        } else {
            this._elems._declare(elemName);
            this._elems._add(elemName, [], node.htmlElement);

            Object.defineProperty(this._elems, nodeInfo.attribs._elem, {
                get: () => {
                    return node.htmlElement;
                }
            });
        }
    }

    _createElement_UpdateElement(element, new_bottom_node) {
        if (element.topNode === null)
            element.topNode = new_bottom_node;
        if (element.bottomNode !== null)
            element.bottomNode.pChildren.add(new_bottom_node);
        element.bottomNode = new_bottom_node;
    }

    _createTextNode(nodeContent, elementsStack) {
        let node = null;

        if (this._fieldsHelper.isValidString(nodeContent, true)) {
            let repeatInfo = new (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo"))(elementsStack);
            let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeContent,
                    true, (_jsLib.import("ab-fields", "./index", "default", "abFields", "ab-fields")).VarDefinition);
            
            node = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).TextNode(fieldInfo.getValue(this._fields, []));

            for (let fd of fieldInfo.fieldDefinitions) {
                fd.addListener({
                    change: (value, keys) => {
                        this._runOnUIThread(() => {
                            let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                    node, keys);

                            for (let nodeInstance of nodeInstances) {
                                nodeInstance.text = fieldInfo.getValue(this._fields, 
                                        nodeInstance.pCopyable.getInstanceKeys());
                            }
                        });
                    },
                });
            }

            if (repeatInfo.virtual) {
                node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                    /* Virtual Node */
                    if (instanceKeys.length < repeatInfo.repeats.length)
                        return;

                    let value = fieldInfo.getValue(this._fields, instanceKeys);

                    this._runOnUIThread(() => {
                        let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                        for (let nodeInstance of nodeInstances)
                            nodeInstance.text = value;
                    });
                });
            }
        } else
            node = new (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).TextNode(nodeContent);

        return node;
    }

    _getNodeInstances(repeatInfo, fieldInfo, node, keys) {
        if (repeatInfo.repeats.length === 0)
            return [ node ];

        let fieldInfos_Requested = [];

        /* Main Field */
        if (fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser.FieldInfo", "default", "FieldInfo", "./LayoutParser.FieldInfo")).Types.Field || 
                fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser.FieldInfo", "default", "FieldInfo", "./LayoutParser.FieldInfo")).Types.Function)
            fieldInfos_Requested.push(fieldInfo);
        
        /* Arg Fields */
        if (fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser.FieldInfo", "default", "FieldInfo", "./LayoutParser.FieldInfo")).Types.Function) {
            for (let argField of fieldInfo.fieldFn_ArgFields)
                fieldInfos_Requested.push(argField.fieldInfo);
        }

        if (fieldInfo.type === (_jsLib.import("spocky", "./LayoutParser.FieldInfo", "default", "FieldInfo", "./LayoutParser.FieldInfo")).Types.Expression) {
            for (let argField of fieldInfo.expr_ArgFields)
                fieldInfos_Requested.push(argField.fieldInfo);
        }

        /* Node Copies */
        // console.log('###', fieldInfos_Requested);
        // let nodeCopies = [];
        // for (let fieldInfo_Requested of fieldInfos_Requested) {
        //     let repeatKeys = repeatInfo.getKeys(fieldInfo_Requested, keys);
        //     console.log('Here', repeatKeys);
        //     let nodeCopies_T = node.pCopyable.getNodeCopies(repeatKeys);
        //     console.log(nodeCopies_T);
        //     for (let nodeCopy_T of nodeCopies_T) {
        //         if (!nodeCopies.includes(nodeCopy_T))
        //             nodeCopies.push(nodeCopy_T);
        //     }
        // }

        let nodeCopies = [];
        let repeatKeys = repeatInfo.getKeys(fieldInfos_Requested, keys);
        let nodeCopies_T = node.pCopyable.getNodeCopies(repeatKeys);
        for (let nodeCopy_T of nodeCopies_T) {
            if (!nodeCopies.includes(nodeCopy_T))
                nodeCopies.push(nodeCopy_T);
        }

        return nodeCopies;
    }

    _isVirtual(elementsStack) {
        for (let i = 0; i < elementsStack.length; i++) {
            if ('repeat' in elementsStack[i].info)
                return true;
        }

        return false;
    }

    _runOnUIThread(fn) {
        fn();
        // setTimeout(fn, 10);
    }


    /* abLayouts.Parser Overrides */
    __afterParse() {
        this._fields = this._fieldsHelper._fieldDefinitions.create();
    }
    
    __createElement(nodeInfo, elementsStack) {
        if (nodeInfo.type === '_content')
            return this._createContentElement(nodeInfo, elementsStack);
        else
            return this._createElement(nodeInfo, elementsStack);
    }
    /* abLayouts.Parser Overrides */

}

/* export { (_jsLib.import("spocky", "./LayoutParser.Elems", "default", "Elems", "./LayoutParser.Elems")), (_jsLib.import("spocky", "./LayoutParser.FieldInfo", "default", "FieldInfo", "./LayoutParser.FieldInfo")), (_jsLib.import("spocky", "./LayoutParser.FieldsHelper", "default", "FieldsHelper", "./LayoutParser.FieldsHelper")), (_jsLib.import("spocky", "./LayoutParser.Holders", "default", "Holders", "./LayoutParser.Holders")), (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo")), }; */

/* JSLib Exports */
_jsLib.export("Elems", (_jsLib.import("spocky", "./LayoutParser.Elems", "default", "Elems", "./LayoutParser.Elems")));
_jsLib.export("FieldInfo", (_jsLib.import("spocky", "./LayoutParser.FieldInfo", "default", "FieldInfo", "./LayoutParser.FieldInfo")));
_jsLib.export("FieldsHelper", (_jsLib.import("spocky", "./LayoutParser.FieldsHelper", "default", "FieldsHelper", "./LayoutParser.FieldsHelper")));
_jsLib.export("Holders", (_jsLib.import("spocky", "./LayoutParser.Holders", "default", "Holders", "./LayoutParser.Holders")));
_jsLib.export("RepeatInfo", (_jsLib.import("spocky", "./LayoutParser.RepeatInfo", "default", "RepeatInfo", "./LayoutParser.RepeatInfo")));
_jsLib.export("default", LayoutParser); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.Holders.js
jsLibs.exportScript("spocky", "./LayoutParser.Holders", [ "default" ], (_jsLib) => { "use strict"; /* export default */ class Holders {
    constructor() {
        
    }

}

/* JSLib Exports */
_jsLib.export("default", Holders); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.RepeatInfo.js
jsLibs.exportScript("spocky", "./LayoutParser.RepeatInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [  ], "js0");
_jsLib.importDeclaration("spocky", "./LayoutParser.FieldInfo", [  ], "./LayoutParser.FieldInfo");

/* export default */ class RepeatInfo {
    constructor(elementsStack) {
        this.repeats = [];
        this.virtual = false;

        for (let i = 0; i < elementsStack.length; i++) {
            let element = elementsStack[i];

            if ('repeat' in element.info) {
                this.repeats.push(element.info.repeat);
                this.virtual = true;
            }
        }
    }

    // getKeys(fieldInfo, keys)
    // {
    //     let repeatKeys = [];
    //     for (let i = 0; i < this.repeats.length; i++)
    //         repeatKeys.push(null);

    //     let rawFieldParts = fieldInfo.getRawParts(this);
    //     let fullFieldPath = rawFieldParts.join('.');
    //     let keysIndex = keys.length - 1;
        
    //     for (let i = this.repeats.length - 1; i >= 0; i--) {
    //         let repeatFieldPath = this.repeats[i].fieldInfo
    //                 .getFullPath(this);
    //         if (fullFieldPath.indexOf(repeatFieldPath) === 0) {
    //             repeatKeys[i] = keys[keysIndex];
    //             keysIndex--;
    //             if (keysIndex < 0)
    //                 break;
    //             // fullFieldPath = fullFieldPath.substring(repeatFieldPath.length);
    //             // if (fullFieldPath[0] === '.')
    //             //     fullFieldPath = fullFieldPath.substring(1);
    //         }
    //     }
        
    //     return repeatKeys;
    // }

    getKeys(fieldInfos, keys) {
        let repeatKeys = [];
        for (let i = 0; i < this.repeats.length; i++)
            repeatKeys.push(null);

        if (keys.length === 0)
            return repeatKeys;

        let keysIndex = keys.length - 1;
        
        for (let i = this.repeats.length - 1; i >= 0; i--) {
            for (let fieldInfo of fieldInfos) {
                let rawFieldParts = fieldInfo.getRawParts(this);
                let fullFieldPath = rawFieldParts.join('.');
                
                let repeatFieldPath = this.repeats[i].fieldInfo
                        .getFullPath(this);
                if (fullFieldPath.indexOf(repeatFieldPath) === 0) {
                    repeatKeys[i] = keys[keysIndex];
                    keysIndex--;
                    if (keysIndex < 0)
                        break;
                    // fullFieldPath = fullFieldPath.substring(repeatFieldPath.length);
                    // if (fullFieldPath[0] === '.')
                    //     fullFieldPath = fullFieldPath.substring(1);
                }
            }

            if (keysIndex < 0)
                break;
        }
        
        return repeatKeys;
    }

}

/* JSLib Exports */
_jsLib.export("default", RepeatInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Module.js
jsLibs.exportScript("spocky", "./Module", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-layouts", "./index", [  ], "ab-layouts");
_jsLib.importDeclaration("ab-nodes", "./index", [  ], "ab-nodes");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spocky", "./Layout", [ { name: "default", alias: "Layout" } ], "./Layout");
_jsLib.importDeclaration("spocky", "./Viewable", [ { name: "default", alias: "Viewable" } ], "./Viewable");

/* export default */ class Module {
    get $name() {
        return this.constructor.name;
    }

    set $view(value) {
        if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(value, [ (_jsLib.import("spocky", "./Layout", "default", "Layout", "./Layout")), Module, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]))
            throw new Error(`'$view' must be 'Layout', 'Module' or 'Null'.`);

        if (this._$view === value)
            return;

        if (this._$view !== null)
            this._$view._$viewable.deactivate();

        this._$view = value;
        if (this._$view !== null && this._$parentNode !== null)
            this._$view._$viewable.activate(this._$parentNode);
    }


    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).prop(this, Module.Viewable, this);

        Object.defineProperties(this, {
            _$view: { value: null, writable: true, },
            _$parentNode: { value: null, writable: true, },

            _$listeners: { value: {
                onActivate: [],
                onDeactivate: [],
            }},
        });
    }

    $onActivate(listener) {
        this._$listeners.onActivate.push(listener);
    }

    $onDeactivate(listener) {
        this._$listeners.onDeactivate.push(listener);
    }

}


Object.defineProperties(Module, {

    Viewable: { value:
    class Module_Viewable extends (_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable")) {

        constructor(module) { super();
            (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Module);

            this._module = module;
            this._onDisplay = (displayed) => {
                for (let listener of this._module._$listeners.onDisplay)
                    listener(displayed);
            };
        }

        __activate(parentNode) {
            this._module._$parentNode = parentNode;
            // console.log(parentNode, 'Added listener.');

            if (this._module._$view === null) {
                // Do nothing.
            } else if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(this._module._$view, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable")))))
                this._module._$view._$viewable.activate(parentNode);
            else
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(`Unknown view type.`);

            for (let listener of this._module._$listeners.onActivate)
                listener();
        }

        __deactivate(parentNode) {
            for (let listener of this._module._$listeners.onDeactivate)
                listener();

            if (this._module._$view === null)
                return;
            else if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).type(this._module._$view, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("spocky", "./Viewable", "default", "Viewable", "./Viewable")))))
                this._module._$view._$viewable.deactivate();
            else
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(`Unknown view type.`);

            this._module._$parentNode = null;
        }

    }},

});

/* JSLib Exports */
_jsLib.export("default", Module); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\PathInfo.js
jsLibs.exportScript("spocky", "./PathInfo", [ "default" ], (_jsLib) => { "use strict"; class PathInfo {

    constructor(importPath)
    {
        let separatorIndex = importPath.lastIndexOf('.');
        let packagePath = importPath.substring(0, separatorIndex);
        let name = importPath.substring(separatorIndex + 1);

        Object.defineProperties(this, {
            path: { value: importPath, },
            name: { value: name, },
            packagePath: { value: packagePath, },
        });
    }

}
/* export default */ PathInfo;

/* JSLib Exports */
_jsLib.export("default", PathInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spocky\Viewable.js
jsLibs.exportScript("spocky", "./Viewable", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-nodes", "./index", [ { name: "default", alias: "abNodes" } ], "ab-nodes");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export default */ class Viewable {
    static get Property() {
        return '_$viewable';
    }


    get active() {
        return this._active;
    }

    get displayed() {
        return this._displayed;
    }


    constructor() {
        Object.defineProperties(this, {
            _parentNode: { value: null, writable: true, },
            _active: { value: false, writable: true, },
            _displayed: { value: false, writable: true, },
        });
    }

    activate(parentNode) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node);

        // setTimeout(() => {
            if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(parentNode, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Prop((_jsLib.import("ab-nodes", "./index", "default", "abNodes", "ab-nodes")).Node.PChildren)))
                throw new Error(`'parentNode' does not have 'PChildren' property.`);

            if (this._parentNode !== null)
                this.deactivate();

            this._parentNode = parentNode;
            this.__activate(this._parentNode);
        // }, 10);

        this._active = true;
    }

    deactivate() {
        // setTimeout(() => {
            if (this._parentNode !== null) {
                this.__deactivate(this._parentNode);
                this._parentNode = null;
            }
        // }, 10);

        this._active = false;
    }

    
    // _setParentNode(parentNode) {
    //     js0.args(arguments, abNodes.Node);

    //     if (!js0.type(parentNode, js0.Prop(abNodes.Node.PChildren)))
    //         throw new Error(`'parentNode' does not have 'PChildren' property.`);

    //     if (this._parentNode !== null && this._active)
    //         this.deactivate();

    //     this._parentNode = parentNode;
    //     if (this._active)
    //         this.activate();
    // }


    __activate(parentNode) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    __deactivate(parentNode) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }

    // activate(parentNode)
    // {
    //     js0.args(arguments, abNodes.Node);
    //     if (!js0.type(parentNode, js0.Prop(abNodes.Node.PChildren)))
    //         throw new Error(`'parentNode' does not have 'PChildren' property.`);

    //     if (!this._parentNode !== null)
    //         this.deactivate();

    //     this._parentNode = parentNode;
    //     this._parentNode.pChildren.add(this.getNode());
    // }

    // deactivate(parentNode)
    // {
    //     if (this._parentNode !== null)
    //         this._parentNode.pChildren.remove(this.getNode());
    // }

    // getNode() { throw new js0.virtual(this); }

    // static Validate(object)
    // {
    //     if (typeof object !== '[object Object]')
    //         return false;
    //     if (!('viewable' in object))
    //         return false;
    //     if (!(object.viewable instanceof Viewable))
    //         return false;
    //
    //     return true;
    // }
}

/* JSLib Exports */
_jsLib.export("default", Viewable); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\e-tasks\index.js
jsLibs.exportScript("e-tasks", "./index", [ "eTasks_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

/* export */ class eTasks_Class {
    constructor() {
        this.timeout = 1000;
    }

    start(api_uri, api_args, destroy_on_finish, fn) {
        let task_hash = null;

        let refresh = function(api_args) {
            api_args.task = {
                hash: task_hash,
                destroyOnFinish: destroy_on_finish
            };

            (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json(api_uri, api_args, function(result) {
                let task = null;
                if (result.isSuccess()) {
                    task = result.data.task;
                    task_hash = task.hash;
                }

                if (!fn(task, result))
                    return false;

                setTimeout(function() {
                    refresh(api_args);
                });
            });
        };
        refresh(api_args);
    }

    // refresh(api_uri, task_hash, destroy_on_finish, fn)
    // {
    //     let check_task = function() {
    //         webABApi.json(api_uri, {
    //             task: {
    //                 hash: task_hash,
    //                 destroyOnFinish: destroy_on_finish
    //             }
    //         }, function(result) {
    //             if (result.isSuccess()) {
    //                 if (fn(result.data.task.finished, result.data.task.info, null))
    //                     setTimeout(check_task, this.timeout);
    //             } else {
    //                 console.warn('Error on task refresh.');
    //                 setTimeout(check_task, this.timeout);
    //             }
    //         });
    //     };

    //     setTimeout(check_task, this.timeout);
    // }

}
const eTasks = new eTasks_Class();
/* export default */ eTasks;

/* JSLib Exports */
_jsLib.export("eTasks_Class", eTasks_Class);
_jsLib.export("default", eTasks); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data-web\index.js
jsLibs.exportScript("ab-data-web", "./index", [ "abDataWeb_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data-web", "./WebRequestProcessor", [ { name: "default", alias: "WebRequestProcessor" } ], "./WebRequestProcessor.js");

/* export */ class abDataWeb_Class {
    get WebRequestProcessor() {
        return (_jsLib.import("ab-data-web", "./WebRequestProcessor", "default", "WebRequestProcessor", "./WebRequestProcessor.js"));
    }


    constructor() {

    }
}
const abDataWeb = new abDataWeb_Class();
/* export default */ abDataWeb;

/* JSLib Exports */
_jsLib.export("abDataWeb_Class", abDataWeb_Class);
_jsLib.export("default", abDataWeb); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-data-web\WebRequestProcessor.js
jsLibs.exportScript("ab-data-web", "./WebRequestProcessor", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");

/* export default */ class WebRequestProcessor extends (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RequestProcessor {
    constructor(dataScheme, device, apiUri) {
        super(dataScheme, device);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).DataScheme, [ (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Device, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 'string');

        this._apiUri = apiUri;
    }

    async __processRequestBatch_Async(requests, transactionId) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let response = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response();

        let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(this._apiUri + 'request', { 
            deviceInfo: this.device === null ? null : {
                deviceId: this.device.id,
                deviceHash: this.device.hash,
                declaredItemIds: this.device.declaredItemIds,
            },
            requests: requests,
            args: {},
        });

        response.info = {
            webResult: result,
        };

        if (!result.isSuccess()) {
            if ((_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).debug) {
                console.error('Request error: ' + result.message);
                console.warn(result.data.data);
            }

            response.type = Response.Types_Error;
            response.error = result.message;

            return response;
        }

        response.parseRawObject(result.data.response);

        for (let request of requests) {
            if (!(request[0] in response.results))
                continue;
            let result = response.results[request[0]];
            if (result === null)
                continue;
            if (result._type > 0)
                continue;

            this._scheme.validateResult(request, result);
        }

        return response;
    }
}

/* JSLib Exports */
_jsLib.export("default", WebRequestProcessor); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\native-app\index.js
jsLibs.exportScript("native-app", "./index", [ "webApp_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-native", "./index", [  ], "ab-native");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("core", "./index", [ { name: "default", alias: "core" } ], "core");

_jsLib.importDeclaration("native-app", "./WebAppActions", [ { name: "default", alias: "WebAppActions" } ], "./WebAppActions.js");

/* export */ class webApp_Class extends (_jsLib.import("core", "./index", "default", "core", "core")).NativeApp {

    get debug() {
        return this._debug;
    }


    constructor() {
        super();
        
        this._debug = false;
        this._actions = new (_jsLib.import("native-app", "./WebAppActions", "default", "WebAppActions", "./WebAppActions.js"))();

        // this.addActionsSet('Core', new NativeActions_Core(this, '/api/v1/core/'));
    }

    setDebug(debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._debug = debug;
    }


    __getActions() {
        return this._actions;
    }
}
const abNative_WebApp = new webApp_Class();
/* export default */ abNative_WebApp;

/* JSLib Exports */
_jsLib.export("webApp_Class", webApp_Class);
_jsLib.export("default", abNative_WebApp); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\native-app\WebAppActions.js
jsLibs.exportScript("native-app", "./WebAppActions", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("ab-data-web", "./index", [ { name: "default", alias: "abDataWeb" } ], "ab-data-web");
_jsLib.importDeclaration("ab-native", "./index", [  ], "ab-native");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");
_jsLib.importDeclaration("core", "./index", [ { name: "default", alias: "core" } ], "core");
_jsLib.importDeclaration("native-app", "./index", [ { name: "default", alias: "webApp" } ], "./index.js");

const App = (_jsLib.import("core", "./index", "default", "core", "core")).App;

/* export default */ class WebAppActions extends (_jsLib.import("core", "./index", "default", "core", "core")).Actions {
    get dataStore() {
        return (_jsLib.import("native-app", "./index", "default", "webApp", "./index.js")).dataStore;
    }

    get dataScheme() {
        return (_jsLib.import("native-app", "./index", "default", "webApp", "./index.js")).dataScheme;
    }


    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);
        super();
    }

    __createDataStore(deviceInfo) {
        let device = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Device(deviceInfo.deviceId, 
                deviceInfo.deviceHash, deviceInfo.lastUpdate, 
                deviceInfo.lastItemId, []);
        let rp = new (_jsLib.import("ab-data-web", "./index", "default", "abDataWeb", "ab-data-web")).WebRequestProcessor(this.dataScheme, device, 
                abNative_ApiUri + 'ab-data/');
                
        setInterval(() => {
            this.dataStore.requestB_Async([])
                .catch((err) => {
                    console.error(err);
                    this.mMain.msgs.showMessage_Failure(err.toString(), '', 
                            () => {
                        location.reload();
                    });
                });
        }, 60 * 1000);

        return new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).DataStore(rp);
    }

    async __init_Async() {
        let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 'core/init', {});

        if (!result.isSuccess()) {
            if (this.nativeApp.debug)
                console.warn(result.data.data);

            throw new Error('Cannot initialize web app.');
        }

        return {
            appInfo: null,
            appVersion: '-',
            fields: result.data.fields,
            user: result.data.user,
            deviceInfo: result.data.deviceInfo,
            extras: result.data.extras,
        };
    }

    async __logIn_Async(login, password) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 'core/log-in', {
            login: login,
            password: password,
        });

        if (!result.isSuccess()) {
            if (this.nativeApp.debug) {
                console.warn('Result Message', result.message);
                console.warn('Result Data', result.data.data);
            }

            return {
                data: null,
                error: result.message,
            };
        }

        return {
            data: {
                appInfo: null,
                user: result.data.user,
                extras: result.data.extras,
            },
            error: null,
        };
    }

    async __logOut_Async() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);

        let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 'core/log-out', {});

        if (!result.isSuccess()) {
            if (this.nativeApp.debug) {
                console.warn('Result Message', result.message);
                console.warn('Result Data', result.data.data);
            }

            return {
                error: result.message,
            };
        }

        return {
            error: null,
        };
    }

    async __messageDisplayed_Async(messageId) {
        let app = App.GetInstance();

        await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 
                'core/app-message-displayed', {
            messageId,
        });
    }
}

/* JSLib Exports */
_jsLib.export("default", WebAppActions); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\index.js
jsLibs.exportScript("ts0", "./index", [ "ts0","ts0Assert","AssertError","TS0List","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ts0", "./ts-lib/index", [ { name: "default", alias: "ts0" } ], "./ts-lib/index.ts");
_jsLib.importDeclaration("ts0", "./ts-lib/ts0Assert", [ { name: "default", alias: "ts0Assert" } ], "./ts-lib/ts0Assert.ts");
_jsLib.importDeclaration("ts0", "./ts-lib/AssertError", [ { name: "default", alias: "AssertError" } ], "./ts-lib/AssertError.ts");
_jsLib.importDeclaration("ts0", "./ts-lib/TS0List", [ { name: "default", alias: "TS0List" } ], "./ts-lib/TS0List.ts");
                                                                              

/* export default */ (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./ts-lib/index.ts"));
                                                                
/* export { (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./ts-lib/index.ts")), (_jsLib.import("ts0", "./ts-lib/ts0Assert", "default", "ts0Assert", "./ts-lib/ts0Assert.ts")), (_jsLib.import("ts0", "./ts-lib/AssertError", "default", "AssertError", "./ts-lib/AssertError.ts")), (_jsLib.import("ts0", "./ts-lib/TS0List", "default", "TS0List", "./ts-lib/TS0List.ts")), }; */

/* JSLib Exports */
_jsLib.export("ts0", (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./ts-lib/index.ts")));
_jsLib.export("ts0Assert", (_jsLib.import("ts0", "./ts-lib/ts0Assert", "default", "ts0Assert", "./ts-lib/ts0Assert.ts")));
_jsLib.export("AssertError", (_jsLib.import("ts0", "./ts-lib/AssertError", "default", "AssertError", "./ts-lib/AssertError.ts")));
_jsLib.export("TS0List", (_jsLib.import("ts0", "./ts-lib/TS0List", "default", "TS0List", "./ts-lib/TS0List.ts")));
_jsLib.export("default", (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./ts-lib/index.ts"))); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\ts-lib\AssertError.js
jsLibs.exportScript("ts0", "./ts-lib/AssertError", [ "default" ], (_jsLib) => { "use strict"; 
/* export default */ class AssertError extends Error {
    constructor(message         = "") {
        super('TS0 Assertion Error' + (message === "" ? "" : `: ${message}`));
    }
}

/* JSLib Exports */
_jsLib.export("default", AssertError); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\ts-lib\index.js
jsLibs.exportScript("ts0", "./ts-lib/index", [ "ts0_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ts0", "./ts-lib/AssertError", [ { name: "default", alias: "AssertError" } ], "./AssertError.ts");
                                                                       

const notSet = Symbol("ts0_NotSet");

const types_TNotNull = Symbol("ts0_TNotNull");
const types_TNull = Symbol("ts0_TNull");
const types_TRawObject = Symbol("ts0_TRawObject");

/* export */ class ts0_Class {
    #types_BasicSet             ;
    #types_ExtendedSet             ;

    /* Types */
    TArray(itemType              )             {
        return new Array_Type(itemType);
    }

    TDefault(defaultValue     )               {
        return new Default_Type(defaultValue);
    }

    TEnum(values            )            {
        return new Enum_Type(values);
    }

    TIterable(itemType              )                {
        return new Iterable_Type(itemType);
    }

    get TNotNull()                        {
        return types_TNotNull;
    }

    get TNull()                     {
        return types_TNull;
    }

    TPreset(presets            , hasExtras          = false)              {
        return new Preset_Type(presets, hasExtras);
    }

    TPresetArray(presets                     )                   {
        return new PresetArray_Type(presets);
    }

    get TRawObject()                          {
        return types_TRawObject;
    }
    /* / Types */


    get notSet()                {
        return notSet;
    }

    constructor() {
        this.#types_BasicSet = new Set([
            'undefined',
            // 'object', /* null */
            'boolean',
            'number',
            'string',
            'symbol',
            'function',
            'object'
        ]);

        this.#types_ExtendedSet = new Set([
            'bigint',
            'bool',
            'finite',
            'int',
            'nan',
            'void'
        ]);
    }


    assert(value         , message         = "")                {
        if (!value)
            throw new (_jsLib.import("ts0", "./ts-lib/AssertError", "default", "AssertError", "./AssertError.ts"))(message);
    }

    assertType(value     , valueType              , extraErrorInfo              = null)      {
        let errors                = [];
        if (this.checkType(value, valueType, errors))
            return value;

        if (extraErrorInfo !== null)
            errors.splice(0, 0, extraErrorInfo);

        console.error('Error:', errors);
        console.warn((new Error()).stack);
        throw new TS0TypeError('Wrong variable type.');
    }

    checkType(value     , valueType              , errors                = [])          {
        let typeofValue = typeof value;

        if (valueType === Default_Type) {
            if (typeof value === 'undefined')
                return true;

            return false;
        } else if (valueType === Iterable_Type) {
            if (value === null || typeof value !== 'object') {                
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            if (typeof value[Symbol.iterator] !== 'function') {
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.TRawObject) {
            if (value === null) {
                errors.push(`RawObject cannot be \`null\`.`);
                return false;
            }

            if (typeofValue === 'undefined') {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            if (Object.getPrototypeOf(value) !== Object.prototype) {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            return true;
        } else if (valueType === this.TNotNull) {
            if (value === null) {
                errors.push(`\`${value}\` cannot be \`null\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.TNull) {
            if (value === null)
                return true;

            return false;
        } else if (valueType instanceof Array_Type) {
            if (!this.checkType(value, Array)) {
                errors.push(`Value must be an instance of Array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            let i = 0;
            for (let itemValue of value) {
                let itemErrors                = [];
                if (!this.checkType(itemValue, valueType.itemType, itemErrors)) {
                    let itemKey = value.keys()[i];
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
                i++;
            }

            return valid;
        } else if (valueType instanceof Enum_Type) {
            for (let value_Enum of valueType.values) {
                if (value === value_Enum)
                    return true;
            }

            errors.push(`Enum value '${value}' not found in '` + 
                    valueType.values.join(', ') + `'.`);
            return false;
        } else if (valueType instanceof Default_Type) {
            return false;
        } else if (valueType instanceof Iterable_Type) {
            if (!this.checkType(value, Iterable_Type)) {
                errors.push(`Preset must be Iterable. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let i = 0; i < value.length; i++) {
                let itemValue = value[i];
                let itemErrors                = [];
                if (!this.checkType(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof ObjectItems_Type) {
            if (!this.checkType(value, this.TRawObject)) {
                errors.push(`Value must be an instance of RawObject. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let itemKey in value) {
                let itemValue = value[itemKey];
                let itemErrors                = [];
                if (!this.checkType(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof Preset_Type) {
            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (typeofValue !== 'object') {
                errors.push(`Preset must be an object. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;

            if (!valueType.hasExtras) {
                for (let key in value) {
                    if (!(key in valueType.presets)) {
                        errors.push(`Unknown key \`${key}\`.`);
                        valid = false;
                    }
                }
            }

            for (let key in valueType.presets) {
                let newErrors                = [];
                
                if (typeof value[key] === 'undefined') {
                    if (valueType.presets[key] instanceof Array) {
                        for (let propValueType of valueType.presets[key]) {
                            if (propValueType instanceof Default_Type)
                                value[key] = propValueType.defaultValue;
                        }
                    }
                } 

                try {
                    if (this.checkType(value[key], valueType.presets[key], newErrors))
                        continue;
                } catch (err) {
                    newErrors.push((err         ).toString());
                }

                for (let newError of newErrors)
                    errors.push(`${key} -> ${newError}`);

                valid = false;
            }

            // console.log('WTF', value, valid, errors);

            return valid;
        } else if (valueType instanceof PresetArray_Type) {
            // if (typeofValue === 'undefined' && typeof 
            //         valueType.defaultValue !== 'undefined') {
            //     value = valueType.defaultValue;
            //     typeofValue = typeof value;
            // }

            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (!(value instanceof Array)) {
                errors.push(`PresetArray must be an array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            
            if (value.length !== valueType.presets.length) {
                errors.push(`Wrong PresetArray length. Required: '${valueType.presets.length}'.`);
                    valid = false;
            }

            for (let i = 0; i < valueType.presets.length; i++) {
                let newErrors                = [];
                
                if (typeof value[i] === 'undefined') {
                    if (valueType.presets[i] instanceof Array) {
                        for (let propValueType of (valueType.presets[i]                       )) {
                            if (propValueType instanceof Default_Type)
                                value[i] = propValueType.defaultValue;
                        }
                    }
                }

                if (this.checkType(value[i], valueType.presets[i], newErrors))
                    continue;

                for (let newError of newErrors)
                    errors.push(`${i} -> ${newError}`);

                valid = false;
            }

            return valid;
        }

        let typeofValueType = typeof valueType;

        /* Basic Types */
        if (typeofValueType === 'string') {
            let result = true;
            if (this.#types_BasicSet.has(valueType          )) {
                result = typeof value === valueType;
            } else if (this.#types_ExtendedSet.has(valueType          )) {
                switch(valueType) {
                    case 'bool':
                        result = typeofValue === 'boolean';
                        break;
                    case 'int':
                        result = Number.isInteger(value);
                        break;
                    case 'finite':
                        result = Number.isFinite(value);
                        break;
                    case 'nan':
                        result = Number.isNaN(value);
                        break;
                    case 'void':
                        result = typeofValue === 'undefined';
                        break;
                }
            } else {
                errors.push(`Unknown type '${valueType}'.`);
                return false;
            }

            if (!result) {
                let typeof_value = typeof value;
                let value_Str = String(value);
                errors.push(`Variable \`${value_Str}\` of type \`${typeof_value}\`` +
                    ` should be of type \`${valueType}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'object') {
            /* Multiple Types */
            if (valueType instanceof Array) {
                if (value === null) {
                    for (let i = 0; i < valueType.length; i++) {
                        if (valueType[i] === this.TNotNull) {
                            errors.push(`\`${value}\` cannot be \`null\`.`);
                            return false;
                        }
                    }
                }

                for (let i = 0; i < valueType.length; i++) {
                    if (this.checkType(value, valueType[i], errors))
                        return true;
                }

                return false;
            }

            console.warn((new Error()).stack);
            console.warn('Value type: ', valueType);
            throw new Error(`Unknown 'valueType': ${typeofValueType}`);
        }

        if (typeofValueType === 'function') {
            // /* Property */
            // if ('Property' in valueType) {
            //     if (!this.implements(value, valueType)) {
            //
            //         errors.push(`Variable does not implement property
            //                 \`${valueType.constructor}\`.`);
            //         return false;
            //     }
            //
            //     return true;
            // }

            /* Class */
            if (!(value instanceof (valueType            ))) {
                let valueStr = String(value);
                errors.push(`Variable \`${valueStr}\` is not an instance of` +
                        ` \`${(valueType            ).name}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'symbol') {
            if (value !== valueType) {
                let value_Str = String(value);
                let valueType_Str = String(valueType);
                errors.push(`Variable '${value_Str}' is not ${valueType_Str}.`);
                return false;
            }

            return true;
        }

        console.warn((new Error()).stack);
        throw new Error(`Unknown 'valueType': ${typeofValueType}`);
    }

    rtn(valueType              , value     )      {
        this.assertType(value, valueType, "Wrong return value.");
        return value;
    }

    rtnFn(valueType              , valueFn                                        = 
            this.notSet)      {
        if (typeof valueFn === 'function') {
            let value = valueFn();
            if (value instanceof Promise) {
                return value
                    .then((resultValue) => {
                        this.assertType(resultValue, valueType);
                        return value;
                    });
            }

            this.assertType(value, valueType);
            return value;
        }

        throw new Error(`'valueFn' is not a function.`);
    }
}
const ts0 = new ts0_Class();
/* export default */ ts0;


class And_Type  {
    #valueTypes                     ;

    get valueTypes()                      {
        return this.#valueTypes;
    }

    constructor(valueTypes                     ) {
        this.#valueTypes = valueTypes;
    }
}

class Array_Type {
    #itemType              ;

    get itemType()               {
        return this.#itemType;
    }

    constructor(itemType              ) {
        this.#itemType = itemType;
    }
}

class Default_Type {
    #defaultValue     ;

    get defaultValue()      {
        return this.#defaultValue;
    }

    constructor(defaultValue = undefined) {
        this.#defaultValue = defaultValue;
    }
}

class Enum_Type {
    #values            ;

    get values()             {
        return this.#values;
    }

    constructor(values            ) {
        this.#values = values;
    }
}

class Iterable_Type {
    #itemType              ;

    get itemType()               {
        return this.#itemType;
    }

    constructor(itemType              ) {
        this.#itemType = itemType;
    }
}

class ObjectItems_Type {
    #itemType              ;

    get itemType()               {
        return this.#itemType;
    }

    constructor(itemType              ) {
        this.#itemType = itemType;
    }
}

    // Or_Type: { value:
    // class ts0_Or_Type
    // {
    //     constructor(propClass)
    //     {
    //         js0.argsE(arguments, js0.PropClass);
    //
    //         Object.defineProperties(this, {
    //             _propClass: { value: propClass, },
    //         });
    //     }
    // }},

class Preset_Type {
    #presets            ;
    #hasExtras         ;

    get hasExtras()          {
        return this.#hasExtras;
    }

    get presets()             {
        return this.#presets;
    }

    constructor(presets            , hasExtras          = false) {
        this.#presets = presets;
        this.#hasExtras = hasExtras;
    }
}

class PresetArray_Type {
    #presets                     ;

    get presets()                      {
        return this.#presets;
    }

    constructor(presets                     ) {
        this.#presets = presets;
    }
}

class TS0TypeError extends Error {
    constructor(message        ) {
        super(message);

        // let stack = this.stack;
        // let stack_array = stack.split('\n');
        // stack_array.splice(1, 3);
        // this.stack = stack_array.join('\n');
    }
}


;                          
                                                
                                                    
                 
                                                        
                                                                                     
                            
;                                              

/* JSLib Exports */
_jsLib.export("ts0_Class", ts0_Class);
_jsLib.export("default", ts0); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\ts-lib\ts-types.js
jsLibs.exportScript("ts0", "./ts-lib/ts-types", [  ], (_jsLib) => { "use strict"; 
                                                                                                 
                                                                                                           

/* JSLib Exports */ });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\ts-lib\ts0Assert.js
jsLibs.exportScript("ts0", "./ts-lib/ts0Assert", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ts0", "./ts-lib/AssertError", [ { name: "default", alias: "AssertError" } ], "./AssertError.ts");

/* export default */ function ts0Assert(value         , message         = "")                {
    if (!value)
        throw new (_jsLib.import("ts0", "./ts-lib/AssertError", "default", "AssertError", "./AssertError.ts"))(message);
}

/* JSLib Exports */
_jsLib.export("default", ts0Assert); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\ts-lib\TS0List.js
jsLibs.exportScript("ts0", "./ts-lib/TS0List", [ "default" ], (_jsLib) => { "use strict"; 
/* export default */ class TS0List                     {
    get size()         {
        return this.#values.length;
    }


    #keys                ;
    #values                  ;


    constructor(iterable                                   = null) {
        this.#keys = [];
        this.#values = [];

        if (iterable !== null) {
            for (let item of iterable)
                this.set(item[0], item[1]);
        }
    }

    [Symbol.iterator]()                                   {
        return new ListIterator(this);
    }

    addAt(index        , key         , value           )       {
        if (index < 0 || index > this.#values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        if (this.#values.length === index) {
            this.#keys.push(key);
            this.#values.push(value);
        } else {
            this.#keys.splice(index, 0, key);
            this.#values.splice(index, 0, value);
        }
    }

    clear()       {
        this.#keys = [];
        this.#values = [];
    }

    delete(key         )       {
        let index = this._getIndexE(key);
        this.deleteAt(index);
    }

    deleteAt(index        )       {
        this.#keys.splice(index, 1);
        this.#values.splice(index, 1);
    }

    get(key         )            {
        let index = this._getIndexE(key);
        return this.#values[index]             ;
    }

    getAt(index        )            {
        if (index < 0 || index >= this.#values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        return this.#values[index]             ;
    }

    getKeyAt(index        )          {
        if (index < 0 || index >= this.#values.length)
            throw new Error(`Key at \`${index}\` does not exist in \`js0_List\`.`);

        return this.#keys[index]           ;
    }

    getKeys()                 {
        return this.#keys.slice();
    }

    getKeysIterator()                         {
        return this.#keys[Symbol.iterator]();
    }

    getValues()                   {
        return this.#values.slice();
    }

    has(key         )          {
        return this.#keys.includes(key);
    }

    includes(value           )          {
        return this.#values.includes(value);
    }

    indexOf(value           )         {
        return this.#values.indexOf(value);
    }

    remove(value           )       {
        for (let i = this.size - 1; i >= 0; i--) {
            if (this.getAt(i) === value) {
                this.deleteAt(i);
                return;
            }
        }     

        throw new Error(`Value '${value}' does not exist in js0_List.`);
    }

    set(key         , value           )       {
        let index = this.#keys.indexOf(key);
        if (index === -1)
            index = this.#values.length;

        this.setAt(index, key, value);
    }

    setAt(index        , key         , value           )       {
        if (index < 0 || index > this.#values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        if (index === this.#values.length) {
            this.#keys.push(key);
            this.#values.push(value);
        } else {
            this.#keys[index] = key;
            this.#values[index] = value;
        }
    }

    // slice() {

    // }

    sort(compareFn                                          
                                                            )       {
        let newKeys = this.#keys.slice();
        newKeys.sort((aKey, bKey) => {
            return compareFn({ key: aKey, value: this.get(aKey)              },
                    { key: bKey, value: this.get(bKey)              });
        });

        let newValues = [];
        for (let i = 0; i < this.size; i++)
            newValues.push(this.get(newKeys[i]));

        this.#keys = newKeys;
        this.#values = newValues                    ;
    }

    values()                   {
        return this.#values.slice();
    }


    _getIndexE(key         )         {
        let index = this.#keys.indexOf(key);
        if (index === -1)
            throw new Error(`Key \`${key}\` does not exist in \`js0_List\`.`);

        return index;
    }
}


class ListIterator                                                                 {
    #list                             ;
    #iterator                        ;


    constructor(list                             ) {
        this.#list = list;
        this.#iterator = list.getKeysIterator();
    }

    next()                                         {
        let keyItem = this.#iterator.next();

        if (keyItem.done)
            return { value: undefined, done: true, };

        return {
            value: [ keyItem.value, this.#list.get(keyItem.value)              ],
            done: false,
        };
    }
}


/* JSLib Exports */
_jsLib.export("default", TS0List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ts0\ts-lib\ts0Helper.js
jsLibs.exportScript("ts0", "./ts-lib/ts0Helper", [ "ts0Helper_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("node:util", "./index", [  ], "node:util");
                                                                       
_jsLib.importDeclaration("ts0", "./ts-lib/index", [ { name: "default", alias: "ts0" } ], "./index.ts");

/* export */ class ts0Helper_Class {
    constructor() {
        
    }

    copyArray(arr                 )                  {
        let arr_New = new Array();
        for (let val of arr) {
            if (val === null) {
                arr.push(null);
                continue;
            }

            if ((_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./index.ts")).checkType(val, (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./index.ts")).TRawObject)) {
                arr_New.push(this.copyRawObject(val                    ));
                continue;
            }

            if (Array.isArray(val)) {
                arr_New.push(this.copyArray(val));
                continue;
            }

            arr_New.push(val);
        }

        return arr_New;
    }

    copyRawObject(obj                  )                   {
        (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./index.ts")).assertType(obj, (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./index.ts")).TRawObject);

        let obj_New                   = {};
        for (let prop in obj) {
            if (obj[prop] === null) {
                obj_New[prop] = null;
                continue;
            }

            if ((typeof obj[prop]) === 'symbol') {
                obj_New[prop] = obj[prop];
                continue;
            }

            if ((_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./index.ts")).checkType(obj[prop], (_jsLib.import("ts0", "./ts-lib/index", "default", "ts0", "./index.ts")).TRawObject)) {
                obj_New[prop] = this.copyRawObject(obj[prop]                    );
                continue;
            }

            if (Array.isArray(obj[prop])) {
                obj_New[prop] = this.copyArray(obj[prop]);
                continue;
            }

            obj_New[prop] = obj[prop];
        }

        return obj_New;
    }
}
const ts0Helper = new ts0Helper_Class();
/* export default */ ts0Helper;

/* JSLib Exports */
_jsLib.export("ts0Helper_Class", ts0Helper_Class);
_jsLib.export("default", ts0Helper); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\index.js
jsLibs.exportScript("ab-pager", "./index", [ "Pager","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./ts-lib/index", [ { name: "default", alias: "abPager" } ], "./ts-lib/index.ts");
_jsLib.importDeclaration("ab-pager", "./ts-lib/Pager", [ { name: "default", alias: "Pager" } ], "./ts-lib/Pager.ts");

/* export default */ (_jsLib.import("ab-pager", "./ts-lib/index", "default", "abPager", "./ts-lib/index.ts"));
/* export { (_jsLib.import("ab-pager", "./ts-lib/Pager", "default", "Pager", "./ts-lib/Pager.ts")) }; */

/* JSLib Exports */
_jsLib.export("Pager", (_jsLib.import("ab-pager", "./ts-lib/Pager", "default", "Pager", "./ts-lib/Pager.ts")));
_jsLib.export("default", (_jsLib.import("ab-pager", "./ts-lib/index", "default", "abPager", "./ts-lib/index.ts"))); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\ts-lib\index.js
jsLibs.exportScript("ab-pager", "./ts-lib/index", [ "abPager_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./ts-lib/Pager", [ { name: "default", alias: "Pager" } ], "./Pager.ts");
                                          

/* export */ class abPager_Class {
    get Pager()               {
        return (_jsLib.import("ab-pager", "./ts-lib/Pager", "default", "Pager", "./Pager.ts"));
    }

    constructor() {
            
    }

    parseSearchParams(search        )       {
        let searchParams                         = {};
        let searchArr = search.split('&');
        for (let searchParam of searchArr) {
            let searchParamArr = searchParam.split('=');
            if (searchParamArr.length < 2)
                continue;
            
            searchParams[searchParamArr[0]] = searchParamArr[1];
        }

        return searchParams;
    }
    
}
const abPager = new abPager_Class();
/* export default */ abPager;

/* JSLib Exports */
_jsLib.export("abPager_Class", abPager_Class);
_jsLib.export("default", abPager); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\ts-lib\Page.js
jsLibs.exportScript("ab-pager", "./ts-lib/Page", [ "Page" ], (_jsLib) => { "use strict";                                                

/* export */ class Page {
    name        ;
    uri        ;
    onPageSetListener                ;
    extraArg         ;

    constructor(name        , uri        , onPageSetListener                ) {
        let extraArg = false;

        if (uri.indexOf('*') !== -1) {
            extraArg = true;

            if (uri.indexOf('*') !== uri.length - 1) 
                throw new Error(`'*' must be the last character of uri.`);

            if (uri.indexOf('*') === uri.length - 1) {
                if (uri.length === 1) {
                    uri = '';
                } else {
                    if (uri.indexOf('/*') !== uri.length - 2)
                        throw new Error(`'*' must be a separate uri element.`);
                    uri = uri.substring(0, uri.length - 2);
                }
            }
        }

        this.name = name;
        this.uri = uri;
        this.onPageSetListener = onPageSetListener;
        this.extraArg = extraArg;
    }
}

/* JSLib Exports */
_jsLib.export("Page", Page); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\ts-lib\PageInfo.js
jsLibs.exportScript("ab-pager", "./ts-lib/PageInfo", [ "PageInfo" ], (_jsLib) => { "use strict";                                           

/* export */ class PageInfo {
    #name        ;
    #args      ;
    #searchParams      ;


    get args()       {
        let argsR       = {};
        for (let argName in this.#args)
            argsR[argName] = this.#args[argName];

        return argsR;
    }

    get name()         {
        return this.#name;
    }

    get searchParams()       {
        let searchParamsR       = {};
        for (let searchParamName in this.#searchParams)
            searchParamsR[searchParamName] = this.#searchParams[searchParamName];

        return searchParamsR;
    }


    constructor(pageName        , args      , 
            searchParams      ) {
        this.#name = pageName;
        this.#args = args;
        this.#searchParams = searchParams;
    }
}

/* JSLib Exports */
_jsLib.export("PageInfo", PageInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\ts-lib\Pager.js
jsLibs.exportScript("ab-pager", "./ts-lib/Pager", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./ts-lib/index", [ { name: "default", alias: "abPager" } ], "./index.ts");
_jsLib.importDeclaration("ab-pager", "./ts-lib/Page", [ { name: "Page", alias: "Page" } ], "./Page.ts");
_jsLib.importDeclaration("ab-pager", "./ts-lib/PageInfo", [ { name: "PageInfo", alias: "PageInfo" } ], "./PageInfo.ts");
                                                                                                                            

/* export default */ class Pager {
    #initialized = false;

    #base        ;
    #useState         ;
    #pages                   ;

    #currentPage           ;
    #currentPageInfo               ;

    #listeners_OnPageChanged                      ;
    #listeners_OnPageSet                                ;
    #listeners_OnBeforePageSet                        ;

    #listeners_NotFound                 ;
    #listeners_OnBeforePopState                       ;


    get base()         {
        return this.#base;
    }

    get current()                {
        return this.#currentPageInfo;
    }

    get pages()                    {
        return this.#pages;
    }


    constructor(base = '/', useState = true) {
        this.#initialized = false;

        this.#base = base;
        this.#useState = useState;
        this.#pages = new Map();

        this.#currentPage = null;
        this.#currentPageInfo = null;

        this.#listeners_OnPageChanged = [];
        this.#listeners_OnPageSet = {};
        this.#listeners_OnBeforePageSet = [];

        this.#listeners_NotFound = null;
        this.#listeners_OnBeforePopState = null;
    }

    addListener_OnBeforePageSet(listenerFn                 )       {
        this.#listeners_OnBeforePageSet.push(listenerFn);
    }

    addListener_OnPageChanged(listenerFn               )       {
        this.#listeners_OnPageChanged.push(listenerFn);
    }

    clearPages()        {
        this.#pages.clear();

        return this;
    }

    getPage(pageName        )       {
        let page = this.#pages.get(pageName);
        if (page === undefined)
            throw new Error(`Page '${pageName}' does not exist.`);

        return page;
    }

    getPageInfo_FromUri(uri        )                {
        if (this.#pages.size === 0)
            throw new Error(`Cannot parse uri '${uri}'. No pages set.`);

        let base = this.#base;
        base = base.substring(0, base.length);

        if (uri.indexOf(base) !== 0) {
            window.location.replace(base);
            return null;
        }

        uri = uri.substring(base.length);
        
        let uriArr = uri.split('?');
        uri = uriArr[0];
        let search = uriArr.length === 1 ? '' : uriArr[1];

        let searchParams = (_jsLib.import("ab-pager", "./ts-lib/index", "default", "abPager", "./index.ts")).parseSearchParams(search);

        let uriArray = uri.split('/');
        if (uriArray[uriArray.length - 1] === '')
            uriArray.pop();

        // if (uriArray.length === 0 && !page.extraArg)
        //     uriArray.push('');

        for (let [ pageName, page ] of this.#pages) {
            let aliasArray = page.uri.split('/');
            if (aliasArray[aliasArray.length - 1] === '')
                aliasArray.pop();

            if (page.extraArg) {
                if (aliasArray.length > uriArray.length)
                    continue;
            } else {
                if (aliasArray.length !== uriArray.length)
                    continue;
            }

            let args       = {};
            let uriMatched = true;

            for (let i = 0; i < aliasArray.length; i++) {
                if (uriArray[i] === '') {
                    uriMatched = aliasArray[i] === '';
                    break;
                }

                if (aliasArray[i][0] === ':') {
                    if (aliasArray[i][0] === '1') {
                        uriMatched = false;
                        break;
                    }

                    let uriArgInfo = this.#getUriArgInfo(aliasArray[i]);

                    args[uriArgInfo.name] = decodeURIComponent(uriArray[i]);
                    continue;
                }

                if (aliasArray[i] !== uriArray[i]) {
                    uriMatched = false;
                    break;
                }
            }

            if (!uriMatched)
                continue;

            if (page.extraArg)
                args['*'] = uriArray.slice(aliasArray.length).join('/');

            return new (_jsLib.import("ab-pager", "./ts-lib/PageInfo", "PageInfo", "PageInfo", "./PageInfo.ts"))(page.name, args, searchParams);
        }

        return null;
    }

    getPageUri(pageName        , args       = {}, searchParams       = {}, 
            pathOnly          = false)         {
        let page = this.getPage(pageName);

        return this.parseUri(page.uri, args, searchParams, null, null, pathOnly);
    }

    hasPage(pageName        )          {
        return this.#pages.has(pageName);
    }

    init(setPage = true)       {
        this.#initialized = true;

        if (this.#useState) {
            window.onpageshow = (evt) => {
                if (!evt.persisted)
                    return;

                let uri_PopState = window.location.pathname + 
                        window.location.search;
                if (this.#listeners_OnBeforePopState !== null) {
                    if (!this.#listeners_OnBeforePopState(uri_PopState))
                        return;
                }
                this.#parseUri(uri_PopState, false);
            };
            window.onpopstate = () => {
                let uri_PopState = window.location.pathname + 
                        window.location.search;
                if (this.#listeners_OnBeforePopState !== null) {
                    if (!this.#listeners_OnBeforePopState(uri_PopState))
                        return;
                }
                this.#parseUri(uri_PopState, false);
            };
        }

        let uri = window.location.pathname + window.location.search;
        let pageInfo = this.getPageInfo_FromUri(uri);
        if (!setPage)
            return;

        this.#setPageInfo(pageInfo, false, uri);
    }

    notFound(notFoundListener            )        {
        this.#listeners_NotFound = notFoundListener;

        return this;
    }

    page(name        , uri        , onPageSetListener           )        {
        this.#pages.set(name, new (_jsLib.import("ab-pager", "./ts-lib/Page", "Page", "Page", "./Page.ts"))(name, uri, onPageSetListener));
        
        if (onPageSetListener !== null) {
            this.#listeners_OnPageSet[name] = onPageSetListener;
            // this.#listeners_OnPageChanged.push((page, sourcePageName) => {
            //     if (page.name === name)
            //         onPageSetListener(sourcePageName);
            // });
        }

        return this;
    }

    parseUri(uri        , args       = {}, searchParams       = {}, 
            args_Parsed            = null, searchParams_Parsed            = null, 
            pathOnly = false)         {   
        let uriArr = uri.split('?');
        uri = uriArr[0];

        /* Uri Args */
        let uriArgs = uri === '' ? [] : uri.split('/');
        if (uriArgs[uriArgs.length - 1] === '')
            uriArgs.pop();

        let pUri = '';
        for (let i = 0; i < uriArgs.length; i++) {
            if (uriArgs[i][0] !== ':') {
                pUri += uriArgs[i] + '/';
                continue;
            }

            let argInfo = this.#getUriArgInfo(uriArgs[i]);

            if (!(argInfo.name in args)) {
                if (argInfo.defaultValue === null)
                    throw new Error(`Uri arg '${argInfo.name}' not set.`);

                pUri += argInfo.defaultValue + '/';
                args[argInfo.name] = argInfo.defaultValue;

                if (args_Parsed !== null)
                    args_Parsed[argInfo.name] = String(args[argInfo.name]);

                continue;
            }

            pUri += encodeURIComponent(args[argInfo.name]) + '/';

            if (args_Parsed !== null)
                args_Parsed[argInfo.name] = String(args[argInfo.name]);
        }
        if ('*' in args) 
            pUri += args['*'];

        /* Search Params */
        let search = '';
        for (let searchParam_Name in searchParams) {
            search += (search === '' ? '?' : '&') + searchParam_Name + '=' +
                    searchParams[searchParam_Name];
        }

        pUri += search;

        if (pathOnly)
            return pUri;
        else
            return this.#base + pUri;
    }

    parseUri_PathOnly(uri        , args       = {}, searchParams       = {}, 
            args_Parsed            = null, searchParams_Parsed            = null)         {   
        return this.parseUri(uri, args, searchParams, args_Parsed, 
                searchParams_Parsed, true);
    }

    removeListener_OnBeforePageSet(listenerFn                 )       {
        for (let i = 0; i < this.#listeners_OnBeforePageSet.length; i++) {
            if (this.#listeners_OnBeforePageSet[i] === listenerFn) {
                this.#listeners_OnBeforePageSet.splice(i, 1);
                return;
            }
        }

        throw new Error(`Listener function does not exist.`);
    }

    setPage(pageName        , uriArgs       = {}, searchParams       = {}, 
            pushState          = true, pageArgs       = {}, 
            skipOnPageChangedListener          = false, 
            skipOnPageSetListener          = false)       {
        if (!this.#pages.has(pageName))
            throw new Error('Page `' + pageName + '` does not exist.`');

        // for (let argName in uriArgs)
        //     uriArgs[argName] = String(uriArgs[argName]);

        let newPage = this.#pages.get(pageName);
        if (newPage === undefined)
            throw new Error(`Page '${pageName}' does not exist.`);

        let uriArgs_Parsed = {};
        let uri = this.parseUri(newPage.uri, uriArgs, searchParams, uriArgs_Parsed);
        uriArgs = uriArgs_Parsed;

        for (let listenerFn of this.#listeners_OnBeforePageSet) {
            if (listenerFn(pageName, uriArgs, searchParams, pushState) === false)
                return;
        }

        let source = this.#currentPage;
        this.#currentPage = newPage;

        this.#currentPageInfo = new (_jsLib.import("ab-pager", "./ts-lib/PageInfo", "PageInfo", "PageInfo", "./PageInfo.ts"))(pageName, uriArgs, searchParams);

        if (this.#useState) {
            if (pushState)
                window.history.pushState({}, '', uri);
            else
                window.history.replaceState({}, '', uri);
        }

        // let currentPage = {
        //     name: this.#currentPageInfo.name,
        //     args: this.#currentPageInfo.args,
        //     searchParams: this.#currentPageInfo.searchParams,
        // };

        if (!skipOnPageChangedListener) {
            for (let i = 0; i < this.#listeners_OnPageChanged.length; i++)
                this.#listeners_OnPageChanged[i](this.#currentPageInfo, source);
        }

        if (!skipOnPageSetListener) {
            if (this.#currentPageInfo.name in this.#listeners_OnPageSet) {
                this.#listeners_OnPageSet[this.#currentPageInfo.name](
                        this.#currentPageInfo, source, pageArgs);
            }
        }
    }

    setListener_OnBeforePopState(listenerFn                  )       {
        this.#listeners_OnBeforePopState = listenerFn;
    }

    setUri(uri        , pushState          = true)       {
        this.#parseUri(uri, pushState);
    }


    #getUriArgInfo(uriArg        )          {
        let argName = uriArg.substring(1);
        let argDefault = null;
        let argNameArray = argName.split('=');
        if (argNameArray.length > 1) {
            argName = argNameArray[0];
            argDefault = argNameArray[1];
        }

        return {
            name: argName,
            defaultValue: argDefault
        };
    }

    #parseUri(uri        , pushState         )       {
        let pageInfo = this.getPageInfo_FromUri(uri);

        this.#setPageInfo(pageInfo, pushState, uri);
    }

    #setPageInfo(pageInfo               , pushState         , uri        )       {
        if (pageInfo === null) {
            if (this.#listeners_NotFound === null)
                throw new Error(`Cannot parse uri '${uri}'. No page found.`);
            else
                this.#listeners_NotFound(uri, pushState);
        } else {
            this.setPage(pageInfo.name, pageInfo.args, pageInfo.searchParams, 
                    pushState);
        }
    }

}

/* JSLib Exports */
_jsLib.export("default", Pager); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\ts-lib\ts-types.js
jsLibs.exportScript("ab-pager", "./ts-lib/ts-types", [  ], (_jsLib) => { "use strict";                                       
                                              

                       
                 
                              
  
                                           
                                                               
                                                           
                                                        
                                                                   
                                                                           
                                                                                       

/* JSLib Exports */ });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\index.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/index", [ "ts0","ts0Assert","AssertError","TS0List","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", [ { name: "default", alias: "ts0" } ], "./ts-lib/index.ts");
_jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/ts0Assert", [ { name: "default", alias: "ts0Assert" } ], "./ts-lib/ts0Assert.ts");
_jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", [ { name: "default", alias: "AssertError" } ], "./ts-lib/AssertError.ts");
_jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/TS0List", [ { name: "default", alias: "TS0List" } ], "./ts-lib/TS0List.ts");
                                                                              

/* export default */ (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./ts-lib/index.ts"));
                                                                
/* export { (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./ts-lib/index.ts")), (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/ts0Assert", "default", "ts0Assert", "./ts-lib/ts0Assert.ts")), (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", "default", "AssertError", "./ts-lib/AssertError.ts")), (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/TS0List", "default", "TS0List", "./ts-lib/TS0List.ts")), }; */

/* JSLib Exports */
_jsLib.export("ts0", (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./ts-lib/index.ts")));
_jsLib.export("ts0Assert", (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/ts0Assert", "default", "ts0Assert", "./ts-lib/ts0Assert.ts")));
_jsLib.export("AssertError", (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", "default", "AssertError", "./ts-lib/AssertError.ts")));
_jsLib.export("TS0List", (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/TS0List", "default", "TS0List", "./ts-lib/TS0List.ts")));
_jsLib.export("default", (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./ts-lib/index.ts"))); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\ts-lib\AssertError.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", [ "default" ], (_jsLib) => { "use strict"; 
/* export default */ class AssertError extends Error {
    constructor(message         = "") {
        super('TS0 Assertion Error' + (message === "" ? "" : `: ${message}`));
    }
}

/* JSLib Exports */
_jsLib.export("default", AssertError); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\ts-lib\index.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", [ "ts0_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", [ { name: "default", alias: "AssertError" } ], "./AssertError.ts");
                                                                       

const notSet = Symbol("ts0_NotSet");

const types_TNotNull = Symbol("ts0_TNotNull");
const types_TNull = Symbol("ts0_TNull");
const types_TRawObject = Symbol("ts0_TRawObject");

/* export */ class ts0_Class {
    #types_BasicSet             ;
    #types_ExtendedSet             ;

    /* Types */
    TArray(itemType              )             {
        return new Array_Type(itemType);
    }

    TDefault(defaultValue     )               {
        return new Default_Type(defaultValue);
    }

    TEnum(values            )            {
        return new Enum_Type(values);
    }

    TIterable(itemType              )                {
        return new Iterable_Type(itemType);
    }

    get TNotNull()                        {
        return types_TNotNull;
    }

    get TNull()                     {
        return types_TNull;
    }

    TPreset(presets            , hasExtras          = false)              {
        return new Preset_Type(presets, hasExtras);
    }

    TPresetArray(presets                     )                   {
        return new PresetArray_Type(presets);
    }

    get TRawObject()                          {
        return types_TRawObject;
    }
    /* / Types */


    get notSet()                {
        return notSet;
    }

    constructor() {
        this.#types_BasicSet = new Set([
            'undefined',
            // 'object', /* null */
            'boolean',
            'number',
            'string',
            'symbol',
            'function',
            'object'
        ]);

        this.#types_ExtendedSet = new Set([
            'bigint',
            'bool',
            'finite',
            'int',
            'nan',
            'void'
        ]);
    }


    assert(value         , message         = "")                {
        if (!value)
            throw new (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", "default", "AssertError", "./AssertError.ts"))(message);
    }

    assertType(value     , valueType              , extraErrorInfo              = null)      {
        let errors                = [];
        if (this.checkType(value, valueType, errors))
            return value;

        if (extraErrorInfo !== null)
            errors.splice(0, 0, extraErrorInfo);

        console.error('Error:', errors);
        console.warn((new Error()).stack);
        throw new TS0TypeError('Wrong variable type.');
    }

    checkType(value     , valueType              , errors                = [])          {
        let typeofValue = typeof value;

        if (valueType === Default_Type) {
            if (typeof value === 'undefined')
                return true;

            return false;
        } else if (valueType === Iterable_Type) {
            if (value === null || typeof value !== 'object') {                
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            if (typeof value[Symbol.iterator] !== 'function') {
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.TRawObject) {
            if (value === null) {
                errors.push(`RawObject cannot be \`null\`.`);
                return false;
            }

            if (typeofValue === 'undefined') {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            if (Object.getPrototypeOf(value) !== Object.prototype) {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            return true;
        } else if (valueType === this.TNotNull) {
            if (value === null) {
                errors.push(`\`${value}\` cannot be \`null\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.TNull) {
            if (value === null)
                return true;

            return false;
        } else if (valueType instanceof Array_Type) {
            if (!this.checkType(value, Array)) {
                errors.push(`Value must be an instance of Array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            let i = 0;
            for (let itemValue of value) {
                let itemErrors                = [];
                if (!this.checkType(itemValue, valueType.itemType, itemErrors)) {
                    let itemKey = value.keys()[i];
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
                i++;
            }

            return valid;
        } else if (valueType instanceof Enum_Type) {
            for (let value_Enum of valueType.values) {
                if (value === value_Enum)
                    return true;
            }

            errors.push(`Enum value '${value}' not found in '` + 
                    valueType.values.join(', ') + `'.`);
            return false;
        } else if (valueType instanceof Default_Type) {
            return false;
        } else if (valueType instanceof Iterable_Type) {
            if (!this.checkType(value, Iterable_Type)) {
                errors.push(`Preset must be Iterable. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let i = 0; i < value.length; i++) {
                let itemValue = value[i];
                let itemErrors                = [];
                if (!this.checkType(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof ObjectItems_Type) {
            if (!this.checkType(value, this.TRawObject)) {
                errors.push(`Value must be an instance of RawObject. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let itemKey in value) {
                let itemValue = value[itemKey];
                let itemErrors                = [];
                if (!this.checkType(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof Preset_Type) {
            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (typeofValue !== 'object') {
                errors.push(`Preset must be an object. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;

            if (!valueType.hasExtras) {
                for (let key in value) {
                    if (!(key in valueType.presets)) {
                        errors.push(`Unknown key \`${key}\`.`);
                        valid = false;
                    }
                }
            }

            for (let key in valueType.presets) {
                let newErrors                = [];
                
                if (typeof value[key] === 'undefined') {
                    if (valueType.presets[key] instanceof Array) {
                        for (let propValueType of valueType.presets[key]) {
                            if (propValueType instanceof Default_Type)
                                value[key] = propValueType.defaultValue;
                        }
                    }
                } 

                try {
                    if (this.checkType(value[key], valueType.presets[key], newErrors))
                        continue;
                } catch (err) {
                    newErrors.push((err         ).toString());
                }

                for (let newError of newErrors)
                    errors.push(`${key} -> ${newError}`);

                valid = false;
            }

            // console.log('WTF', value, valid, errors);

            return valid;
        } else if (valueType instanceof PresetArray_Type) {
            // if (typeofValue === 'undefined' && typeof 
            //         valueType.defaultValue !== 'undefined') {
            //     value = valueType.defaultValue;
            //     typeofValue = typeof value;
            // }

            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (!(value instanceof Array)) {
                errors.push(`PresetArray must be an array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            
            if (value.length !== valueType.presets.length) {
                errors.push(`Wrong PresetArray length. Required: '${valueType.presets.length}'.`);
                    valid = false;
            }

            for (let i = 0; i < valueType.presets.length; i++) {
                let newErrors                = [];
                
                if (typeof value[i] === 'undefined') {
                    if (valueType.presets[i] instanceof Array) {
                        for (let propValueType of (valueType.presets[i]                       )) {
                            if (propValueType instanceof Default_Type)
                                value[i] = propValueType.defaultValue;
                        }
                    }
                }

                if (this.checkType(value[i], valueType.presets[i], newErrors))
                    continue;

                for (let newError of newErrors)
                    errors.push(`${i} -> ${newError}`);

                valid = false;
            }

            return valid;
        }

        let typeofValueType = typeof valueType;

        /* Basic Types */
        if (typeofValueType === 'string') {
            let result = true;
            if (this.#types_BasicSet.has(valueType          )) {
                result = typeof value === valueType;
            } else if (this.#types_ExtendedSet.has(valueType          )) {
                switch(valueType) {
                    case 'bool':
                        result = typeofValue === 'boolean';
                        break;
                    case 'int':
                        result = Number.isInteger(value);
                        break;
                    case 'finite':
                        result = Number.isFinite(value);
                        break;
                    case 'nan':
                        result = Number.isNaN(value);
                        break;
                    case 'void':
                        result = typeofValue === 'undefined';
                        break;
                }
            } else {
                errors.push(`Unknown type '${valueType}'.`);
                return false;
            }

            if (!result) {
                let typeof_value = typeof value;
                let value_Str = String(value);
                errors.push(`Variable \`${value_Str}\` of type \`${typeof_value}\`` +
                    ` should be of type \`${valueType}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'object') {
            /* Multiple Types */
            if (valueType instanceof Array) {
                if (value === null) {
                    for (let i = 0; i < valueType.length; i++) {
                        if (valueType[i] === this.TNotNull) {
                            errors.push(`\`${value}\` cannot be \`null\`.`);
                            return false;
                        }
                    }
                }

                for (let i = 0; i < valueType.length; i++) {
                    if (this.checkType(value, valueType[i], errors))
                        return true;
                }

                return false;
            }

            console.warn((new Error()).stack);
            console.warn('Value type: ', valueType);
            throw new Error(`Unknown 'valueType': ${typeofValueType}`);
        }

        if (typeofValueType === 'function') {
            // /* Property */
            // if ('Property' in valueType) {
            //     if (!this.implements(value, valueType)) {
            //
            //         errors.push(`Variable does not implement property
            //                 \`${valueType.constructor}\`.`);
            //         return false;
            //     }
            //
            //     return true;
            // }

            /* Class */
            if (!(value instanceof (valueType            ))) {
                let valueStr = String(value);
                errors.push(`Variable \`${valueStr}\` is not an instance of` +
                        ` \`${(valueType            ).name}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'symbol') {
            if (value !== valueType) {
                let value_Str = String(value);
                let valueType_Str = String(valueType);
                errors.push(`Variable '${value_Str}' is not ${valueType_Str}.`);
                return false;
            }

            return true;
        }

        console.warn((new Error()).stack);
        throw new Error(`Unknown 'valueType': ${typeofValueType}`);
    }

    rtn(valueType              , value     )      {
        this.assertType(value, valueType, "Wrong return value.");
        return value;
    }

    rtnFn(valueType              , valueFn                                        = 
            this.notSet)      {
        if (typeof valueFn === 'function') {
            let value = valueFn();
            if (value instanceof Promise) {
                return value
                    .then((resultValue) => {
                        this.assertType(resultValue, valueType);
                        return value;
                    });
            }

            this.assertType(value, valueType);
            return value;
        }

        throw new Error(`'valueFn' is not a function.`);
    }
}
const ts0 = new ts0_Class();
/* export default */ ts0;


class And_Type  {
    #valueTypes                     ;

    get valueTypes()                      {
        return this.#valueTypes;
    }

    constructor(valueTypes                     ) {
        this.#valueTypes = valueTypes;
    }
}

class Array_Type {
    #itemType              ;

    get itemType()               {
        return this.#itemType;
    }

    constructor(itemType              ) {
        this.#itemType = itemType;
    }
}

class Default_Type {
    #defaultValue     ;

    get defaultValue()      {
        return this.#defaultValue;
    }

    constructor(defaultValue = undefined) {
        this.#defaultValue = defaultValue;
    }
}

class Enum_Type {
    #values            ;

    get values()             {
        return this.#values;
    }

    constructor(values            ) {
        this.#values = values;
    }
}

class Iterable_Type {
    #itemType              ;

    get itemType()               {
        return this.#itemType;
    }

    constructor(itemType              ) {
        this.#itemType = itemType;
    }
}

class ObjectItems_Type {
    #itemType              ;

    get itemType()               {
        return this.#itemType;
    }

    constructor(itemType              ) {
        this.#itemType = itemType;
    }
}

    // Or_Type: { value:
    // class ts0_Or_Type
    // {
    //     constructor(propClass)
    //     {
    //         js0.argsE(arguments, js0.PropClass);
    //
    //         Object.defineProperties(this, {
    //             _propClass: { value: propClass, },
    //         });
    //     }
    // }},

class Preset_Type {
    #presets            ;
    #hasExtras         ;

    get hasExtras()          {
        return this.#hasExtras;
    }

    get presets()             {
        return this.#presets;
    }

    constructor(presets            , hasExtras          = false) {
        this.#presets = presets;
        this.#hasExtras = hasExtras;
    }
}

class PresetArray_Type {
    #presets                     ;

    get presets()                      {
        return this.#presets;
    }

    constructor(presets                     ) {
        this.#presets = presets;
    }
}

class TS0TypeError extends Error {
    constructor(message        ) {
        super(message);

        // let stack = this.stack;
        // let stack_array = stack.split('\n');
        // stack_array.splice(1, 3);
        // this.stack = stack_array.join('\n');
    }
}


;                          
                                                
                                                    
                 
                                                        
                                                                                     
                            
;                                              

/* JSLib Exports */
_jsLib.export("ts0_Class", ts0_Class);
_jsLib.export("default", ts0); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\ts-lib\ts-types.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/ts-lib/ts-types", [  ], (_jsLib) => { "use strict"; 
                                                                                                 
                                                                                                           

/* JSLib Exports */ });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\ts-lib\ts0Assert.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/ts-lib/ts0Assert", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", [ { name: "default", alias: "AssertError" } ], "./AssertError.ts");

/* export default */ function ts0Assert(value         , message         = "")                {
    if (!value)
        throw new (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/AssertError", "default", "AssertError", "./AssertError.ts"))(message);
}

/* JSLib Exports */
_jsLib.export("default", ts0Assert); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\ts-lib\ts0Helper.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/ts-lib/ts0Helper", [ "ts0Helper_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("node:util", "./index", [  ], "node:util");
                                                                       
_jsLib.importDeclaration("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", [ { name: "default", alias: "ts0" } ], "./index.ts");

/* export */ class ts0Helper_Class {
    constructor() {
        
    }

    copyArray(arr                 )                  {
        let arr_New = new Array();
        for (let val of arr) {
            if (val === null) {
                arr.push(null);
                continue;
            }

            if ((_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./index.ts")).checkType(val, (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./index.ts")).TRawObject)) {
                arr_New.push(this.copyRawObject(val                    ));
                continue;
            }

            if (Array.isArray(val)) {
                arr_New.push(this.copyArray(val));
                continue;
            }

            arr_New.push(val);
        }

        return arr_New;
    }

    copyRawObject(obj                  )                   {
        (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./index.ts")).assertType(obj, (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./index.ts")).TRawObject);

        let obj_New                   = {};
        for (let prop in obj) {
            if (obj[prop] === null) {
                obj_New[prop] = null;
                continue;
            }

            if ((typeof obj[prop]) === 'symbol') {
                obj_New[prop] = obj[prop];
                continue;
            }

            if ((_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./index.ts")).checkType(obj[prop], (_jsLib.import("ab-pager", "./node_modules/@allblue/ts0/ts-lib/index", "default", "ts0", "./index.ts")).TRawObject)) {
                obj_New[prop] = this.copyRawObject(obj[prop]                    );
                continue;
            }

            if (Array.isArray(obj[prop])) {
                obj_New[prop] = this.copyArray(obj[prop]);
                continue;
            }

            obj_New[prop] = obj[prop];
        }

        return obj_New;
    }
}
const ts0Helper = new ts0Helper_Class();
/* export default */ ts0Helper;

/* JSLib Exports */
_jsLib.export("ts0Helper_Class", ts0Helper_Class);
_jsLib.export("default", ts0Helper); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\ab-pager\node_modules\@allblue\ts0\ts-lib\TS0List.js
jsLibs.exportScript("ab-pager", "./node_modules/@allblue/ts0/ts-lib/TS0List", [ "default" ], (_jsLib) => { "use strict"; 
/* export default */ class TS0List                     {
    get size()         {
        return this.#values.length;
    }


    #keys                ;
    #values                  ;


    constructor(iterable                                   = null) {
        this.#keys = [];
        this.#values = [];

        if (iterable !== null) {
            for (let item of iterable)
                this.set(item[0], item[1]);
        }
    }

    [Symbol.iterator]()                                   {
        return new ListIterator(this);
    }

    addAt(index        , key         , value           )       {
        if (index < 0 || index > this.#values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        if (this.#values.length === index) {
            this.#keys.push(key);
            this.#values.push(value);
        } else {
            this.#keys.splice(index, 0, key);
            this.#values.splice(index, 0, value);
        }
    }

    clear()       {
        this.#keys = [];
        this.#values = [];
    }

    delete(key         )       {
        let index = this._getIndexE(key);
        this.deleteAt(index);
    }

    deleteAt(index        )       {
        this.#keys.splice(index, 1);
        this.#values.splice(index, 1);
    }

    get(key         )            {
        let index = this._getIndexE(key);
        return this.#values[index]             ;
    }

    getAt(index        )            {
        if (index < 0 || index >= this.#values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        return this.#values[index]             ;
    }

    getKeyAt(index        )          {
        if (index < 0 || index >= this.#values.length)
            throw new Error(`Key at \`${index}\` does not exist in \`js0_List\`.`);

        return this.#keys[index]           ;
    }

    getKeys()                 {
        return this.#keys.slice();
    }

    getKeysIterator()                         {
        return this.#keys[Symbol.iterator]();
    }

    getValues()                   {
        return this.#values.slice();
    }

    has(key         )          {
        return this.#keys.includes(key);
    }

    includes(value           )          {
        return this.#values.includes(value);
    }

    indexOf(value           )         {
        return this.#values.indexOf(value);
    }

    remove(value           )       {
        for (let i = this.size - 1; i >= 0; i--) {
            if (this.getAt(i) === value) {
                this.deleteAt(i);
                return;
            }
        }     

        throw new Error(`Value '${value}' does not exist in js0_List.`);
    }

    set(key         , value           )       {
        let index = this.#keys.indexOf(key);
        if (index === -1)
            index = this.#values.length;

        this.setAt(index, key, value);
    }

    setAt(index        , key         , value           )       {
        if (index < 0 || index > this.#values.length)
            throw new Error(`Index \`${index}\` does not exist in \`js0_List\`.`);

        if (index === this.#values.length) {
            this.#keys.push(key);
            this.#values.push(value);
        } else {
            this.#keys[index] = key;
            this.#values[index] = value;
        }
    }

    // slice() {

    // }

    sort(compareFn                                          
                                                            )       {
        let newKeys = this.#keys.slice();
        newKeys.sort((aKey, bKey) => {
            return compareFn({ key: aKey, value: this.get(aKey)              },
                    { key: bKey, value: this.get(bKey)              });
        });

        let newValues = [];
        for (let i = 0; i < this.size; i++)
            newValues.push(this.get(newKeys[i]));

        this.#keys = newKeys;
        this.#values = newValues                    ;
    }

    values()                   {
        return this.#values.slice();
    }


    _getIndexE(key         )         {
        let index = this.#keys.indexOf(key);
        if (index === -1)
            throw new Error(`Key \`${key}\` does not exist in \`js0_List\`.`);

        return index;
    }
}


class ListIterator                                                                 {
    #list                             ;
    #iterator                        ;


    constructor(list                             ) {
        this.#list = list;
        this.#iterator = list.getKeysIterator();
    }

    next()                                         {
        let keyItem = this.#iterator.next();

        if (keyItem.done)
            return { value: undefined, done: true, };

        return {
            value: [ keyItem.value, this.#list.get(keyItem.value)              ],
            done: false,
        };
    }
}


/* JSLib Exports */
_jsLib.export("default", TS0List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-file-upload\FileUpload.js
jsLibs.exportScript("spk-file-upload", "./FileUpload", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

_jsLib.importDeclaration("spk-file-upload", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");

/* export default */ class FileUpload extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    get files() {
        return this._files;
    }


    constructor(callback, extensions = '.*', multiple = false)
    { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function', [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], 
                [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this._callback = callback;
        this._extensions = extensions;
        this._multiple = multiple;

        this._files = [];

        this._createInput(callback);
    }

    upload()
    {
        let event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        this.l.$elems.fileInput.dispatchEvent(event);
    }

    
    _createInput()
    {
        this.l = new (_jsLib.import("spk-file-upload", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Input();
        this.l.$fields.extensions = this._extensions;

        let el = this.l.$elems.fileInput;
        if (this._multiple)
            el.setAttribute('multiple', true);
        el.addEventListener('change', () => {
            this._files = el.files;
            this._callback(el.files);
            this._createInput();
        });
    }

}


/* JSLib Exports */
_jsLib.export("default", FileUpload); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-file-upload\index.js
jsLibs.exportScript("spk-file-upload", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [  ], "js0");
_jsLib.importDeclaration("spocky", "./index", [  ], "spocky");
_jsLib.importDeclaration("spk-file-upload", "./$layouts/index", [  ], "./$layouts/index.js");
_jsLib.importDeclaration("spk-file-upload", "./FileUpload", [ { name: "default", alias: "FileUpload" } ], "./FileUpload.js");
_jsLib.importDeclaration("spk-file-upload", "./LiveUpload", [ { name: "default", alias: "LiveUpload" } ], "./LiveUpload.js");

class spkFileUpload_Class {
    get FileUpload() {
        return (_jsLib.import("spk-file-upload", "./FileUpload", "default", "FileUpload", "./FileUpload.js"));
    }

    get LiveUpload() {
        return (_jsLib.import("spk-file-upload", "./LiveUpload", "default", "LiveUpload", "./LiveUpload.js"));
    }


    constructor() {

    }
}
const spkFileUpload = new spkFileUpload_Class();
/* export default */ spkFileUpload;


/* JSLib Exports */
_jsLib.export("default", spkFileUpload); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-file-upload\LiveUpload.js
jsLibs.exportScript("spk-file-upload", "./LiveUpload", [ "init","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-file-upload", "./index", [ { name: "default", alias: "spkFileUpload" } ], "spk-file-upload");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

_jsLib.importDeclaration("spk-file-upload", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");

let initialized = false;
/* export */ function init() {
    if (initialized)
        return;
    initialized = true;
    
     /* Disable dragging for the whole document. */
     document.addEventListener('dragover', (evt) => {
        evt.stopPropagation();
        evt.preventDefault();
        evt.dataTransfer.dropEffect = 'copy';
    });
}


/* export default */ class LiveUpload extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    constructor(title, displayType, listeners, exts = '*', texts = {})
    { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, 
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], [ 'object', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(listeners, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            onCopy: 'function',
            onDelete: 'function',
            onInsert: 'function',
            onUpload: 'function',
        }));

        if (![ 'file', 'image' ].includes(displayType))
                throw new Error(`Unknown display type '${displayType}'.`);

        init();

        this._title = title;
        this._listeners = listeners;
        this._displayType = displayType;
        this._texts = texts;

        this.l = null;
        this.files = new Map();

        this._fileUpload = new (_jsLib.import("spk-file-upload", "./index", "default", "spkFileUpload", "spk-file-upload")).FileUpload((files) => {
            this._listeners.onUpload(files);
                }, exts, true);

        this._createLayout();
        this._createElems();

        this.$view = this.l;
    }

    deleteAllFiles()
    {
        this.files = new Map();
        this.l.$fields.files = [];
    }

    deleteFile(fileId)
    {
        this.files.delete(fileId);
        this.l.$fields.files().$delete(fileId);
    }

    hideLoading()
    {
        this.l.$fields.loading = false;
    }

    refresh()
    {
        this.l.$fields.timestamp = Date.now();
    }

    setFile(fileInfo)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        console.log(fileInfo);

        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(fileInfo, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            id: [ 'number', 'string' ],
            title: 'string',
            uri: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            imgUri: 'string',
        }));

        this.files.set(fileInfo.id, fileInfo);
        this.l.$fields.files(fileInfo.id, fileInfo);

        this.refresh();
    }

    showLoading()
    {
        this.l.$fields.loading = true;
    }


    _createElems()
    {
        this.l.$elems.upload.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._fileUpload.upload();
        });

        /* Images */
        this.l.$elems.images_Insert_Text((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.images_Insert_Image((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.images_Copy((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onCopy(this.files.get(keys[0]));
            });
        });
        this.l.$elems.images_Delete((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onDelete(this.files.get(keys[0]));
            });
        });

        /* Files */
        this.l.$elems.files_Insert_Text((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.files_Insert_Image((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.files_Copy((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onCopy(this.files.get(keys[0]));
            });
        });
        this.l.$elems.files_Delete((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onDelete(this.files.get(keys[0]));
            });
        });

        this._createElems_Images();
    }

    _createElems_Images()
    {
        this.l.$elems.files.addEventListener('dragover', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            evt.dataTransfer.dropEffect = 'copy';

            this.l.$fields.class = 'dragover';
        });

        this.l.$elems.files.addEventListener('dragleave', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();

            this.l.$fields.class = '';
        });

        this.l.$elems.files.addEventListener('drop', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();

            this.l.$fields.class = '';

            var files = evt.dataTransfer.files;
            this._listeners.onUpload(files);
        });
    }

    _createLayout()
    {
        this.l = new (_jsLib.import("spk-file-upload", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Files();

        this.l.$fields = {
            title: this._title,
            type: {
                isFile: this._displayType === 'file',
                isImage: this._displayType === 'image',
            },
            text: (text) => {
                return text in this._texts ? this._texts[text] : `#${text}#`;
            },
        }

        this.l.$holders.fileUpload.$view = this._fileUpload;
    }

}

/* JSLib Exports */
_jsLib.export("init", init);
_jsLib.export("default", LiveUpload); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-file-upload\$layouts\Files.js
jsLibs.exportScript("spk-file-upload", "./$layouts/Files", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Files extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["card"]},["div",{"class":["card-header"]},["div",{"class":["row"]},["div",{"class":["col"]},"$title"],["div",{"class":["col-auto"]},["button",{"_elem":["upload"],"class":["btn btn-primary btn-sm m-0 float-right"]},["i",{"class":["fas fa-file-upload"],"aria-hidden":["true"]}]," ","$text('Buttons_Upload')"]]]],["div",{"class":["card-body p-0"]},["div",{"class":["spk-e-images"]},["div",{"_show":["loading"],"class":["files-loader"]},["div",{"class":["spinner-border"],"role":["status"]},["span",{"class":["visually-hidden"]},"$text('Texts_Loading')"]]],["div",{"_elem":["files"],"class":["files-holder ","$class"]},["$",{"_hide":["loading"]},["div",{"_repeat":["files:file"],"_show":["type.isImage"],"class":["image-holder"]},["div",{"class":["image-displayer"],"style":["background-image: url('","${file.imgUri}","?t=","${timestamp}","');'"]},["a",{"_elem":["images_Insert_Image"],"href":[""]},["img",{"src":["/dev/node_modules/spk-file-upload/images/dummy.png"],"alt":[""]}]]],["div",{"class":["btn-group w-100"]},["a",{"_elem":["images_Insert_Text"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-image"],"aria-hidden":["true"]}]],["a",{"_elem":["images_Copy"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-link"],"aria-hidden":["true"]}]],["a",{"_elem":["images_Delete"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-times text-danger"],"aria-hidden":["true"]}]]]],["div",{"class":["clearfix"]}],["div",{"_repeat":["files:file"],"_show":["type.isFile"],"class":["file-holder"]},["div",{"class":["alert alert-info"]},["div",{"class":["row file-details"]},["div",{"class":["col file-name"]},["a",{"_elem":["files_Insert_Image"],"href":[""]},["i",{"class":["far fa-file me-2"],"aria-hidden":["true"]}],"$file.title"]],["div",{"class":["col-auto"]},["div",{"class":["btn-group"]},["a",{"_elem":["files_Insert_Text"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fas fa-arrow-down"],"aria-hidden":["true"]}]],["a",{"_elem":["files_Copy"],"_show":["notImplemented"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-link"],"aria-hidden":["true"]}]],["a",{"_elem":["files_Delete"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-times text-danger"],"aria-hidden":["true"]}]]]]]]]]]]]],["$",{"_holder":["fileUpload"]}]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Files.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Files); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-file-upload\$layouts\index.js
jsLibs.exportScript("spk-file-upload", "./$layouts/index", [ "$layouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-file-upload", "./$layouts/Files", [ { name: "default", alias: "Files" } ], "./Files.js");
_jsLib.importDeclaration("spk-file-upload", "./$layouts/Input", [ { name: "default", alias: "Input" } ], "./Input.js");

/* export */ class $layouts_Class {
    get Files() {
        return (_jsLib.import("spk-file-upload", "./$layouts/Files", "default", "Files", "./Files.js"));
    }
    get Input() {
        return (_jsLib.import("spk-file-upload", "./$layouts/Input", "default", "Input", "./Input.js"));
    }
}
const $layouts = new $layouts_Class();
/* export default */ $layouts

/* JSLib Exports */
_jsLib.export("$layouts_Class", $layouts_Class);
_jsLib.export("default", $layouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-file-upload\$layouts\Input.js
jsLibs.exportScript("spk-file-upload", "./$layouts/Input", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Input extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"style":["display: none;"]},["input",{"_elem":["fileInput"],"type":["file"],"accept":["$extensions"],"style":["display: none;"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Input.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Input); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\Ext.js
jsLibs.exportScript("spk-forms", "./Ext", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text-parser", "./index", [  ], "ab-text-parser");
_jsLib.importDeclaration("js0", "./index", [  ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

_jsLib.importDeclaration("spk-forms", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "./index.js");

/* export default */ class Ext extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Ext
{

    constructor()
    { super();
        (_jsLib.import("spk-forms", "./index", "default", "spkForms", "./index.js")).extInitialized = true;
    }

    onParseLayoutNode(layoutNode)
    {
        this._onParseLayoutNode_Field(layoutNode);
        this._onParseLayoutNode_Message(layoutNode);
    }


    _getFieldInfo(layoutNode)
    {
        let dataTypes = [ 'input-type', 'label', 'placeholder', 'label-class', 
                'field-class' ];
        let data = {};

        for (let attrName in layoutNode.attribs) {
            data[attrName] = layoutNode.attribs[attrName]
                .join('')
                .replace(/"/g, '\\"')
                .replace(/\$/g, '\\$')
                .replace(/\?/g, '\\?');
        }

        return JSON.stringify(data);
    }

    _getFieldLayoutContent(fieldName)
    {
        let layoutName = `${fieldName}Field`;

        if (layoutName === 'DateTimeField')
            layoutName = 'DateField';

        if (!(layoutName in (_jsLib.import("spk-forms", "./$layouts/index", "default", "$layouts", "./$layouts/index.js"))))
            throw new Error(`Field type '${fieldName}' does not exist.`);

        return (_jsLib.import("spk-forms", "./$layouts/index", "default", "$layouts", "./$layouts/index.js"))[layoutName].Content;
    }

    _onParseLayoutNode_Field(layoutNode)
    {
        if (layoutNode.type !== 'spk-form-field')
            return;

        if (!('form' in layoutNode.attribs))    
            throw new Error(`No 'form' set for 'spk-form-field'.`);
        if (!('name' in layoutNode.attribs))    
            throw new Error(`No 'name' set for 'spk-form-field'.`);
        if (!('type' in layoutNode.attribs))
            throw new Error(`No 'type' set for 'spk-form-field' '${layoutNode.attribs.name[0]}.`);

        let formName = layoutNode.attribs.form[0];
        let fullFormName = 'spkForms_' + layoutNode.attribs.form[0];
        let fieldName = layoutNode.attribs.name[0];
        let fullFieldName = `spkForms_${formName}_Fields_${fieldName}`;
        let fieldInfo = this._getFieldInfo(layoutNode);

        let layoutContent = this._getFieldLayoutContent(layoutNode.attribs.type[0]);

        let replaceArr = [
            [ '{{formName}}', formName ],
            [ '{{fullFormName}}', fullFormName ],
            [ '{{fieldName}}', fieldName ],
            [ '{{fullFieldName}}', fullFieldName ],
            [ '{{fieldInfo}}', fieldInfo ],

            [ '{{showLabel}}', 'show-label' in layoutNode.attribs 
                    ? layoutNode.attribs['show-label'].join('') : '?(true)' ],
            [ '{{fieldLabel}}', 'label' in layoutNode.attribs ? 
                    layoutNode.attribs.label.join('') : '\'\'' ],
            [ '{{fieldPlaceholder}}', 'placeholder' in layoutNode.attribs ? 
                    layoutNode.attribs.placeholder.join('') : '' ],

            [ '{{labelClass}}', 'label-class' in layoutNode.attribs ? 
                    layoutNode.attribs['label-class'].join('') : '' ],
            [ '{{fieldClass}}', 'field-class' in layoutNode.attribs ? 
                    layoutNode.attribs['field-class'].join('') : '' ],
            [ '{{divClass}}', 'div-class' in layoutNode.attribs ? 
                    layoutNode.attribs['div-class'].join('') : '' ],

            [ '{{fieldRows}}', 'rows' in layoutNode.attribs ? 
                    layoutNode.attribs.rows.join('') : '3' ],
        ];

        /* Special */
        if (layoutNode.attribs.type[0] === 'Input') {
            replaceArr.push(
                [ '{{inputType}}', 'input-type' in layoutNode.attribs ? 
                        layoutNode.attribs['input-type'].join('') : 'text' ]
            );
        }

        (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout.Replace(layoutContent, replaceArr);

        layoutNode.content = [];
        for (let newLayoutNode of layoutContent)
            layoutNode.content.push(newLayoutNode);
    }

    _onParseLayoutNode_Message(layoutNode)
    {
        if (layoutNode.type !== 'spk-form-message')
            return;

        let layoutContent = (_jsLib.import("spk-forms", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Message.Content;

        if (!('form' in layoutNode.attribs)) {
            console.warn(`No 'form' attribute in '${layoutNode.type}'.`);
            return;
        }

        let formName = layoutNode.attribs.form[0];
        let fullFormName = `spkForms_${formName}`;

        let replaceArr = [
            [ '{{formName}}', formName ],
            [ '{{fullFormName}}', fullFormName ],
        ];
        (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout.Replace(layoutContent, replaceArr);

        layoutNode.content = [];
        for (let newLayoutNode of layoutContent)
            layoutNode.content.push(newLayoutNode);
    }

}

/* JSLib Exports */
_jsLib.export("default", Ext); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\Field.js
jsLibs.exportScript("spk-forms", "./Field", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-date", "./index", [ { name: "default", alias: "abDate" } ], "ab-date");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "./index.js");


/* export default */ class Field
{

    get elem() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).assert(`${this._fullName}_Field` in this._layout.$elems, 
                `Cannot find 'elem' in field layout.`);

        return this._layout.$elems[`${this._fullName}_Field`];
    }

    get fullName() {
        return this._fullName;
    }

    get info() {
        return this._info;
    }

    get value() {
        let type = this._info.type;

        /* Date Time */
        if (type === 'Checkbox') {
            return this.elem.checked ? true : false;
        } else if (type === 'Date') {
            let value = this.elem.value;

            return value === '' ? null : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).strToTime_Date_UTC(value);
        } else if (type === 'DateTime') {
            let value = this.elem.value;

            return value === '' ? null : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).strToTime_DateTime_UTC(value);
        } else if (type === 'Message') {
            throw new Error('Value of Message Field is not gettable.');
        } else if (type === 'Time') {
            let value = this.elem.value;

            return value === '' ? null : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).strToTime_Time_UTC(value);
        } else if (type === 'File') {
            let file = this.elem.files[0];
            return typeof file === 'undefined' ? null : file;
        } else if (type === 'Text')
            return null;
        else if (type === 'Radio') {
            let options = this._layout.$elems.$getAll(`${this._fullName}_Field`);

            for (let i = 0; i < options.length; i++) {
                if (options[i].checked)
                    return options[i].getAttribute('value');
            }

            return '';
        } else if (type === 'SelectMultiple') {
            let values = [];

            let options = this.elem.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].selected) {
                    values.push(options[i].value);
                }
            }

            return values;
        } else if (type === 'Input' && 
                this._info['input-type'].toLowerCase() === 'checkbox') {
            return this.elem.checked ? true : false;
        }

        return this.elem.value;
    }
    set value(value) {
        this.clearValidator();

        if (this._info.type === 'Checkbox') {
            this.elem.checked = value ? true : false;
            let event = new Event('change', { bubbles: true, cancelable: true });
            this.elem.dispatchEvent(event);
        } else if (this._info.type === 'Date' || this._info.type === 'DateTime' ||
                this._info.type === 'Time') {
            if (value === null)
                this.elem.value = '';
            else {
                let m = moment(value * 1000).utcOffset(0);
                $(this.elem).data('DateTimePicker').date(m);
            }
        } else if (this._info.type === 'Message') {
            /* Do nothing */
        } else if (this._info.type === 'File') {
            /* Do nothing. */
        } else if (this._info.type === 'Radio') {
            let options = this._layout.$elems.$getAll(`${this._fullName}_Field`);

            for (let i = 0; i < options.length; i++) {
                if (options[i].getAttribute('value') === String(value)) {
                    options[i].checked = true;
                    return;
                }
            }
        } else if (this._info.type === 'Input') {
            if (this._info['input-type'].toLowerCase() === 'checkbox') {
                this.elem.checked = value ? true : false;
                let event = new Event('change', { bubbles: true, cancelable: true });
                this.elem.dispatchEvent(event);
            } else
                this.elem.value = value;
        } else if (this._info.type === 'Select') {
            let selected = false;
            let options = this.elem.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === value + '') {
                    options[i].selected = true;

                    let event = new Event('change', { bubbles: true, cancelable: true });
                    this.elem.dispatchEvent(event);

                    selected = true;
                    break;
                }
            }

            if (!selected)
                console.warn('Cannot find option `' + value + '` for field `' +
                        this.fullName + '`.');
        } else if (this._info.type === 'SelectMultiple') { 
            if (!(value instanceof Array)) {
                console.warn(`SelectMultiple value '` + value + `' should be an Array.`);
                return;
            }

            for (let value_T of value) {
                let selected = false;
                let options = this.elem.options;
                for (let i = 0; i < options.length; i++) {
                    if (options[i].value === value_T + '') {
                        options[i].selected = true;

                        let event = new Event('change', { bubbles: true, 
                            cancelable: true });
                        this.elem.dispatchEvent(event);

                        selected = true;
                        break;
                    }
                }

                if (!selected)
                    console.warn('Cannot find option `' + value_T + '`.');
            }
        } else if (this._info.type === 'Text')
            this.elem.innerHTML = value;
        else
            this.elem.value = value;

        // if (this._private.valueFieldName !== null)
        //     this._private.mForm.$fields[this._private.valueFieldName] = this.value;
        // }
    }

    constructor(layout, fieldInfo)
    {
        this._layout = layout;
        this._info = fieldInfo;

        this._fullName = `spkForms_${fieldInfo.form}_Fields_${fieldInfo.name}`;

        let fields = {};
        fields[`${this._fullName}_Label`] = 'label' in this._info ? this._info.label : '';        

        this.init();

        this._layout.$fields = fields;
    }

    clear()
    {
        this.value = '';
        this.clearValidator();
    }

    clearValidator()
    {
        this._layout.$fields[`${this._fullName}_Validator`] = {
            errors: [],
            fieldClass: '',
            divClass: '',
        }
    }

    field(fieldName, ...args)
    {
        if (args.length === 0)
            return this._layout.$fields[`${this.fullName}_${fieldName}`];
        else
            this._layout.$fields[`${this.fullName}_${fieldName}`] = args[0];
    }

    getLayoutElem(elemName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');
        return this._layout.$elems[`${this._fullName}_${elemName}`];
    }

    getLayoutField(fieldName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');
        return this._layout.$fields[`${this._fullName}_${elemName}`];
    }

    init()
    {
        let onChange = (evt) => {
            this.clearValidator();
        };

        if (this._info.type === 'Checkbox') {
            this.elem.addEventListener('change', onChange);
            this.elem.addEventListener('keyup', onChange);
        } else if (this._info.type === 'Date' || this._info.type === 'DateTime' ||
                this._info.type === 'Time') {
            let format;
            if (this._info.type === 'Date')
                format = (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).formats_Date;
            else if (this._info.type === 'DateTime')
                format = (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).formats_DateTime;
            else if (this._info.type === 'Time')
                format = (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).formats_Time;

            /* Initialize `date` field. */
            $(this.elem)
                .datetimepicker( {
                    format: format,
                    showTodayButton: this._info.type !== 'Time',
                    useCurrent: false,
                    locale: (_jsLib.import("spk-forms", "./index", "default", "spkForms", "./index.js")).lang,
                    ignoreReadonly: true,
                })
                .on('dp.show', (evt) => {
                    if($(this.elem).data("DateTimePicker").date() === null)
                        $(this.elem).data("DateTimePicker").date(moment());
                })
                .on('dp.hide', (evt) => {
                    this.elem.setAttribute('value', this.elem.value);
                    this.clearValidator();
                    this.elem.blur();
                });

            this._layout.$elems[`${this._fullName}_ClearCalendar`].addEventListener(
                    'click', (evt) => {
                evt.preventDefault();
                this.value = null;
            });
        } else if (this._info.type === 'File') {
            this.field('Accept', '');
            if ('accept' in this._info)
                this.field('Accept', this._info.accept);
        } else if (this._info.type === 'Input' || this._info.type === 'TextArea') {
            // this.value = '';

            this.elem.addEventListener('change', onChange);
            this.elem.addEventListener('keyup', onChange);

            // this.elem.setAttribute('value', '');
        } else if (this._info.type === 'Radio') {
            this.getLayoutElem('Field')((elem) => {
                elem.addEventListener('change', onChange);
            });
            // this._layout.$elems.each('field', function(elem) {
            //     elem.addEventListener('change', onChange);
            // });
        } else if (this._info.type === 'Select' || this._info.type === 'file') {
            this.elem.addEventListener('change', onChange);
        }
    }

    setDisabled(disabled)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        let elems = this._layout.$elems.$getAll(`${this._fullName}_Field`);

        for (let elem of elems) {
            if (disabled)
                elem.setAttribute('disabled', '');
            else
                elem.removeAttribute('disabled');
        }
    }

    setValidator(validator)
    {
        this._layout.$fields[`${this._fullName}_Validator`] = {
            errors: 'errors' in validator ? validator.errors : [],
            fieldClass: validator.valid ? '' : 'is-invalid',
            divClass: '',
        }
    }

}

/* JSLib Exports */
_jsLib.export("default", Field); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\Form.js
jsLibs.exportScript("spk-forms", "./Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "./index.js");
_jsLib.importDeclaration("spk-forms", "./Field", [ { name: "default", alias: "Field" } ], "./Field.js");

/* export default */ class Form
{

    get fields() {
        return this._fields;
    }

    get l() {
        console.warn(`'l() is deprecated. Use layout() instead.'`, new Error());

        return this._layout;
    }

    get layout() {
        return this._layout;
    }


    constructor(layout, formName)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout, 'string');

        if (!(_jsLib.import("spk-forms", "./index", "default", "spkForms", "./index.js")).extInitialized)
            throw new Error('Ext not initialized.');

        this._layout = layout;
        this.formName = formName;
        this.fullFormName = `spkForms_${formName}`;

        this._fields = {};

        if (!('spk-field' in layout.$data)) {
            if ((_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Debug)
                console.warn('No spk-fields in layout.', new Error());
            return;
        }

        for (let field of layout.$data['spk-field']) {
            let separatorIndex = field.indexOf(':');
            
            let formName = field.substring(0, separatorIndex);
            if (formName !== this.formName)
                continue;

            let fieldInfo = JSON.parse(field.substring(separatorIndex + 1));

            for (let attrName in fieldInfo) {
                fieldInfo[attrName] = fieldInfo[attrName]
                    .replace(/\\"/g, '"')
                    .replace(/\\\$/g, '$');
            }

            this._fields[fieldInfo.name] = new (_jsLib.import("spk-forms", "./Field", "default", "Field", "./Field.js"))(layout, fieldInfo);
        }
    }

    clear()
    {
        for (let fieldName in this._fields)
            this._fields[fieldName].clear();

        this.clearValidator();
        this.clearMessage();
    }

    clearMessage()
    {
        let messageFound = false;
        if ('spk-form-message' in this._layout.$data) {
            if (this._layout.$data['spk-form-message'].includes(this.formName))
                messageFound = true;
        }
        if (!messageFound)
            return;

        this._layout.$fields = {
            [`${this.fullFormName}_Message_Class`]: '',
            [`${this.fullFormName}_Message`]: '',
            [`${this.fullFormName}_Message_Show`]: false,
        };
    }

    clearValidator()
    {
        for (let fieldName in this._fields)
            this._fields[fieldName].clearValidator();
    }

    getField(fieldName)
    {
        if (!(fieldName in this._fields))
            throw new Error(`Field '${fieldName}' does not exist.`);

        return this._fields[fieldName];
    }

    getFiles()
    {
        let values = {};

        for (let fieldName in this._fields) {
            if (this._fields[fieldName].info.type === 'Message')
                continue;
            if (this._fields[fieldName].info.type === 'Text')
                continue;

            let value = this._fields[fieldName].value;
            if (!(value instanceof File))
                continue;

            values[fieldName] = this._fields[fieldName].value;
        }

        return values;
    }

    getValues()
    {
        let values = {};

        for (let fieldName in this._fields) {
            if (this._fields[fieldName].info.type === 'Message')
                continue;
            if (this._fields[fieldName].info.type === 'Text')
                continue;

            let value = this._fields[fieldName].value;
            if (value instanceof File)
                continue;

            values[fieldName] = this._fields[fieldName].value;
        }

        return values;
    }

    setDisabled(disabled)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        for (let fieldName in this._fields)
            this._fields[fieldName].setDisabled(disabled);
    }

    setMessage(message, messageClass)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        let messageFound = false;
        if ('spk-form-message' in this.l.$data) {
            if (this.l.$data['spk-form-message'].includes(this.formName))
                messageFound = true;
        }
        if (!messageFound) {
            if ((_jsLib.import("spk-forms", "./index", "default", "spkForms", "./index.js")).debug)
                console.warn(`Message field not found in form '${this.formName}'.`);
        }

        this.l.$fields = {
            [`${this.fullFormName}_Message_Class`]: messageClass,
            [`${this.fullFormName}_Message`]: message,
            [`${this.fullFormName}_Message_Show`]: true,
        };
    }

    setMessage_Error(message)
    {
        this.setMessage(message, 'alert-danger');
    }

    setMessage_Success(message)
    {
        this.setMessage(message, 'alert-success');
    }

    setValidator(validatorInfo)
    {
        this.clearMessage();
        this.clearValidator();

        for (let fieldName in validatorInfo.fields) {
            if (!(fieldName in this._fields)) {
                if ((_jsLib.import("spk-forms", "./index", "default", "spkForms", "./index.js")).debug)
                    console.warn(`Field '${fieldName}' does not exist in form.`)
                continue;
            }

            this._fields[fieldName].setValidator(validatorInfo.fields[fieldName]);
        }

        if (validatorInfo.errors.length > 0) {
            this.setMessage_Error(validatorInfo.errors.join(' '));
        }
    }

    setValues(values, ignoreNotExisting = false)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'object', [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        for (let fieldName in values) {
            if (!(fieldName in this._fields)) {
                if ((_jsLib.import("spk-forms", "./index", "default", "spkForms", "./index.js")).debug && !ignoreNotExisting) {
                    console.warn(`Field '${fieldName}' does not exist. Cannot set value.`, 
                            new Error());
                }

                continue;
            }

            this._fields[fieldName].value = values[fieldName];
        }
    }

}

/* JSLib Exports */
_jsLib.export("default", Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\index.js
jsLibs.exportScript("spk-forms", "./index", [ "spkForms_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [  ], "spocky");
_jsLib.importDeclaration("spk-forms", "./$layouts/index", [  ], "./$layouts/index.js");
_jsLib.importDeclaration("spk-forms", "./Ext", [ { name: "default", alias: "Ext" } ], "./Ext.js");
_jsLib.importDeclaration("spk-forms", "./Field", [ { name: "default", alias: "Field" } ], "./Field.js");
_jsLib.importDeclaration("spk-forms", "./Form", [ { name: "default", alias: "Form" } ], "./Form.js");

/* export */ class spkForms_Class {
    get Ext() {
        return (_jsLib.import("spk-forms", "./Ext", "default", "Ext", "./Ext.js"));
    }

    get Field() {
        return (_jsLib.import("spk-forms", "./Field", "default", "Field", "./Field.js"));
    }

    get Form() {
        return (_jsLib.import("spk-forms", "./Form", "default", "Form", "./Form.js"));
    }


    get debug() {
        return this._debug;
    }

    get lang() {
        return this._lang;
    }

    constructor()
    {
        this.extInitialized = false;
    }

    setDebug(debug)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._debug = debug;
    }

    setLang(lang)
    {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        this._lang = lang;
    }

}
const spkForms = new spkForms_Class();
/* export default */ spkForms;

/* JSLib Exports */
_jsLib.export("spkForms_Class", spkForms_Class);
_jsLib.export("default", spkForms); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\CheckboxField.js
jsLibs.exportScript("spk-forms", "./$layouts/CheckboxField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class CheckboxField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form-check {{divClass}} {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["checkbox"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-check-input ","${{fullFieldName}}_Validator.fieldClass"],"placeholder":["{{fieldPlaceholder}}"]}],["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-check-label {{labelClass}}"]},["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"],["span",{"_field":["?({{fieldLabel}})"]}]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(CheckboxField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", CheckboxField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\DateField.js
jsLibs.exportScript("spk-forms", "./$layouts/DateField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class DateField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fieldName}}"],"class":["form-label {{labelClass}}"]},"{{fieldLabel}}"],["div",{"class":["{{fieldClass}}"]},["div",{"class":["input-group"]},["span",{"class":["input-group-text"]},["span",{"_elem":["{{fullFieldName}}_Calendar"],"class":["fa fa-calendar"]}]],["input",{"_elem":["{{fullFieldName}}_Field"],"type":["text"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control datetimepicker ","${{fullFieldName}}_Validator.fieldClass"],"placeholder":["{{fieldPlaceholder}}"],"readonly":["true"],"style":["cursor: default; background-color: #ffffff;"]}],["span",{"class":["input-group-text"]},["span",{"_elem":["{{fullFieldName}}_ClearCalendar"],"class":["fa fa-times"]}]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(DateField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", DateField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\FileField.js
jsLibs.exportScript("spk-forms", "./$layouts/FileField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class FileField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},"{{fieldLabel}}"],["div",{"class":["{{field.fieldClass}}"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["file"],"accept":["${{fullFieldName}}_Accept"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(FileField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", FileField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\HiddenField.js
jsLibs.exportScript("spk-forms", "./$layouts/HiddenField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class HiddenField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["input",{"ab-elem":["field(field)"],"type":["hidden"],"id":["{{field.name}}"],"name":["{{field.name}}"],"class":["form-control"],"placeholder":["{{field.placeholder}}"]}]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(HiddenField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", HiddenField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\index.js
jsLibs.exportScript("spk-forms", "./$layouts/index", [ "$layouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-forms", "./$layouts/CheckboxField", [ { name: "default", alias: "CheckboxField" } ], "./CheckboxField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/DateField", [ { name: "default", alias: "DateField" } ], "./DateField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/FileField", [ { name: "default", alias: "FileField" } ], "./FileField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/HiddenField", [ { name: "default", alias: "HiddenField" } ], "./HiddenField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/InputField", [ { name: "default", alias: "InputField" } ], "./InputField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/Message", [ { name: "default", alias: "Message" } ], "./Message.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/MessageField", [ { name: "default", alias: "MessageField" } ], "./MessageField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/RadioField", [ { name: "default", alias: "RadioField" } ], "./RadioField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/SelectField", [ { name: "default", alias: "SelectField" } ], "./SelectField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/SelectMultipleField", [ { name: "default", alias: "SelectMultipleField" } ], "./SelectMultipleField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/TextAreaField", [ { name: "default", alias: "TextAreaField" } ], "./TextAreaField.js");
_jsLib.importDeclaration("spk-forms", "./$layouts/TextField", [ { name: "default", alias: "TextField" } ], "./TextField.js");

/* export */ class $layouts_Class {
    get CheckboxField() {
        return (_jsLib.import("spk-forms", "./$layouts/CheckboxField", "default", "CheckboxField", "./CheckboxField.js"));
    }
    get DateField() {
        return (_jsLib.import("spk-forms", "./$layouts/DateField", "default", "DateField", "./DateField.js"));
    }
    get FileField() {
        return (_jsLib.import("spk-forms", "./$layouts/FileField", "default", "FileField", "./FileField.js"));
    }
    get HiddenField() {
        return (_jsLib.import("spk-forms", "./$layouts/HiddenField", "default", "HiddenField", "./HiddenField.js"));
    }
    get InputField() {
        return (_jsLib.import("spk-forms", "./$layouts/InputField", "default", "InputField", "./InputField.js"));
    }
    get Message() {
        return (_jsLib.import("spk-forms", "./$layouts/Message", "default", "Message", "./Message.js"));
    }
    get MessageField() {
        return (_jsLib.import("spk-forms", "./$layouts/MessageField", "default", "MessageField", "./MessageField.js"));
    }
    get RadioField() {
        return (_jsLib.import("spk-forms", "./$layouts/RadioField", "default", "RadioField", "./RadioField.js"));
    }
    get SelectField() {
        return (_jsLib.import("spk-forms", "./$layouts/SelectField", "default", "SelectField", "./SelectField.js"));
    }
    get SelectMultipleField() {
        return (_jsLib.import("spk-forms", "./$layouts/SelectMultipleField", "default", "SelectMultipleField", "./SelectMultipleField.js"));
    }
    get TextAreaField() {
        return (_jsLib.import("spk-forms", "./$layouts/TextAreaField", "default", "TextAreaField", "./TextAreaField.js"));
    }
    get TextField() {
        return (_jsLib.import("spk-forms", "./$layouts/TextField", "default", "TextField", "./TextField.js"));
    }
}
const $layouts = new $layouts_Class();
/* export default */ $layouts

/* JSLib Exports */
_jsLib.export("$layouts_Class", $layouts_Class);
_jsLib.export("default", $layouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\InputField.js
jsLibs.exportScript("spk-forms", "./$layouts/InputField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class InputField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["{{fieldClass}}"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["{{inputType}}"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"],"placeholder":["{{fieldPlaceholder}}"],"autocomplete":["off"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(InputField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", InputField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\Message.js
jsLibs.exportScript("spk-forms", "./$layouts/Message", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Message extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_show":["{{fullFormName}}_Message_Show"],"_data-spk-form-message":["{{formName}}"],"class":["alert ","${{fullFormName}}_Message_Class"," {{divClass}}"]},"${{fullFormName}}_Message"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Message.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Message); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\MessageField.js
jsLibs.exportScript("spk-forms", "./$layouts/MessageField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class MessageField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_data-spk-field":["{{formName}}:{{fieldInfo}}"],"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["alert alert-danger {{divClass}}"]},"$errorMessage"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(MessageField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", MessageField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\RadioField.js
jsLibs.exportScript("spk-forms", "./$layouts/RadioField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class RadioField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["{{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["{{fieldClass}} col-form-label"]},["div",{"_repeat":["{{fullFieldName}}_Options:Option"],"class":["form-check"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["radio"],"id":["{{fullFieldName}}_","${Option.value}"],"name":["{{fieldName}}"],"value":["$Option.value"],"class":["form-check-input ","${{fullFieldName}}_Validator.fieldClass"],"style":["${{fullFieldName}}_Style"]}],["label",{"for":["{{fullFieldName}}_","${Option.value}"],"class":["form-check-label"]}," ","${Option.title}"]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(RadioField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", RadioField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\SelectField.js
jsLibs.exportScript("spk-forms", "./$layouts/SelectField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class SelectField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["{{fieldClass}}"]},["select",{"_elem":["{{fullFieldName}}_Field"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"],"style":["${{fullFieldName}}_Style"]},["option",{"_repeat":["{{fullFieldName}}_Options:option"],"_field":["option.title"],"value":["$option.value"],"class":["$option.class"],"style":["$option.style"]}]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(SelectField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", SelectField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\SelectMultipleField.js
jsLibs.exportScript("spk-forms", "./$layouts/SelectMultipleField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class SelectMultipleField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["${{fullFieldName}}.divClass"," ","${{rowClass}}"," {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}}"]},"{{fieldLabel}}"],["div",{"class":["{{fieldClass}}"]},["select",{"_elem":["{{fullFieldName}}_Field"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control"],"style":["${{fullFieldName}}_Style"],"multiple":["1"]},["option",{"_repeat":["{{fullFieldName}}_Options:option"],"_field":["option.title"],"value":["$option.value"],"class":["$option.class"],"style":["$option.style"]}]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(SelectMultipleField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", SelectMultipleField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\TextAreaField.js
jsLibs.exportScript("spk-forms", "./$layouts/TextAreaField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class TextAreaField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} ","$validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}}"]},"{{fieldLabel}}"],["div",{"class":["{{fieldClass}}"]},["textarea",{"_elem":["{{fullFieldName}}_Field"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"placeholder":["{{fieldPlaceholder}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"],"rows":["{{fieldRows}}"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(TextAreaField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", TextAreaField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\TextField.js
jsLibs.exportScript("spk-forms", "./$layouts/TextField", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class TextField extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["textField {{fieldClass}}"]},["span",{"_elem":["{{fullFieldName}}_Field"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(TextField.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", TextField); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-messages\index.js
jsLibs.exportScript("spk-messages", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-messages", "./Messages", [ { name: "default", alias: "Messages" } ], "./Messages.js");
_jsLib.importDeclaration("spk-messages", "./languages/pl.spk-messages", [ { name: "default", alias: "lang_PL" } ], "./languages/pl.spk-messages.js");
_jsLib.importDeclaration("spk-messages", "./languages/en.spk-messages", [ { name: "default", alias: "lang_EN" } ], "./languages/en.spk-messages.js");

class spkMessages_Class {
    get Messages() {
        return (_jsLib.import("spk-messages", "./Messages", "default", "Messages", "./Messages.js"))
    }


    get debug() {
        return this._debug;
    }


    constructor() {
        this._debug = false;

        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).add('en.spkMessages', (_jsLib.import("spk-messages", "./languages/en.spk-messages", "default", "lang_EN", "./languages/en.spk-messages.js")));
        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).add('pl.spkMessages', (_jsLib.import("spk-messages", "./languages/pl.spk-messages", "default", "lang_PL", "./languages/pl.spk-messages.js")));

        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).setLang("pl");
    }

    setDebug(debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._debug = debug;
    }

    text(text) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string');

        return (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`spkMessages.${text}`);
    }
}
const spkMessages = new spkMessages_Class();
/* export default */ spkMessages;

/* JSLib Exports */
_jsLib.export("default", spkMessages); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-messages\Messages.js
jsLibs.exportScript("spk-messages", "./Messages", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

_jsLib.importDeclaration("spk-messages", "./index", [ { name: "default", alias: "spkMessages" } ], "./index.js");

_jsLib.importDeclaration("spk-messages", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index");

/* export default */ class Messages extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {
    constructor(presets = {}, layout = null) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], 
                [ (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(presets, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            modulePath: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('/dev/node_modules/spk-messages/'), ],
            images: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                loading: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet), ],
                success: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet), ],
                failure: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet), ],
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}) ],
        }));

        if (presets.images.loading === (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet)
            presets.images.loading = null;
        if (presets.images.success === (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet)
            presets.images.success = presets.modulePath + 'images/success.png';
        if (presets.images.failure === (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet)
            presets.images.failure = presets.modulePath + 'images/failure.png';

        this.loading_MinTime = 500;
        this.loading_Timeout = 500;

        this._loading = false;
        this._loading_Start = null;

        this._images = presets.images;

        this._msg = null;
        this._msg_Result_ExtraButton = false;
        this._msg_CloseOnBackgroundClick = true;
        this._msg_Fn = null;

        this._confirmation = null;
        this._confirmation_Fn = null;
        this._confirmation_Result = null;

        this._l = layout === null ? new (_jsLib.import("spk-messages", "./$layouts/index", "default", "$layouts", "./$layouts/index")).Messages() : layout;

        this._l.$fields.Loading.Image = this._images.loading;
        this._l.$fields.Text = (text) => {
            return (_jsLib.import("spk-messages", "./index", "default", "spkMessages", "./index.js")).text(text);
        }

        this._createElems();

        this.hide();

        this.$view = this._l;
    }

    getImageUri_Failure() {
        return this._images.success;
    }

    getImageUri_Success() {
        return this._images.failure;
    }

    hide() {
        this.hideConfirmation();
        this.hideLoading();
        this.hideMessage();
    }

    hideConfirmation() {
        this._l.$fields.Confirmation = {
            Image: null,
            Title: '',
            Text: '',
            Yes: '',
            No: '',
        };

        if (this._confirmation_Fn !== null) {
            let fn = this._confirmation_Fn;;
            this._confirmation_Fn = null;

            let result = this._confirmation_Result;
            this._confirmation_Result = false;
            fn(result);

            return;
        }

        this._confirmation_Fn = null;
        this._confirmation_Result = false;
    }

    hideLoading() {
        this._loading = false;

        if ((_jsLib.import("spk-messages", "./index", "default", "spkMessages", "./index.js")).debug)
            console.log('spkMessages.hideLoading', new Error());

        let loadingTimeLeft = 1;
        if (this._loading_Start !== null) {
            loadingTimeLeft = Math.max(this.loading_MinTime - 
                ((new Date()).getTime() - this._loading_Start), 1);
        }

        setTimeout(() => {
            if (this._loading)
                return;

            this._loading_Start = null;
            this._l.$fields.Loading = {
                Show: false,
                Text: '',
            };
        }, loadingTimeLeft);

    }

    hideMessage() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this._l.$fields.Message = {
            Image: '',
            Title: '',
            Text: '',
            ExtraButton_Text: '',
            ExtraButton_Class: '',
        };

        if (this._msg_Result_ExtraButton) {
            if (this._msgs_ExtraButtonFn !== null) {
                let extraButtonFn = this._msgs_ExtraButtonFn;

                this._msg_Result_ExtraButton = false;
                this._msg_Fn = null;
                this._msgs_ExtraButtonFn = null;
                this._msg_CloseOnBackgroundClick = true;

                extraButtonFn();
                return;
            }
        } else if (this._msg_Fn !== null) {
            let msgFn = this._msg_Fn;

            this._msg_Result_ExtraButton = false;
            this._msg_Fn = null;
            this._msgs_ExtraButtonFn = null;
            this._msg_CloseOnBackgroundClick = true;

            msgFn();
            return;
        }

        this._msg_Result_ExtraButton = false;
        this._msg_Fn = null;
        this._msgs_ExtraButtonFn = null;
        this._msg_CloseOnBackgroundClick = true;
    }

    showConfirmation(title, text, yesText, noText, fn = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', 'string', 'string', 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 'function' ])

        this._confirmation_Fn = fn;

        this._l.$fields.Confirmation = {
            Image: null,
            Title: title,
            Text: text,
            Yes: yesText,
            No: noText,
        };

        this._confirmation.show();
    }

    showConfirmationWithImage(image, title, text, yesText, noText, fn = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 'string', 'string', 'string', 'string', 
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 'function' ])

        this._confirmation_Fn = fn;

        this._l.$fields.Confirmation = {
            Image: image,
            Title: title,
            Text: text,
            Yes: yesText,
            No: noText,
        };

        this._confirmation.show();
    }

    showConfirmation_Failure(title, text, yesText, noText, fn = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', 'string', 
                'string', [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 'function' ])

        this.showConfirmationWithImage(this._images.failure, title, text, 
                yesText, noText, fn);
    }

    async showConfirmation_Async(title, text, yesText, noText) {
        return await this.showConfirmationWithImage_Async(null, title, text, 
                yesText, noText);
    }

    async showConfirmation_Failure_Async(title, text, yesText, noText) {
        return await this.showConfirmationWithImage_Async(this._images.failure, 
                title, text, yesText, noText);
    }

    async showConfirmationWithImage_Async(image, title, text, yesText, noText) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], 'string', 'string', 'string', 'string');

        return new Promise((resolve) => {
            this.showConfirmationWithImage(image, title, text, yesText, noText, 
                    (result) => {
                resolve(result);
            });
        });
    }

    showLoading(text = '', instant = false) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        // instant = true;

        if ((_jsLib.import("spk-messages", "./index", "default", "spkMessages", "./index.js")).debug)
            console.log('spkMessages.showLoading', new Error());

        this._loading = true;
        if (instant) {
            this._loading_Start = (new Date()).getTime();
            this._l.$fields.Loading = {
                Text: text,
                Show: true,
            };

            return;
        }

        let t0 = (new Date()).getTime();
        let checkShowLoading = () => {
            if (!this._loading)
                return;

            let t1 = (new Date()).getTime() - t0;
            if (t1 < this.loading_Timeout) {
                setTimeout(() => {
                    checkShowLoading();
                }, 50);
                return;
            }

            this._loading_Start = (new Date()).getTime();
            this._l.$fields.Loading = {
                Text: text,
                Show: true,
            };
        };
        setTimeout(() => {
            checkShowLoading();
        }, 50);
    }

    showLoading_Instant(text = '') {
        this.showLoading(text, true);
    }

    showMessage(title = '', text = '', presets = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ],
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(presets, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            image: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],  
            afterClose: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ], 
            extraButton: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                text: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ], 
                class: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('btn-secondary') ], 
                afterClick: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ], 
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}) ],
            closeOnBackgroundClick: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
        }));

        if ((_jsLib.import("spk-messages", "./index", "default", "spkMessages", "./index.js")).debug)
            console.log('spkMessages.showMessage', new Error());

        this._msg_Fn = presets.afterClose;
        this._msgs_ExtraButtonFn = presets.extraButton.afterClick;
        this._msg_CloseOnBackgroundClick = presets.closeOnBackgroundClick;

        this._l.$fields.Message = {
            Image: presets.image,
            Title: title,
            Text: text,
            ExtraButton_Text: presets.extraButton.text,
            ExtraButton_Class: presets.extraButtonClass,
        };

        this._msg.show();
    }

    async showMessage_Async(title = '', text = '', presets = {}) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ],
                [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(presets, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            image: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],  
            afterClose: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ], 
            extraButton: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                text: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ], 
                class: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('btn-secondary') ], 
                afterClick: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ], 
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}) ],
            closeOnBackgroundClick: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true) ],
        }));

        return new Promise((resolve) => {
            presets.afterClose = () => { resolve(); };
            let extraButton_AfterClick = presets.afterClick;
            presets.extraButton.afterClick = () => {
                extraButton_AfterClick();
                resolve();
            };

            this.showMessage(title, text, presets);
        });
    }

    showMessage_Failure(title = '', text = '', fn = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ], 
                [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this.showMessage(title, text, {
            image: this._images.failure, 
            afterClose: fn,
        });
    }

    showMessage_Failure_Async(title = '', text = '') {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ], 
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ]);

        return new Promise((resolve) => {
            this.showMessage_Failure(title, text, () => {
                resolve();
            });
        });
    }

    showMessage_Success(title = '', text = '', fn = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ], [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ], 
                [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this.showMessage(title, text, {
            image: this._images.success, 
            afterClose: fn,
        });
    }

    showMessage_Success_Async(title = '', text = '') {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ], 
                [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default, ]);

        return new Promise((resolve) => {
            this.showMessage_Success(title, text, () => {
                resolve();
            });
        });
    }

    showNotification(message, faIcon = null) {
        this._l.$fields.Notification = {
            FaIcon: faIcon === null ? 'fa-info' : faIcon,
            Message: message,
        };

        $(this._l.$elems.Notification).fadeIn(() => {
            setTimeout(() => {
                $(this._l.$elems.Notification).fadeOut(() => {
                    this._l.$fields.Notification = {
                        FaIcon: '',
                        Message: '',
                    };
                });
            }, 1500);
        });
    }

    _createElems() {
        this._msg = new bootstrap.Modal(this._l.$elems.Message, {
            backdrop: 'static',
            keyboard: false,
        });
        this._l.$elems.Message.addEventListener('hidden.bs.modal', (e) => {
            this.hideMessage();
        });
        this._confirmation = new bootstrap.Modal(this._l.$elems.Confirmation, {
            backdrop: 'static',
            keyboard: false,
        });
        this._l.$elems.Confirmation.addEventListener('hidden.bs.modal', (e) => {
            this.hideConfirmation();
        });

        // this._l.$elems.msg.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.hideMessage();
        // });

        this._l.$elems.Message.addEventListener('click', (evt) => {
            evt.preventDefault();

            if (evt.target !== this._l.$elems.Message)
                return;

            if (!this._msg_CloseOnBackgroundClick)
                return;

            this._msg_Result_ExtraButton = false;
            this._msg.hide();
        });

        this._l.$elems.Message_Close.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._msg_Result_ExtraButton = false;
            this._msg.hide();
        });
        this._l.$elems.Message_Confirm.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._msg_Result_ExtraButton = false;
            this._msg.hide();
        });
        this._l.$elems.Message_ExtraButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._msg_Result_ExtraButton = true;
            this._msg.hide();
        });

        this._l.$elems.Confirmation_Close.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._confirmation_Result = null;
            this._confirmation.hide();
        });
        
        this._l.$elems.Confirmation_Yes.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._confirmation_Result = true;
            this._confirmation.hide();
        });

        this._l.$elems.Confirmation_No.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._confirmation_Result = false;
            this._confirmation.hide();
        });
    }

}

/* JSLib Exports */
_jsLib.export("default", Messages); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-messages\languages\en.spk-messages.js
jsLibs.exportScript("spk-messages", "./languages/en.spk-messages", [ "default" ], (_jsLib) => { "use strict"; const lang_EN = {
    Close: 'Close',
}
/* export default */ lang_EN;

/* JSLib Exports */
_jsLib.export("default", lang_EN); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-messages\languages\pl.spk-messages.js
jsLibs.exportScript("spk-messages", "./languages/pl.spk-messages", [ "default" ], (_jsLib) => { "use strict"; const lang_PL = {
    Close: 'Zamknij',
};
/* export default */ lang_PL;

/* JSLib Exports */
_jsLib.export("default", lang_PL); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-messages\$layouts\index.js
jsLibs.exportScript("spk-messages", "./$layouts/index", [ "$layouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-messages", "./$layouts/Messages", [ { name: "default", alias: "Messages" } ], "./Messages.js");

/* export */ class $layouts_Class {
    get Messages() {
        return (_jsLib.import("spk-messages", "./$layouts/Messages", "default", "Messages", "./Messages.js"));
    }
}
const $layouts = new $layouts_Class();
/* export default */ $layouts

/* JSLib Exports */
_jsLib.export("$layouts_Class", $layouts_Class);
_jsLib.export("default", $layouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-messages\$layouts\Messages.js
jsLibs.exportScript("spk-messages", "./$layouts/Messages", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Messages extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_elem":["Message"],"class":["modal fade"],"tabindex":["-1"]},["div",{"class":["modal-dialog modal-choice modal-dialog-scrollable"]},["div",{"class":["modal-content"]},["div",{"class":["modal-header"]},["img",{"_show":["Message.Image"],"class":["modal-image"],"src":["$Message.Image"]}],["h5",{"_show":["Message.Title"],"class":["modal-title"]},"$Message.Title"],["button",{"_elem":["Message_Close"],"type":["button"],"class":["btn-close"],"aria-label":["Close"]}]],["div",{"_show":["Message.Text"],"class":["modal-body"]},["p",{"_field":["Message.Text"]}]],["div",{"class":["modal-footer"]},["div",{"class":["row"]},["div",{"_show":["Message.ExtraButton_Text"],"class":["col"]},["button",{"_elem":["Message_ExtraButton"],"type":["button"],"class":["btn ","$Message.ExtraButton_Class"," w-100 lh-sm"]},"$Message.ExtraButton_Text"]],["div",{"class":["col text-end"]},["button",{"_elem":["Message_Confirm"],"type":["button"],"class":["btn btn-primary w-100 h-100 "]},"$Text('Close')"]]]]]]],["div",{"_show":["Loading.Show"],"class":["loader-holder"]},["h3",{}],["div",{"class":["d-flex align-items-center"]},["div",{"class":["spinner-border me-3 text-primary"],"role":["status"],"aria-hidden":["true"]}],["strong",{},"$Loading.Text"]]],["div",{"_elem":["Confirmation"],"class":["modal fade"],"tabindex":["-1"]},["div",{"class":["modal-dialog modal-choice"]},["div",{"class":["modal-content"]},["div",{"class":["modal-header"]},["img",{"_show":["Confirmation.Image"],"class":["modal-image"],"src":["$Confirmation.Image"]}],["h5",{"_show":["Confirmation.Title"],"class":["modal-title"]},"$Confirmation.Title"],["button",{"_elem":["Confirmation_Close"],"type":["button"],"class":["btn-close"],"aria-label":["Close"]}]],["div",{"_show":["Confirmation.Text"],"class":["modal-body"]},["p",{"_field":["Confirmation.Text"]}]],["div",{"class":["modal-footer"]},["div",{"class":["row"]},["div",{"class":["col"]},["button",{"_elem":["Confirmation_Yes"],"type":["button"],"class":["btn btn-secondary w-100"]},["i",{"class":["fa fa-check pe-2"]}],"$Confirmation.Yes"]],["div",{"class":["col"]},["button",{"_elem":["Confirmation_No"],"type":["button"],"class":["btn btn-primary w-100"]},["i",{"class":["fa fa-times pe-2"]}],"$Confirmation.No"]]]]]]],["div",{"_elem":["Notification"],"class":["notification-holder"],"style":["display: none;"]},["div",{"class":["notification-bg bg-light"]},["i",{"class":["fas ","$Notification.FaIcon"]}],"  ","$Notification.Message"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Messages.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Messages); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\index.js
jsLibs.exportScript("spk-lemon-bee", "./index", [ "spkLemonBee_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-lemon-bee", "./presets", [ { name: "default", alias: "presets" } ], "./presets");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "./System");

/* export */ class spkLemonBee_Class {
    get System() {
        return (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "./System"));
    }
    
    get presets() {
        return (_jsLib.import("spk-lemon-bee", "./presets", "default", "presets", "./presets"));
    }


    constructor() {

    }
}
const spkLemonBee = new spkLemonBee_Class();
/* export default */ spkLemonBee;

/* JSLib Exports */
_jsLib.export("spkLemonBee_Class", spkLemonBee_Class);
_jsLib.export("default", spkLemonBee); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\presets.js
jsLibs.exportScript("spk-lemon-bee", "./presets", [ "presets_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

/* export */ class presets_Class {
    get logInResult() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset_Type, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            user: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                loggedIn: 'boolean',
                login: 'string',
                permissions: (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems('string'),
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            reload: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(false) ],
        });
    })}

    get logOutResult() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset_Type, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
        });
    })}

    get panel() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset_Type, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            permissions: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]), Array ],

            name: 'string',
            shortcut: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), ],
            
            menu: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                shortcut: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), ],
                uri: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
                action: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
            }),

            alias: 'string',
            title: 'string',
            faIcon: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
            image: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
            
            subpanels: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable(this.subpanel),
        });
    })}

    get subpanel() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset_Type, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            name: 'string',
            moduleFn: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            uri: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],

            permissions: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]), Array ],

            alias: 'string',
            title: 'string',
            faIcon: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), 'string' ],
            image: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), 'string' ],    

            shortcut: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), 'boolean' ],
        });
    })}

    constructor() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    '', () => {
        
    })}
}
const presets = new presets_Class();
/* export default */ presets;

/* JSLib Exports */
_jsLib.export("presets_Class", presets_Class);
_jsLib.export("default", presets); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\System.js
jsLibs.exportScript("spk-lemon-bee", "./System", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./index", [ { name: "default", alias: "abPager" } ], "ab-pager");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-messages", "./index", [ { name: "default", alias: "spkMessages" } ], "spk-messages");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

_jsLib.importDeclaration("spk-lemon-bee", "./presets", [ { name: "default", alias: "presets" } ], "./presets.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/index", [ { name: "default", alias: "modules" } ], "./modules/index.js");

_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");

/* export default */ class System
{

    get actions() {
        return this._actions;
    }

    get body() {
        return this._mBody;
    }

    get layouts() {
        return this._layouts;
    }

    get isLocked() {
        return this._locked;
    }

    get mainFn() {
        return this._mainFn;
    }

    get module() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._module;
    }

    get panels() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._panels;
    }

    get panels_Preset() {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("spk-lemon-bee", "./presets", "default", "presets", "./presets.js")).panel);
    }

    get setDefaultPageFn() {
        return this._setDefaultPageFn;
    }

    get uris() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._uris;
    }

    get user() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._user;
    }


    constructor(pager, msgs) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-pager", "./index", "default", "abPager", "ab-pager")).Pager, (_jsLib.import("spk-messages", "./index", "default", "spkMessages", "spk-messages")).Messages)

        this._initialized = false;
        this._locked = false;

        /* Presets */
        this._actions = null;
        this._aliases = null;
        this._dev = null;
        this._images = null;
        this._layouts = null;
        this._setDefaultPageFn = () => {
            this.pager.setPage('lb.main');
        };
        this._mainFn = null;
        this._settings = null;
        this._shows = null;
        this._title = null;
        this._textFn = null;
        this._uris = null;
        /* / Presets */

        this._user = {
            loggedIn: false,
            permissions: [],
            login: '',
        };
        /* / Presets */

        this._panels = new Map();
        this._module = new (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module();
        this._module_Layout = new (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout([
            [ 'div', { _holder: 'content', } ],
            [ 'div', { _holder: 'msgs', } ],
        ]);
        this._module.$view = this._module_Layout;
        
        this.pager = pager;
        this.msgs = msgs;

        this._mBody = null;

        this._listeners_AfterPage = [];
        this._listeners_BeforePage = [];
        this._listeners_OnBack = null;
    }

    addListener_AfterPage(listener) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_AfterPage.push(listener);
    }

    addListener_BeforePage(listener) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_BeforePage.push(listener);
    }

    call_OnBack() {
        if (this._locked)
            return true;

        if (this._listeners_OnBack === null)
            return false;

        if ((_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn('boolean', this._listeners_OnBack()))
            return true;

        return false;
    }

    clear() {
        this._mBody = null;
        // this.msgs.hide();
    }

    createLayout(layoutClass) {
        let l = new layoutClass();
        l.$fields.lb = this.getFields();

        return l;
    }

    getFields() {
        return {
            dev: this._dev,
            images: this._images,
            settings: this._settings,
            shows: this._shows,
            text: (text) => {
                return this.text(text);
            },
            uris: this._uris,
            user: this._user,
        };
    }

    getPanels() {
        let allowedPanels = [];
        for (let [ panelName, panel ] of this._panels) {
            let allowed = true;
            for (let permission of panel.permissions) {
                if (!this._user.permissions.includes(permission)) {
                    allowed = false;
                    break;
                }
            }

            if (!allowed)
                continue;
                
            allowedPanels.push(panel);
        }

        return allowedPanels;
    }

    lock() {
        this._locked = true;
    }

    logOut() {
        this.msgs.showLoading();
        this.actions.logOut_Async()
            .then((result) => {
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(result, (_jsLib.import("spk-lemon-bee", "./presets", "default", "presets", "./presets.js")).logOutResult);

                if (result.error !== null) {
                    this.msgs.showMessage_Failure(result.error);
                    this.msgs.hideLoading();

                    return;
                }

                this.setUser({
                    loggedIn: false,
                    login: '',
                    permissions: [],
                });

                this.msgs.hideLoading();

                this.pager.setPage('lb.logIn');
            })
            .catch((e) => {
                console.error(e.stack);
                this.msgs.showMessage_Failure(e.toString());
            });
    }

    setBackButton(hasBackButton) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        if (this._mBody === null)
            throw new Error('No active panel.');

        this._mBody.lMenu.$fields.HasBackButton = hasBackButton;
    }

    setListener_OnBack(listener) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_OnBack = listener;
    }

    setPanels(panels) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, this.panels_Preset);

        this._panels.clear();

        for (let panel of panels)
            this._addPanel(panel);

        this.setup_Pager();
    }

    setUser(user) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(user, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            loggedIn: 'boolean',                
            login: 'string',
            permissions: Array,
        }));

        this._user = user;
    }

    setup(presets) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(presets, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            actions: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                changePassword_Async: 'function',
                logIn_Async: 'function',
                logOut_Async: 'function',
                remindPassword_Async: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
                resetPassword_Async: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            }),
            aliases: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                account: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('account') ],
                main: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
                logIn: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('log-in') ],
                remindPassword: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('remind-password') ],
                resetPassword: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('reset-password') ],
            }),
            dev: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                email: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
                login: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
                password: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}), ],
            setDefaultPageFn: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            images: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                logo: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
                logo_Main: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null), ],
            }),
            layouts: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                'Account': [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Account), ],
                'Body': [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Body), ],
                'LogIn': [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).LogIn), ],
                'LogIn_Form': [ 'function', 
                        (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).LogIn_Form), ],
                'Main': [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Main), ],
                'RemindPassword': [ 'function', 
                        (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).RemindPassword), ],
                'ResetPassword': [ 'function', 
                        (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).ResetPassword), ],
                'TopMenu': [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).TopMenu), ],
                'UserInfo': [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-lemon-bee", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).UserInfo), ],
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}), ],  
            mainFn: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            panels: this.panels_Preset,
            shows: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                home: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), ],
                userInfo: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), ],
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}) ],
            textFn: 'function',
            title: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('LemonBee') ],
            uris: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                base: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
                package: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
                // api: [ 'string' ],
            }),
            
            settings: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                hasRemindPassword: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), 'boolean' ],
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default({}) ],
        }));

        this._actions = presets.actions;
        this._aliases = presets.aliases;
        this._dev = presets.dev;
        this._images = presets.images;
        this._layouts = presets.layouts;
        this._mainFn = presets.mainFn;
        this._settings = presets.settings;
        this._shows = presets.shows;
        this._textFn = presets.textFn;
        this._title = presets.title;
        this._uris = presets.uris;

        if (presets.setDefaultPageFn !== null)
            this._setDefaultPageFn = presets.setDefaultPageFn;

        if (this._images.logo === null)
            this._images.logo = `${this._uris.package}images/logo.png`;
        if (this._images.logo_Main === null)
            this._images.logo_Main = `${this._uris.package}images/logo_main.png`;
        for (let messageType in this._images.messages) {
            if (this._images.messages[messageType] === null) {
                let ext = messageType === 'loading' ? 'gif' : 'png';
                this._images.messages[messageType] = `${this._uris.package}images/messages/${messageType}.${ext}`;
            }
        }

        this._uris.base = this.pager.base + this._uris.base;
        if (this._uris.package === null)
            this._uris.package = this._uris.base + 'dev/node_modules/spk-lemon-bee/';
        this._uris.logOut = this._uris.base;

        this.setPanels(presets.panels);

        // this.msgs = spkMessages;
        
        // this._module_Layout.$holders.msgs.$view = this.msgs;
    }

    setup_Pager() {
        this.pager.page('lb.main', this._aliases.main, 
                (page, source, pageArgs) => {
            if (!this._user.loggedIn) {
                this.pager.setPage('lb.logIn', {}, {}, false);
                return;
            }

            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();
            this._setBodyModule(new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).Body(this));
            this._setPanelModule(new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).Main(this), this._title);

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        this._uris.main = this.pager.getPageUri('lb.main');

        this.pager.page('lb.logIn', this._aliases.logIn, 
                (page, source, pageArgs) => {
            if (this._user.loggedIn) {               
                // this.pager.setPage('lb.main');
                this._setDefaultPageFn();
                return;
            }

            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();

            this._module_Layout.$holders.content.$view = new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).LogIn(this);
            document.title = this._title + ' - ' + this.text('Titles_LogIn');

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });

        this.pager.page('lb.remindPassword', this._aliases.remindPassword, 
                (page, source, pageArgs) => {
            if (this._user.loggedIn) {               
                // this.pager.setPage('lb.main');
                this._setDefaultPageFn();
                return;
            }

            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();

            this._module_Layout.$holders.content.$view = 
                    new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).RemindPassword(this);
            document.title = this._title + ' - ' + 
                    this.text('Titles_RemindPassword');

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        this._uris.remindPassword = this.pager.getPageUri('lb.remindPassword');

        this.pager.page('lb.resetPassword', this._aliases.resetPassword + 
                '/:resetPasswordHash', (page, source, pageArgs) => {
             if (this._user.loggedIn) {               
                // this.pager.setPage('lb.main');
                this._setDefaultPageFn();
                return;
            }
    
            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();

            this._module_Layout.$holders.content.$view = 
                    new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).ResetPassword(this);
            document.title = this._title + ' - ' + 
                    this.text('Titles_ResetPassword');

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        
        this.pager.page('lb.account', this._aliases.account, 
                (page, source, pageArgs) => {
            if (!this._user.loggedIn) {
                this.pager.setPage('lb.logIn', {}, {}, false);
                return;
            }

            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();
            this._setBodyModule(new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).Body(this));
            this._setPanelModule(new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).Account(this), this._title + ' - ' +
                    this.text('Titles_Account'));

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        this._uris.account = this.pager.getPageUri('lb.account');

        for (let [ panelName, panel ] of this._panels) {
            if (panel.subpanels.size === 0)
                continue;

            this.pager.page(`lb.panels.${panel.name}`, panel.alias, 
                    (page, source, pageArgs) => {

                for (let listener of this._listeners_BeforePage)
                    listener(page, source, pageArgs);

                if (panel.subpanels.size === 0)
                    throw new Error(`No subpanels in panel '${panelName}'.`);

                let defaultSubpanel = panel.subpanels.values().next().value;

                this.clear();
                this.pager.setPage(
                        `lb.subpanels.${panel.name}.${defaultSubpanel.name}`, 
                        {}, {}, false);
                // window.location = `${this._uris.base}${panel.alias}/${defaultSubpanel.alias}`;

                // No AfterPage listeners if redirected.
                // for (let listener of this._listeners_AfterPage)
                //     listener(page, source, pageArgs);
            });

            for (let [ subpanelName, subpanel ] of panel.subpanels) {
                if (subpanel.module === null)
                    continue;

                this.pager.page(`lb.subpanels.${panel.name}.${subpanel.name}`, 
                        `${panel.alias}/${subpanel.alias}`, 
                        (page, source, pageArgs) => {
                    if (!this._user.loggedIn) {
                        this.pager.setPage('lb.logIn', {}, {}, false);
                        // window.location = this._uris.base + this._aliases.logIn;
                        return;
                    }

                    for (let listener of this._listeners_BeforePage)
                        listener(page, source, pageArgs);

                    this.clear();

                    this._setBodyModule(new (_jsLib.import("spk-lemon-bee", "./modules/index", "default", "modules", "./modules/index.js")).Body(this));
                    let module = subpanel.moduleFn(this, page, source, pageArgs);
                    if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(module, (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module)) {
                        throw new Error(`'moduleFn' of subpanel ` + 
                                `'${panel.name}.${subpanel.name}' does not return spocky.Module`);
                    }

                    this._setPanelModule(module, panel.title + ' - ' +
                            subpanel.title);

                    for (let listener of this._listeners_AfterPage)
                        listener(page, source, pageArgs);
                });
            }
        }
    }

    init() {
        this.pager.setListener_OnBeforePopState((uri) => {
            if (this._locked) {
                window.location = uri;
                return false;
            }

            return true;
        });

        window.onbeforeunload = (evt) => {
            if (this._locked)
                return true;

            return null;
        };

        this._initialized = true;
    }

    text(text) {
        return this._textFn(text);
    }

    unlock() {
        this._locked = false;
    }


    _addPanel(panel) {
        let pPanel = {};
        for (let pKey in panel) {
            if (pKey === 'subpanels') {
                pPanel.subpanels = new Map();
                for (let subpanel of panel.subpanels) {
                    let pSubpanel = {};
                    for (let sKey in subpanel)
                        pSubpanel[sKey] = subpanel[sKey];

                    if (panel.shortcut && subpanel.shortcut) {
                        if (pSubpanel.uri === null)
                            pSubpanel.uri = this.pager.parseUri(`${panel.alias}/${subpanel.alias}`);
                    } else
                        pSubpanel.uri = null;

                    pPanel.subpanels.set(subpanel.name, pSubpanel);
                }
            } else if (pKey === 'alias')
                pPanel[pKey] = panel[pKey];
            else
                pPanel[pKey] = panel[pKey];
        }
        pPanel.uri = this.pager.parseUri(panel.alias);

        this._panels.set(panel.name, pPanel);
    }

    _setBodyModule(module) {
        this._mBody = module;
    }

    _setPanelModule(module, title = null) {
        if (this._mBody === null)
            throw new Error('Body module not set.');

        this._mBody.setContent(module);

        document.title = title === null ? this._title : title;

        this._module_Layout.$holders.content.$view = this._mBody;
    }

}

/* JSLib Exports */
_jsLib.export("default", System); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Account.js
jsLibs.exportScript("spk-lemon-bee", "./modules/Account", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class Account extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    constructor(system) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")));

        this.system = system;

        this.l = system.createLayout(system.layouts.Account);        
        this.f = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.l, 'ChangePassword');        

        this.l.$elems.BackButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            system.pager.setPage('lb.main');
        });
        this.l.$fields.Uris.Main = system.pager.getPageUri('lb.main');
        this.l.$elems.changePassword.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.changePassword();
        });

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    checkNewPassword() {
        let fields = this.f.getValues();

        if (fields.NewPassword === '') {
            this.f.setValidator({
                valid: false,
                fields: {
                    NewPassword: {
                        valid: false,
                        errors: [ this.system.text('Errors_PasswordCannotBeEmpty') ],
                    },
                },
                state: '',
                errors: [],
            });
            return false;
        }

        if (fields.NewPassword !== fields.NewPassword_Confirmation) {
            this.f.setValidator({
                valid: false,
                fields: {
                    NewPassword_Confirmation: {
                        valid: false,
                        errors: [ this.system.text('Errors_PasswordsDoNotMatch') ],
                    },
                },
                state: '',
                errors: [],
            });
            return false;
        }

        return true;
    }

    changePassword() {
        this.message_Clear();

        if (!this.checkNewPassword())
            return;

        this.system.msgs.showLoading();
        let fValues = this.f.getValues();
        this.system.actions.changePassword_Async(fValues.Password, fValues.NewPassword)
            .then((result) => {
                if (result.success) {
                    this.message_SetSuccess(result.message);
                    this.f.setValues({
                        Password: '',
                        NewPassword: '',
                        NewPassword_Confirmation: '',
                    });
                } else
                    this.message_SetError(result.message);

                this.system.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);
            });
    }

    message_Clear() {
        this.l.$fields.message = null;
        this.l.$fields.messageType = 'dark';
    }

    message_SetError(message) {
        this.l.$fields.message = message;
        this.l.$fields.messageType = 'danger';
    }

    message_SetSuccess(message) {
        this.l.$fields.message = message;
        this.l.$fields.messageType = 'success';
    }

}

/* JSLib Exports */
_jsLib.export("default", Account); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Body.js
jsLibs.exportScript("spk-lemon-bee", "./modules/Body", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class Body extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {
    constructor(system) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")));

        this.lb = system;

        let l = system.createLayout(this.lb.layouts.Body);
        this.lMenu = this._getMenuLayout();
        this.lUserInfo = this._getUserInfoLayout();

        l.$elems.backToTop.addEventListener('click', (evt) => {
            evt.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "fast");
        });

        this.lUserInfo.$elems.logOut.addEventListener('click', (evt) => {
            evt.preventDefault();
            system.logOut();
        });

        l.$holders.topMenu.$view = this.lMenu;
        l.$holders.userInfo.$view = this.lUserInfo;

        this.layout = l;

        this.$view = l;
    }

    setContent(content) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout, (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module ]);

        this.layout.$holders.content.$view = content;
    }


    _getMenuLayout() {
        let l = this.lb.createLayout(this.lb.layouts.TopMenu);

        l.$fields.hasBackButton = false;

        let panels = this.lb.getPanels();

        l.$elems.menuItem_Home.addEventListener('click', (evt) => {
            evt.preventDefault();
            if (this.lb.isLocked)
                return;
            this.lb.pager.setPage('lb.main');
        });
        l.$elems.menuItems_Panel((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                let panel = panels[keys[0]];
                if (panel.menu.action !== null) {
                    $(l.$elems.Menu).collapse('hide');
                    panel.menu.action();
                } else {
                    if (this.lb.isLocked)
                        return;
                    this.lb.pager.setUri(l.$fields.menuItems(keys[0]).uri);
                }
            });
        });
        l.$elems.BackButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.lb.call_OnBack();
        });

        let items = new Map();
        for (let i = 0; i < panels.length; i++) {
            let panel = panels[i];
            if (!panel.menu.shortcut)
                continue;

            items.set(i, {
                uri: panel.menu.uri === null ?
                        `${this.lb.uris.base}${panel.alias}/` :
                        panel.menu.uri,
                title: panel.title,
                faIcon: panel.faIcon,
                image: panel.image,
            });
        }
        l.$fields.menuItems = items;

        /* User Info */
        l.$elems.LogOut.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.lb.logOut();
        });

        return l;
    }

    _getUserInfoLayout() {
        let l = this.lb.createLayout(this.lb.layouts.UserInfo);

        l.$fields.lb = this.lb.getFields();

        return l;
    }
}

/* JSLib Exports */
_jsLib.export("default", Body); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\index.js
jsLibs.exportScript("spk-lemon-bee", "./modules/index", [ "modules_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-lemon-bee", "./modules/Account", [ { name: "default", alias: "Account" } ], "./Account.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/Body", [ { name: "default", alias: "Body" } ], "./Body.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/LogIn", [ { name: "default", alias: "LogIn" } ], "./LogIn.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/Main", [ { name: "default", alias: "Main" } ], "./Main.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/Panel", [ { name: "default", alias: "Panel" } ], "./Panel.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/RemindPassword", [ { name: "default", alias: "RemindPassword" } ], "./RemindPassword.js");
_jsLib.importDeclaration("spk-lemon-bee", "./modules/ResetPassword", [ { name: "default", alias: "ResetPassword" } ], "./ResetPassword.js");

/* export */ class modules_Class {
    get Account() {
        return (_jsLib.import("spk-lemon-bee", "./modules/Account", "default", "Account", "./Account.js"));
    }

    get Body() {
        return (_jsLib.import("spk-lemon-bee", "./modules/Body", "default", "Body", "./Body.js"));
    }

    get LogIn() {
        return (_jsLib.import("spk-lemon-bee", "./modules/LogIn", "default", "LogIn", "./LogIn.js"));
    }

    get Main() {
        return (_jsLib.import("spk-lemon-bee", "./modules/Main", "default", "Main", "./Main.js"));
    }

    get Panel() {
        return (_jsLib.import("spk-lemon-bee", "./modules/Panel", "default", "Panel", "./Panel.js"));
    }

    get RemindPassword() {
        return (_jsLib.import("spk-lemon-bee", "./modules/RemindPassword", "default", "RemindPassword", "./RemindPassword.js"));
    }

    get ResetPassword() {
        return (_jsLib.import("spk-lemon-bee", "./modules/ResetPassword", "default", "ResetPassword", "./ResetPassword.js"));
    }


    constructor() {

    }
}
const modules = new modules_Class();
/* export default */ modules;


/* JSLib Exports */
_jsLib.export("modules_Class", modules_Class);
_jsLib.export("default", modules); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\LogIn.js
jsLibs.exportScript("spk-lemon-bee", "./modules/LogIn", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("spk-lemon-bee", "./presets", [ { name: "default", alias: "presets" } ], "../presets.js");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class LogIn extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    constructor(system) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")));

        this.lb = system;

        this.l = system.createLayout(this.lb.layouts.LogIn);
        this.lForm = system.createLayout(this.lb.layouts.LogIn_Form);

        this.lForm.$elems.Form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.logIn();
        });
        this.lForm.$elems.Login.addEventListener('change', (evt) => {
            this.clearError();
        });
        this.lForm.$elems.Password.addEventListener('change', (evt) => {
            this.clearError();
        });

        this.lForm.$elems.RemindPassword.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.lb.pager.setPage('lb.remindPassword');
        });

        this.l.$holders.form.$view = this.lForm;

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    clearError() {
        this.lForm.$fields.error = {
            show: false,
            message: ''
        };
    }

    logIn() {
        this.lb.msgs.showLoading();

        this.lb.actions.logIn_Async(this.lForm.$elems.Login.value,
                this.lForm.$elems.Password.value)
            .then((result) => {
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(result, (_jsLib.import("spk-lemon-bee", "./presets", "default", "presets", "../presets.js")).logInResult);

                let user = {
                    loggedIn: false,
                    login: '',
                    permissions: [],
                };
                if (result.user !== null) 
                    user = result.user;
                // if (result.error !== null) {
                //     this.lb.msgs.showMessage_Failure(result.error);
                //     return;
                // }

                if (user.loggedIn) {
                    this.lForm.$fields.error = {
                        show: false,
                        message: '',
                    };

                    if (result.reload) {
                        window.location.reload();
                        return;
                    } else {
                        this.lb.setUser(result.user);
                        this.lb.setDefaultPageFn();
                    }
                } else {
                    this.lForm.$fields.error = {
                        show: true,
                        message: result.error,
                    };
                }

                this.lb.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e.stack);
                this.lb.msgs.showMessage_Failure(this.lb.text('Errors_CannotLogIn'), 
                        e.toString());
                this.lb.msgs.hideLoading();
            });

        // abApi.json(`${this.lb.uris.api}log-in`, {
        //     Login: this.lForm.$elems.login.value,
        //     Password: this.lForm.$elems.password.value,
        //         }, (result) => {
        //     if (result.isSuccess())
        //         window.location = this.lb.uris.base;
        //     else if (result.isFailure()) {
        //         this.lForm.$fields.error = {
        //             show: true,
        //             message: this.lb.text('errors_LogInFailed'),
        //         };
        //         this.lb.msgs.hideLoading();
        //     } else {
        //         this.lForm.$fields.error = {
        //             show: true,
        //             message: this.lb.text('errors_LogInError'),
        //         };
        //         this.lb.msgs.hideLoading();
        //     }
        // });
    }

}

/* JSLib Exports */
_jsLib.export("default", LogIn); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Main.js
jsLibs.exportScript("spk-lemon-bee", "./modules/Main", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class Main extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module 
{

    constructor(system)  { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")));

        this.panels = system.getPanels();

        let l = system.createLayout(system.layouts.Main);        
        l.$fields.panels = this.panels;

        l.$elems.Buttons_Panel((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                system.pager.setUri(this.panels[keys[0]].uri);
            });
        });

        l.$elems.Buttons_Subpanel((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                system.pager.setUri(this.panels[keys[0]].subpanels.get(keys[1]).uri);
            });
        });

        system.msgs.hideLoading();

        if (system.mainFn !== null)
            system.mainFn(this);

        this.$view = l;
    }

}

/* JSLib Exports */
_jsLib.export("default", Main); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Panel.js
jsLibs.exportScript("spk-lemon-bee", "./modules/Panel", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class Panel extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    constructor(system, panel) { super();
        js0.args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")), 'object');

        let l = system.createLayout(system.layouts.Panel);
        l.$fields.panel = panel;

        this.$view = l;
    }

}

/* JSLib Exports */
_jsLib.export("default", Panel); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\RemindPassword.js
jsLibs.exportScript("spk-lemon-bee", "./modules/RemindPassword", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class RemindPassword extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    constructor(system) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")));

        this.lb = system;

        this.l = system.createLayout(this.lb.layouts.RemindPassword);
        
        this.l.$elems.Form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.remindPassword();
        });

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    clearError() {
        this.lForm.$fields.error = {
            show: false,
            message: ''
        };
    }

    remindPassword() {
        this.lb.msgs.showLoading();

        this.lb.actions.remindPassword_Async(this.l.$elems.Login.value)
            .then((result) => {
                if (result.success) {
                    this.l.$fields.messageType = 'success';
                    this.l.$fields.message = result.message;

                    this.l.$elems.Login.value = '';
                } else {
                    this.l.$fields.messageType = 'danger';
                    this.l.$fields.message = result.message;
                }

                this.lb.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e.stack);
                this.lb.msgs.showMessage_Failure(e.toString());
            });
    }

}

/* JSLib Exports */
_jsLib.export("default", RemindPassword); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\ResetPassword.js
jsLibs.exportScript("spk-lemon-bee", "./modules/ResetPassword", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("spk-lemon-bee", "./System", [ { name: "default", alias: "System" } ], "../System.js");

/* export default */ class ResetPassword extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module
{

    constructor(system) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./System", "default", "System", "../System.js")));

        this.lb = system;

        this.l = system.createLayout(this.lb.layouts.ResetPassword);
        
        this.l.$elems.Form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.resetPassword();
        });

        this.l.$elems.NewPassword.addEventListener('input', (evt) => {
            this.clearError();
        });
        this.l.$elems.NewPassword_Confirmation.addEventListener('input', 
                (evt) => {
            this.clearError();
        });

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    clearError() {
        this.l.$fields.messageType = 'primary';
        this.l.$fields.message = null;
    }

    resetPassword() {
        if (this.l.$elems.NewPassword.value === '') {
            this.l.$fields.messageType = 'danger';
            this.l.$fields.message = this.lb.text('Errors_PasswordCannotBeEmpty');

            return false;
        }

        if (this.l.$elems.NewPassword.value !== 
                this.l.$elems.NewPassword_Confirmation.value) {
            this.l.$fields.messageType = 'danger';
            this.l.$fields.message = this.lb.text('Errors_PasswordsDoNotMatch');

            return false;
        }

        let resetPasswordHash = this.lb.pager.current.args.resetPasswordHash;
        let newPassword = this.l.$elems.NewPassword.value;

        this.lb.msgs.showLoading();

        this.lb.actions.resetPassword_Async(resetPasswordHash, newPassword)
            .then((result) => {
                if (result.success) {
                    this.l.$fields.messageType = 'success';
                    this.l.$fields.message = result.message;

                    this.l.$elems.NewPassword.value = '';
                    this.l.$elems.NewPassword_Confirmation.value = '';

                    setTimeout(() => {
                        this.lb.pager.setPage('lb.logIn');
                    }, 3000);
                } else {
                    this.l.$fields.messageType = 'danger';
                    this.l.$fields.message = result.message;
                }

                this.lb.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e.stack);
                this.lb.msgs.showMessage_Failure(e.toString());
            });
    }

}

/* JSLib Exports */
_jsLib.export("default", ResetPassword); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\Account.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/Account", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Account extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["row"]},["div",{"class":["col"]},["h2",{},["a",{"_elem":["BackButton"],"href":["$Uris.Main"],"class":["btn btn-theme-light me-2"]},["i",{"class":["fa fa-chevron-left"]}]],"$lb.text('Titles_Account')"]]],["div",{"class":["card"]},["div",{"class":["card-body"]},["form",{},["div",{"class":["mb-2"]},["spk-form-field",{"form":["ChangePassword"],"name":["Password"],"type":["Input"],"input-type":["password"],"label":["$lb.text('Labels_Password')"],"placeholder":["$lb.text('Labels_Password')","..."]}]],["div",{"class":["mb-2"]},["spk-form-field",{"form":["ChangePassword"],"name":["NewPassword"],"type":["Input"],"input-type":["password"],"label":["$lb.text('Labels_NewPassword')"],"placeholder":["$lb.text('Labels_NewPassword')","..."]}]],["div",{"class":["mb-2"]},["spk-form-field",{"form":["ChangePassword"],"name":["NewPassword_Confirmation"],"type":["Input"],"input-type":["password"],"placeholder":["$lb.text('Labels_NewPassword_Confirmation')","..."]}]],["div",{"class":["mb-2"]},["div",{"_show":["message"],"class":["alert alert-","$messageType"]},"$message"]],["button",{"type":["submit"],"_elem":["changePassword"],"href":[""],"class":["btn btn-theme-primary w-100"]},"$lb.text('Buttons_Save')"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Account.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Account); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\index.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/index", [ "$layouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-lemon-bee", "./$layouts/Account", [ { name: "default", alias: "Account" } ], "./Account.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/Body", [ { name: "default", alias: "Body" } ], "./Body.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/LogIn", [ { name: "default", alias: "LogIn" } ], "./LogIn.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/LogIn_Form", [ { name: "default", alias: "LogIn_Form" } ], "./LogIn_Form.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/Main", [ { name: "default", alias: "Main" } ], "./Main.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/RemindPassword", [ { name: "default", alias: "RemindPassword" } ], "./RemindPassword.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/ResetPassword", [ { name: "default", alias: "ResetPassword" } ], "./ResetPassword.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/TopMenu", [ { name: "default", alias: "TopMenu" } ], "./TopMenu.js");
_jsLib.importDeclaration("spk-lemon-bee", "./$layouts/UserInfo", [ { name: "default", alias: "UserInfo" } ], "./UserInfo.js");

/* export */ class $layouts_Class {
    get Account() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/Account", "default", "Account", "./Account.js"));
    }
    get Body() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/Body", "default", "Body", "./Body.js"));
    }
    get LogIn() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/LogIn", "default", "LogIn", "./LogIn.js"));
    }
    get LogIn_Form() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/LogIn_Form", "default", "LogIn_Form", "./LogIn_Form.js"));
    }
    get Main() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/Main", "default", "Main", "./Main.js"));
    }
    get RemindPassword() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/RemindPassword", "default", "RemindPassword", "./RemindPassword.js"));
    }
    get ResetPassword() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/ResetPassword", "default", "ResetPassword", "./ResetPassword.js"));
    }
    get TopMenu() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/TopMenu", "default", "TopMenu", "./TopMenu.js"));
    }
    get UserInfo() {
        return (_jsLib.import("spk-lemon-bee", "./$layouts/UserInfo", "default", "UserInfo", "./UserInfo.js"));
    }
}
const $layouts = new $layouts_Class();
/* export default */ $layouts

/* JSLib Exports */
_jsLib.export("$layouts_Class", $layouts_Class);
_jsLib.export("default", $layouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\Body.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/Body", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Body extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["container-fluid min-vh-100"]},["div",{"class":["row"]},["div",{"class":["col-md-3 col-lg-2 lb-menu-holder"]},["$",{"_holder":["topMenu"]}]],["div",{"class":["offset-md-3 offset-lg-2 col-md-9 col-lg-10 min-vh-100 lb-content-holder"]},["div",{"class":["lb-top-bar"]},["$",{"_holder":["userInfo"]}]],["div",{"class":["lb-main-holder"]},["$",{"_holder":["content"]}],["div",{"class":["back-to-top"]},["a",{"_elem":["backToTop"],"class":["spScrollToTop btn btn-theme-light"],"href":[""]},["i",{"class":["fa fa-chevron-up"]}]]]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Body.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Body); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\LogIn.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/LogIn", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class LogIn extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-bg-holder fill lb-background-login"]}],["div",{"class":["lb-login-holder"]},["div",{"class":["col-xl-4 col-lg-6 col-10 lb-login"]},["div",{"class":["lb-login-content"]},["div",{"class":["lb-login-logo"]},["img",{"src":["${lb.images.logo}"]}]],["div",{"class":["lb-login-form"]},["$",{"_holder":["form"]}]]],["div",{"class":["lb-povered-by"]},"Powered by  ",["a",{"href":["https://allblue.pl"]},"AllBlue"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(LogIn.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", LogIn); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\LogIn_Form.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/LogIn_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class LogIn_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-login-info"]},["form",{"_elem":["Form"],"method":["post"],"role":["form"],"name":["form"],"id":["form"]},["input",{"_elem":["Login"],"placeholder":["$lb.text('LogIn_Login_Placeholder')"],"value":["$lb.dev.login"],"type":["text"],"required":[""],"class":["form-control"]}],["input",{"_elem":["Password"],"placeholder":["$lb.text('LogIn_Password_Placeholder')"],"value":["$lb.dev.password"],"type":["password"],"required":[""],"class":["form-control"]}],["div",{"_show":["error.show"],"class":["alert alert-danger alert-narrow text-break"]},["p",{},"$error.message"]],["button",{"type":["submit"],"class":["btn btn-theme-primary w-100"]},"$lb.text('LogIn_LogIn')"],["a",{"_elem":["RemindPassword"],"_show":["lb.settings.hasRemindPassword"],"href":["$lb.uris.remindPassword"]},"$lb.text('RemindPassword')"]],["div",{"_holder":["notifications"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(LogIn_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", LogIn_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\Main.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/Main", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Main extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-menu-tiles row"]},["div",{"_repeat":["panels:panel"],"_show":["panel.shortcut"],"class":["col-xxl-3 col-xl-4 col-sm-6 ","$class"]},["div",{"class":["card"]},["a",{"_elem":["Buttons_Panel"],"class":["btn btn-theme-primary lb-tile-main w-100"],"href":["${lb.uris.base}","${panel.alias}","/"]},["$",{"_show":["panel.image"]},["img",{"src":["$panel.image"],"alt":["$panel.title"]}]],["div",{"class":[""]},"$panel.title"]],["div",{"class":["card-body"]},["div",{"class":["row g-2"]},["div",{"_repeat":["panel.subpanels:subpanel"],"_show":["subpanel.shortcut"],"class":["col"]},["a",{"_elem":["Buttons_Subpanel"],"href":["$subpanel.uri"],"class":["btn btn-theme-light w-100"]},["i",{"class":["fa ","$subpanel.faIcon"," pe-2"]}],"$subpanel.title"]]]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Main.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Main); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\RemindPassword.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/RemindPassword", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class RemindPassword extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-bg-holder fill lb-background-login"]}],["div",{"class":["lb-login-holder"]},["div",{"class":["col-xl-4 col-sm-8 lb-login"]},["div",{"class":["lb-login-content"]},["div",{"class":["lb-login-logo"]},["img",{"src":["${lb.images.logo}"]}]],["div",{"class":["lb-login-form"]},["div",{"class":["login-info"]},["form",{"_elem":["Form"],"method":["POST"],"role":["form"],"name":["Form"]},["input",{"_elem":["Login"],"placeholder":["$lb.text('RemindPassword_RemindPassword_Placeholder')"],"value":["$lb.dev.email"],"type":["text"],"required":[""],"class":["form-control mb-3"]}],["div",{"_show":["message"],"class":["mb-2"]},["div",{"class":["alert alert-","$messageType"]},"$message"]],["button",{"type":["submit"],"class":["btn btn-theme-primary w-100"]},"$lb.text('RemindPassword_RemindPassword')"]],["div",{"_holder":["notifications"]}]]]],["div",{"class":["lb-povered-by"]},"Powered by  ",["a",{"href":["https://allblue.pl"]},"AllBlue"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(RemindPassword.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", RemindPassword); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\ResetPassword.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/ResetPassword", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class ResetPassword extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-bg-holder fill lb-background-login"]}],["div",{"class":["lb-login-holder"]},["div",{"class":["col-xl-4 col-sm-8 lb-login"]},["div",{"class":["lb-login-content"]},["div",{"class":["lb-login-logo"]},["img",{"src":["${lb.images.logo}"]}]],["div",{"class":["lb-login-form"]},["div",{"class":["login-info"]},["form",{"_elem":["Form"],"method":["POST"],"role":["form"],"name":["Form"]},["input",{"_elem":["NewPassword"],"placeholder":["$lb.text('NewPassword_Placeholder')"],"value":["$lb.dev.password"],"type":["password"],"required":[""],"class":["form-control mb-3"]}],["input",{"_elem":["NewPassword_Confirmation"],"placeholder":["$lb.text('NewPassword_Confirmation_Placeholder')"],"value":["$lb.dev.password"],"type":["password"],"required":[""],"class":["form-control mb-3"]}],["div",{"_show":["message"],"class":["mb-2"]},["div",{"class":["alert alert-","$messageType"]},"$message"]],["button",{"type":["submit"],"_elem":["changePassword"],"href":[""],"class":["btn btn-theme-primary w-100"]},"$lb.text('Buttons_Save')"]],["div",{"_holder":["notifications"]}]]]],["div",{"class":["lb-povered-by"]},"Powered by  ",["a",{"href":["https://allblue.pl"]},"AllBlue"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(ResetPassword.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", ResetPassword); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\TopMenu.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/TopMenu", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class TopMenu extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-logo"]},["a",{"href":["$lb.uris.base"]},["img",{"src":["$lb.images.logo_Main"],"alt":["logo"]}]]],["div",{"class":["lb-menu-main"]},["nav",{"class":["navbar navbar-expand-md navbar-light"]},["button",{"_show":["HasBackButton"],"_elem":["BackButton"],"class":["navbar-toggler lb-navbar-back"]},["i",{"class":["fas fa-arrow-left"]}," "]],["button",{"_hide":["HasBackButton"],"class":["navbar-toggler"],"type":["button"],"data-bs-toggle":["collapse"],"data-bs-target":["#collapsibleNavbar"]},["span",{"class":["navbar-toggler-icon"]}]],["div",{"_elem":["Menu"],"class":["collapse navbar-collapse"],"id":["collapsibleNavbar"]},["ul",{"class":["navbar-nav clearfix"]},["li",{"_show":["lb.shows.home"],"class":["nav-item"]},["a",{"_elem":["menuItem_Home"],"class":["nav-link"],"href":["$lb.uris.base"]},["i",{"class":["fa fa-home"],"aria-hidden":["true"]}]," ","$lb.text('Titles_Home')"]],["li",{"_repeat":["menuItems:item"],"class":["nav-item ","$item.activeClass"]},["a",{"_elem":["menuItems_Panel"],"class":["nav-link"],"href":["$item.uri"]},["$",{"_show":["item.faIcon"]},["i",{"class":["$item.faIcon"]}]," "],["$",{"_show":["item.image"]},["i",{"class":["$item.image"]}]," "],"$item.title"]]],["div",{"_show":["lb.shows.userInfo"],"class":["lb-user-info-sm d-md-none"]},["i",{"class":["fa fa-user pe-2"],"aria-hidden":["true"]}],["a",{"class":["w-100"],"href":["$lb.uris.account"]},"$lb.user.login"],["a",{"_elem":["LogOut"],"href":["$lb.uris.logOut"],"class":["btn btn-theme-light btn-sm w-100 mt-2"]},"$lb.text('UserInfo_LogOut')"]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(TopMenu.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", TopMenu); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\UserInfo.js
jsLibs.exportScript("spk-lemon-bee", "./$layouts/UserInfo", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class UserInfo extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_show":["lb.shows.userInfo"],"class":["lb-user-info"]},["i",{"class":["fa fa-user pe-2"],"aria-hidden":["true"]}],["a",{"href":["$lb.uris.account"]},"$lb.user.login"],["a",{"_elem":["logOut"],"href":["$lb.uris.logOut"],"class":["btn btn-theme-light btn-sm ms-3"]},"$lb.text('UserInfo_LogOut')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(UserInfo.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", UserInfo); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\index.js
jsLibs.exportScript("spk-tables", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [  ], "js0");
_jsLib.importDeclaration("spk-messages", "./index", [  ], "spk-messages");
_jsLib.importDeclaration("spocky", "./index", [  ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");

_jsLib.importDeclaration("spk-tables", "./$layouts/index", [  ], "./$layouts/index.js");
_jsLib.importDeclaration("spk-tables", "./presets", [ { name: "default", alias: "presets" } ], "./presets.js");
_jsLib.importDeclaration("spk-tables", "./Table", [ { name: "default", alias: "Table" } ], "./Table.js");
_jsLib.importDeclaration("spk-tables", "./languages/en.spkTables", [ { name: "default", alias: "lang_EN" } ], "./languages/en.spkTables.js");
_jsLib.importDeclaration("spk-tables", "./languages/pl.spkTables", [ { name: "default", alias: "lang_PL" } ], "./languages/pl.spkTables.js");

class spkTables_Class {

    get presets() {
        return (_jsLib.import("spk-tables", "./presets", "default", "presets", "./presets.js"));
    }

    get Table() {
        return (_jsLib.import("spk-tables", "./Table", "default", "Table", "./Table.js"));
    }


    constructor()
    {
        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).add('en.spkTables', (_jsLib.import("spk-tables", "./languages/en.spkTables", "default", "lang_EN", "./languages/en.spkTables.js")));
        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).add('pl.spkTables', (_jsLib.import("spk-tables", "./languages/pl.spkTables", "default", "lang_PL", "./languages/pl.spkTables.js")));
    }

}
const spkTables = new spkTables_Class();
/* export default */ spkTables;

/* JSLib Exports */
_jsLib.export("default", spkTables); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\presets.js
jsLibs.exportScript("spk-tables", "./presets", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-tables", "./Table", [ { name: "default", alias: "Table" } ], "./Table.js");

class presets_Class {
    get apiTableArgs() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TPreset, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            table: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                filter: 'string',
                orderColumnName: 'string',
                orderColumnDesc: 'boolean',
                offset: [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).TNull ],
                limit: [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            }),
            custom: (_jsLib.import("js0", "./index", "default", "js0", "js0")).TRawObject,
        });
    })}

    get apiTableInfo() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TPreset, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            columns: this.tableInfo_Columns,
        });
    })}

    get tableInfo() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TPreset, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            columns: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable(this.tableInfo_Column),
            apiUri: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            fn: [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            orderBy: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                columnName: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                reverse: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(false) ],
            }),
            hiddenColumnNames: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable('string'), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
            showInstantLoading: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(false) ],
        });
    })}

    get tableInfo_Column() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TPreset, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            name: 'string',
            refColumnName: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, 'symbol', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default((_jsLib.import("spk-tables", "./Table", "default", "Table", "./Table.js")).NotSet) ],
            header: 'string',
            class: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
            style: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
            textStyle: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default('') ],
            orderBy: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                priority: [ 'number', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(0) ],
                reverse: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(false) ],
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(null) ],
            filter: [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default(true), ],
        });
    })}

    get tableInfo_Columns() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TArrayItems, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems(this.tableInfo_Column);
    })}

    get tableRow() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TArgType, () => {
        return Array;
    })}

    get tableRows() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TArrayItems, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems(this.tableRow);
    })}

    get refreshResult() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).TPreset, () => {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            data: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                table: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).ArrayItems(Array), (_jsLib.import("js0", "./index", "default", "js0", "js0")).TNull, ],
            }, true), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
        });
    })}

    constructor() { return (_jsLib.import("js0", "./index", "default", "js0", "js0")).fn(arguments,
    '', () => {
        
    })}
}
const presets = new presets_Class();
/* export default */ presets;

/* JSLib Exports */
_jsLib.export("default", presets); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\Table.js
jsLibs.exportScript("spk-tables", "./Table", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [ { name: "default", alias: "abStrings" } ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-messages", "./index", [ { name: "default", alias: "spkMessages" } ], "spk-messages");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("..js", "./index", [  ], "..js");
_jsLib.importDeclaration("spk-tables", "./presets", [ { name: "default", alias: "presets" } ], "./presets.js");
_jsLib.importDeclaration("spk-tables", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");

/* export default */ class Table extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {
    get columnRefs() {
        return this._columnRefs;
    }

    get isSelectable() {
        return this._selectable;
    }

    get layout() {
        return this.l;
    }

    constructor(msgs, tableInfo) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-messages", "./index", "default", "spkMessages", "spk-messages")).Messages, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);

        tableInfo = (_jsLib.import("js0", "./index", "default", "js0", "js0")).copyRawObject(tableInfo);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(tableInfo, (_jsLib.import("spk-tables", "./presets", "default", "presets", "./presets.js")).tableInfo);

        for (let column of tableInfo.columns) {
            if (column.refColumnName === Table.NotSet)
                column.refColumnName = column.name;
        }

        this.msgs = msgs;

        this._info = tableInfo;

        this._columnNames = [];
        this._columnRefs = {};
        this._columnsOrder = [];

        this._dynamic = false;

        this._rows = [];
        this._rows_Current = [];
        this._rows_Fields = [];
        this._rows_Fields_Index = 0;

        this._rows_RefreshQueueCount = 0;

        this._noSort = false;
        this._selectable = false;
        this._selectable_ShowSelectAll = true;
        this._selectable_SelectedOnTop = false;
        this._sortable = true;

        this._filter = {
            value: '',
            current: '',
            timeoutId: null
        };
        this._limit = {
            start: 50,
            current: 50,
            step: 100,
        };
        this._rowsFilterFn = null;

        this._fns_ApiFields = null;
        this._fns_CustomFilterFns = {};
        this._fns_RowHref = null;

        this._listeners_OnApiResult = null;
        this._listeners_OnClick = null;
        this._listeners_OnColumnButtonClick = null;
        this._listeners_OnRefresh = null;
        this._listeners_OnRowSelected = null;
        this._listeners_OnSearch = null;
        this._listeners_OnSort = null;

        this.l = new (_jsLib.import("spk-tables", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Table();

        /* Why is it needed? */
        // this.l.$onDisplay((active) => {
            // if (active) {
            //     if (this._rows_Fields.length > 0)
            //         this._rows_UpdateFields(this._rows_Fields, true);
            // } else {
            //     this._rows_Fields_Index++;
            //     this.l.$fields.table.rows = [];
            // }
        // });

        this._createFields();
        this._createElems();
        this._parseInfo();

        this.$view = this.l;
    }

    addCustomFilter(filterName, filterFieldsFn) {
        if (filterName in this._fns_CustomFilterFns)
            throw new Error(`Filter '${filterName}' already exists.`);

        this._fns_CustomFilterFns[filterName] = filterFieldsFn;
        return this;
    }

    addHiddenColumns(hiddenColumnNames) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array);

        hiddenColumnNames = this._info.hiddenColumnNames.concat(hiddenColumnNames);        
        this.setHiddenColumns(hiddenColumnNames);
    }

    getSelectedRows() {
        let rows_Selected = [];
        for (let row of this._rows_Current) {
            if (row.selected) {
                let row_Selected = {};
                for (let i = 0; i < row.cols.length; i++)
                    row_Selected[this._columnNames[i]] = row.cols[i].value;

                rows_Selected.push(row_Selected);
            }
        }

        return rows_Selected;
    }

    getTableArgs() {
        let tableArgs = {};

        tableArgs.table = {
            filter: this._filter.value.substring(0, Math.min(
                    this._filter.value.length, 128)),
            orderColumnName: this._info.orderBy.columnName,
            orderColumnDesc: this._info.orderBy.reverse,
            offset: null,
            limit: null,
        };

        tableArgs.custom = this._getCustomFilterInfos();

        return tableArgs;
    }

    getTableInfo() {
        return {
            columns: this._info.columns,
        };
    }

    refresh() {
        this._limit.current = this._limit.start;        

        this._rows_Refresh(false);
    }

    refreshRow(index) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');

        this._rows_Fields[index] = this._rows_UpdateFields_ParseRow(
            this._rows_Current[index]);
        this.l.$fields.table.rows(index, this._rows_Fields[index]);
    }

    refreshAllRows() {
        if (!this._noSort)
            this._rows = this._rows_Sort(this._rows);
        else
            this._rows = this._rows_NoSort(this._rows);

        this._rows_Current = this._rows_Filter(this._rows);
        this._rows_Update_Async(this._rows_Current)
            .then(() => {
                this.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), 
                        e.toString());
                this.msgs.hideLoading();
            });
    }

    removeHiddenColumns(hiddenColumnNames) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array);

        hiddenColumnNames = this._info.hiddenColumnNames.filter((el) => {
            return hiddenColumnNames.indexOf(el) < 0;
        });
        this.setHiddenColumns(hiddenColumnNames);
    }

    setApiFields(apiFieldsFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._fns_ApiFields = apiFieldsFn;

        return this;
    }

    setDynamic(dynamic) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._dynamic = dynamic;

        return this;
    }

    setFilterText(filterValue) {
        this.l.$elems.filter.value = filterValue;
        this._filter.value = filterValue;
    }

    setHiddenColumns(hiddenColumnNames) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable('string'));

        for (let colName of hiddenColumnNames) {
            if (!this._columnNames.includes(colName))
                throw new Error(`Column '${colName}' does not exist in table.`);
        }

        this._info.hiddenColumnNames = hiddenColumnNames;

        for (let i = 0; i < this._columnNames.length; i++) {
            this.l.$fields.table.headers(i).show = 
                    !hiddenColumnNames.includes(this._columnNames[i]);
        }

        for (let i = 0; i < this._rows.length; i++) {
            for (let j = 0; j < this._columnNames.length; j++) {
                this.l.$fields.table.rows(i).cols(j).show = 
                        !hiddenColumnNames.includes(this._columnNames[j]);
            }
        }

        return this;
    }

    setLimit(start, step) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'number', 'number');

        this._limit = {
            start: start,
            current: start,
            step: step,
        };

        return this;
    }

    setNoSort(noSort) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._noSort = noSort;

        return this;
    }

    setOnApiResult(onApiResultFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_OnApiResult = onApiResultFn;

        return this;
    }    

    setOnColumnButtonClick(onColumnButtonClickFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_OnColumnButtonClick = onColumnButtonClickFn;
    }

    setOnRefresh(onRefreshFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_OnRefresh = onRefreshFn;

        return this;
    }

    setOnRowSelected(onRowSelectedFn) {
        this._listeners_OnRowSelected = onRowSelectedFn;

        return this;
    }

    setOnSearch(onSearchFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_OnSearch = onSearchFn;

        return this;
    }

    setOnSort(onSortFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        this._listeners_OnSort = onSortFn;

        return this;
    }

    // setOnRefreshRow(onRefreshRowFn)
    // {
    //     js0.args(arguments, 'function');

    //     this._listeners_OnRefreshRow = onRefreshRowFn;

    //     return this;
    // }

    setOnRowClick(onClickFn, rowHrefFn = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ], [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this._listeners_OnClick = onClickFn;        
        this._fns_RowHref = rowHrefFn;

        for (let i = 0; i < this._rows_Current.length; i++) {
            this.l.$fields.rows(i).href = rowHrefFn === null ? 
                    '' : rowHrefFn(this._rows_Current[i], this._columnRefs);
        }

        return this;
    }

    setOrderBy(columnName, reverse = false) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        this._info.orderBy.columnName = columnName
        this._info.orderBy.reverse = reverse;

        return this;
    }

    setRowsFilter(rowsFilterFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'function', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        this._rowsFilterFn = rowsFilterFn;

        return this;
    }

    setSelectable(selectable) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._selectable = selectable;
        this.l.$fields.table.selectable = selectable;

        return this;
    }

    setSelectable_SelectedOnTop(selectedOnTop) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._selectable_SelectedOnTop = selectedOnTop;

        return this;
    }

    setSelectable_ShowSelectAll(showSelectAll) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');

        this._selectable_ShowSelectAll = showSelectAll;
        this.l.$fields.table.selectable_ShowSelectAll = this._selectable && 
                showSelectAll;

        return this;
    }

    setShowSearch(showSearch) {
        this.l.$fields.table.showSearch = showSearch;

        return this;
    }
    setSortable(sortable) {
        this._sortable = sortable;

        return this;
    }

    setTitle(title) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ]);

        this.l.$fields.Title = title;

        return this;
    }

    update(tableData = (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet) {
        this.msgs.showLoading('', this._info.showInstantLoading);

        if (tableData === (_jsLib.import("js0", "./index", "default", "js0", "js0")).NotSet) {
            tableData = [];
            for (let row of this._rows) {
                let tableData_Col = [];
                for (let col of row.cols)
                    tableData_Col.push(col.value);
                tableData.push(tableData_Col);
            }
        }

        let rows = this._parseResultRows(tableData);

        if (this._noSort) {
            this._info.orderBy.columnName = null;
            this._rows = this._rows_NoSort(rows);
        } else
            this._rows = this._rows_Sort(rows);

        this._rows_Current = this._rows_Filter(this._rows);
        this._rows_Update_Async(this._rows_Current)
            .then(() => {
                this.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), 
                        e.toString());
                this.msgs.hideLoading();
            });
    }


    _createElems() {
        this._createElems_ColumnButtons();
        this._createElems_Filter();
        this._createElems_Header();
        this._createElems_LoadMore();
        this._createElems_Rows();
        this._createElems_Selectable();
        this._createElems_ColumnLayouts();
    }

    _createElems_ColumnButtons() {
        this.l.$elems.columnButton((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.stopPropagation();
                evt.preventDefault();

                let row = this._rows_Current[keys[0]];
                let col = row.cols[keys[1]];

                if (this._listeners_OnColumnButtonClick !== null) {
                    this._listeners_OnColumnButtonClick(row, col, 
                        keys[0], keys[1], this.columnRefs);
                }
            });
        });
    }

    _createElems_Filter() {
        let updateFilter = (evt) => {
            let filterValue = this.l.$elems.filter.value;
            if (this._listeners_OnSearch !== null)
                filterValue = this._listeners_OnSearch(filterValue);

            this._filter.value = filterValue;

            /* Cancel timeout if filter changed. */
            if (this._filter.timeoutId !== null) {
                this.msgs.hideLoading();
                clearTimeout(this._filter.timeoutId);
            }

            this._filter.timeoutId = setTimeout(() => {
                this.msgs.showLoading('', this._info.showInstantLoading);

                if (this._filter.current === this._filter.value) {
                    this.msgs.hideLoading();
                    return;
                }

                this._limit.current = this._limit.start;

                this._filter.current = this._filter.value;

                if (this._dynamic)
                    this._rows_Refresh(false);
                else {
                    this._rows_Current = this._rows_Filter(this._rows);
                    this._rows_Update_Async(this._rows_Current)
                        .then(() => {
                            this._filter.timeoutId = null;
                            this.msgs.hideLoading();
                        })
                        .catch((e) => {
                            console.error(e);

                            this.msgs.showMessage_Failure(
                                    (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), e.toString());
                            this.msgs.hideLoading();
                            console.error(e);
                        });
                }
            }, 300);
        };

        this.l.$elems.filter.addEventListener('change', updateFilter);
        this.l.$elems.filter.addEventListener('keyup', updateFilter);
        this.l.$elems.filter.addEventListener('keydown', (evt) => {
            if (evt.keyCode === 13)
                evt.preventDefault();
        });
    }

    _createElems_Header() {
        this.l.$elems.header((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                if (!this._sortable)
                    return;


                let columnName = this._columnNames[keys[0]];
                if (this._info.orderBy.columnName === columnName)
                    this._info.orderBy.reverse = !this._info.orderBy.reverse
                else {
                    this._info.orderBy.columnName = columnName
                    this._info.orderBy.reverse = false;
                }

                this._limit.current = this._limit.start;

                if (this._dynamic)
                    this._rows_Refresh(false);
                else {
                    this._rows = this._rows_Sort(this._rows);
                    this._rows_Current = this._rows_Filter(this._rows);

                    this.msgs.showLoading('', this._info.showInstantLoading);
                    this._rows_Update_Async(this._rows_Current)
                        .then(() => {
                            this.msgs.hideLoading();
                        })
                        .catch((e) => {
                            console.error(e);

                            this.msgs.showMessage_Failure(
                                    (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), e.toString());
                            this.msgs.hideLoading();
                        });
                }
            });
        })
    }

    _createElems_ColumnLayouts() {
        this.l.$holders.colLayout((holder, keys) => {
            let row = this._rows_Current[keys[0]];
            let col = row.cols[keys[1]];

            if (col.layout !== null) {
                holder.$view = col.layout;
            }
        });
    }

    _createElems_LoadMore() {
        this.l.$elems.loadMore.addEventListener('click', (evt) => {
            evt.preventDefault();

            this._limit.current += this._limit.step;

            if (this._dynamic)
                this._rows_Refresh(true, false);
            else {
                this.msgs.showLoading('', this._info.showInstantLoading);
                this._rows_Update_Async(this._rows_Current, false)
                    .then(() => {
                        this.msgs.hideLoading();
                    })
                    .catch((e) => {
                        console.error(e);

                        this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), 
                                e.toString());
                        this.msgs.hideLoading();
                    });

            }
        });
    }

    _createElems_Rows() {
        this.l.$elems.row((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                if (this._listeners_OnClick === null)
                    return;

                evt.preventDefault();

                this._listeners_OnClick(this._rows_Current[keys[0]], 
                        this.columnRefs, keys[0]);
            })
        });
    }

    _createElems_Selectable() {
        let selectAll = (val) => {
            if (!this._selectable_ShowSelectAll)
                return;

            this.l.$elems.selectable_TableCheckbox.checked = val;

            for (let i = 0; i < this.l.$fields.table.rows().$size; i++) {
                this._rows_Current[i].selected = val;
                this.l.$fields.table.rows(i).selected = val;
            }
        }

        this.l.$elems.selectable_TableCheckbox.addEventListener('click', (evt) => {
            evt.stopPropagation();

            selectAll(evt.target.checked);
        });

        this.l.$elems.selectable_TableCheckboxHolder.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            selectAll(!this.l.$elems.selectable_TableCheckbox.checked);            
        });

        this.l.$elems.selectable_RowCheckboxHolder((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                evt.stopPropagation();

                let val = !this.l.$fields.table.rows(keys[0]).selected;
                let row = this._rows_Current[keys[0]];

                if (this._listeners_OnRowSelected) {
                    if (!this._listeners_OnRowSelected(val, row, this.columnRefs, 
                            keys[0]))
                        return;
                }

                row.selected = val;
                this.l.$fields.table.rows(keys[0]).selected = val;
                        
                if (!val)
                    this.l.$elems.selectable_TableCheckbox.checked = false;

                if (this._selectable_SelectedOnTop)
                    this.refreshAllRows();
            });
        });
    }

    _createFields() {
        this.l.$fields.table.selectable_ShowSelectAll = this._selectable_ShowSelectAll;
        this.l.$fields.table.trClass = '';
        this.l.$fields.text = (text) => {
            return (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.' + text);
        }
    }

    _getCustomFilterInfos() {
        let filterInfos = {};
        for (var filterName in this._fns_CustomFilterFns)
            filterInfos[filterName] = this._fns_CustomFilterFns[filterName]();

        return filterInfos;
    }

    _getFields(update = false) {
        /* Fields */
        let fields = {};

        let tableArgs = this.getTableArgs();
        if (this._dynamic) {
            tableArgs.table.offset = update ? this._rows_Current.length : 0;
            tableArgs.table.limit = this._limit.current - (update ? this._rows_Current.length : 0);
        }

        fields.tableInfo = this.getTableInfo();
        fields.tableArgs = tableArgs;

        if (this._fns_ApiFields !== null) {
            let apiFields = this._fns_ApiFields();
            for (let fieldName in apiFields)
                fields[fieldName] = apiFields[fieldName];
        }

        return fields;
    }

    _parseInfo() {
        this._columnNames = this._info.columns.map((item) => { return item.name });
        this._columnRefs = {};
        for (let i = 0; i < this._columnNames.length; i++)
            this._columnRefs[this._columnNames[i]] = i;

        this._columnsOrder = [];
        for (let col of this._info.columns) {
            let orderByInfo = col.orderBy;
            if (orderByInfo === null)
                continue;

            this._columnsOrder.push({
                colRef: this._columnRefs[col.name],
                priority: orderByInfo.priority,
                reverse: orderByInfo.reverse,
            });
        }
        this._columnsOrder.sort((a, b) => {
            return b.priority - a.priority;
        });

        /* Table Fields */
        for (let col of this._info.columns) {
            this.l.$fields.table.headers().$push({
                title: col.header,
                show: !this._info.hiddenColumnNames.includes(col.name),
                caretDown: false,
                caretUp: false,
                class: col.class,
                style: col.style,
                textStyle: col.textStyle,
            });
        }
    }

    _parseResultRows(resultRows) {
        let rows = [];
        for (let i = 0; i < resultRows.length; i++) {
            let cols = [];
            for (let j = 0; j < resultRows[i].length; j++) {
                cols.push({
                    class: '',
                    show: !this._info.hiddenColumnNames.includes(this._columnNames[j]),
                    value: resultRows[i][j],
                    html: resultRows[i][j],
                    button: {
                        show: false,
                        btnClass: '',
                        iClass: '',
                        text: '',
                    },
                    layout: null,
                });
            }

            let row = {
                order: i,
                href: null,
                class: '',
                cols: cols,
                style: this._listeners_OnClick === null ? '' : 'cursor: pointer;',
                selected: false,
            };

            row.href = this._fns_RowHref === null ? null : this._fns_RowHref(row, 
                    this._columnRefs);

            rows.push(row);
        }

        if (this._listeners_OnRefresh !== null)
            this._listeners_OnRefresh(rows, this._columnRefs);

        return rows;
    }

    _rows_Filter(rows) {
        if (this._rowsFilterFn !== null) {
            rows = this._rowsFilterFn(rows, this.columnRefs);
            if (!(_jsLib.import("js0", "./index", "default", "js0", "js0")).type(rows, Array)) {
                throw new Error(`'RowsFilterFn' must return an array.`);
            }
        }

        if (this._dynamic)
            return rows;

        if (this._filter.value === '')
            return rows;

        let filterString = (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).escapeRegExpChars(
                this._rows_Filter_FormatString(this._filter.value));

        let regexp = new RegExp('.*' + filterString + '.*');

        let fRows = [];
        for (let i = 0; i < rows.length; i++) {
            if (this._selectable_SelectedOnTop) {
                if (rows[i].selected) {
                    fRows.push(rows[i]);
                    continue;
                }
            }

            for (let j = 0; j < rows[i].cols.length; j++) {
                if (!this._info.columns[j].filter)
                    continue;

                let colString = this._rows_Filter_FormatString(
                        String(rows[i].cols[j].value));

                if (colString.match(regexp)) {
                    fRows.push(rows[i]);
                    break;
                }
            }
        }

        return fRows;
    }

    _rows_Filter_FormatString(str) {
        return (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).escapeLangChars(str.toLowerCase());
    }

    _rows_Sort(rows) {
        if (this._dynamic)
            return rows;

        if (this._info.orderBy.columnName === null)
            return rows;

        if (!(this._info.orderBy.columnName in this._columnRefs)) {
            throw new Error(`Order by column '${this._info.orderBy.columnName}'` +
                ` does not exist.`);
        }
        
        let columnIndex = this._columnRefs[this._info.orderBy.columnName];

        rows = rows.sort((a, b) => {
            let result = 0;
            if (this._selectable_SelectedOnTop) {
                if (a.selected && !b.selected)
                    result = -1;
                else if (!a.selected && b.selected)
                    result = 1;
            }
            if (result !== 0)
                return result;

            result = this._rows_Sort_Column(a, b, columnIndex,
                    this._info.orderBy.reverse);

            if (result !== 0)
                return result;

            for (let i = 0; i < this._columnsOrder.length; i++) {
                let orderBy = this._columnsOrder[i];

                if (orderBy.columnRef === columnIndex)
                    continue;

                result = this._rows_Sort_Column(a, b, orderBy.colRef, orderBy.reverse);

                if (result !== 0)
                    return result;
            }

            return 0;
        });

        if (this._listeners_OnSort !== null)
            this._listeners_OnSort(rows, this._columnRefs);

        return rows;
    }

    _rows_Sort_Column(a, b, column_index, reverse) {
        let a_value = a.cols[column_index].value;
        let b_value = b.cols[column_index].value;

        if (a_value === null)
            return b_value === null ? 0 : (!reverse ? -1 : 1);
        if (b_value === null)
            return (!reverse ? 1 : -1);

        /* BigInt */
        if (typeof(a_value) === 'bigint' || typeof(b_value) === 'bigint') {
            if (b_value > a_value)
                return -1;
            if (a_value > a_value)
                return 1;

            return 0;
        }

        /* Number */
        if (!isNaN(parseFloat(a_value)) && isFinite(a_value) &&
                !isNaN(parseFloat(b_value)) && isFinite(b_value)) {
            if (reverse)
                return b_value - a_value;
            else
                return a_value - b_value;
        }

        /* Boolean */
        if (typeof a_value === 'boolean' && typeof b_value === 'boolean') {
            if (a_value === b_value)
                return 0;

            if (reverse)
                return a_value ? 1 : -1;
            else
                return a_value ? -1 : 1;
        }

        /* String / Other */
        a_value = a_value + '';
        b_value = b_value + '';

        if (reverse)
            return -a_value.localeCompare(b_value);
        else
            return a_value.localeCompare(b_value);
    }

    _rows_Update_Async(rows, clear = true) {
        return new Promise((resolve, reject) => {
            /* Header */
            let orderBy_ColumnIndex = this._columnRefs[this._info.orderBy.columnName];
            for (let i = 0; i < this.l.$fields.table.headers().$size; i++) {
                if (i !== orderBy_ColumnIndex) {
                    this.l.$fields.table.headers(i).caretDown = false;
                    this.l.$fields.table.headers(i).caretUp = false;
                } else {
                    this.l.$fields.table.headers(i).caretDown = !this._info.orderBy.reverse;
                    this.l.$fields.table.headers(i).caretUp = this._info.orderBy.reverse;
                }
            }

            // if (clearAll)
            //     this.l.$fields.table.rows = [];
            /* / Header */

            /* Rows */
            let tRows;
            if (this._dynamic)
                tRows = rows;
            else
                tRows = rows.slice(0, this._limit.current);

            this.l.$fields.table = {
                // rows: tRows,
                isEmpty: rows.length === 0,
                showLoadMore: this._dynamic ? 
                    (tRows.length >= this._limit.current) :
                    (this._rows_Current.length > this._limit.current),
                colsLength: tRows.length === 0 ? 0 : tRows[0].cols.length,
                loading: true,
            };

            this._rows_UpdateFields(tRows, clear);

            resolve();
            
            // rows = rows.slice(0, 150);

            // let m1 = js0.TimeSpan.MarkStart('Test', 'A');
            // let rowI = 0;
            // for (let i = 0; i < tRows.length; i += 1) {
            //     setTimeout(() => {
            //         this.l.$fields.table.rows().$push(tRows[rowI]);
            //         rowI++;

            //         if (rowI >= tRows.length) {
            //             m1.end();
            //             console.log(js0.TimeSpan.GetInstance('Test').getDiffs());
            //             resolve();
            //         }

            //         // ts.markStart('Test ' + rowI);
            //         // this.l.$fields.table.rows().$add(rowI, rows[rowI]);
            //         // rowI++;
            //         // ts.markEnd('Test ' + rowI);

            //         // if (rowI === rows.length) {
            //         //     console.log(ts.getDiffs());
            //         //     console.log(js0.TimeSpan.GetInstance('ListField').getDiffs());
                        
            //         //     resolve();
            //         // }
            //     }, 0);
            // }
        });
    }

    _rows_UpdateFields(rows, clear = true) {
        if (clear)
            this.l.$fields.table.rows = [];

        let startFrom = clear ? 0 : this._rows_Fields.length;

        this._rows_Fields = this._rows_UpdateFields_ParseRows(rows);
        this._rows_Fields_Index++;

        let rowFieldsIndex = this._rows_Fields_Index;
        let rowI = startFrom;

        let updateRows = () => {
            if (this._rows_Fields_Index > rowFieldsIndex)
                return;

            // this.l.$fields.table.rows().$push(this._rows_Fields[rowI]);

            for (let i = 0; i < 10 && rowI < this._rows_Fields.length; i++) {
                this.l.$fields.table.rows().$push(this._rows_Fields[rowI]);
                rowI++;
            }

            // rowI++;
            if (rowI >= this._rows_Fields.length) {
                this.l.$fields.table.loading = false;
                return;
            }

            setTimeout(() => {
                updateRows();
            }, 100);
        };

        /* Remove 'clear' check and change 'this.l.$fields.table.rows = ' to 
         * $pushArr when it will exist. */
        if (clear) {
            rowI = Math.min(this._rows_Fields.length, 50);
            let rows_Fields_Part = this._rows_Fields.slice(0, rowI);
            this.l.$fields.table.rows = rows_Fields_Part;
        }

        // for (let i = 0; i < Math.min(this._rows_Fields.length, 50); i++) {
        //     this.l.$fields.table.rows().$push(this._rows_Fields[rowI]);
        //     rowI++;
        // }

        if (rowI >= this._rows_Fields.length) {
            this.l.$fields.table.loading = false;
            return;
        } else {
            setTimeout(() => {
                updateRows();
            }, 100);
        }
    }

    _rows_UpdateFields_ParseRow(row) {
        let fCols = [];
        for (let col of row.cols) {
            fCols.push({
                class: col.class,
                show: col.show,
                value: col.value,
                html: col.html,
                button: {
                    btnClass: col.button.btnClass,
                    iClass: col.button.iClass,
                    show: col.button.show,
                    text: col.button.text,
                },
                hasLayout: col.layout !== null,
            });
        }

        return {
            href: row.href,
            class: row.class,
            cols: fCols,
            style: row.style,
            selected: row.selected,
        };
    }

    _rows_UpdateFields_ParseRows(rows) {
        let fRows = [];
        for (let row of rows)
            fRows.push(this._rows_UpdateFields_ParseRow(row));

        return fRows;
    }

    _rows_Refresh(update = false, clearAll = true) {
        this._rows_RefreshQueueCount++;
        update = this._dynamic ? update : false;

        let fields = this._getFields(update);

        this.msgs.showLoading('', this._info.showInstantLoading);

        // setTimeout(() => {
        if (this._info.fn !== null) {
            this._info.fn(fields)
                .then((result) => {
                    (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(result, (_jsLib.import("spk-tables", "./presets", "default", "presets", "./presets.js")).refreshResult);

                    this._rows_RefreshQueueCount--;
                    if (this._rows_RefreshQueueCount > 0)
                        return;

                    if (result.error === null) {
                        this._rows_Refresh_Process_Async(update, clearAll, result.data, fields)
                            .then(() => {
                                this.msgs.hideLoading();
                            })
                            .catch((e) => {
                                console.error(e);

                                this.msgs.showMessage_Failure(
                                        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), e.toString());
                                this.msgs.hideLoading();
                            });
                    } else {
                        this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'),
                                result.error);
                        this.msgs.hideLoading();
                    }
                })
                .catch((e) => {
                    console.error(e);

                    this.msgs.hideLoading();
                    this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'),
                            e.toString());
                });
        } else if (this._info.apiUri !== null) {
            (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json(this._info.apiUri, fields, (result) => {
                this._rows_RefreshQueueCount--;
                if (this._rows_RefreshQueueCount > 0)
                    return;

                if (result.isSuccess()) {
                    this._rows_Refresh_Process_Async(update, clearAll, result.data, fields)
                        .then(() => {
                            this.msgs.hideLoading();
                        })
                        .catch((e) => {
                            console.error(e);

                            this.msgs.showMessage_Failure(
                                    (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'), 
                                    e.toString());
                            this.msgs.hideLoading();
                        });
                } else {
                    // this.rows_Update(this.rows);
    
                    this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('spkTables.Error'),
                            result.data.message);
                }
    
                // this.$layout.$elems.each('select', function(elem) {
                //     elem.checked = false;
                // });
    
                this.msgs.hideLoading();
            });
        } else
            throw new Error('No data source set.');
        // }, 5000);
    }

    async _rows_Refresh_Process_Async(update, clearAll, data, apiFields) {
        if (!('table' in data)) {
            console.error('Table refresh result:', data);
            throw new Error('No `table` in data.');
        }

        if (this._listeners_OnApiResult !== null)
            this._listeners_OnApiResult(data, apiFields);

        let rows_ApiResult = this._parseResultRows(data.table);
            
        if (update) {
            this._rows = this._rows.concat(rows_ApiResult);                    
            this._rows_Current = this._rows;
        } else {
            if (this._noSort) {
                this._info.orderBy.columnName = null;
                this._rows = this._rows_NoSort(rows_ApiResult);
            } else
                this._rows = this._rows_Sort(rows_ApiResult);

            this._rows_Current = this._rows_Filter(this._rows);
        }

        return await this._rows_Update_Async(this._rows_Current, clearAll);
    }

    _rows_NoSort(rows) {
        return rows.sort((a, b) => {
            if (this._selectable_SelectedOnTop) {
                let result = 0;

                if (a.selected && !b.selected)
                    result = -1;
                if (!a.selected && b.selected)
                    result = 1;

                if (result !== 0)
                    return result;

                return a.order - b.order;
            }
        });
    }
}

Table.NotSet = Symbol('spkTables_NotSet');

/* JSLib Exports */
_jsLib.export("default", Table); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\languages\en.spkTables.js
jsLibs.exportScript("spk-tables", "./languages/en.spkTables", [ "default" ], (_jsLib) => { "use strict"; const lang_EN = {
    Error: 'Error',
    Loading: 'Loading...',
    LoadMore: 'Show more',
    Search_Placeholder: 'Search...',
    TableEmpty: 'Table is empty',
};
/* export default */ lang_EN;

/* JSLib Exports */
_jsLib.export("default", lang_EN); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\languages\pl.spkTables.js
jsLibs.exportScript("spk-tables", "./languages/pl.spkTables", [ "default" ], (_jsLib) => { "use strict"; const lang_PL = {
    Error: 'Błąd',
    Loading: 'Trwa ładowanie...',
    LoadMore: 'Pokaż więcej',
    Search_Placeholder: 'Szukaj...',
    TableEmpty: 'Tabela jest pusta',
};
/* export default */ lang_PL;

/* JSLib Exports */
_jsLib.export("default", lang_PL); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\$layouts\index.js
jsLibs.exportScript("spk-tables", "./$layouts/index", [ "$layouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-tables", "./$layouts/Table", [ { name: "default", alias: "Table" } ], "./Table.js");

/* export */ class $layouts_Class {
    get Table() {
        return (_jsLib.import("spk-tables", "./$layouts/Table", "default", "Table", "./Table.js"));
    }
}
const $layouts = new $layouts_Class();
/* export default */ $layouts

/* JSLib Exports */
_jsLib.export("$layouts_Class", $layouts_Class);
_jsLib.export("default", $layouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\spk-tables\$layouts\Table.js
jsLibs.exportScript("spk-tables", "./$layouts/Table", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Table extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["h3",{"_show":["Title"]},"$Title"],["$",{"_holder":["beforeSearch"]}],["div",{"_show":["table.showSearch"],"class":["search"]},["div",{"class":["row g-2"]},["div",{"class":["col"]},["form",{},["div",{"class":["input-group"]},["div",{"class":["input-group-text"]},["i",{"class":["fa fa-search"]}]],["input",{"_elem":["filter"],"placeholder":["$text('Search_Placeholder')"],"type":["text"],"class":["form-control"]}]]]],["div",{"class":["col-auto"]},["$",{"_holder":["afterSearch"]}]]]],["$",{"_holder":["beforeTable"]}],["$",{"_holder":["beforeTable2"]}],["$",{"_holder":["beforeTable3"]}],["$",{"_holder":["beforeTable4"]}],["div",{"_show":["table.isEmpty"],"class":["table_empty pb-5"]},"$text('TableEmpty')"],["div",{"_hide":["table.isEmpty"],"class":["table-responsive"]},["table",{"class":["table"]},["thead",{},["tr",{"class":["header"]},["th",{"_elem":["selectable_TableCheckboxHolder"],"_show":["table.selectable"],"class":["text-center"]},["input",{"_elem":["selectable_TableCheckbox"],"_show":["table.selectable_ShowSelectAll"],"type":["checkbox"]}]],["th",{"_repeat":["table.headers:header"],"_elem":["header"],"_show":["header.show"],"class":["text-nowrap ","$header.class"],"style":["$header.style"]},["a",{"href":[""]},["span",{"style":["$header.textStyle"],"_field":["header.title"]}]]," ",["i",{"_show":["header.caretDown"],"class":["fa fa-caret-down"]}],["i",{"_show":["header.caretUp"],"class":["fa fa-caret-up"]}]]]],["tbody",{},["tr",{"_repeat":["table.rows:row"],"_elem":["row"],"class":["$table.trClass"," ","$row.class"],"style":["$row.style"]},["td",{"_elem":["selectable_RowCheckboxHolder"],"_show":["table.selectable"],"class":["text-center"]},["input",{"_show":["row.selected"],"type":["checkbox"],"checked":["true"]}],["input",{"_hide":["row.selected"],"type":["checkbox"]}]],["td",{"_repeat":["row.cols:col"],"_show":["col.show"],"class":["$col.class"],"style":["$col.style"]},["$",{"_show":["col.hasLayout"]},["$",{"_holder":["colLayout"]}]],["$",{"_hide":["col.hasLayout"]},["a",{"_show":["row.href"],"href":["$row.href"]},["span",{"_field":["col.html"]}]],["span",{"_hide":["row.href"],"_field":["col.html"]}],["$",{"_show":["col.button.show"]},["div",{"class":["$col.button.class"]},["a",{"_elem":["columnButton"],"href":["#"],"class":["btn ","$col.button.btnClass"," w-100"]},["i",{"class":["$col.button.iClass"]}],"$col.button.text"]]]]]],["tr",{"_show":["table.loading"],"class":["e-load-more"]},["td",{"colspan":["$table.colsLength"],"style":["text-align: center;"]},"$text('Loading')"]],["tr",{"_show":["table.showLoadMore"],"_hide":["table.loading"],"class":["e-load-more"]},["td",{"_elem":["loadMore"],"colspan":["$table.colsLength"],"class":["clickable"],"style":["text-align: center;"]},["a",{"href":["#"],"class":["btn btn-outline-secondary mt-3 w-100"]},"$text('LoadMore')","\r\n                         ",["i",{"class":["fa fa-caret-down"],"aria-hidden":["true"]}]]]]]]],["div",{"class":["clearfix"]}],["$",{"_holder":["afterTable"]}],["$",{"_holder":["afterTable2"]}],["$",{"_holder":["afterTable3"]}],["$",{"_holder":["afterTable4"]}]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Table.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Table); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\Actions.js
jsLibs.exportScript("core", "./Actions", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("core", "./NativeApp", [  ], "./NativeApp.js");
_jsLib.importDeclaration("native-app", "./index", [ { name: "default", alias: "nativeApp" } ], "native-app");

/* export default */ class Actions {
    get nativeApp() {
        return (_jsLib.import("native-app", "./index", "default", "nativeApp", "native-app"))
    }


    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);
    }

    createDataStore(deviceInfo) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject);
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).typeE(deviceInfo, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            deviceId: 'int',
            deviceHash: 'string',
            lastUpdate: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            lastItemId: (_jsLib.import("js0", "./index", "default", "js0", "js0")).Long,
            declaredItemIds: [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default([]) ],
        }));
        
       this.nativeApp.setDataStore((_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).DataStore, this.__createDataStore(
                deviceInfo)));
    }

    async init_Async() {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            appInfo: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            appVersion: 'string',
            fields: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            user: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            deviceInfo: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            extras: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
        }), await this.__init_Async());
    }

    async logIn_Async(login, password) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            data: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                appInfo: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                user: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
                    info: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                    info_Client: [ (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                    permissions: Array,
                }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
                extras: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            }), (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, ],
            error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
        }), await this.__logIn_Async(login, password));
    }

    async logOut_Async() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);

        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("js0", "./index", "default", "js0", "js0")).Preset({
            error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
        }), await this.__logOut_Async());
    }

    async messageDisplayed_Async(messageId) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'int');

        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn('undefined', await this.__messageDisplayed_Async(
                messageId));
    }


    async __createDataStore(deviceInfo) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    async __init_Async() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    async __logIn_Async(login, password) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    async __logOut_Async() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    async __messageDisplayed_Async(messageId) { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
}

/* JSLib Exports */
_jsLib.export("default", Actions); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\App.js
jsLibs.exportScript("core", "./App", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");
_jsLib.importDeclaration("core", "./index", [ { name: "default", alias: "core" } ], "./index.js");
_jsLib.importDeclaration("core", "./Main", [ { name: "default", alias: "Main" } ], "./Main.js");
_jsLib.importDeclaration("ab-data-web", "./index", [  ], "ab-data-web");
_jsLib.importDeclaration("ab-data-native", "./index", [  ], "ab-data-native");
_jsLib.importDeclaration("native-app", "./index", [ { name: "default", alias: "nativeApp" } ], "native-app");
_jsLib.importDeclaration("core", "./texts/pl", [ { name: "default", alias: "lang_PL" } ], "./texts/pl.js");
_jsLib.importDeclaration("core", "./panels", [ { name: "default", alias: "panels" } ], "./panels.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "./sys.js");
_jsLib.importDeclaration("core", "./$ab-data/index", [ { name: "default", alias: "$abData" } ], "./$ab-data/index.js");

/* export default */ class App {
    static get ApiVersion() {
        return 4;
    }

    static get Base() {
        return abNative_Base;
    }

    static get Platform() {
        if (abNative_Platform === 'web')  
            return 'web';

        if (abNative_Platform === 'android' || abNative_Platform === 'android_dev')
            return 'native';

        if (abNative_Platform === 'ios' || abNative_Platform === 'ios_dev')
            return 'native';
    }

    static GetInstance() {
        if (App._Instance === null)
            throw new Error('App instance not created.');
        
        return App._Instance;
    }


    get appInfo() {
        if (this._appInfo === null)
            throw new Error('App not initialized.');

        return this._appInfo;
    }

    get displayedMessageIds() {
        return this._displayedMessageIds;
    }

    get dataScheme() {
        return this._dataScheme;
    }

    get dataStore() {
        return this.nativeApp.dataStore;
    }

    get fields() {
        if (this._fields === null)
            throw new Error('App not initialized.');

        return this._fields;
    }

    get mMain() { 
        if (this._mMain === null)
            throw new Error('App not initialized.');

        return this._mMain;
    }

    get nativeApp() {
        return this._nativeApp;
    }

    constructor(mMain) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("core", "./Main", "default", "Main", "./Main.js")));

        if (App._Instance !== null)
            throw new Error('App instance already created.');
        
        App._Instance = this;

        this.appVersion = '-';

        this._dataScheme = null;
        this._dataStore = null;
        this._nativeApp = null;

        this._mMain = mMain;
        this._appInfo = null;
        this._fields = null;

        this._displayedMessageIds = [];

        this.loadTexts();

        this._create_DataScheme();

        this._nativeApp = (_jsLib.import("native-app", "./index", "default", "nativeApp", "native-app"));

        this._nativeApp.setDebug((_jsLib.import("core", "./index", "default", "core", "./index.js")).debug);
    }

    checkAppMessages() {

    }

    async clearData_Async(syncDB = true, clearDataStore = true, 
        transactionId = null) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], [ 'boolean', 
                (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ], [ 'int', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let db = this.nativeApp.db;

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        if (clearDataStore)
            await this.dataStore.clearData_Async(transactionId);

        await this.nativeApp.getTable('Sys_Associations').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_Bulls').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_ClientBulls').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_Clients').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_Cows').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_Farmers').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_Receipts').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('Sys_Users').delete_Async(db, {},
                transactionId);
        
        if (syncDB && this.dataStore !== null) {
            let rAppInfo = await this.nativeApp.getT('_Native_Settings')
                    .row_Async(db, {
                where: [ 'Name', '=', 'appInfo' ],
            }, transactionId);

            let syncDB_Response = await this.dataStore.syncDB_Async({
                apiVersion: App.ApiVersion,
                appInfo: rAppInfo === null ? null : rAppInfo.Data.value,
            }, async (transactionId) => {
                let unsyncedData = await this._getUnsyncedData_Async(
                        transactionId);
                if (unsyncedData.receipts_Unsynced.length > 0) {
                    let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 
                            'app/clear-data', {
                        appId: app.appInfo.appId,
                        authenticationHash: app.appInfo.authenticationHash,
                        data: unsyncedData,
                    });

                    if (!result.isSuccess()) {
                        throw new Error(
                            'Cannot send unsynced receipts before data clear.');
                    }
                }

                await this.clearData_Async(false, false, transactionId);
            }, transactionId);

            if (syncDB_Response.type !== (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response.Types_Success) {
                await db.transaction_Finish_Async(false, transactionId);

                throw new Error((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_CannotSynchronizeData', { 
                            error: syncDB_Response.errorMessage }));
            }
        }

        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);
    }

    createDataStore(deviceInfo) {
        this.nativeApp.actions.createDataStore(deviceInfo);
    }

    displayedMessageIds_Add(displayedMessageId) {
        this._displayedMessageIds.push(displayedMessageId);
    }

    displayedMessageIds_Set(displayedMessageIds) {
        this._displayedMessageIds = displayedMessageIds;
    }

    loadTexts() {
        let texts = null;

        texts = (_jsLib.import("core", "./texts/pl", "default", "lang_PL", "./texts/pl.js"));
        let Text_Sys = {};
        for (let text in texts)
            Text_Sys['Sys:' + text] = texts[text];
        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).add('pl', Text_Sys);

        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).setLang('pl');
    }

    async logOut_Async() {
        let db = this.nativeApp.db;

        let transactionId = await db.transaction_Start_Async();

        await this.clearData_Async(false, true, transactionId);

        await this.nativeApp.getTable('_ABData_DBRequests').delete_Async(db, {}, 
                transactionId);
        await this.nativeApp.getTable('_ABData_Settings').delete_Async(db, {},
                transactionId);
        await this.nativeApp.getTable('_Native_Settings').delete_Async(db, {},
                transactionId);

        await db.transaction_Finish_Async(true, transactionId);

        // console.log(
        //     'Native Settings 2',
        //     await this.nativeApp.getTable('_Native_Settings').select_Async(db));

        this.setUser(null);
        this.mMain.lb.setUser({
            loggedIn: false,
            login: '',
            permissions: [],
        });
        this.mMain.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create(this.mMain));
    }

    async isConnectedToInternet_Async() {
        return (await this.nativeApp.nativeActions.callNative_Async(
                'IsConnectedToInternet')).result;
    }

    refreshPanels() {
        this._mMain.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create());
    }

    setAppInfo(appInfo) {
        this._appInfo = appInfo;
    }

    setFields(fields) {
        this._fields = fields;
    }

    setUser(user) {
        this.user = {
            info: user === null ? null : user.info,
            info_Client: user === null ? null : user.info_Client,
            permissions: user === null ? [] : user.permissions,

            isClient: user === null ? 
                false : (user.info === null ? false : user.info.Client__Id !== null), 
            isClinic: user === null ? 
                false : (user.info === null ? false : user.info.Clinic__Id !== null),
            isClinicInseminator: user === null ?
                false: (user.info === null ? false : user.info.Inseminator_Clinic__Id !== null),
            isEmployee: false,
            isFarmer: user === null ? 
                    false : (user.info === null ? false : user.info.Farmer__Id !== null),
            isInseminator: user === null ? 
                    false : (user.info === null ? false : user.info.Inseminator__Id !== null),
            isTrader: user === null ? 
                    false : (user.info === null ? false : user.info.Trader__Id !== null),
            isAdministrator: user === null ? 
                    false : (user.info === null ? false : user.info.Administrator__Id !== null),
        };

        this.user.isEmployee = this.user.isAdministrator || this.user.isTrader;
    }

    async syncDB_Async() {
        let app = App.GetInstance();

        app.mMain.msgs.showLoading((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Loadings_DBSync'));

        try {
            let response = await app.dataStore.syncDB_Async({
                apiVersion: App.ApiVersion,
                appInfo: app.appInfo,
            }, async (transactionId) => {
                let unsyncedData = await this._getUnsyncedData_Async(
                        transactionId);
                if (unsyncedData.receipts_Unsynced.length > 0) {
                    let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 
                            'app/clear-data', {
                        appId: app.appInfo.appId,
                        authenticationHash: app.appInfo.authenticationHash,
                        data: unsyncedData,
                    });

                    if (!result.isSuccess()) {
                        throw new Error(
                            'Cannot send unsynced receipts before data clear.');
                    }
                }

                await this.clearData_Async(false, false, transactionId);
            });

            if (response.type !== (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response.Types_Success) {
                let errorInfo = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).getResponseErrorInfo(response);

                console.error('Cannot synchronize data.', response);
                await app.mMain.msgs.showMessage_Failure_Async((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                        'Sys:Errors_CannotSynchronizeData_Title'),
                        errorInfo.title +  ' -> ' + errorInfo.message);

                app.mMain.msgs.hideLoading();
                return;
            }
                    
            await app.nativeApp.refreshLastUpdate();

            let rUnsyncedReceiptsCount = await app.nativeApp.db.query_Select_Async(
                    'SELECT COUNT(*) FROM Sys_Receipts WHERE _Modified_DateTime IS NULL', 
                    [ (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).SelectColumnType.Int ], null);
            let unsyncedReceiptsCount = rUnsyncedReceiptsCount[0][0];
            if (unsyncedReceiptsCount > 0 && !this._unsyncedReceiptsMsgShown) {
                this._unsyncedReceiptsMsgShown = true;
                app.mMain.msgs.showMessage_Success(
                        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Warnings_UnsyncedReceipts_Title'),
                        (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Warnings_UnsyncedReceipts_Text', 
                        { unsyncedReceiptsCount: unsyncedReceiptsCount }), () => {
                    app.mMain.msgs.hideLoading();
                });
            } else
                app.mMain.msgs.hideLoading();
        } catch (e) {
            console.error(e);

            app.mMain.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                    'Sys:Errors_CannotSynchronizeData_Title'),
                    e.toString());
            app.mMain.msgs.hideLoading();
        }
    }


    _create_DataScheme() {
        let abData_Types = [];
        if (App.Platform === 'web')
            abData_Types.push('db');
        if (App.Platform === 'native')
            abData_Types.push('native');

        this._dataScheme = (_jsLib.import("core", "./$ab-data/index", "default", "$abData", "./$ab-data/index.js"))(abData_Types);
    }

    async _getUnsyncedData_Async(transactionId = null) {
        let data = {};
        data.updateData = await this.dataStore.getDBRequests_ForSync_Async(
                transactionId);
        data.receipts_Unsynced = await this.nativeApp.getT('Sys_Receipts')
                .select_Async(this.nativeApp.db, {
            where: [
                [ '_Modified_DateTime', null, 'IS NULL' ],
            ],
        }, transactionId);

        return data;
    }

}
App._Instance = null;

/* JSLib Exports */
_jsLib.export("default", App); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\helper.js
jsLibs.exportScript("core", "./helper", [ "api_Delete_Async","api_DeleteSelected_Async","api_Row_Async","api_RequestUpdate_Async","api_Request_Async","api_Update_Async" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [  ], "ab-data");
_jsLib.importDeclaration("ab-text", "./index", [  ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [  ], "js0");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");

/* export */ async function api_Delete_Async(panelTitle, fields) {
    let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

    let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 'delete', {
        args: fields,
    });

    return response;
}


/* export */ async function api_DeleteSelected_Async(panelTitle, fields) {
    let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

    let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 'deleteSelected', {
        args: fields,
    });

    return response;
}


/* export */ async function api_Row_Async(panelTitle, fields) {
    let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

    let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 'row', {
        args: fields,
    });

    return response;
}

// export async function api_Select_Async(panelTitle, fields)
// {
//     let app = App.GetInstance();

//     let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 'select', {
//         args: fields,
//     });

//     return response;
// }

/* export */ async function api_RequestUpdate_Async(panelTitle, fields) {
    let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

    let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 
            'requestUpdate', {
        args: fields,
    });

    return response;
}

/* export */ async function api_Request_Async(panelTitle, fields) {
    let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

    let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 'request', {
        args: fields,
    });

    return response;
}

/* export */ async function api_Update_Async(panelTitle, fields) {
    let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

    let response = await app.dataStore.request_Async(`Sys_${panelTitle}`, 'update', {
        args: fields,
    });

    return response;
}

/* JSLib Exports */
_jsLib.export("api_Delete_Async", api_Delete_Async);
_jsLib.export("api_DeleteSelected_Async", api_DeleteSelected_Async);
_jsLib.export("api_Row_Async", api_Row_Async);
_jsLib.export("api_RequestUpdate_Async", api_RequestUpdate_Async);
_jsLib.export("api_Request_Async", api_Request_Async);
_jsLib.export("api_Update_Async", api_Update_Async); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\index.js
jsLibs.exportScript("core", "./index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("ab-date", "./index", [ { name: "default", alias: "abDate" } ], "ab-date");
_jsLib.importDeclaration("ab-text", "./index", [  ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");
_jsLib.importDeclaration("spk-messages", "./index", [  ], "spk-messages");
_jsLib.importDeclaration("spk-tables", "./index", [  ], "spk-tables");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "./sys.js");
_jsLib.importDeclaration("core", "./Actions", [ { name: "default", alias: "Actions" } ], "./Actions.js");
_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");
_jsLib.importDeclaration("core", "./NativeApp", [ { name: "default", alias: "NativeApp" } ], "./NativeApp.js");

_jsLib.importDeclaration("core", "./Main", [ { name: "default", alias: "Main" } ], "./Main.js");

class core_Class {
    get debug() {
        return this._debug;
    }

    get sys() {
        return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js"));
    }

    get Actions() {
        return (_jsLib.import("core", "./Actions", "default", "Actions", "./Actions.js"));
    }

    get App() {
        return (_jsLib.import("core", "./App", "default", "App", "./App.js"));
    }

    get NativeApp() {
        return (_jsLib.import("core", "./NativeApp", "default", "NativeApp", "./NativeApp.js"));
    }


    constructor(viewName) {
        this._spk = null;
    }

    init(viewName, debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'boolean');

        this._debug = debug;

        this._spk = new (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).App()
            .config(($app, $cfg) => {
                $cfg
                    .container('_html_App', (_jsLib.import("core", "./Main", "default", "Main", "./Main.js")));
            });

        (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).ext(new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Ext());

        (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).setDebug(debug);
        (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).setDebug(debug);
        (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).setDebug(debug);
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).setDebug(debug);
            
        (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).setTimezone('Europe/Warsaw');

        (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).formats_Date = 'DD.MM.YYYY';
        (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).formats_DateTime = 'DD.MM.YYYY HH:mm';
        (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).formats_Time = 'HH:mm';

        (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).setLang('pl');

        this._spk.init(debug);
    }
}
const core = new core_Class();
/* export default */ core;

/* JSLib Exports */
_jsLib.export("default", core); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\Main.js
jsLibs.exportScript("core", "./Main", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-pager", "./index", [ { name: "default", alias: "abPager" } ], "ab-pager");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [  ], "js0");
_jsLib.importDeclaration("spk-lemon-bee", "./index", [ { name: "default", alias: "spkLemonBee" } ], "spk-lemon-bee");
_jsLib.importDeclaration("spk-messages", "./index", [ { name: "default", alias: "spkMessages" } ], "spk-messages");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");
    
_jsLib.importDeclaration("core", "./panels", [ { name: "default", alias: "panels" } ], "./panels.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "./sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");

_jsLib.importDeclaration("core", "./pages/Register", [ { name: "default", alias: "Register" } ], "./pages/Register.js");
_jsLib.importDeclaration("core", "./pages/PrivacyPolicy", [ { name: "default", alias: "PrivacyPolicy" } ], "./pages/PrivacyPolicy.js");
_jsLib.importDeclaration("core", "./pages/Statement", [ { name: "default", alias: "Statement" } ], "./pages/Statement.js");

_jsLib.importDeclaration("core", "./app-messages/index", [ { name: "default", alias: "appMessages" } ], "./app-messages/index.js");

/* export default */ class Main extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {
    constructor() {
        super();

        let app = new (_jsLib.import("core", "./App", "default", "App", "./App.js"))(this);

        // this.na_Core = abNative.addActionsSet('Core', new NativeActionsDef_Core());
        // if (abNative_Platform === 'android' || abNative_Platform)
        //     this.na_App = abNative.addActionsSet('App', new NativeActionsSet_App());
        this.pager = new (_jsLib.import("ab-pager", "./index", "default", "abPager", "ab-pager")).Pager(abNative_Base, abNative_Platform !== 'android' && 
                abNative_Platform !== 'ios')
            .page('register', 'rejestracja', (page) => {
                this.msgs.hideLoading();

                let mPage = new (_jsLib.import("core", "./pages/Register", "default", "Register", "./pages/Register.js"))(this);
                this.l.$holders.content.$view = mPage;
            })
            .page('privacyPolicy', 'polityka-prywatnosci', (page) => {
                this.msgs.hideLoading();

                let mPage = new (_jsLib.import("core", "./pages/PrivacyPolicy", "default", "PrivacyPolicy", "./pages/PrivacyPolicy.js"))(this);
                this.l.$holders.content.$view = mPage;
            })
            .page('statement', 'oswiadczenie', (page) => {
                this.msgs.hideLoading();

                let mPage = new (_jsLib.import("core", "./pages/Statement", "default", "Statement", "./pages/Statement.js"))(this);
                this.l.$holders.content.$view = mPage;
            });

        this.msgs = new (_jsLib.import("spk-messages", "./index", "default", "spkMessages", "spk-messages")).Messages({
            modulePath: abNative_Base + 'dev/node_modules/spk-messages/',
        });
        this.lb = new (_jsLib.import("spk-lemon-bee", "./index", "default", "spkLemonBee", "spk-lemon-bee")).System(this.pager, this.msgs);

        this.l = new (_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Main();
        this.l.$fields.Status = '...';

        this.l.$holders.messages.$view = this.msgs;
        this.msgs.showLoading();

        this.$view = this.l;

        // this.l.$fields.Status = 'Initializing...';
        // this.l.$elems.SyncDB.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.l.$fields.Status = 'Syncing DB...';
        //     app.dataStore.syncDB_Async()
        //         .then(() => {
        //             this.l.$fields.Status = 'Done Syncing DB.';
        //         })
        //         .catch((e) => {
        //             console.error(e);
        //         });
        // });

        this.setup();

        app.nativeApp.actions.init_Async()
            .then((result) => {
                app.appVersion = result.appVersion;

                app.setAppInfo(result.appInfo);
                app.setFields(result.fields);
                app.setUser(result.user);

                if (result.deviceInfo !== null)
                    app.createDataStore(result.deviceInfo);

                // app.dataStore.requestB_Async([
                //     [ 'rows', 'Sys_Bulls', 'select', {
                //         join: [
                //             {
                //                 prefix: 'Client_',
                //                 table: app.nativeApp.getTable('Sys_Clients'),
                //                 on: [ 
                //                     [ '_Id', 'Client__Id' ],
                //                 ],
                //                 // where: [
                //                 //     [ '_Id', '=', 's_b.Client__Id' ],
                //                 // ],
                //             },
                //         ],
                //     }],
                //         ])
                //     .then((r) => {
                //         console.log(r.rows.rows);
                //     })
                //     .catch((e) => {
                //         console.error(e);
                //     });

                this.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create(this));

                if ((_jsLib.import("core", "./App", "default", "App", "./App.js")).Platform === 'native') {
                    if (app.user.info !== null) {
                        (async () => {
                            if (await app.isConnectedToInternet_Async()) {
                                await app.syncDB_Async();
                                
                                this.init({
                                    loggedIn: app.user.info !== null,
                                    login: app.user.info === null ? 
                                            '' : app.user.info.Email,
                                    permissions: app.user.permissions,
                                }, result.extras);
                            } else {
                                if (await app.nativeApp.actions.isUpToDate()) {
                                    // this.msgs.hideLoading();
                                } else {
                                    this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                            'Sys:Warnings_UpdateApp'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                                'Sys:Warnings_UpdateApp_Message'));
                                    // this.msgs.hideLoading();
                                }

                                this.init({
                                    loggedIn: app.user.info !== null,
                                    login: app.user.info === null ? 
                                            '' : app.user.info.Email,
                                    permissions: app.user.permissions,
                                }, result.extras);
                            }
                                })()
                            .catch((e) => {
                                this.init({
                                    loggedIn: app.user.info !== null,
                                    login: app.user.info === null ? 
                                            '' : app.user.info.Email,
                                    permissions: app.user.permissions,
                                }, result.extras);

                                console.log(e);

                                this.msgs.showMessage_Failure(e.toString());
                                this.msgs.hideLoading();
                            });
                    } else {
                        this.init({
                            loggedIn: app.user.info !== null,
                            login: app.user.info === null ? '' : app.user.info.Email,
                            permissions: app.user.permissions,
                        }, result.extras);

                        // this.msgs.hideLoading();    
                    }
                } else {
                    this.init({
                        loggedIn: app.user.info !== null,
                        login: app.user.info === null ? '' : app.user.info.Email,
                        permissions: app.user.permissions,
                    }, result.extras);
                    
                    // this.msgs.hideLoading();
                }
            })
            .catch((err) => {
                console.error(err);
                console.error(err.stack);
                this.msgs.showMessage_Failure(err.toString());
                this.msgs.hideLoading();
            });
    }

    setup(user) {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        this.lb.setup({
            actions: {
                changePassword_Async: async(oldPassword, newPassword) => {
                    let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(
                            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).uris.pages['ecore.api.user'] + 'change-password', 
                            { password: oldPassword, newPassword: newPassword });

                    if (result.isSuccess()) {
                        return {
                            success: true,
                            message: result.data.message,
                        }
                    } else {
                        return {
                            success: false,
                            message: result.data.message,
                        };
                    }
                },
                logIn_Async: async (login, password) => {
                    if ((_jsLib.import("core", "./App", "default", "App", "./App.js")).Platform === 'web') {
                        let result = await app.nativeApp.actions.logIn_Async(login,
                                password);

                        if (result.data !== null) {
                            app.setAppInfo(result.data.appInfo);
                            app.setUser(result.data.user);
                            app.displayedMessageIds_Set(result.data.extras
                                    .displayedMessageIds);

                            this.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create(this));
                        }

                        return {
                            user: {
                                loggedIn: app.user.info !== null,
                                login: app.user.info === null ? '' : app.user.info.Email,
                                permissions: app.user.permissions,
                            },
                            error: result.error,
                        };
                    } else if ((_jsLib.import("core", "./App", "default", "App", "./App.js")).Platform === 'native') {
                        let result = await app.nativeApp.actions.logIn_Async(login, password);

                        if (result.data !== null) {
                            app.setAppInfo(result.data.appInfo);
                            app.setUser(result.data.user);
                            app.displayedMessageIds_Set(result.data.extras
                                    .displayedMessageIds);

                            this.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create(this));
                        }

                        return {
                            user: {
                                loggedIn: app.user.info !== null,
                                login: app.user.info === null ? '' : app.user.info.Email,
                                permissions: app.user.permissions,
                            },
                            error: result.error,
                        };
                    }
                },
                logOut_Async: async () => {
                    if ((_jsLib.import("core", "./App", "default", "App", "./App.js")).Platform === 'web') {
                        let result = await app.nativeApp.actions.logOut_Async();

                        if (result.success) {
                            app.setUser(null);
                            this.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create(this));
                        }

                        return result;
                    }
                },
                remindPassword_Async: async(login) => {
                    let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(
                            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).uris.pages['ecore.api.user'] + 'remind-password', 
                            { login: login, email: login });

                    if (result.isSuccess()) {
                        return {
                            success: true,
                            message: result.data.message,
                        }
                    } else {
                        return {
                            success: false,
                            message: result.data.message,
                        };
                    }
                },
                resetPassword_Async: async(resetPasswordHash, newPassword) => {
                    let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(
                            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).uris.pages['ecore.api.user'] + 'reset-password', 
                            { resetPasswordHash: resetPasswordHash, 
                            newPassword: newPassword, });

                    if (result.isSuccess()) {
                        return {
                            success: true,
                            message: result.data.message,
                        }
                    } else {
                        return {
                            success: false,
                            message: result.data.message,
                        };
                    }
                },
            },

            aliases: {
                account: 'account',
                main: '',
                logIn: 'log-in',
                remindPassword: 'remind-password',
                resetPassword: 'reset-password',
            },
            dev: {
                login: abWeb_BuildType === 'dev' ? 'hod@allblue.pl' : '',
                password: abWeb_BuildType === 'dev' ? 'Banana11' : '',
            },
            images: {
                logo: (_jsLib.import("core", "./App", "default", "App", "./App.js")).Base + 'res/images/logo.png',
                logo_Main: (_jsLib.import("core", "./App", "default", "App", "./App.js")).Base + 'res/images/logo.png',
            },
            mainFn: (mMain) => {
                this.lb.setListener_OnBack(() => {
                    return true;
                });
                this._checkAppMessages();
            },
            panels: (_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).createAll(),
            shows: {
                userInfo: abNative_Platform === 'web',
            },
            textFn: (text) => {
                return (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:' + text);
            },
            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Titles_System'),
            uris: {
                package: '',
            },

            settings: {
                hasRemindPassword: abNative_Platform === 'web',
            }
        });
    }

    init(user, extras) {
        (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance().displayedMessageIds_Set(extras.displayedMessageIds);

        this.lb.setUser(user);

        this.lb.setPanels((_jsLib.import("core", "./panels", "default", "panels", "./panels.js")).create(this));

        let lb_Initialized = false;
        this.lb.addListener_BeforePage(() => {
            if (lb_Initialized)
                return;

            lb_Initialized = true;
            this.l.$holders.content.$view = this.lb.module;    
        });

        this.lb.init();
        this.pager.init();
    }


    async _checkAppMessages() {
        (async () => {
            let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();
            let messages = (_jsLib.import("core", "./app-messages/index", "default", "appMessages", "./app-messages/index.js"))(abNative_Base);
            for (let message of messages) {
                if (message.archived)
                    continue;

                if (!app.displayedMessageIds.includes(message.id)) {
                    await this.msgs.showMessage_Async(message.title, 
                            message.content, {
                        closeOnBackgroundClick: false,
                    });
                    app.displayedMessageIds_Add(message.id);
                    app.nativeApp.actions.messageDisplayed_Async(message.id);
                }
            }
        })();
    }
}

/* JSLib Exports */
_jsLib.export("default", Main); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\modules.js
jsLibs.exportScript("core", "./modules", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");
_jsLib.importDeclaration("spk-tables", "./index", [ { name: "default", alias: "spkTables" } ], "spk-tables");
_jsLib.importDeclaration("spocky", "./index", [  ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");

_jsLib.importDeclaration("core", "./panels/farmers", [  ], "./panels/farmers.js");

_jsLib.importDeclaration("core", "./helper", [ { name: "*", alias: "helper" } ], "./helper.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "./sys.js");
_jsLib.importDeclaration("core", "./tables", [ { name: "default", alias: "tables" } ], "./tables.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");
    ;

/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).Module {

    constructor(lb, panelName, panelTitle, formClass) {
        super(lb);
        this.fm = new formClass(lb, true);
        this.fm.m.lContent.$fields = {
            isNew: true,
        };
        this.fm.m.l.$fields = {
            // shows: {
            //     delete: false,
            // },
            texts: {
                Buttons_Submit: (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Buttons_Create'),
                title: (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText(`Sys:Titles_${panelTitle}_Create`),
            },
        };

        this.fm.m.onSubmit = (result) => {
            this.pager.setPage(`lb.subpanels.${panelName}.list`);
        }

        this.fm.m.refresh();

        this.$view = this.fm;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).Module {

    constructor(lb, panelName, panelTitle, formClass) {
        super(lb);
        this.fm = new formClass(lb, false);
        this.fm.m.l.$fields = {
            texts: {
                Buttons_Submit: (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Buttons_Save'),
                title: (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText(`Sys:Titles_${panelTitle}_Save`),
            },
        };

        this.$view = this.fm;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? Number(this.pager.current.args.id) : null;
    }


    constructor(lb, panelName, panelTitle, create = false, noCard = false) {
        super(lb);
        this.panelName = panelName;
        this.panelTitle = panelTitle;

        this.create = create;
        this.data = null;

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.listeners_Back();
            return true;
        });

        this.refresh_OnSetApiFields = (fields) => { return fields; };
        this.refresh_OnParseApiResult = () => { };
        this.submit_OnSetApiFields = (fields) => { return fields; };
        this.submit_OnValidator = (result) => { };

        this.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.list`);
        };

        /* Edit */
        this.l = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Form);
        this.l.$fields = {
            noCard: noCard,
            texts: {
                title: (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText(`Sys:Titles_${panelTitle}_Edit`),
            },
            shows: {
                submit: true,
            },
            uris: {
                back: this.pager.getPageUri(`lb.subpanels.${panelName}.list`),
            },
        };

        this.l.$elems.back.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.listeners_Back();
        });

        this.l.$elems.submit.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.submit((result) => {
                this.onSubmit(result);
            });
        });
        // this.l.$elems.submit2.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.submit((result) => {
        //         this.onSubmit(result);
        //     })
        // });
        this.l.$elems.delete.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.delete((result) => {
                this.onDelete();
            });
        });

        this.lInfos_Inseminator = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Inseminators_Info);
        this.l.$holders.infos_Inseminator.$view = this.lInfos_Inseminator;
        this.lInfos_Farmer = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Farmers_Info);
        this.l.$holders.infos_Farmer.$view = this.lInfos_Farmer;
        this.lInfos_Cows = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Cows_Info);
        this.l.$holders.infos_Cows.$view = this.lInfos_Cows;
        this.lInfos_Bull = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Bull_Info);
        this.l.$holders.infos_Bull.$view = this.lInfos_Bull;

        /* Submit */
        this.onSubmit = (result) => {
            this.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Successes_Success'), '', () => {
                this.refresh();
            });
            this.msgs.hideLoading();
        };
        this.onDelete = (result) => {
            this.pager.setPage(`lb.subpanels.${panelName}.list`);
        }

        /* Content */
        this.lContent = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js"))[`${panelTitle}_Form`]);

        this.f = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lContent, 'Form');

        if (noCard)
            this.l.$holders.content_NoCard.$view = this.lContent;
        else
            this.l.$holders.content.$view = this.lContent;
        /* / Content */

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100)

        this.$view = this.l;
    }

    delete(onDeleteFn) {
        if (this.isLocked())
            return;

        this.msgs.showConfirmation(
            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Confirmations_Delete'), '',
            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Text_Yes'),
            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Text_No'), (result) => {
                if (!result)
                    return;

                this.lock();
                this.msgs.showLoading();

                let fields = {
                    id: Number(this.pager.current.args.id),
                };

                (_jsLib.import("core", "./helper", "*", "helper", "./helper.js")).api_Delete_Async(this.panelTitle, fields)
                    .then((response) => {
                        this.unlock();
                        (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseRequestResponse(this, response, (result) => {
                            if (result.success)
                                onDeleteFn(result);
                            else {
                                this.msgs.showMessage_Failure(result.message);
                                this.msgs.hideLoading();
                            }
                        });
                    })
                    .catch((e) => {
                        this.unlock();

                        console.error(e);

                        this.msgs.showMessage_Failure(e.toString());
                        this.msgs.hideLoading();
                    });
            });
    }

    refresh() {
        this.msgs.showLoading();

        let fields = {
            id: 'id' in this.pager.current.args ?
                Number(this.pager.current.args.id) : '0',
        };

        this.refresh_OnSetApiFields(fields);

        (_jsLib.import("core", "./helper", "*", "helper", "./helper.js")).api_Row_Async(this.panelTitle, fields)
            .then((response) => {
                (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseRequestResponse(this, response, (result) => {
                    this.data = result.data;

                    this._submit_OnParseApiResult_Info(result.data, 'Inseminator');
                    this._submit_OnParseApiResult_Info(result.data, 'Farmer');
                    this._submit_OnParseApiResult_Cows(result.data, 'Cows');
                    this._submit_OnParseApiResult_Bull(result.data, 'Bull');

                    this.refresh_OnParseApiResult(result.data);

                    if (this.data.row !== null)
                        this.f.setValues(this.data.row, true);
                    else {
                        if (fields.id !== '0') {
                            this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_ItemDoesNotExist'),
                                '', () => {
                                    this.pager.setPage('lb.main');
                                });
                        }
                    }

                    this.msgs.hideLoading();
                });
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure(e.toString());
                this.msgs.hideLoading();
            });
    }

    submit(onSubmitFn) {
        if (this.isLocked())
            return;

        this.lock();
        this.msgs.showLoading();

        let row = this.f.getValues();
        let fields = {
            id: this.data === null ?
                (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance().dataStore.nextId() :
                (this.data.row === null ?
                    (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance().dataStore.nextId() : this.data.row._Id),
            row: row,
        };
        fields = this.submit_OnSetApiFields(fields);

        (_jsLib.import("core", "./helper", "*", "helper", "./helper.js")).api_Update_Async(this.panelTitle, fields)
            .then((response) => {
                this.unlock();

                (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseRequestResponse(this, response, (result) => {
                    if (result.success) {
                        onSubmitFn(result);
                    } else {
                        if ('data' in result) {
                            if (result.data !== null) {
                                if ('validator' in result.data) {
                                    this.f.setValidator(result.data.validator);
                                    this.submit_OnValidator(result);

                                    this.msgs.hideLoading();

                                    return;
                                }
                            }
                        }

                        this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Titles_Error'),
                            result.error);
                        this.msgs.hideLoading();
                    }
                });
            })
            .catch((e) => {
                this.unlock();

                console.error(e);

                this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Titles_Error'),
                    e.toString());
                this.msgs.hideLoading();
            });
    }

    _submit_OnParseApiResult_Bull(data, title) {
        if (`rBull` in data) {
            if (data.rBull !== null) {
                let name = data.rBull.Name === '' ?
                    data.rBull.Nr : data.rBull.Name;
                if (data.rBull.Nr2 !== null ||
                    data.rBull.Nr3 !== null ||
                    data.rBull.Nr4 !== null ||
                    data.rBull.Nr5 !== null)
                    name += ' (MIX)';
                this.lInfos_Bull.$fields.name = name;
                this.l.$fields.shows_Infos_Bull = true;
            }
        }
    }

    _submit_OnParseApiResult_Cows(data, title) {
        if (`rCows` in data) {
            if (data.rCows !== null) {
                let nrs = [];
                for (let row of data.rCows)
                    nrs.push(row.Nr);

                this[`lInfos_Cows`].$fields.nrs = nrs.join(', ');
                this.l.$fields[`shows_Infos_Cows`] = true;
            }
        }
    }

    _submit_OnParseApiResult_Info(data, title) {
        if (`r${title}` in data) {
            if (data[`r${title}`] !== null) {
                this[`lInfos_${title}`].$fields.row = data[`r${title}`];
                this.l.$fields[`shows_Infos_${title}`] = true;
            }
        }
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).Module {

    constructor(lb, panelName, panelTitle) {
        super(lb);
        this.panelName = panelName;
        this.panelTitle = panelTitle;

        lb.setBackButton(false);
        lb.setListener_OnBack(() => {
            this.listeners_Back();
            return true;
        });

        this.l = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).List);

        this.lInfos_Inseminator = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Inseminators_Info);
        this.l.$holders.infos_Inseminator.$view = this.lInfos_Inseminator;
        this.lInfos_Farmer = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Farmers_Info);
        this.l.$holders.infos_Farmer.$view = this.lInfos_Farmer;
        this.lInfos_Cows = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Cows_Info);
        this.l.$holders.infos_Cows.$view = this.lInfos_Cows;
        this.lInfos_Bull = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Bull_Info);
        this.l.$holders.infos_Bull.$view = this.lInfos_Bull;

        this.refresh_SetApiFields = (fields) => { return fields; };
        this.refresh_SetOnRefresh = (rows, colRefs) => { };
        this.refresh_OnApiResult = (result) => { };

        this.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.add`);
        };
        this.listeners_Back = () => {
            this.pager.setPage('lb.main');
        };

        this.l.$fields = {
            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_${panelTitle}`),
            texts: {
                Buttons_Add: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Buttons_Add'),
            },
            shows: {
                add: this.pager.hasPage(`lb.subpanels.${panelName}.add`) ?
                    true : false,
            },
            uris: {
                add: this.pager.hasPage(`lb.subpanels.${panelName}.add`) ?
                    this.pager.getPageUri(`lb.subpanels.${panelName}.add`) :
                    '#',
                back: this.pager.getPageUri('lb.main'),
            },
        };

        this.l.$elems.back.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.listeners_Back();
        });
        this.l.$elems.add.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.listeners_Add();
        });

        this.t = new (_jsLib.import("spk-tables", "./index", "default", "spkTables", "spk-tables")).Table(this.msgs, (_jsLib.import("core", "./tables", "default", "tables", "./tables.js"))[`tables_${panelTitle}`]())
            .setApiFields(() => {
                let fields = {};

                fields = this.refresh_SetApiFields(fields);

                return fields;
            })
            .setShowSearch(true)
            .setOnApiResult((data) => {
                this._table_SetOnApiResult_Info(data, 'Inseminator');
                this._table_SetOnApiResult_Info(data, 'Farmer');
                this._table_SetOnApiResult_Cows(data, 'Cows');
                this._table_SetOnApiResult_Bull(data, 'Bull');

                this.refresh_OnApiResult(data);
            })
            .setOnRefresh((rows, colRefs) => {
                this.refresh_SetOnRefresh(rows, colRefs);
            })
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                if (!('_Id' in colRefs))
                    return '#';

                return this.pager.getPageUri(`lb.subpanels.${panelName}.edit`,
                    { id: row.cols[colRefs._Id].value, });
            });

        this.l.$holders.table.$view = this.t;

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        this.$view = this.l;
    }

    deleteSelected(ids, onDeleteFn) {
        if (ids.length === 0) {
            this.msgs.showMessage_Failure((_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Errors_NoRowsSelected'));
            return;
        }

        this.msgs.showConfirmation(
            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Confirmations_DeleteSelected'), '',
            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Text_Yes'),
            (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).eText('Sys:Text_No'), (result) => {
                if (!result)
                    return;

                this.msgs.showLoading();

                let fields = {
                    ids: [],
                };
                for (let id of ids) {
                    fields.ids.push(Number(id));
                }

                (_jsLib.import("core", "./helper", "*", "helper", "./helper.js")).api_DeleteSelected_Async(this.panelTitle, fields)
                    .then((response) => {
                        (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseRequestResponse(this, response, (result) => {
                            if (result.success)
                                onDeleteFn(result);
                            else {
                                this.msgs.showMessage_Failure(result.message);
                                this.msgs.hideLoading();
                            }
                        });
                    })
                    .catch((e) => {
                        console.error(e);

                        this.msgs.showMessage_Failure(e.toString());
                        this.msgs.hideLoading();
                    });
            });
    }

    _table_SetOnApiResult_Bull(data, title) {
        if (`rBull` in data) {
            if (data.rBull !== null) {
                let name = data.rBull.Name === '' ?
                    data.rBull.Nr : data.rBull.Name;
                if (data.rBull.Nr2 !== null ||
                    data.rBull.Nr3 !== null ||
                    data.rBull.Nr4 !== null ||
                    data.rBull.Nr5 !== null)
                    name += ' (MIX)';
                this.lInfos_Bull.$fields.name = name;
                this.l.$fields[`shows_Infos_Bull`] = true;
            }
        }
    }

    _table_SetOnApiResult_Cows(data, title) {
        if (`rCows` in data) {
            if (data.rCows !== null) {
                let nrs = [];
                for (let row of data.rCows)
                    nrs.push(row.Nr);
                this[`lInfos_Cows`].$fields.nrs = nrs.join(', ');
                this.l.$fields[`shows_Infos_Cows`] = true;
            }
        }
    }

    _table_SetOnApiResult_Info(data, title) {
        if (`r${title}` in data) {
            if (data[`r${title}`] !== null) {
                this[`lInfos_${title}`].$fields.row = data[`r${title}`];
                this.l.$fields[`shows_Infos_${title}`] = true;
            }
        }
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\NativeApp.js
jsLibs.exportScript("core", "./NativeApp", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("ab-date", "./index", [  ], "ab-date");
_jsLib.importDeclaration("ab-text", "./index", [  ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("core", "./index", [ { name: "default", alias: "core" } ], "core");
_jsLib.importDeclaration("core", "./Actions", [ { name: "default", alias: "Actions" } ], "./Actions.js");

/* export default */ class NativeApp {
    get actions() {
        return (_jsLib.import("js0", "./index", "default", "js0", "js0")).rtn((_jsLib.import("core", "./Actions", "default", "Actions", "./Actions.js")), this.__getActions());
    }

    get dataScheme() {
        return (_jsLib.import("core", "./index", "default", "core", "core")).App.GetInstance().dataScheme;
    }

    get dataStore() {
        if (this._dataStore === null)
            throw new Error('Data store not set.');

        return this._dataStore;
    }
    
    get debug() {
        return this._debug;
    }


    constructor() {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments);
    }

    // async init_Async() {
    //     js0.rtn(js0.Void, await this.__init_Async());
    // }

    setDebug(debug) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'boolean');
        this._debug = debug;
    }

    setDataStore(dataStore) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).DataStore);

        this._dataStore = dataStore;
    }

    
    __getActions() { (_jsLib.import("js0", "./index", "default", "js0", "js0")).virtual(this); }
    // async __init_Async() { js0.virtual(this); };
}

/* JSLib Exports */
_jsLib.export("default", NativeApp); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panels.js
jsLibs.exportScript("core", "./panels", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");
_jsLib.importDeclaration("core", "./Main", [ { name: "default", alias: "Main" } ], "./Main.js");

_jsLib.importDeclaration("core", "./panelDatas/index", [ { name: "*", alias: "panelDatas" } ], "./panelDatas/index.js");

class panels_Class {
    constructor() {

    }

    create(mMain) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("core", "./Main", "default", "Main", "./Main.js")));

        let panels = [];
        let user = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance().user;

        if (user.isFarmer) {
            panels.push(this.panels_NewReceipt(user));
            panels.push(this.panels_NewReceipt_Shortcut(user));
            panels.push(this.panels_Receipts(user));
            panels.push(this.panels_Cows(user));
            panels.push(this.panels_Bulls(user));

            panels.push(this.panels_Associations(user));
        } else if (user.isInseminator) {
            panels.push(this.panels_NewReceipt(user));
            panels.push(this.panels_NewReceipt_Shortcut(user));
            panels.push(this.panels_Receipts(user));
            panels.push(this.panels_Farmers(user));
            panels.push(this.panels_Cows(user));
            panels.push(this.panels_Bulls(user));

            let pCows = this.panels_Cows(user);
            pCows['shortcut'] = false;
            pCows['menu']['shortcut'] = false;
            panels.push(pCows);

            let pAssociations = this.panels_Associations();
            pAssociations['shortcut'] = false;
            pAssociations['menu']['shortcut'] = false;
            panels.push(pAssociations);
        // } else if (user.isClinic) {
        //     panels.push(this.panels_Receipts(user));
        //     panels.push(this.panels_Inseminators(user));
        //     panels.push(this.panels_Farmers(user));
        //     panels.push(this.panels_Cows(user));
        //     panels.push(this.panels_Bulls(user));

        //     let pCows = this.panels_Cows(user);
        //     pCows['shortcut'] = false;
        //     pCows['menu']['shortcut'] = false;
        //     panels.push(pCows);

        //     let pAssociations = this.panels_Associations();
        //     pAssociations['shortcut'] = false;
        //     pAssociations['menu']['shortcut'] = false;
        //     panels.push(pAssociations);
        } else if (user.isAdministrator) {
            panels.push(this.panels_Receipts(user));
            // panels.push(this.panels_Clinics(user));
            panels.push(this.panels_Inseminators(user));
            panels.push(this.panels_Farmers(user));
            panels.push(this.panels_Bulls(user));
            panels.push(this.panels_Traders(user));
            panels.push(this.panels_Administrators(user));
            panels.push(this.panels_Registrations(user));

            panels.push(this.panels_Backups(user));

            let pCows = this.panels_Cows(user);
            pCows['shortcut'] = false;
            pCows['menu']['shortcut'] = false;
            panels.push(pCows);
        } else if (user.isTrader) {
            panels.push(this.panels_Receipts(user));
            // panels.push(this.panels_Clinics(user));
            panels.push(this.panels_Inseminators(user));
            panels.push(this.panels_Farmers(user));
            panels.push(this.panels_Bulls(user));

            let pCows = this.panels_Cows(user);
            pCows['shortcut'] = false;
            pCows['menu']['shortcut'] = false;
            panels.push(pCows);
        }

        // if (App.Platform === 'web')
        panels.push(this.panels_About(user));

        if ((_jsLib.import("core", "./App", "default", "App", "./App.js")).Platform === 'native') {
            // panels.push(this.panels_SetPrinter_Shortcut(user));
            // panels.push(this.panels_LogOut_Shortcut(user));
            // panels.push(this.panels_ClearData_Shortcut(user));
            panels.push(this.panels_Refresh_Shortcut(user));
        }

        return panels;
    }

    createAll() {
        let panels = [];

        panels.push(this.panels_Administrators(null));
        panels.push(this.panels_Associations(null));
        panels.push(this.panels_Backups(null));
        panels.push(this.panels_Bulls(null));
        // panels.push(this.panels_Clinics(null));
        panels.push(this.panels_Cows(null));
        panels.push(this.panels_Farmers(null));
        panels.push(this.panels_Inseminators(null));
        panels.push(this.panels_NewReceipt(null));
        panels.push(this.panels_Receipts(null));
        panels.push(this.panels_Registrations(null));
        panels.push(this.panels_Traders(null));

        // if (App.Platform === 'web')
        panels.push(this.panels_About(null));

        if ((_jsLib.import("core", "./App", "default", "App", "./App.js")).Platform === 'native') {
            panels.push(this.panels_ClearData_Shortcut(null));
            panels.push(this.panels_Refresh_Shortcut(null));
            panels.push(this.panels_LogOut_Shortcut(null));
        }

        return panels;
    }

    panels_About(user) {
        let panel = this.createPanel_Basic('about', 'About');
        panel.faIcon = 'fas fa-cog';

        let subpanel = this.createSubpanel_Basic('spk-e-sys', 'about', 
                'About', 'basic', 'Basic', 'fas fa-cog');

        panel['subpanels'].push(subpanel);

        return panel;
    }

    panels_Administrators() {
        let panel = this.createPanel_Basic('administrators', 'Administrators');
        this.addSubpanels_Table(panel, 'administrators', 'Administrators');

        return panel;
    }

    panels_Associations() {
        let panel = this.createPanel_Basic('associations', 'Associations');
        this.addSubpanels_Table(panel, 'associations', 'Associations');

        panel['subpanels'][0]['alias'] += '/:farmerId=0';
        panel['subpanels'][1]['alias'] += '/:farmerId=0';
        panel['subpanels'][1]['shortcut'] = false;

        return panel;
    }

    panels_Backups() {
        let panel = this.createPanel_Basic('backups', 'Backups');
        panel.faIcon = "fas fa-toolbox";

        let subpanel = this.createSubpanel_Basic('spk-e-sys', 'backups', 
                'Backups', 'basic', 'Basic', 'fas fa-toolbox');
        panel['subpanels'].push(subpanel);

        return panel;
    }

    panels_Bulls(user) {
        let panel = this.createPanel_Basic('bulls', 'Bulls');
        this.addSubpanels_Table(panel, 'bulls', 'Bulls');

        panel['subpanels'][0]['alias'] += '/:clientId=0';
        panel['subpanels'][1]['alias'] += '/:clientId=0/:newReceipt_CowIds=0';
        panel['subpanels'][2]['alias'] += '/:clientId=0';

        if (user !== null) {
            if (user.isTrader)
                panel['subpanels'].splice(1, 1);
        }

        return panel;
    }

    panels_ClearData_Shortcut() {
        let panel = this.createPanel_Basic('clearData_Shortcut', 'ClearData_Shortcut');

        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-trash',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

            app.mMain.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_ClearData'),
                    (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), (result) => {
                if (!result)
                    return;

                app.mMain.msgs.showLoading();

                console.log('Clearing data...');
                app.clearData_Async()
                    .then(() => {
                        console.log('Data cleared.');
                        
                        app.mMain.msgs.hideLoading();
                        app.mMain.pager.setPage(app.mMain.pager.current.name, 
                                app.mMain.pager.current.args);
                    })
                    .catch((e) => {
                        console.error(e);
    
                        app.mMain.msgs.showMessage_Failure(e.toString());
                        app.mMain.msgs.hideLoading();
                    });
            });
        }
        
        return panel;
    }

    panels_Clinics() {
        let panel = this.createPanel_Basic('clinics', 'Clinics');
        this.addSubpanels_Table(panel, 'clinics', 'Clinics');

        return panel;
    }

    panels_Cows() {
        let panel = this.createPanel_Basic('cows', 'Cows');
        this.addSubpanels_Table(panel, 'cows', 'Cows');

        panel['subpanels'][0]['alias'] += '/:farmerId=0';
        panel['subpanels'][1]['alias'] += '/:farmerId=0/:newReceipt=0/:selectedCows=0';

        return panel;
    }

    panels_Farmers() {
        let panel = this.createPanel_Basic('farmers', 'Farmers');
        this.addSubpanels_Table(panel, 'farmers', 'Farmers');

        panel['subpanels'][1]['alias'] += '/:farmerId=0/:newReceipt=0';

        return panel;
    }

    panels_LogOut_Shortcut() {
        let panel = this.createPanel_Basic('logOut_Shortcut', 'LogOut_Shortcut');

        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-sign-out-alt',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

            app.mMain.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_LogOut'),
                    (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), (result) => {
                if (!result)
                    return;

                app.mMain.msgs.showLoading();

                app.logOut_Async()
                    .then(() => {
                        console.log('Logged out.');
                        
                        app.mMain.msgs.hideLoading();
                        app.mMain.pager.setPage('lb.main');
                    })
                    .catch((e) => {
                        console.error(e);

                        app.mMain.msgs.showMessage_Failure(e.toString());
                        app.mMain.msgs.hideLoading();
                    });
            });
        }
        
        return panel;
    }

    panels_Inseminators() {
        let panel = this.createPanel_Basic('inseminators', 'Inseminators');
        this.addSubpanels_Table(panel, 'inseminators', 'Inseminators');

        return panel;
    }

    panels_NewReceipt() {
        let panel = this.createPanel_Basic('newReceipt', 'NewReceipt');

        let panelName = 'newReceipt';
        let panelTitle = 'NewReceipt';

        panel['subpanels'].push(this.createSubpanel_Basic('spk-e-sys', 
                panelName, panelTitle, 'farmer', 'Farmer', 'fas fa-list'));
        
        let subpanel = null;
        
        subpanel = this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'cow', 'Cow', 'fas fa-list');
        subpanel['alias'] += '/:farmerId=0/:selectedCows=0';
        panel['subpanels'].push(subpanel);

        subpanel = this.createSubpanel_Basic('spk-e-sys', panelName, panelTitle, 
                'bull', 'Bull', 'fas fa-list');
        subpanel['alias'] += '/:cowIds/:clientId=0/:selectedBulls=0';
        subpanel['shortcut'] = false;
        panel['subpanels'].push(subpanel);        

        subpanel = this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'details', 'Details', 'fas fa-file');
        subpanel['alias'] += '/:cowIds/:bullId';
        subpanel['shortcut'] = false;
        panel['subpanels'].push(subpanel);

        return panel;
    }

    panels_NewReceipt_Shortcut(user) {
        let panel = this.createPanel_Basic('newReceipt_Shortcut', 'NewReceipt_Shortcut');

        panel['image'] = null;
        panel['shortcut'] = false;
        panel['alias'] = (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Aliases_NewReceipt') + '/' +
                (user.isFarmer ? 
                ((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Aliases_Cow') + '/0/0') :
                ((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Aliases_Farmer')));

        panel['alias'] = panel['alias'].replace(/#/g, '');
        
        return panel;
    }

    panels_Receipts(user) {
        let panel = this.createPanel_Basic('receipts', 'Receipts');
        this.addSubpanels_Table(panel, 'receipts', 'Receipts');

        let isFarmer = user === null ? false : user.isFarmer;

        panel['subpanels'][1]['moduleFn'] = null;        
        panel['subpanels'][1]['uri'] = abNative_Base + 
                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Aliases_NewReceipt') + '/' +
                (isFarmer ? 
                ((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Aliases_Cow') + '/0/0') :
                ((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Aliases_Farmer')));

        if (user !== null) {
            if (user.isAdministrator || user.isTrader || user.isClinic)
                panel['subpanels'].splice(1, 1);
        }

        return panel;
    }

    panels_Registrations() {
        let panel = this.createPanel_Basic('registrations', 'Registrations');
        this.addSubpanels_Table(panel, 'registrations', 'Registrations');

        panel['subpanels'].splice(1, 1);

        return panel;
    }

    panels_SetPrinter_Shortcut(user) {
        let panel = this.createPanel_Basic('setPrinter_Shortcut', 'SetPrinter_Shortcut');

        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-print',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

            app.nativeApp.nativeActions.callNative_Async('SetPrinter', {})
                .then((result) => {
                    console.log('Setting Printer', result.success);
                })
                .catch((e) => {
                    
                });
        }
        
        return panel;
    }

    panels_Refresh_Shortcut(user) {
        let panel = this.createPanel_Basic('refresh_Shortcut', 'Refresh_Shortcut');

        panel['image'] = null;
        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-sync',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

            app.isConnectedToInternet_Async()
                .then((result) => {
                    if (!result) {
                        app.mMain.msgs.showMessage_Failure(
                                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Messages_NoInternetConnection'));
                        return;
                    }

                    return app.syncDB_Async()
                        .then(() => {
                            app.mMain.pager.setPage(app.mMain.pager.current.name, 
                                    app.mMain.pager.current.args);
                        });
                });
        }
        
        return panel;
    }

    panels_Traders() {
        let panel = this.createPanel_Basic('traders', 'Traders');
        this.addSubpanels_Table(panel, 'traders', 'Traders');

        return panel;
    }


    /* Panels */
    createPanel_Basic(panelName, panelTitle) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string');

        let panel = {
            'name': panelName,
            'permissions': [ `Sys_${panelTitle}` ],
            'alias': (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Aliases_${panelTitle}`).replace(/#/g, ''),
            'title': (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_${panelTitle}`),
            'image': `${(_jsLib.import("core", "./App", "default", "App", "./App.js")).Base}res/images/panels/${panelName}.png`,

            'shortcut': true,

            'menu': {
                'shortcut': true,
                'uri': null,
                'action': null,
            },

            'subpanels': []
        };

        return panel;
    }

    createSubpanel_Basic(packageName, panelName, panelTitle, subpanelName, 
            subpanelTitle, faIcon) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', 'string', 'string', 'string', 'string', 
                'string');

        let subpanel = {
            'name': subpanelName,
            'moduleFn': (lb) => { return new ((_jsLib.import("core", "./panelDatas/index", "*", "panelDatas", "./panelDatas/index.js"))[panelName][subpanelTitle])(lb); },
            'alias': (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Aliases_${subpanelTitle}`).replace(/#/g, ''),
            'title': (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_${subpanelTitle}`),
            'faIcon': faIcon,
            'image': `${(_jsLib.import("core", "./App", "default", "App", "./App.js")).Base}res/images/panels/${subpanelName}.png`,
            
            'shortcut': true,
        };

        return subpanel;
    }

    addSubpanels_Table(panel, panelName, panelTitle) {
        panel['subpanels'].push(this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'list', 'List', 'fas fa-list'));
        panel['subpanels'].push(this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'add', 'Add', 'fas fa-plus'));
        panel['subpanels'].push(this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'edit', 'Edit', 'fas fa-edit'));
        panel['subpanels'][2]['alias'] += '/:id';
        panel['subpanels'][2]['shortcut'] = false;
    }
    /* / Panels */

}
const panels = new panels_Class();
/* export default */ panels;

/* JSLib Exports */
_jsLib.export("default", panels); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\sys.js
jsLibs.exportScript("core", "./sys", [ "User_ManageAccount","Module","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("ab-date", "./index", [ { name: "default", alias: "abDate" } ], "ab-date");
_jsLib.importDeclaration("ab-strings", "./index", [ { name: "default", alias: "abStrings" } ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("spk-lemon-bee", "./index", [ { name: "default", alias: "spkLemonBee" } ], "spk-lemon-bee");
_jsLib.importDeclaration("spk-tables", "./index", [ { name: "default", alias: "spkTables" } ], "spk-tables");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");
_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");
_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "./$layouts/index.js");

class sys_Class {
    get Module() {
        return Module;
    }

    get User_ManageAccount() {
        return User_ManageAccount;
    }

    get uris() {    
        return (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance().fields.uris;
    }

    get user() {
        return (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance().user;
    }


    constructor() {
        this.langs = [ 'PL' ];

        this.tables = new tables_Class();
    }

    createLayout(layoutClass) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'function');

        let l = new layoutClass();

        l.$fields.base = abNative_Base;

        l.$fields.eField = (fieldName) => {
            return '###NOT IMPLEMENTED###'; //this._getField(fieldName);
        };
        l.$fields.eText = (text) => {
            return (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(text);
        };

        l.$fields.eSys = {
            user: this.user,
        }

        return l;
    }

    delete(module, apiUri, successFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Module, 'string', 'function');

        module.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Adm:Confirmations_Delete'), '',
                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Adm:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Adm:Text_No'), (result) => {
            if (!result)
                return;

            module.msgs.showLoading();
            (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json(apiUri, { id: module.pager.current.args.id }, (result) => {
                this.parseApiResult(module, result, () => {
                    successFn();
                });
            });
        });
    }

    eText(text) {
        return (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(text);
    }

    formatReceiptForPrint(row) {
        let dateStr = (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date(row.Date);
        let fileNr = row.FileNr + dateStr[dateStr.length - 1];

        let row_Print = {
            Nr_Formatted: sys.formatReceiptNr(row.Nr),
            Date: dateStr,
            FileNr: fileNr,

            LastCalving: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date(row.LastCalving),
            SemenProduction: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date(row.SemenProduction),
            Sexed: row.Sexed,

            Cow_Name: row.Cow_Name,
            Cow_CowshedNr: row.Cow_CowshedNr,
            Cow_Race: row.Cow_Race,
            Cow_Nr: row.Cow_Nr,
            Cow_Birth: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date(row.Cow_Birth),

            Farmer_Client_Name: row.Farmer_Client_Name,
            Farmer_Client_Address: row.Farmer_Client_Address + 
                    `, ${row.Farmer_Client_City}`,
                    // `, ${row.Farmer_Client_City} ${row.Farmer_Client_ZipCode}`,

            Farmer_HerdNr: row.Farmer_HerdNr,
            Farmer_HerdUnderGradeNr: row.Farmer_HerdUnderGradeNr,
            TreatmentNr: row.TreatmentNr,
            ReinseminationsCount: row.ReinseminationsCount,
            SemenProduction: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date(row.SemenProduction),

            Bull_Name: row.Bull_Name + (row.Bull_Race === '' ? '' : ` (${row.Bull_Race})`),
            Bull_ManufacturerNr: row.Bull_ManufacturerNr,
            Bull_Nr: row.Bull_Nr,
            // Bull_Race: row.Bull_Race,

            Farmer_Client_Name: row.Farmer_Client_Name,
            InseminatorName: row.InseminatorName,

            NextHeat: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date_UTC(row.Date + (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).span_Day * 21),
            PlannedCalving: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date_UTC(row.Date + (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).span_Day * 282),

            Bull_Nr2: row.Bull_Nr2 === null ? '-' : row.Bull_Nr2,
            Bull_Nr3: row.Bull_Nr3 === null ? '-' : row.Bull_Nr3,
            Bull_Nr4: row.Bull_Nr4 === null ? '-' : row.Bull_Nr4,
            Bull_Nr5: row.Bull_Nr5 === null ? '-' : row.Bull_Nr5,

            BullSexed: row.BullSexed,
        };

        return row_Print;
    }

    formatReceiptNr(nr) {
        if (nr === 0)
            return '-';

        return 'AL' + (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).pad(String(nr), '0', 7);
    }

    getUriArg(module, argName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Module, 'string');

        return argName in module.pager.current.args ? 
                module.pager.current.args[argName] : null;
    }

    getResponseErrorInfo(response) {
        if ('webResult' in response.info) {
            let webResult = response.info.webResult;

            let webResultError = this.getWebResultErrorInfo(webResult);

            if (webResultError !== null)
                return webResultError;
        }

        if (response.type > (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response.Types_ResultFailure) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_Other'),
                message: response.errorMessage,
            };
        } else if (response.type == (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response.Types_ResultFailure) {
            let resultError = (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).debug ? response.errorMessage : ''; 
            for (let requestId of response.requestIds) {
                let result = response.results[requestId];

                if (result.data !== null) {
                    if ('validator' in result.data) {
                        if (!result.data.validator.valid)
                            return null;
                    }
                }

                if (result.error !== null) {
                    if (resultError !== '')
                        resultError += ' ';
                    resultError += response.results[requestId].error;
                }
            }

            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_ResultError'),
                message: resultError,
            };
        }

        return null;
    }

    getWebResultErrorInfo(webResult) {
        if (webResult.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).Result.ErrorResults_Other) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_Other'),
                message: webResult.message,
            }
        } else if (webResult.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).Result.ErrorResults_HttpRequestError) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Errors_Response_HttpRequestError'),
                message: '',
            };
        } else if (webResult.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).Result.ErrorResults_CannotParseJSON) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Response_CannotParseJSON'),
                message: webResult.data.data,
            };
        } else if (webResult.result === (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).Result.ErrorResults_WrongResultFormat) {
            return {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Errors_Response_WrongResultFormat'),
                message: '',
            };
        }

        return null;
    }

    parseApiResult(module, result, fn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Module, (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).Result, 'function');

        if (result.isSuccess())
            fn();
        else if (result.isFailure()) {
            if (module.f !== null) {
                if ('validator' in result.data) {
                    module.f.setValidator(result.data.validator);
                    module.msgs.hideLoading();
                    return;
                }
            }

            module.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Error'), 
                    result.message);
            module.msgs.hideLoading();
        } else {
            let errorInfo = this.getWebResultErrorInfo(result);

            module.msgs.showMessage_Failure(errorInfo.title, errorInfo.message);
            module.msgs.hideLoading();
        }
    }

    parseRequestResponse(module, response, fn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Module, (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response, 
                'function');

        if ((_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Debug)
            console.log('Api Result', module, response);

        let errorInfo = this.getResponseErrorInfo(response);
        
        if (errorInfo !== null) {
            module.msgs.showMessage_Failure(errorInfo.title, errorInfo.message);
            module.msgs.hideLoading();

            return;
        }
        
        let actionError = response.actionErrors.request;
        let result = response.results.request;

        if (actionError !== null) {
            if ((_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Debug)
                console.error(actionError);

            module.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                    'Sys:Errors_Response_ResultError'), actionError.message);
            module.msgs.hideLoading();

            return;
        }

        fn(result);
    }

    parseTableRequestResponse(tables, columns, response) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Object, Array, (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).Response);

        if ((_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).debug)
            console.log('Api Result',response);

        let errorInfo = this.getResponseErrorInfo(response);

        if (errorInfo !== null) {
            return {
                data: {
                    table: null,
                },
                error: errorInfo.message,
            };
        }

        let result = response.results.request;
        let table = null;

        if (result.error === null)
            result.data.table = tables.parseRows(columns, result.data.rows);

        return {
            data: result.data,
            error: result.error,
        };
    }

    setLayoutFields_List(module, panelTitle, panelName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Module, 'string', 'string');

        module.l.$fields = {
            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Adm:Titles_${panelTitle}`),
            show: {
                add: true,
            },
            uris: {
                add: module.pager.getPageUri(`lb.subpanels.${panelName}.add`),
                back: module.pager.getPageUri('lb.main'),
            },
        };

        module.t = new (_jsLib.import("spk-tables", "./index", "default", "spkTables", "spk-tables")).Table(this.msgs, eLibs.eField('tables').Routers)
            .setShowSearch(true)
            .setOnRefresh((rows, colRefs) => {
                
            })
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri('lb.subpanels.routers.edit',
                        { id: row.cols[colRefs._Id].value, });
            });
        this.t.refresh();
    }

}


class tables_Class {

    format(rows, colRefs, colName, formatFn) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, 'object', 'string', 'function');

        if (!(colName in colRefs))
            throw new Error(`Column '${colName}' does not exist in table`);

        for (let i = 0; i < rows.length; i++) {
            let col = rows[i].cols[colRefs[colName]];

            formatFn(col, rows[i]);
        }
    }

    formatBool(table, rows, colRefs, colName, onlyCheck = false) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-tables", "./index", "default", "spkTables", "spk-tables")).Table, Array, 'object', 'string', 
                [ 'boolean', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        let colRef = colRefs[colName];

        table.l.$fields.table.headers(colRef).class = 'text-center';

        for (let i = 0; i < rows.length; i++) {
            let col = rows[i].cols[colRef];

            col.class = 'text-center';
            col.html = col.value ? 
                    '<i class="fa fa-check" />' : 
                    (onlyCheck ? '' : '<i class="fa fa-times" />');
        }
    }

    formatDate(rows, colRefs, colName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, 'object', 'string');

        this.format(rows, colRefs, colName, (col) => {
            col.html = col.value === null ? '-' : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date(col.value);
        });
    }

    formatDate_UTC(rows, colRefs, colName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, 'object', 'string');

        this.format(rows, colRefs, colName, (col) => {
            col.html = col.value === null ? '-' : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date_UTC(col.value);
        });
    }

    formatDateTime(rows, colRefs, colName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, 'object', 'string');

        let colRef = colRefs[colName];

        for (var i = 0; i < rows.length; i++) {
            var col = rows[i].cols[colRef];
            col.html = col.value === null ? '-' : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_DateTime(col.value);
        }
    }

    formatDateTime_Microseconds(rows, colRefs, colName) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, Array, 'object', 'string');

        let colRef = colRefs[colName];

        for (var i = 0; i < rows.length; i++) {
            var col = rows[i].cols[colRef];
            col.html = col.value === null ? '-' : (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_DateTime(
                Math.floor(col.value / 1000));
        }
    }

}


/* export */ class User_ManageAccount {

    constructor(module) {
        this.module = module;
        this.l = sys.createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "./$layouts/index.js")).Users_ManageAccount);

        this.l.$elems.activate_Activate.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._activate(true);
        });
        this.l.$elems.activate_Deactivate.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._activate(false);
        });

        this.l.$elems.resetPassword.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._resetPassword();
        });

        module.m.fm.m.lContent.$holders.user_ManageAccount.$view = this.l;
    }

    refresh_OnParseApiResult(data) {
        if (data.rUser === null) {
            this.l.$fields.show = false;
            return;
        }
        
        this.l.$fields.show = true;

        this.l.$fields.shows.activate = true;
        this.l.$fields.shows.deactivate = true;

        if (data.rUser.User_Active) {
            this.l.$fields.shows.activate = false;
            this.l.$fields.shows.deactivate = true;
        } else {
            this.l.$fields.shows.activate = true;
            this.l.$fields.shows.deactivate = false;
        }
    }


    _activate(active) {
        this.module.msgs.showLoading();

        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json(sys.uris.pages[`api.users`] + 'activate', 
                { id: this.module.m.fm.m.data.row.User__Id, 
                active: active, }, 
                (result) => {
            if (result.isSuccess())
                this.module.m.fm.m.refresh();
            else {
                this.module.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Error'),
                        result.message);
                this.module.msgs.hideLoading();
            }
        });
    }

    _resetPassword() {
        this.module.msgs.showLoading();

        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json(sys.uris.pages[`api.users`] + 'reset-password', 
                { id: this.module.m.fm.m.data.row.User__Id, }, 
                (result) => {
            if (result.isSuccess()) {
                this.module.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Successes_Success'));
                this.module.msgs.hideLoading();
            } else {
                this.module.msgs.showMessage_Failure(result.message);
                this.module.msgs.hideLoading();
            }
        });
    }

}


/* export */ class Module extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {

    constructor(lb) { super();
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("spk-lemon-bee", "./index", "default", "spkLemonBee", "spk-lemon-bee")).System);

        this.lb = lb;
        this.msgs = lb.msgs;
        this.pager = lb.pager;
        this.l = null;
        this.f = null;

        this._locked = false;
    }

    eText(text, args = []) {
        (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, 'string', [ Array, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Default ]);

        return (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$s.get(text, args);
    }

    isLocked() {
        return this._locked;
    }

    lock() {
        this._locked = true;
        this.lb.lock();
    }

    unlock() {
        this._locked = false;
        this.lb.unlock();
    }

}
const sys = new sys_Class();
/* export default */ sys;

/* JSLib Exports */
_jsLib.export("User_ManageAccount", User_ManageAccount);
_jsLib.export("Module", Module);
_jsLib.export("default", sys); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\Select.js
jsLibs.exportScript("core", "./Select", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("js0", "./index", [  ], "js0");

_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "./sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [  ], "./$layouts/index.js");

/* export default */ class Select extends (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).Module {

    constructor(lb, buttonLayout, table, viewInfo = null, onActiveFn = null) {
        super(lb);

        this._viewInfo = viewInfo;
        this._onActiveFn = onActiveFn;

        this._active = false;

        this.t = table;
        this.l = (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).createLayout(buttonLayout);

        this.l.$elems.select.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.setActive(!this._active);
        });

        this.$view = this.l;
    }

    setActive(active) {
        this._active = active;
        this.t.setSelectable(this._active);
        this.l.$fields.active = this._active;

        if (this._viewInfo !== null) {
            this._viewInfo[0].$view = this._active ? 
                    this._viewInfo[2] : this._viewInfo[1];
        }

        if (this._onActiveFn !== null)
            this._onActiveFn(this._active);
    }

}

/* JSLib Exports */
_jsLib.export("default", Select); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\tables.js
jsLibs.exportScript("core", "./tables", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-strings", "./index", [  ], "ab-strings");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("js0", "./index", [  ], "js0");

_jsLib.importDeclaration("core", "./helper", [  ], "./helper.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "./sys.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "./App.js");

class tables_Class {
    tables_Administrators() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: 'Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'User_Email',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Email'),
            }
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_Administrators', 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Name', 
                reverse: false,
            },
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_AssociatedBulls() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let tableInfo = {
            columns: [
                {
                    name: '_Id',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
                    orderBy: {
                        priority: 1,
                        reverse: false,
                    },
                }, {
                    name: 'Bull__Id',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
                }, {
                    name: 'Bull_Name',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Name'),
                }, {
                    name: 'Inb',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Inb'),
                }
            ],
            orderBy: {
                columnName: '_Id', 
                reverse: true,
            },
        };

        return {
            columns: tableInfo.columns,
            hiddenColumnNames: [ '_Id', 'Bull__Id' ],
            orderBy: tableInfo.orderBy,

            apiUri: null,
            fn: null,

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Associations() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'Cow_Nr',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Cow'),
            }, {
                name: 'Cow_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Cow_FirstName'),
            }, {
                name: 'Bull_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
            }, {
                name: 'Inb',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Inb'),
            }
        ];

        return {
            columns: columns,
            hiddenColumnNames: [ '_Id' ],
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async(`Sys_Associations`, 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: {
                columnName: 'Cow_Nr', 
                reverse: true,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Bulls() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: '_Modified_DateTime',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Modified_DateTime'),
            }, {
                name: 'ClientBull__Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: 'ClientBull__Modified_DateTime',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Modified_DateTime'),
            }, {
                name: 'Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Name'),
                orderBy: {
                    priority: 2,
                    reverse: false,
                },
            }, {
                name: 'Nr',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Race',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Race'),
            }, {
                name: 'ClientBull_StrawsConvCount_Client',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_StrawsConvCount_Client'),
            }, {
                name: 'ClientBull_StrawsConvCount_Company',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_StrawsConvCount_Company'),
            }, {
                name: 'ClientBull_StrawsSexedCount_Client',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_StrawsSexedCount_Client'),
            }, {
                name: 'ClientBull_StrawsSexedCount_Company',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_StrawsSexedCount_Company'),
            }, {
                name: 'Client_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Client'),
            }, {
                name: 'Nr2',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Nr3',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Nr4',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Nr5',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            },
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async(`Sys_Bulls`, 'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            'hiddenColumnNames': [ '_Id', 
                    'ClientBull__Id', 'ClientBull__Modified_DateTime', 
                    'Client_Name', 'ClientBull_StrawsConvCount_Company',
                    'ClientBull_StrawsSexedCount_Company',
                    'Nr2', 'Nr3', 'Nr4', 'Nr5' ],
            orderBy: { 
                columnName: 'Name',
                reverse: false,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_CowHistory() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: 'Date',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Date'),
            }, {
                name: 'Nr_Formatted',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Bull_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_BullName'),
            },
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_CowHistory', 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Date', 
                reverse: false,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    // tables_Clinics()
    // {
    //     let app = App.GetInstance();

    //     let columns = [
    //         {
    //             name: '_Id',
    //             header: abText.$('Sys:TableHeaders_Id'),
    //         }, {
    //             name: 'Client_Name',
    //             header: abText.$('Sys:TableHeaders_FirstName'),
    //             orderBy: {
    //                 priority: 1, 
    //                 reverse: false, 
    //             },
    //         }, {
    //             name: 'User_Email',
    //             header: abText.$('Sys:TableHeaders_Email'),
    //         }, {
    //             name: 'Client_Trader_Name',
    //             header: abText.$('Sys:TableHeaders_Trader'),
    //         }
    //     ];

    //     return {
    //         columns: columns,
    //         apiUri: null,
    //         fn: async (fields) => {
    //             let response = await app.dataStore.request_Async('Sys_Clinics', 
    //                     'select', {
    //                 args: fields,
    //             });

    //             result.data.table = this.parseRows(columns, result.data.rows);

    //             return result;
    //         },
    //         orderBy: { 
    //             columnName: 'Client_Name', 
    //             reverse: false,
    //         },
    //     };
    // }

    tables_Cows() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: '_Modified_DateTime',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'Nr',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_FirstName'),
            }, {
                name: 'CowshedNr',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_CowshedNr'),
            }, {
                name: 'Birth',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Birth'),
            }, {
                name: 'Race',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Race'),
            },
        ];

        let cowHistory_TableInfo = this.tables_CowHistory();

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_Cows', 'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Nr', 
                reverse: false,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Farmers() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: 'OrdinalNumber',
                'refColumnName': null,
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_OrdinalNumber'),
            }, {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: '_Modified_DateTime',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'Client__Modified_DateTime',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'Client_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'Client_City',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_City'),
            }, {
                name: 'HerdUnderGradeNr',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_HerdUnderGradeNr'),
            }, {
                name: 'Inseminator_Client_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Inseminator'),
            }, {
                name: 'Trader_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Trader'),
            },
        ];

        return {
            columns: columns,

            'hiddenColumnNames': [ '_Id', '_Modified_DateTime', 
                    'Client__Modified_DateTime' ],

            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_Farmers', 'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Client_Name', 
                reverse: false,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Inseminators() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: 'OrdinalNumber',
                'refColumnName': null,
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_OrdinalNumber'),
            }, {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: 'Client_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'Client_City',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_City'),
            }, {
                name: 'Client_SymlekId',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_SymlekId'),
            }, {
                name: 'Client_Trader_Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Trader'),
            },
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_Inseminators', 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Client_Name', 
                reverse: false,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Receipts() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let tableInfo = {
            columns: [
                {
                    name: '_Id',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
                    orderBy: {
                        priority: 10, 
                        reverse: true,
                    },
                }, {
                    name: '_Modified_DateTime',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Modified_Datetime'),
                }, {
                    name: 'Nr',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Nr'),
                }, {
                    name: 'Date',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_InseminationDate'),
                }, {
                    name: 'Added',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Added'),
                }, {
                    name: 'Farmer_Client_Name',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Farmer'),
                }, {
                    name: 'Farmer_HerdUnderGradeNr',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_HerdUnderGradeNr'),
                }, {
                    name: 'InseminatorName',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Inseminator'),
                }, {
                    name: 'Cow_Nr',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Cow'),
                }, {
                    name: 'Bull_Name',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
                }, {
                    name: 'Bull_Nr',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
                }, {
                    name: 'Bull_Nr2',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
                }, {
                    name: 'Bull_Nr3',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
                }, {
                    name: 'Bull_Nr4',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
                }, {
                    name: 'Bull_Nr5',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Bull'),
                // }, {
                //     name: 'Downloaded_Client',
                //     header: abText.$('Sys:TableHeaders_Downloaded'),
                }, {
                    name: 'Downloaded',
                    header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Symlek'),
                },
            ],
            orderBy: { 
                columnName: 'Added', 
                reverse: true,
            },
        };

        return {
            columns: tableInfo.columns,
            orderBy: tableInfo.orderBy,
            
            hiddenColumnNames: [ '_Id', '_Modified_DateTime', 'Bull_Nr', 
                    'Bull_Nr2', 'Bull_Nr3', 'Bull_Nr4', 'Bull_Nr5', ],

            apiUri: null,
            fn: async (fields) => {
                fields.tableInfo = tableInfo;
                let response = await app.dataStore.request_Async('Sys_Receipts', 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, tableInfo.columns, response);
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Registrations() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: 'Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: 'Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Name'),
            }, {
                name: 'Type',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_RegistrationType'),
            }, {
                name: 'DateTime',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Date'),
            },
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_Registrations', 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'DateTime', 
                reverse: true,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Traders() {
        let app = (_jsLib.import("core", "./App", "default", "App", "./App.js")).GetInstance();

        let columns = [
            {
                name: '_Id',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Id'),
            }, {
                name: 'Name',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1, 
                    reverse: false, 
                },
            }, {
                name: 'User_Email',
                header: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:TableHeaders_Email'),
            }
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.dataStore.request_Async('Sys_Traders', 
                        'select', {
                    args: fields,
                });

                return (_jsLib.import("core", "./sys", "default", "sys", "./sys.js")).parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Name', 
                reverse: false,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    parseRows(columns, rows) {
        let rows_Parsed = [];

        for (let row of rows) {
            let row_Parsed = [];
            for (let column of columns) {
                let columnName = column.name;
                if ('refColumnName' in column) {
                    if (column.refColumnName === null) {
                        row_Parsed.push(null);
                        continue;
                    }

                    columnName = columns.refColumnName;
                }

                if (!(columnName in row))
                    throw new Error(`No column '${columnName}' in row.`);

                row_Parsed.push(row[columnName]);
            }

            rows_Parsed.push(row_Parsed);
        }

        return rows_Parsed;
    }
}
const tables = new tables_Class();
/* export default */ tables;

/* JSLib Exports */
_jsLib.export("default", tables); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$ab-data\index.js
jsLibs.exportScript("core", "./$ab-data/index", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("ab-strings", "./index", [ { name: "default", alias: "abStrings" } ], "ab-strings");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");
_jsLib.importDeclaration("core", "./$ab-data/TableRequestDef_Core", [ { name: "default", alias: "TableRequestDef_Core" } ], "./TableRequestDef_Core.js");

const f = (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).fields;
const v = (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).validators;

/* export default */ function $abData(types) {
    (_jsLib.import("js0", "./index", "default", "js0", "js0")).args(arguments, (_jsLib.import("js0", "./index", "default", "js0", "js0")).Iterable((_jsLib.import("js0", "./index", "default", "js0", "js0")).Enum([ 'db', 'native' ])));

    let ds = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).DataScheme(8);

    ds
        .defT(tSys_AppMessages)
        .defT(tSys_Associations)
        .defT(tSys_Bulls)
        .defT(tSys_ClientBulls)
        .defT(tSys_Clients)
        .defT(tSys_Cows)
        // .defT(tSys_Devices)
        .defT(tSys_Farmers)
        .defT(tSys_Inseminators)
        .defT(tSys_Receipts)
        .defT(tSys_Traders)
        .defT(tSys_Users)

    if (types.includes('db')) {
        ds
            .ignoreT([ '_ABData_DeletedRows', '_ABData_DeviceRequests',
                '_ABData_DeviceRows', '_ABData_Devices',
                
                'App_Infos', 'Cache_Files', 'Config_Settings', 
                'Log_Logs', 'Session_Sessions', 'Sys_Registrations', 'Tasks_Tasks', 
                'Users_Users', 'Users_ResetPasswordHashes' ])

            .defT(tSys_Administrators)
            .defT(tSys_Clinics)
    }

    if (types.includes('native')) {
        ds.ignoreT([ 'Sys_Clinics' ]);

        ds
            // .defT('_ABData_DeviceInfos', tABData_DeviceInfos)
            .defT(tABData_DBRequests)
            .defT(tABData_Settings)
            .defT(tABData_DeviceDeletedRows)

            .defT(tNative_Settings)

        ds
            .defR('Sys_Associations', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Bulls', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Clients', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Cows', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Farmers', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Receipts', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Users', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())

            .defR('Sys_ClientBulls', new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).TableRequestDef())
    } else {
        ds
            .defR('Sys_Administrators', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Traders', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Inseminators', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())

            .defR('Sys_Associations', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Bulls', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_ClientBulls', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Clinics', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Cows', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Farmers', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())
            .defR('Sys_Receipts', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))())

            .defR('Sys_Registrations', new (_jsLib.import("core", "./$ab-data/TableRequestDef_Core", "default", "TableRequestDef_Core", "./TableRequestDef_Core.js"))());
    }

    return ds;
};

/* Tables */
/* System */
// let tABData_DeviceInfos = new abData.TableDef(101, '_ABData_DeviceInfos', 'abd_di', [
//     [ 'Id',             f.String(16, { notNull: true }) ],
//     [ 'RequestName',    f.String(16, { notNull: true }) ],
//     [ 'ActionName',     f.String(16, { notNull: true }) ],
//     [ 'ActionArgs',     f.JSON({ notNull: true }) ],
//         ])
//     .setPKs([ 'Id' ]);

let tABData_DeviceDeletedRows = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).TableDef(101, '_ABData_DeviceDeletedRows', 
        'abd_ddr', [
    [ 'TableId',    f.Int({ notNull: true }) ],
    [ 'RowId',      f.Long({ notNull: true }) ],
        ])
    .setPKs([ 'TableId', 'RowId' ]);

let tABData_DBRequests = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).TableDef(102, '_ABData_DBRequests', 'abd_dbr', [
    [ 'Id',             f.String(16, { notNull: true }) ],
    [ 'RequestName',    f.String(16, { notNull: true }) ],
    [ 'ActionName',     f.String(16, { notNull: true }) ],
    [ 'ActionArgs',     f.JSON({ notNull: true }) ],
    [ 'SchemeVersion',  f.Int({ notNull: false }) ],
        ])
    .setPKs([ 'Id' ]);

let tABData_Settings = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).TableDef(103, '_ABData_Settings', 'abd_s', [
    [ 'Name', f.String(16, { notNull: true, }) ],
    [ 'Data', f.JSON({ notNull: true}) ],
        ])
    .setPKs([ 'Name' ]);

/* Native */
let tNative_Settings = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).TableDef(201, '_Native_Settings', 'n_s', [
    [ 'Name', f.String(16, { notNull: true, }) ],
    [ 'Data', f.JSON({ notNull: true}) ],
        ])
    .setPKs([ 'Name' ]);

// let tTableIds = new abData.TableDef('_ABData_TableIds', 'abd_r', [
//     [ 'TableName',             f.String(16, { notNull: true }) ],
//     [ 'NextId',    f.String(16, { notNull: true }) ],
//         ])
//     .setPKs('TableName, NextId');


let tSys_Administrators = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1001, 'Sys_Administrators', 's_adm', [
    [ 'User__Id', f.Id({ notNull: false, }) ],
    [ 'Name', f.String(64, { notNull: true, }) ],
]);

let tSys_Associations = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1002, 'Sys_Associations', 's_a', [
    [ 'Cow__Id', f.Id({ notNull: true, }), ],
    [ 'Bull__Id', f.Id({ notNull: true, }), ],
    [ 'Inb', f.Float({ notNull: false, }) ],
]);

let tSys_Bulls = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1003, 'Sys_Bulls', 's_b', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],

    [ 'Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'FullName', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Nr', f.String(20, { notNull: true, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'ManufacturerNr', f.String(9, { notNull: true, }), {
        required: false,
    }],
    [ 'Race', f.String(2, { notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.Time({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(64, { notNull: true, }) ],

    /* v1.4.0 */
    [ 'Nr2', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Nr3', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Nr4', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Nr5', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
]);

let tSys_ClientBulls = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1004, 'Sys_ClientBulls', 's_cb', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],
    [ 'Bull__Id', f.Id({ notNull: false, }) ],
    [ 'StrawsConvCount_Client', f.Int({ notNull: false, }) ],
    [ 'StrawsConvCount_Company', f.Int({ notNull: false, }) ],
    [ 'StrawsSexedCount_Client', f.Int({ notNull: false, }) ],
    [ 'StrawsSexedCount_Company', f.Int({ notNull: false, }) ],
]);

let tSys_Clients = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1005, 'Sys_Clients', 's_cl', [
    [ 'User__Id', f.Id({ notNull: false, }) ],
    [ 'Trader__Id', f.Id({ notNull: false, }) ],

    [ 'SymlekId', f.String(6, { notNull: false, }), {
        'regexp': [ '^[0-9]{6}$', '123456' ],
    }],
    [ 'Name', f.String(64, { notNull: true, }) ],
    [ 'ShipTo', f.String(32, { notNull: true, }), {
        required: false,
    }],
    [ 'Address', f.String(256, { notNull: true, }), {
        required: false,
    }],
    [ 'City', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Phone', f.String(9, { notNull: true, }), {
        required: false,
        regexp: [ '^[0-9]{9}$', '123456789' ],
    }],
    [ 'District', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'PostalCode', f.String(16, { notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.Time({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(64, { notNull: true, }) ],
]);

let tSys_Cows = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1006, 'Sys_Cows', 's_c', [
    [ 'Farmer__Id', f.Id({ notNull: false, }) ],

    [ 'Nr', f.String(14, { notNull: true, }), {
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'CowshedNr', f.String(14, { notNull: true, }), {
        required: false,
        regexp: [ '^[0-9]{0,5}$', '12345' ],
    }],
    [ 'Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Race', f.String(2, { notNull: true, }), {
        required: false,
        minLength: 2,
        chars: (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).getCharsRegExp([ 'letters' ]),
    }],
    [ 'Birth', f.Time({ notNull: false, }), {
        type: 'date',
    }],
    [ 'LastCalving', f.Time({ notNull: false, }), {
        type: 'date',
    }],

    [ 'Added_Date', f.Time({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(64, { notNull: true, }) ],

    /* v1.0.1 */
    [ 'Genealogy_F_Nr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_F_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_FF_Nr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_FF_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_FM_Nr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_FM_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_M_Nr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_M_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_MF_Nr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_MF_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_MM_Nr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Genealogy_MM_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],

]);

// let tSys_Devices = new abData.RTableDef(1007, 'Sys_Devices', 's_d', [
//     [ 'Device_Id', f.Id({ notNull: true, }) ],
//     [ 'ReceiptNrs', f.JSON({ notNull: true, }) ],
//     [ 'ReceiptNrs_Last', f.Int({ notNull: true, }) ],
// ]);

let tSys_Farmers = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1008, 'Sys_Farmers', 's_f', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],
    [ 'Inseminator__Id', f.Id({ notNull: false, }) ],
    [ 'HerdNr', f.String(14, { notNull: true }), {
        required: false,
        regexp: [ '^[a-zA-Z]{2}[0-9]{12}$', 'AB123456789012' ],
    }],
    [ 'HerdUnderGradeNr', f.String(7, { notNull: false }), {
        regexp: [ '^[0-9]{7}$', '1234567' ],
    }],
    [ 'NotificationsEmail', f.String(128, { notNull: false }) ],

    /* v1.0.1 */
    [ 'Clinic__Id', f.Id({ notNull: false, }) ],
]);

let tSys_Inseminators = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1009, 'Sys_Inseminators', 's_i', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],

    /* v1.0.1 */
    [ 'Clinic__Id', f.Id({ notNull: false, }) ],
]);

let tSys_Receipts = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1010, 'Sys_Receipts', 's_r', [
    [ 'Trader__Id', f.Id({ notNull: false }) ],
    [ 'Farmer__Id', f.Id({ notNull: false }) ],
    [ 'Inseminator__Id', f.Id({ notNull: false }) ],
    [ 'Added', f.Time({ notNull: true }) ],
    [ 'Downloaded', f.Time({ notNull: false }) ],
    [ 'Downloaded_Client', f.Time({ notNull: false }) ],
    [ 'Nr', f.Int({ notNull: true }) ],
    // [ 'Nr_Formatted', f.Expr('IFNULL(s_r.Nr, CONCAT("' +
    //         abConfig.getRequired('Sys', 'receiptPrefix') +
    //         '", LPAD(s_r.Id, 7, 0)))'),
    //         f.String(9, { notNull: false }) ],
    [ 'Date', f.Time({ notNull: true }) ],
    [ 'FileNr', f.String(4, { notNull: true }), {
        chars: (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).getCharsRegExp([ 'digits' ]),
    }],
    [ 'TreatmentNr', f.String(2, { notNull: true }), {
        regexp: [ '^[0-9]{1,2}$', '1' ],
    }],
    [ 'ReinseminationsCount', f.String(2, { notNull: true }), {
        regexp: [ '^[0-9]{2}$', '01' ],
    }],
    [ 'LastCalving', f.Time({ notNull: false }) ],
    [ 'SemenProduction', f.Time({ notNull: false }), {
        required: false,
    }],
    [ 'Note', f.String(512, { notNull: true, }), {
        required: false,
        chars: (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).getCharsRegExp_Basic('\r\n'),
    }],
    
    [ 'InseminatorSymlekId', f.String(6, { notNull: false }) ],
    [ 'InseminatorName', f.String(64, { notNull: true }) ],

    [ 'Farmer_Client_Name', f.String(64, { notNull: true, }) ],
    [ 'Farmer_Client_Address', f.String(256, { notNull: true, }), {
        required: false,
    }],
    [ 'Farmer_Client_City', f.String(64, { notNull: true, }), {
        required: false,
    }],

    [ 'Farmer_HerdNr', f.String(14, { notNull: true }), {
        regexp: [ '^[a-zA-Z]{2}[0-9]{12}$', 'AB123456789012' ],
    }],
    [ 'Farmer_HerdUnderGradeNr', f.String(7, { notNull: false }), {
        regexp: [ '^[0-9]{7}$', '1234567' ],
    }],

    [ 'Cow_Nr', f.String(14, { notNull: true, }), {
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Cow_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Cow_Race', f.String(2, { notNull: true, }), {
        required: false,
        minLength: 2,
        chars: (_jsLib.import("ab-strings", "./index", "default", "abStrings", "ab-strings")).getCharsRegExp([ 'letters' ]),
    }],
    [ 'Cow_Birth', f.Time({ notNull: false, }) ],

    [ 'Bull_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Bull_Nr', f.String(20, { notNull: true, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Bull_ManufacturerNr', f.String(9, { notNull: true, }), {
        required: false,
    }],
    [ 'Bull_Race', f.String(2, { notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.Time({ notNull: true }) ],
    [ 'Added_User__Id', f.Long({ notNull: true }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true }) ],
    
    /* v1.0.1 */
    [ 'Clinic__Id', f.Id({ notNull: false, }) ],

    /* v4 */
    [ 'Bull_Nr2', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Bull_Nr3', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Bull_Nr4', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Bull_Nr5', f.String(20, { notNull: false, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],

    /* v8 */
    [ 'BullSexed', f.String(1, { notNull: true, }), {
        required: false,
        regexp: [ '^[XY]$', 'X/Y' ],
    }],
]);

let tSys_Traders = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1011, 'Sys_Traders', 's_t', [
    [ 'User__Id', f.Id({ notNull: false, }) ],
    [ 'Name', f.String(64, { notNull: true, }) ],
]);

let tSys_Users = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1012, 'Sys_Users', 's_u', [
    [ 'Email', f.String(128, { notNull: true }) ],
    [ 'Added_Date', f.Time({ notNull: true }) ],
    [ 'Added_User__Id', f.Long({ notNull: true }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true }) ],
        ])
    .addColumnValidator('Email', v.Email());

/* v1.0.1 */
let tSys_Clinics = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1013, 'Sys_Clinics', 's_cl', [
    [ 'Client__Id', f.Id({ notNull: true, }) ],
]);

/* v1.4.0 */
let tSys_AppMessages = new (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RTableDef(1014, 'Sys_AppMessages', 's_am', [
    [ 'User__Id', f.Id({ notNull: true, }), ],
    [ 'MessageId', f.Int({ notNull: true, }) ],
        ])
    .setPKs([ 'User__Id', 'MessageId' ]);

/* JSLib Exports */
_jsLib.export("default", $abData); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$ab-data\TableRequestDef_Core.js
jsLibs.exportScript("core", "./$ab-data/TableRequestDef_Core", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-data", "./index", [ { name: "default", alias: "abData" } ], "ab-data");
_jsLib.importDeclaration("js0", "./index", [ { name: "default", alias: "js0" } ], "js0");

class TableRequestDef_Core extends (_jsLib.import("ab-data", "./index", "default", "abData", "ab-data")).RequestDef {

    constructor() {
        super();

        this
            .defA('delete', 'r', {
                args: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            }, {
                data: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            })
            .defA('deleteSelected', 'r', {
                args: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            }, {
                data: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            })
            .defA('row', 'r', {
                args: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            }, {
                data: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            })
            .defA('select', 'r', {
                args: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            }, {
                data: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            })
            .defA('update', 'r', {
                args: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
            }, {
                data: (_jsLib.import("js0", "./index", "default", "js0", "js0")).RawObject,
                success: 'boolean',
                error: [ 'string', (_jsLib.import("js0", "./index", "default", "js0", "js0")).Null ],
            });
    }

}
/* export default */ TableRequestDef_Core;

/* JSLib Exports */
_jsLib.export("default", TableRequestDef_Core); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\app-messages\index.js
jsLibs.exportScript("core", "./app-messages/index", [ "default" ], (_jsLib) => { "use strict"; 
/* export default */ function appMessages(base) { return [
    {
        id: 4,
        archived: false,
        title: 'Dodano możliwość odznaczania nasienia seksowanego - 24.03.2026',
        content: 
`<p><img style="width: 100%; max-width: 480px;" src="${base}res/images/app-messages/m4_bull-sexed.jpg" /></p>`
        ,
    }, {
        id: 3,
        archived: false,
        title: 'Nowy adres strony systemu - 23.02.2026',
        content: 
`<p>Szanowni Użytkownicy,</p>
<p>informujemy, że serwis <b>altapokrycia.pl</b> zmienia nazwę oraz identyfikację wizualną i od teraz funkcjonuje jako <b>agpokrycia.pl</b>.</p>

<p><b>Zmiana dotyczy wyłącznie nazwy i wyglądu serwisu — wszystkie funkcjonalności oraz dostęp do kont użytkowników pozostają bez zmian.</b></p>

<p>Dziękujemy za zaufanie i zapraszamy do korzystania z agpokrycia.pl w nowej odsłonie.</p>`
        ,
    }, {
        id: 2,
        archived: false,
        title: 'Nasienie MIX - 08.07.2025',
        content: 
`<h4><b>Krycia nasieniem MIX</b></h4>
<p>Żeby dodać słomkę typu MIX w zakładce DODAJ BUHAJA zaznacz opcję <b>MIX</b>.</p>
<img style="width: 100%; max-width: 480px;" src="${base}res/images/app-messages/m1_mix-1.jpg" />
<p style="margin-top: 20px;"><b>Wypełnij nazwę słomki i podaj numery buhajów. Możesz podać do 4 numerów.</b></p>
<img style="width: 100%; max-width: 480px;" src="${base}res/images/app-messages/m1_mix-2.jpg" />
<p style="margin-top: 20px;">Podczas dodawania zaświadczenia wybierz słomkę mix z listy, taj samo jak zwykłego buhaja.</p>`
        ,
    }, {
        id: 1,
        archived: false,
        title: 'Krycia grupowe - 08.07.2025',
        content: 
`<h4><b>Krycia grupowe</b></h4>
<p>Żeby wykonać krycie grupowe w zakładce KROWY naciśnij przycisk zaznaczania.</p>
<img style="width: 100%; max-width: 480px;" src="${base}res/images/app-messages/m0_group-1.jpg" />
<p style="margin-top: 20px;"><b>Możesz zaznaczyć dowolną liczbę krów.</b> Zaznaczona krowa zostanie umieszczona na górze listy. Jeśli chcesz przejść do wyboru buhaja naciśnij <b>DALEJ</b>.</p>
<img style="width: 100%; max-width: 480px;" src="${base}res/images/app-messages/m0_group-2.jpg" />
<p style="margin-top: 20px;">Wybierz buhaja, wypełnij dane krycia, aplikacja wygeneruje osobne zaświadczenie dla każdej z zaznaczonych krów.</p>`
        ,
    },
];}

/* JSLib Exports */
_jsLib.export("default", appMessages); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\about.js
jsLibs.exportScript("core", "./panelDatas/about", [ "Basic" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");
_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");
_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");
_jsLib.importDeclaration("core", "./app-messages/index", [ { name: "default", alias: "appMessages" } ], "../app-messages/index.js");

/* export */ class Basic extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();

        lb.setListener_OnBack(() => {
            this.pager.setPage('lb.main');
            return true;
        });

        this.l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).About_Basic);

        this.l.$fields.IsNative = (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native';
        this.l.$fields.DBSchemeVersion = (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native' ?
                app.dataScheme.version : '-';

        let messages = (_jsLib.import("core", "./app-messages/index", "default", "appMessages", "../app-messages/index.js"))(abNative_Base);
        let l_AppMessages = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).About_Basic_AppMessages);
        let fAppMessages = [];
        for (let i = messages.length - 1; i >= 0; i--) {
            fAppMessages.push({
                Index: messages.length - i,
                Title: messages[i].title,
                Content: messages[i].content,
            })
        }
        l_AppMessages.$fields.AppMessages = fAppMessages;

        if ((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native') {
            this.l.$fields.AppId = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().appInfo.appId;
            this.l.$fields.AppVersion = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().appVersion;
            this.l.$fields.PrinterSet = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().nativeApp.printer !== null;

            this.l.$elems.SetPrinter.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.setPrinter();
            });
            this.l.$elems.RemovePrinter.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.removePrinter();
            });
            this.l.$elems.ReportProblem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.reportProblem();
            });
            this.l.$elems.ClearData.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.clearData();
            });
            this.l.$elems.LogOut.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.logOut();
            });

            app.nativeApp.setListener_OnPrinterSet((printer) => {
                this.l.$fields.PrinterSet = printer !== null;
            });

            this.l.$holders.AppMessages_Native.$view = l_AppMessages;
        } else {
            this.l.$holders.AppMessages_Web.$view = l_AppMessages;
        }

        // this.refresh();

        app.mMain.msgs.hideLoading();

        this.$view = this.l;
    }
    
    clearData() {
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();

        app.mMain.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_ClearData'), '',
                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), (result) => {
            if (!result)
                return;

            app.mMain.msgs.showLoading();

            app.clearData_Async()
                .then(() => { 
                    app.mMain.msgs.hideLoading();
                    app.mMain.pager.setPage(app.mMain.pager.current.name, 
                            app.mMain.pager.current.args);
                })
                .catch((e) => {
                    console.error(e);

                    app.mMain.msgs.showMessage_Failure(e.toString());
                    app.mMain.msgs.hideLoading();
                });
        });
    }

    logOut() {
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();

        app.mMain.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_LogOut'), '',
                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), (result) => {
            if (!result)
                return;

            app.mMain.msgs.showLoading();

            app.logOut_Async()
                .then(() => {
                    app.mMain.msgs.hideLoading();
                    app.mMain.pager.setPage('lb.main');
                })
                .catch((e) => {
                    console.error(e);

                    app.mMain.msgs.showMessage_Failure(e.toString());
                    app.mMain.msgs.hideLoading();
                });
        });
    }

    removePrinter() {
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();
        ((async () => {
            await app.nativeApp.removePrinter_Async();
            this.l.$fields.PrinterSet = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().nativeApp.printer !== null;
        })());
    }

    async reportProblem()
    {
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();

        app.mMain.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_ReportProblem'), '',
                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), async (confirmed) => {
            if (!confirmed)
                return;

            app.mMain.msgs.showLoading();

            let data = {};
            data.receipts_Unsynced = await app.nativeApp.getTable('Sys_Receipts')
                    .select_Async(app.nativeApp.db, {
                where: [
                    [ '_Modified_DateTime', null, 'IS NULL' ],
                ],
            });

            let result = await (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json_Async(abNative_ApiUri + 'app/report-problem', {
                appId: app.appInfo.appId,
                authenticationHash: app.appInfo.authenticationHash,
                data: data,
            });

            if (result.isSuccess()) {
                app.mMain.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                        'Sys:Successes_ProblemReportSent'));
            } else {
                app.mMain.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                    'Sys:Errors_CannotSendProblemReport'), result.message);
            }

            app.mMain.msgs.hideLoading();
        });
    }

    setPrinter() {
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();
        app.nativeApp.nativeActions.callNative_Async('SetPrinter');
    }

}

/* JSLib Exports */
_jsLib.export("Basic", Basic); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\administrators.js
jsLibs.exportScript("core", "./panelDatas/administrators", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'administrators';
let panelTitle = 'Administrators';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.m.fm.m.l.$fields.shows.delete = true;

        this.user_ManageAccount = new (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).User_ManageAccount(this);

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);
        };

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        this.lUser = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Users_Form);
        this.lUser.$fields.isNew = create;
        this.m.f.l.$holders.userForm.$view = this.lUser;
        this.fUser = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lUser, 'Form');

        this.m.refresh_OnParseApiResult = (data) => {
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.user = this.fUser.getValues();

            return fields;
        };
        this.m.submit_OnValidator = (result) => {
            this.fUser.setValidator(result.data.validator);
        };

        this.$view = this.m;
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        this.m.t.refresh();

        this.$view = this.m;
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\associations.js
jsLibs.exportScript("core", "./panelDatas/associations", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-file-upload", "./index", [ { name: "default", alias: "spkFileUpload" } ], "spk-file-upload");
_jsLib.importDeclaration("spk-forms", "./index", [  ], "spk-forms");
_jsLib.importDeclaration("spk-tables", "./index", [ { name: "default", alias: "spkTables" } ], "spk-tables");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");
    
_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");
_jsLib.importDeclaration("core", "./tables", [ { name: "default", alias: "tables" } ], "../tables.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'associations';
let panelTitle = 'Associations';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        this.m.f.m.l.$fields = {
            shows: {
                delete: false,
            },
        };

        if (this.pager.current.args.newReceipt !== '0') {
            this.m.f.m.l.$fields = {
                texts: {
                    title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Cow`),
                },
            },

            this.m.f.m.onSubmit = (result) => {
                this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                        { associationId: result.data.row._Id, });
            }
        } else {
            this.m.f.m.onSubmit = (result) => {
                this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                        { farmerId: this.pager.current.args.farmerId });
            }
        }

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        this.associationHistory_Table = new (_jsLib.import("spk-tables", "./index", "default", "spkTables", "spk-tables")).Table(this.msgs, 
                (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_CowHistory())
            .setOnRefresh((rows, colRefs) => {
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDate(rows, colRefs, 'Date');
            });
        this.m.lContent.$holders.associationHistory.$view = this.associationHistory_Table;

        this.m.onDelete = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                    { farmerId: this.m.data.row.Farmer__Id, });
        }

        this.m.refresh_OnSetApiFields = (fields) => {
            fields.farmerId = this.pager.current.args.farmerId;

            return fields;
        };
        this.m.refresh_OnParseApiResult = (data) => {
            let farmerId = data.rFarmer === null ? 0 : data.rFarmer._Id;

            if (create && this.pager.current.args.newReceipt !== '0') {
                this.m.l.$fields = {
                    uris: {
                        back: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                                this.pager.getPageUri(`lb.subpanels.newReceipt.association`) :
                                this.pager.getPageUri(`lb.subpanels.newReceipt.association`, 
                                { farmerId: farmerId, }),
                    },
                };
            } else {
                this.m.l.$fields = {
                    uris: {
                        back: this.pager.getPageUri(`lb.subpanels.${panelName}.list`, 
                                { farmerId: farmerId, }),
                    },
                };
            }

            if (data.associationHistory_Rows !== null) {
                this.m.lContent.$fields.shows.associationHistory = true;
                this.associationHistory_Table.update((_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).parseRows(
                        (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_CowHistory().columns, data.associationHistory_Rows));
            } else
                this.m.lContent.$fields.shows.associationHistory = false;
        }
        this.m.submit_OnSetApiFields = (fields) => {
            fields.farmerId = this.pager.current.args.farmerId;

            return fields;
        };

        this.$view = this.m;
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Inseminator__Id !== null) {
            lb.setBackButton(true);
            lb.setListener_OnBack(() => {
                this.m.listeners_Back();
                return true;
            });   
        }

        this.m.l.$fields.shows.add = false;

        this.m.l.$fields = {
            uris: {
                back: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                        this.pager.getPageUri(`lb.main`) :
                        this.pager.getPageUri(`lb.subpanels.farmers.edit`, 
                        { id: this.pager.current.args.farmerId, }),
            },
        };
        this.m.listeners_Back = () => { 
            this.pager.setPage((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                    'lb.main' :
                    'lb.subpanels.farmers.edit', 
                    { id: this.pager.current.args.farmerId, });
        };

        /* Buttons */
        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id !== null || 
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Trader__Id !== null) {
            this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Buttons`]);

            this.upload_FileUpload = new (_jsLib.import("spk-file-upload", "./index", "default", "spkFileUpload", "spk-file-upload")).FileUpload((files) => {
                this._upload(files);
            }, '.pdf');
            this.lButtons.$elems.upload.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.upload_FileUpload.upload();
            });

            this.lButtons.$elems.deleteAll.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._deleteAll();
            });

            this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        }
        /* / Buttons */

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            // sys.tables.formatDate(rows, colRefs, 'Birth');
        };

        this.m.t.setApiFields((fields) => {
            return {
                farmerId: this.pager.current.args.farmerId,
            };
        });
        this.m.t.setOnRowClick(null);

        this.m.t.refresh();

        this.$view = this.m;
    }


    _deleteAll() {
        this.msgs.showLoading();
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.associations'] + 'delete-all',
                { farmer_Id: this.pager.current.args.farmerId, },
                (result) => {
            if (result.isSuccess()) {
                if ('warningMessage' in result.data) {
                    this.msgs.showMessage_Failure(result.data.warningMessage, () => {
                        this.m.t.refresh();
                    });
                    this.msgs.hideLoading();
                } else
                    this.m.t.refresh();
            } else {
                this.msgs.showMessage_Failure(result.message);
                this.msgs.hideLoading();
            }
        });
    }

    _upload(files) {
        this.msgs.showLoading();
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).upload((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.associations'] + 'upload', {},
                { farmer_Id: this.pager.current.args.farmerId, file: files[0] },
                (result) => {
            if (result.isSuccess()) {
                if ('warningMessage' in result.data) {
                    this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Warnings_Warning'), result.data.warningMessage, 
                            () => {
                        this.m.t.refresh();
                    });
                    this.msgs.hideLoading();
                } else {
                    this.msgs.showMessage_Success(
                            (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Successes_Success'), '', () => {
                        this.m.t.refresh();
                    });
                }
            } else {
                this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Errors_Error'),     
                        'errorMessage' in result.data ? 
                        result.data.errorMessage : result.message);
                this.msgs.hideLoading();
            }
        });
    }

}


/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\backups.js
jsLibs.exportScript("core", "./panelDatas/backups", [ "Basic" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");
    
_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


/* export */ class Basic extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Backups_Basic);

        this.l.$elems.downloadLast.addEventListener('click', (evt) => {
            this.clear(this.l.$fields.files(0).url);
        });

        this.refresh();

        this.$view = this.l;
    }

    clear(backupFileUrl) {
        this.msgs.showLoading('');
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.backups'] + 'backups-clear', {}, 
                (result) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseApiResult(this, result, () => {
                this.refresh(() => {
                    window.location = backupFileUrl;
                    this.msgs.hideLoading();
                });
            });
        });
    }

    refresh(callbackFn) {
        callbackFn = typeof callbackFn === 'undefined' ? null : callbackFn;

        this.msgs.showLoading('');
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.backups'] + 'backups-list', {}, 
                (result) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseApiResult(this, result, () => {
                this.l.$fields.files = result.data.backupFileInfos;

                if (callbackFn === null)
                    this.msgs.hideLoading();
                else
                    callbackFn();
            });
        });
    }
    
}

/* JSLib Exports */
_jsLib.export("Basic", Basic); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\bulls.js
jsLibs.exportScript("core", "./panelDatas/bulls", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("spk-file-upload", "./index", [ { name: "default", alias: "spkFileUpload" } ], "spk-file-upload");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");
_jsLib.importDeclaration("core", "./Select", [  ], "../Select.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");

let panelName = 'bulls';
let panelTitle = 'Bulls';

/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        if (this.pager.current.args.newReceipt_CowIds !== '0') {
            this.m.fm.m.listeners_Back = () => {
                this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                        { cowIds: this.pager.current.args.newReceipt_CowIds });
            };

            this.m.fm.m.l.$fields = {
                texts: {
                    title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Bull`),
                },
            };

            this.m.fm.m.l.$fields = {
                uris: {
                    back: this.pager.getPageUri(`lb.subpanels.newReceipt.bull`, 
                            { cowIds: this.pager.current.args.newReceipt_CowIds }),
                },
            };

            this.m.fm.m.onSubmit = (result) => {
                this.pager.setPage(`lb.subpanels.newReceipt.details`, 
                        { cowIds: this.pager.current.args.newReceipt_CowIds, 
                        bullId: String(result.data.row._Id) });
            }
        } else {
            this.m.fm.m.onSubmit = (result) => {
                this.pager.setPage(`lb.subpanels.bulls.list`, 
                        { clientId: this.pager.current.args.clientId, });
            }
        }

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.m.fm.m.refresh();

        this.$view = this.m;
    }
}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);
        this.farmerId = null;

        this.m.l.$fields = {
            uris: {
                back: this.pager.getPageUri(`lb.subpanels.bulls.list`, 
                        { clientId: this.pager.current.args.clientId, }),
            },
        };
        this.m.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.bulls.list`, 
                    { clientId: this.pager.current.args.clientId, });
        };

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id === null &&
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Trader__Id === null)
            this.m.f.layout.$fields.shows_StrawsCount = true;
        else {
            this.m.f.layout.$fields.shows_StrawsCount = 
                    this.pager.current.args.clientId !== '0';
        }

        this.m.f.getField('Mix').elem.addEventListener('change', (evt) => {
            this.m.lContent.$fields.shows_Mix = this.m.f
                    .getField('Mix').value;
        });

        this.m.refresh_OnParseApiResult = (data) => {
            if (data.row !== null) {
                let shows = {
                    submit: true,
                    delete: true,
                }

                this.m.f.setValues({
                    'Mix': data.row.Nr2 !== null ||
                            data.row.Nr3 !== null ||
                            data.row.Nr4 !== null ||
                            data.row.Nr5 !== null,
                });

                if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id === null && 
                        (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Trader__Id === null && 
                        data.row['Client__Id'] === null) {
                    // this.m.l.$fields.shows.submit = false;
                    shows.delete = false;

                    this.m.f.setDisabled(true);
                } else if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Trader__Id !== null && 
                        data.row['Client__Id'] === null) {
                    shows.submit = this.pager.current.args.clientId !== '0';
                    shows.delete = false;

                    this.m.f.setDisabled(true);
                    this.m.f.fields.ClientBull_StrawsConvCount_Client.setDisabled(
                            false);
                    this.m.f.fields.ClientBull_StrawsSexedCount_Client.setDisabled(
                            false);

                    this.m.f.fields.ClientBull_StrawsConvCount_Company.setDisabled(
                            false);
                    this.m.f.fields.ClientBull_StrawsSexedCount_Company.setDisabled(
                            false);
                }

                this.m.l.$fields.shows = shows;
            }  

            this.m.f.fields.ClientBull_StrawsConvCount_Client.setDisabled(
                    (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinicInseminator);
            this.m.f.fields.ClientBull_StrawsSexedCount_Client.setDisabled(
                    (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinicInseminator);
        };
        this.m.refresh_OnSetApiFields = (fields) => {
            fields.clientId = Number(this.pager.current.args.clientId);

            return fields;
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.clientId = Number(this.pager.current.args.clientId);

            if (fields.row.Mix) {
                let noExtraBulls = true;
                for (let i = 1; i < 5; i++) {
                    let bullIndex = i + 1;
                    if (fields.row[`Nr${bullIndex}`] === '')
                        fields.row[`Nr${bullIndex}`] = null;
                    else
                        noExtraBulls = false;
                }
                if (noExtraBulls)
                    fields.row['Nr2'] = '';
            } else {
                for (let i = 1; i < 5; i++) {
                    let bullIndex = i + 1;
                    fields.row[`Nr${bullIndex}`] = null;

                }
            }

            delete fields.row.Mix;

            return fields;
        };

        this.m.onDelete = () => {
            let clientId = Number(this.pager.current.args.clientId);
            if (clientId === 0)
                this.pager.setPage(`lb.subpanels.bulls.list`);
            else {
                this.pager.setPage(`lb.subpanels.bulls.list`,
                        { clientId: clientId, });
            }
        };

        this.$view = this.m;
    }
}

/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb, refresh = true) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)
        this.cowIds = null;

        this.m.l.$fields = {
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.${panelName}.add`, 
                        { clientId: this.pager.current.args.clientId, }),
            },
        };
        this.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.add`, 
                    { clientId: this.pager.current.args.clientId, });
        };

        // if (sys.user.info.Trader__Id !== null)
        //     this.m.l.$fields.shows.add = false;

        // if (sys.user.isClient)    
        //     this.m.t.addHiddenColumns([ 'Client_Name', ]);

        /* Buttons */
        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Buttons`]);
        this.m.l.$holders.Buttons_Before.$view = this.lButtons;

        this.lButtons.$fields.uris.register = (_jsLib.import("core", "./App", "default", "App", "../App.js")).Base + 
                'api/pobierz/bulls-register?clientId=' + 
                this.pager.current.args.clientId;

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isEmployee) {
            this.upload_FileUpload = new (_jsLib.import("spk-file-upload", "./index", "default", "spkFileUpload", "spk-file-upload")).FileUpload((files) => {
                this._upload(files);
            }, '.csv');
            this.lButtons.$elems.upload.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.upload_FileUpload.upload();
            });

            this.uploadStrawsCount_FileUpload = new (_jsLib.import("spk-file-upload", "./index", "default", "spkFileUpload", "spk-file-upload")).FileUpload((files) => {
                this._uploadStrawsCount(files);
            }, '.csv');
            this.lButtons.$elems.uploadStrawsCount.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.uploadStrawsCount_FileUpload.upload();
            });
        }

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator) {
            this.lButtons.$fields.shows.upload = 
                    this.pager.current.args.clientId === '0';
            this.lButtons.$fields.shows.uploadStrawsCount = 
                    this.pager.current.args.clientId !== '0';
            this.lButtons.$fields.shows.register = 
                    this.pager.current.args.clientId !== '0';  
        } else if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isTrader) {
            this.m.l.$fields.shows.add = 
                    this.pager.current.args.clientId !== '0';;

            this.lButtons.$fields.shows.upload = false;
            this.lButtons.$fields.shows.uploadStrawsCount =
                    this.pager.current.args.clientId !== '0';
            this.lButtons.$fields.shows.register = 
                    this.pager.current.args.clientId !== '0';
        } else {
            this.lButtons.$fields.shows.upload = false;
            this.lButtons.$fields.shows.uploadClientBulls = false;
            this.lButtons.$fields.shows.register = (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web';
        }
        /* / Buttons */

        this.m.refresh_OnApiResult = (data) => {
            // if (!this.pager.current.args)
            if (data.rFarmer !== null) {
                if (data.rFarmer.Clinic__Id !== null)
                    this.lButtons.$fields.shows.uploadStrawsCount = false;
                
                this.m.l.$fields.uris.back = this.pager.getPageUri(
                        'lb.subpanels.farmers.edit', 
                        { id: data.rFarmer._Id });
                this.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.farmers.edit', 
                            { id: data.rFarmer._Id });
                }
            }

            if (data.rInseminator !== null) {
                if (data.rInseminator.Clinic__Id !== null)
                        this.lButtons.$fields.shows.uploadStrawsCount = false;

                this.m.l.$fields.uris.back = this.pager.getPageUri(
                        'lb.subpanels.inseminators.edit', 
                        { id: data.rInseminator._Id });
                this.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.inseminators.edit', 
                            { id: data.rInseminator._Id });
                }
            }
        };

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.format(rows, colRefs, 'Name', (col, row) => {
                let name = row.cols[colRefs.Name].value;
                if (name === '')
                    name = '-';
                if (row.cols[colRefs.Nr2].value !== null ||
                        row.cols[colRefs.Nr3].value !== null ||
                        row.cols[colRefs.Nr4].value !== null ||
                        row.cols[colRefs.Nr5].value !== null) {
                    name = name === '-' ? '(MIX)' : `${name} (MIX)`;
                }

                col.html = name;
            });

            for (let row of rows) {
                if (row.cols[colRefs._Modified_DateTime].value === null ||
                        (row.cols[colRefs.ClientBull__Modified_DateTime].value === null &&
                        row.cols[colRefs.ClientBull__Id].value !== null)) {
                    console.log(row.cols[colRefs._Modified_DateTime].value,
                            row.cols[colRefs.ClientBull__Modified_DateTime].value);
                    row.class = 'data-offline';
                }
            }

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDateTime_Microseconds(rows, colRefs, 
                    '_Modified_DateTime');
        };

        this.m.refresh_SetApiFields = (fields) => {
            fields.cowIds = this.cowIds;

            return fields;
        };

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isEmployee) {
            if (this.pager.current.args.clientId === '0') {
                this.m.t.addHiddenColumns([
                    'ClientBull_StrawsConvCount_Client',
                    'ClientBull_StrawsSexedCount_Client',
                    'ClientBull_StrawsConvCount_Company',
                    'ClientBull_StrawsSexedCount_Company',
                ]);
                this.m.t.removeHiddenColumns([
                    'Client_Name',
                ]);
            } else {
                this.m.t.removeHiddenColumns([
                    'ClientBull_StrawsConvCount_Company',
                    'ClientBull_StrawsSexedCount_Company', 
                ]);
            }
        } else {
            // if (this.pager.current.args.clientId === '0')
            this.m.t.addHiddenColumns([ 
                '_Modified_DateTime',
                'ClientBull__Modified_DateTime',
                'ClientBull_StrawsConvCount_Company',
                'ClientBull_StrawsSexedCount_Company' 
            ]); 
        }

        this.m.t.setApiFields(() => {
            let fields = {};

            fields = this.m.refresh_SetApiFields(fields);
            fields.clientId = this.pager.current.args.clientId;

            return fields;  
        });
        this.m.t.setLimit(1000, 1000);
        this.m.t.setOnRowClick((row, colRefs) => {
            this.pager.setUri(row.href);
        }, (row, colRefs) => {
            return this.pager.getPageUri(`lb.subpanels.bulls.edit`,
                    { id: row.cols[colRefs._Id].value, 
                    clientId: this.pager.current.args.clientId, });
        });

        if (refresh)
            this.m.t.refresh();

        this.$view = this.m;
    }


    _upload(files) {
        this.msgs.showLoading();
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).upload((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.bulls'] + 'upload', {},
                { file: files[0] },
                (result) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseApiResult(this, result, () => {
                this.msgs.hideLoading();
                this.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                    'Sys:Successes_Success'), '', () => {
                    this.m.t.refresh();
                });
            });
        });
    }

    _uploadStrawsCount(files) {
        this.msgs.showLoading();
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).upload((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.bulls'] + 'upload-straws-count', 
                { clientId: this.pager.current.args.clientId }, { file: files[0] }, 
                (result) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseApiResult(this, result, () => {
                this.msgs.hideLoading();
                console.log('', result.message);
                this.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Successes_Success'), result.message, () => {
                    this.m.t.refresh();
                });
            });
        });
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\cows.js
jsLibs.exportScript("core", "./panelDatas/cows", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-date", "./index", [  ], "ab-date");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-file-upload", "./index", [ { name: "default", alias: "spkFileUpload" } ], "spk-file-upload");
_jsLib.importDeclaration("spk-forms", "./index", [  ], "spk-forms");
_jsLib.importDeclaration("spk-tables", "./index", [ { name: "default", alias: "spkTables" } ], "spk-tables");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");
    
_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");
_jsLib.importDeclaration("core", "./tables", [ { name: "default", alias: "tables" } ], "../tables.js");

_jsLib.importDeclaration("core", "./Select", [ { name: "default", alias: "Select" } ], "../Select.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");

let panelName = 'cows';
let panelTitle = 'Cows';

/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        this.m.fm.m.l.$fields = {
            shows: {
                delete: false,
            },
        };

        if (this.pager.current.args.newReceipt === '1') {
            if (this.pager.current.args.selectedCows === '0') {
                this.m.fm.m.l.$fields = {
                    texts: {
                        title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Cow`),
                    },
                },

                this.m.fm.m.onSubmit = (result) => {
                    this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                            { cowIds: [ result.data.row._Id ], });
                }
            } else {
                this.m.fm.m.l.$fields = {
                    texts: {
                        title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Cow`),
                    },
                };

                this.m.fm.m.onSubmit = (result) => {
                    let args_SelectedCows = lb.pager.current.args.selectedCows;
                    let cowIds = [ String(result.data.row._Id) ];
                    if (args_SelectedCows !== '-1') {
                        let selectedCowIds = args_SelectedCows.split(',');
                        cowIds = cowIds.concat(selectedCowIds);
                    }

                    this.pager.setPage(`lb.subpanels.newReceipt.cow`, 
                            { farmerId: lb.pager.current.args.farmerId,
                            cowId: result.data.row._Id, selectedCows: 
                            cowIds.join(',') });
                }
            }
        } else {
            this.m.fm.m.onSubmit = (result) => {
                this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                        { farmerId: this.pager.current.args.farmerId });
            }
        }

        this.$view = this.m;
    }
}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.m.fm.m.l.$fields = {
            shows: {
                delete: true,
            },
        };

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }

    
    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        this.m.l.$fields.HasGenealogy = false;

        this.cowHistory_Table = new (_jsLib.import("spk-tables", "./index", "default", "spkTables", "spk-tables")).Table(this.msgs, 
                (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_CowHistory())
            .setOnRefresh((rows, colRefs) => {
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDate(rows, colRefs, 'Date');
            });
        this.m.lContent.$holders.cowHistory.$view = this.cowHistory_Table;

        this.m.onDelete = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                    { farmerId: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isFarmer ? 
                    '0' : this.m.data.row.Farmer__Id, });
        }

        this.m.refresh_OnSetApiFields = (fields) => {
            fields.farmerId = this.pager.current.args.farmerId;

            return fields;
        };
        this.m.refresh_OnParseApiResult = (data) => {
            let farmerId = data.rFarmer === null ? 0 : data.rFarmer._Id;

            if (create && this.pager.current.args.newReceipt !== '0') {
                this.m.l.$fields = {
                    uris: {
                        back: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                                this.pager.getPageUri(`lb.subpanels.newReceipt.cow`) :
                                this.pager.getPageUri(`lb.subpanels.newReceipt.cow`, 
                                { farmerId: farmerId, }),
                    },
                };

                this.m.listeners_Back = () => {
                    if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null)
                        this.pager.setPage(`lb.subpanels.newReceipt.cow`,
                                { selectedCows: lb.pager.current.args.selectedCows });
                    else {
                        this.pager.setPage(`lb.subpanels.newReceipt.cow`, 
                            { farmerId: farmerId, selectedCows: lb.pager.current
                            .args.selectedCows });
                    }
                };
            } else {
                this.m.l.$fields = {
                    uris: {
                        back: this.pager.getPageUri(`lb.subpanels.${panelName}.list`, 
                                { farmerId: farmerId, }),
                    },
                };

                this.m.listeners_Back = () => {
                    if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null)
                        this.pager.setPage(`lb.subpanels.${panelName}.list`);
                    else {
                        this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                                { farmerId: farmerId, });
                    }
                };
            }

            if (data.cowHistory_Rows !== null) {
                this.m.lContent.$fields.shows.cowHistory = true;
                this.cowHistory_Table.update((_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).parseRows(
                        (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_CowHistory().columns, data.cowHistory_Rows));
            } else
                this.m.lContent.$fields.shows.cowHistory = false;
        }
        this.m.submit_OnSetApiFields = (fields) => {
            fields.farmerId = 'farmerId' in this.pager.current.args ?
                    this.pager.current.args.farmerId : null;

            return fields;
        };

        this.$view = this.m;
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb, refresh = true, multiDelete = true, multiSelect = false) { 
            super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Inseminator__Id !== null) {
            lb.setBackButton(true);
            lb.setListener_OnBack(() => {
                this.m.listeners_Back();
                return true;
            });   
        }

        this.m.l.$fields = {
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.${panelName}.add`, 
                        { farmerId: this.pager.current.args.farmerId, }),
                back: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                        this.pager.getPageUri(`lb.main`) :
                        this.pager.getPageUri(`lb.subpanels.farmers.edit`, 
                        { id: this.pager.current.args.farmerId, }),
            },
        };
        this.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.add`, 
                    { farmerId: this.pager.current.args.farmerId, });
        };
        this.m.listeners_Back = () => {
            this.pager.setPage((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                    'lb.main' :
                    'lb.subpanels.farmers.edit', 
                    { id: this.pager.current.args.farmerId, });
        };

        /* Buttons */
        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields.Shows.Upload = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator ||
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isTrader;
        this.upload_FileUpload = new (_jsLib.import("spk-file-upload", "./index", "default", "spkFileUpload", "spk-file-upload")).FileUpload((files) => {
            this._upload(files);
        }, '.txt');
        this.lButtons.$elems.upload.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.upload_FileUpload.upload();
        });
        this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        /* / Buttons */

        /* Select */
        this.lButtons_Select = null;
        if (multiDelete) {
            this.lButtons_Select = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Buttons_Delete);
            this.lButtons_Select.$elems.delete.addEventListener('click', (evt) => {
                evt.preventDefault();
                let ids = [];
                let rows = this.m.t.getSelectedRows();
                for (let row of rows)
                ids.push(row['_Id']);
                this.m.deleteSelected(ids, () => {
                    this.m.t.refresh();
                });
            });

            this.mSelect = new (_jsLib.import("core", "./Select", "default", "Select", "../Select.js"))(this.lb, (_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Select, this.m.t, 
                [ this.m.l.$holders.Buttons_Before, this.lButtons, this.lButtons_Select ],
                    (active) => {
                this.m.l.$fields.shows.add = !active;
            });
            this.m.t.layout.$holders.afterSearch.$view = this.mSelect;
        } else if (multiSelect) {
            this.lButtons_Select = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Buttons_Next);
            this.lButtons_Select.$elems.Next.addEventListener('click', (evt) => {
                evt.preventDefault();
                let ids = [];
                let rows = this.m.t.getSelectedRows();
                for (let row of rows)
                ids.push(row['_Id']);
                lb.pager.setPage(`lb.subpanels.newReceipt.bull`, { cowIds: 
                        ids.join(','), });
            });

            this.mSelect = new (_jsLib.import("core", "./Select", "default", "Select", "../Select.js"))(this.lb, (_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Select, this.m.t, 
                [ this.m.l.$holders.Buttons_After, this.lButtons, this.lButtons_Select ],
                    (active) => {
                // this.m.l.$fields.shows.add = !active;
            });
            this.m.t.layout.$holders.afterSearch.$view = this.mSelect;
        }
        /* / Select */

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            for (let row of rows) {
                if (row.cols[colRefs._Modified_DateTime].value === null)
                    row.class = 'data-offline';
            }

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDate(rows, colRefs, 'Birth');
        };

        this.m.t.setApiFields((fields) => {
            return {
                farmerId: this.pager.current.args.farmerId,
            };
        });
        this.m.t.setHiddenColumns([ '_Id', '_Modified_DateTime' ]);

        if (refresh)
            this.m.t.refresh();

        this.$view = this.m;
    }


    _upload(files) {
        this.msgs.showLoading();
        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).upload((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['api.cows'] + 'upload', {},
                { farmer_Id: this.pager.current.args.farmerId, file: files[0] },
                (result) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseApiResult(this, result, () => {
                this.msgs.hideLoading();
                this.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Successes_Success'), '', () => {
                    this.m.t.refresh();
                });
            });
        });
    }

}


/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\clinics.js
jsLibs.exportScript("core", "./panelDatas/clinics", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'clinics';
let panelTitle = 'Clinics';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_Form_Buttons`]);
        this.m.f.m.l.$holders.Buttons_Before.$view = this.lButtons;
        
        let refresh_OnParseApiResult = this.m.f.m.refresh_OnParseApiResult;
        this.m.f.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            if (data.row !== null) {
                this.lButtons.$fields.hrefs.bulls = this.pager.getPageUri(
                        `lb.subpanels.bulls.list`,
                        { clientId: data.row.Client__Id, });

                this.lButtons.$elems.bulls.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.pager.setPage(`lb.subpanels.bulls.list`,
                            { clientId: data.row.Client__Id });
                });
            }
        }

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        this.lClient = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Clients_Form);
        this.m.f.l.$holders.clientForm.$view = this.lClient;
        this.fClient = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lClient, 'Form');

        this.lClient.$fields.isUser = true;
        this.lClient.$fields.isUnderGrade = false;
        this.lClient.$fields.showTrader__Id = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id !== null;

        this.lUser = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Users_Form);
        this.lUser.$fields.isNew = true;
        this.lClient.$holders.userForm.$view = this.lUser;
        this.fUser = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lUser, 'Form');

        this.user_ManageAccount = new (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).User_ManageAccount(this);

        this.m.refresh_OnParseApiResult = (data) => {
            this._initSelects(data);

            if (this.m.data.rClient !== null)
                this.fClient.setValues(this.m.data.rClient);
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);

            this.user_ManageAccount.refresh_OnParseApiResult(data);
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.client = this.fClient.getValues();
            fields.user = this.fUser.getValues();

            delete fields.client.UnderGrade;

            if (fields.client.Trader__Id === '0')
                fields.client.Trader__Id = null;

            return fields;
        }
        this.m.submit_OnValidator = (result) => {
            this.fClient.setValidator(result.data.validator);
            this.fUser.setValidator(result.data.validator);
        };

        this.$view = this.m;
    }


    _initSelects(data) {
        let traderOptions = [];
        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator) {
            traderOptions.push({
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Options_None'),
                value: '0',
            });
        }
        for (let rTrader of data.rTraders) {
            traderOptions.push({
                title: rTrader.Name,
                value: rTrader._Id,
            });
        }
        this.fClient.fields.Trader__Id.field('Options', traderOptions);
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        this.m.t.refresh();

        this.$view = this.m;
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\farmers.js
jsLibs.exportScript("core", "./panelDatas/farmers", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'farmers';
let panelTitle = 'Farmers';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        if (this.pager.current.args.newReceipt !== '0') {
            this.m.fm.m.l.$fields = {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Farmer`),
                uris: {
                    back: this.pager.getPageUri('lb.subpanels.newReceipt.farmer'),
                },
            },

            this.m.fm.m.listeners_Back = () => {
                this.pager.setPage('lb.subpanels.newReceipt.farmer');
            }

            this.m.fm.m.onSubmit = (result) => {
                this.pager.setPage(`lb.subpanels.newReceipt.cow`, 
                        { farmerId: result.data.row._Id, });
            }
        }
        

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.user_ManageAccount = new (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).User_ManageAccount(this);

        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_Form_Buttons`]);
        
        this.lButtons.$fields = {
            hrefs: {
                associations: this.pager.getPageUri(`lb.subpanels.associations.list`,
                    { farmerId: this.pager.current.args.id }),
                bulls: '#',
                cows: this.pager.getPageUri(`lb.subpanels.cows.list`,
                    { farmerId: this.pager.current.args.id }),
            },
            shows: {
                bulls: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator || (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isTrader,
            }
        };

        this.lButtons.$elems.associations.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.pager.setPage(`lb.subpanels.associations.list`,
                    { farmerId: this.pager.current.args.id });
        });
        this.lButtons.$elems.cows.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.pager.setPage(`lb.subpanels.cows.list`,
                    { farmerId: this.pager.current.args.id });
        });

        this.m.fm.m.l.$holders.Buttons_Before.$view = this.lButtons;

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);

            if (data.row !== null) {
                this.m.fm.m.l.$fields.shows.delete = true;

                this.lButtons.$fields.hrefs.bulls = this.pager.getPageUri(
                        `lb.subpanels.bulls.list`,
                        { clientId: data.row.Client__Id, });
                this.lButtons.$elems.bulls.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.pager.setPage(`lb.subpanels.bulls.list`,
                            { clientId: data.row.Client__Id });
                });

                // this.lButtons.$fields.shows.bulls = data.row.Clinic__Id === null &&
                //         data.row.Inseminator__Id === null;
                this.lButtons.$fields.shows.bulls = data.row.Inseminator__Id === null;
            }
        }

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        // this.m.lContent.$fields.shows.Clinic__Id =
        //         !(sys.user.isInseminator || sys.user.isClinic);
        this.m.lContent.$fields.shows.Inseminator__Id =
                !((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isInseminator || (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinic);

        this.lClient = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Clients_Form);
        this.m.f.l.$holders.clientForm.$view = this.lClient;
        this.fClient = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lClient, 'Form');        

        this.lUser = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Users_Form);
        this.lUser.$fields.isNew = true;
        this.lClient.$holders.userForm.$view = this.lUser;
        this.fUser = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lUser, 'Form');

        this._initForm();

        this.m.refresh_OnParseApiResult = (data) => {
            this._initSelects(data);

            if (this.m.data.rClient !== null)
                this.fClient.setValues(this.m.data.rClient);
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);

            if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinic || (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isInseminator)
                this.lClient.$fields.isUser = false;
            else if (data.row !== null)
                this.lClient.$fields.isUser = data.rUser !== null;

            if (data.row !== null) {
                this.m.f.setValues({
                    'HasNotificationsEmail': data.row.NotificationsEmail !== null,
                });
                this.fClient.setValues({
                    'UnderGrade': data.row.HerdUnderGradeNr !== null,
                });
            }

            if (data.row !== null) {
                // this.m.f.fields.Clinic__Id.setDisabled(true); 
                this.m.f.fields.Inseminator__Id.setDisabled(true);
            }
        };
        this.m.submit_OnSetApiFields = (fields) => {
            /* Row */
            if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isInseminator || (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinic) {
                // fields.row.Clinic__Id = null;
                fields.row.Inseminator__Id = null;
            } else {
                // fields.row.Clinic__Id = fields.row.Clinic__Id === '0' ?
                //         null : parseInt(fields.row.Clinic__Id);
                fields.row.Inseminator__Id = fields.row.Inseminator__Id === '0' ?
                        null : parseInt(fields.row.Inseminator__Id);
            }
            
            fields.row.NotificationsEmail = fields.row.HasNotificationsEmail ? 
                    fields.row.NotificationsEmail : null;
            delete fields.row.HasNotificationsEmail;

            /* Client */
            fields.client = this.fClient.getValues();
            fields.client._Id = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().dataStore.nextId();
            
            fields.client.Trader__Id = fields.client.Trader__Id === '0' ?
            fields.client.Trader__Id = null : parseInt(fields.client.Trader__Id);
            
            fields.client.SymlekId = fields.client.UnderGrade ? 
                    fields.client.SymlekId : null;

            fields.row.HerdUnderGradeNr = fields.client.UnderGrade ? 
                    fields.row.HerdUnderGradeNr : null;
            delete fields.client.UnderGrade;

            /* User */
            fields.user = fields.row.Inseminator__Id === null ?
                    this.fUser.getValues() : null;

            return fields;
        }
        this.m.submit_OnValidator = (result) => {
            this.fClient.setValidator(result.data.validator);
            this.fUser.setValidator(result.data.validator);
        };

        this.$view = this.m;
    }


    _initForm() {
        /* Clients */
        this.lClient.$fields.showUnderGrade = true;

        let fUnderGrade_Elem = this.fClient.fields.UnderGrade.elem;
        fUnderGrade_Elem.addEventListener('change', (evt) => {
            this.lClient.$fields.isUnderGrade = fUnderGrade_Elem.checked;
            this.m.f.l.$fields.isUnderGrade = fUnderGrade_Elem.checked;
        });

        this.fClient.setValues({
            UnderGrade: true,
        });

        /* Farmer */ 
        // this.m.f.fields.Clinic__Id.field('Options', [
        //     {
        //         title: sys.eText('Sys:Options_None'),
        //         value: 0,
        //     },
        // ]);
        // this.m.f.fields.Clinic__Id.elem.addEventListener('change', (evt) => {
        //     this.m.f.l.$fields.shows.Inseminator__Id = 
        //             this.m.f.fields.Clinic__Id.value === '0';
        //     this.lClient.$fields.isUser = this.m.f.fields.Clinic__Id.value === '0';
        // });

        this.m.f.fields.Inseminator__Id.field('Options', [
            {
                title: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText('Sys:Options_None'),
                value: 0,
            },
        ]);
        let fInseminator__Id_Elem = this.m.f.fields.Inseminator__Id.elem;
        fInseminator__Id_Elem.addEventListener('change', (evt) => {
            if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id !== null)
                this.lClient.$fields.showTrader__Id = fInseminator__Id_Elem.value === '0';
            this.lClient.$fields.isUser = fInseminator__Id_Elem.value === '0';
        });        

        let fHasNotificationsEmail_Elem = this.m.f.fields.HasNotificationsEmail.elem;
        fHasNotificationsEmail_Elem.addEventListener('change', (evt) => {
            this.m.f.l.$fields.shows.NotificationsEmail = fHasNotificationsEmail_Elem.checked;
        });        

        this.m.f.setValues({
            'Inseminator__Id': '0',
            'HasNotificationsEmail': false,
        });
    }

    _initSelects(data) {
        // let clinicOptions = [
        //     {
        //         title: sys.eText('Sys:Options_None'),
        //         value: 0,
        //     },
        // ];
        // for (let rClinic of data.rClinics) {
        //     clinicOptions.push({
        //         title: rClinic.Client_Name,
        //         value: rClinic._Id,
        //     });
        // }
        // this.m.f.fields.Clinic__Id.field('Options', clinicOptions);

        let inseminatorOptions = [
            {
                title: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText('Sys:Options_None'),
                value: 0,
            },
        ];
        for (let rInseminator of data.rInseminators) {
            inseminatorOptions.push({
                title: rInseminator.Client_Name,
                value: rInseminator._Id,
            });
        }
        this.m.f.fields.Inseminator__Id.field('Options', inseminatorOptions);

        let traderOptions = [];
        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator) {
            traderOptions.push({
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Options_None'),
                value: '0',
            });
        }
        for (let rTrader of data.rTraders) {
            traderOptions.push({
                title: rTrader.Name,
                value: rTrader._Id,
            });
        }
        this.fClient.fields.Trader__Id.field('Options', traderOptions);
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb, refresh = true) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isTrader)
            this.m.t.addHiddenColumns([ 'Trader_Name', ]);
        else if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinic) 
            this.m.t.addHiddenColumns([ 'Trader_Name', 'Clinic_Client_Name' ]);
        else if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isInseminator) {
            this.m.t.addHiddenColumns([ 'Trader_Name', 'Inseminator_Client_Name', ]);
        }

        /* Buttons */
        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields = {
            hrefs: {
                register: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages.download + 'farmers-register', 
            },
            shows: {
                register: (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web',
            },
        };
        this.lButtons.$elems.register.addEventListener('click', (evt) => {
            evt.preventDefault();
            window.location = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages.download + 'farmers-register';
        });
        this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        /* / Buttons */

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            for (let i = 0; i < rows.length; i++) {
                rows[i].cols[colRefs.OrdinalNumber].value = i + 1;
                rows[i].cols[colRefs.OrdinalNumber].html = i + 1;

                if (rows[i].cols[colRefs._Modified_DateTime].value === null ||
                        rows[i].cols[colRefs.Client__Modified_DateTime].value === null)
                    rows[i].class = 'data-offline';
            }


        }

        if (refresh)
            this.m.t.refresh();

        this.$view = this.m;
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\index.js
jsLibs.exportScript("core", "./panelDatas/index", [ "about","administrators","associations","backups","bulls","clinics","cows","farmers","inseminators","newReceipt","receipts","registrations","traders" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("core", "./panelDatas/about", [ { name: "*", alias: "about" } ], "./about.js");
_jsLib.importDeclaration("core", "./panelDatas/administrators", [ { name: "*", alias: "administrators" } ], "./administrators.js");
_jsLib.importDeclaration("core", "./panelDatas/associations", [ { name: "*", alias: "associations" } ], "./associations.js");
_jsLib.importDeclaration("core", "./panelDatas/backups", [ { name: "*", alias: "backups" } ], "./backups.js");
_jsLib.importDeclaration("core", "./panelDatas/bulls", [ { name: "*", alias: "bulls" } ], "./bulls.js");
_jsLib.importDeclaration("core", "./panelDatas/clinics", [ { name: "*", alias: "clinics" } ], "./clinics.js");
_jsLib.importDeclaration("core", "./panelDatas/cows", [ { name: "*", alias: "cows" } ], "./cows.js");
_jsLib.importDeclaration("core", "./panelDatas/farmers", [ { name: "*", alias: "farmers" } ], "./farmers.js");
_jsLib.importDeclaration("core", "./panelDatas/inseminators", [ { name: "*", alias: "inseminators" } ], "./inseminators.js");
_jsLib.importDeclaration("core", "./panelDatas/newReceipt", [ { name: "*", alias: "newReceipt" } ], "./newReceipt.js");
_jsLib.importDeclaration("core", "./panelDatas/receipts", [ { name: "*", alias: "receipts" } ], "./receipts.js");
_jsLib.importDeclaration("core", "./panelDatas/registrations", [ { name: "*", alias: "registrations" } ], "./registrations.js");
_jsLib.importDeclaration("core", "./panelDatas/traders", [ { name: "*", alias: "traders" } ], "./traders.js");

/* export */ { (_jsLib.import("core", "./panelDatas/about", "*", "about", "./about.js")), (_jsLib.import("core", "./panelDatas/administrators", "*", "administrators", "./administrators.js")), (_jsLib.import("core", "./panelDatas/associations", "*", "associations", "./associations.js")), (_jsLib.import("core", "./panelDatas/backups", "*", "backups", "./backups.js")), (_jsLib.import("core", "./panelDatas/bulls", "*", "bulls", "./bulls.js")), (_jsLib.import("core", "./panelDatas/clinics", "*", "clinics", "./clinics.js")), (_jsLib.import("core", "./panelDatas/cows", "*", "cows", "./cows.js")),
        (_jsLib.import("core", "./panelDatas/farmers", "*", "farmers", "./farmers.js")), (_jsLib.import("core", "./panelDatas/inseminators", "*", "inseminators", "./inseminators.js")), (_jsLib.import("core", "./panelDatas/newReceipt", "*", "newReceipt", "./newReceipt.js")), (_jsLib.import("core", "./panelDatas/receipts", "*", "receipts", "./receipts.js")), (_jsLib.import("core", "./panelDatas/registrations", "*", "registrations", "./registrations.js")), (_jsLib.import("core", "./panelDatas/traders", "*", "traders", "./traders.js")) };

/* JSLib Exports */
_jsLib.export("about", (_jsLib.import("core", "./panelDatas/about", "*", "about", "./about.js")));
_jsLib.export("administrators", (_jsLib.import("core", "./panelDatas/administrators", "*", "administrators", "./administrators.js")));
_jsLib.export("associations", (_jsLib.import("core", "./panelDatas/associations", "*", "associations", "./associations.js")));
_jsLib.export("backups", (_jsLib.import("core", "./panelDatas/backups", "*", "backups", "./backups.js")));
_jsLib.export("bulls", (_jsLib.import("core", "./panelDatas/bulls", "*", "bulls", "./bulls.js")));
_jsLib.export("clinics", (_jsLib.import("core", "./panelDatas/clinics", "*", "clinics", "./clinics.js")));
_jsLib.export("cows", (_jsLib.import("core", "./panelDatas/cows", "*", "cows", "./cows.js")));
_jsLib.export("farmers", (_jsLib.import("core", "./panelDatas/farmers", "*", "farmers", "./farmers.js")));
_jsLib.export("inseminators", (_jsLib.import("core", "./panelDatas/inseminators", "*", "inseminators", "./inseminators.js")));
_jsLib.export("newReceipt", (_jsLib.import("core", "./panelDatas/newReceipt", "*", "newReceipt", "./newReceipt.js")));
_jsLib.export("receipts", (_jsLib.import("core", "./panelDatas/receipts", "*", "receipts", "./receipts.js")));
_jsLib.export("registrations", (_jsLib.import("core", "./panelDatas/registrations", "*", "registrations", "./registrations.js")));
_jsLib.export("traders", (_jsLib.import("core", "./panelDatas/traders", "*", "traders", "./traders.js"))); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\inseminators.js
jsLibs.exportScript("core", "./panelDatas/inseminators", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'inseminators';
let panelTitle = 'Inseminators';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.user_ManageAccount = new (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).User_ManageAccount(this);

        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_Form_Buttons`]);
        this.m.fm.m.l.$holders.Buttons_Before.$view = this.lButtons;

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);
            if (data.row !== null) {
                this.m.fm.m.l.$fields.shows.delete = true;

                this.lButtons.$fields.hrefs.bulls = this.pager.getPageUri(
                        `lb.subpanels.bulls.list`,
                        { clientId: data.row.Client__Id, });

                this.lButtons.$elems.bulls.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    console.log(this.pager);
                    this.pager.setPage(`lb.subpanels.bulls.list`,
                            { clientId: data.row.Client__Id });
                });

                if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isClinicInseminator) {
                    this.lButtons.$fields.shows.bulls = 
                            data.row.Clinic_Client__Id === null;
                } else {
                    this.lButtons.$fields.shows.bulls = 
                            data.row.Client__Id !== null;
                }

                this.user_ManageAccount.refresh_OnParseApiResult(data);
            }
        }

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        // this.m.f.l.$fields.shows.Clinic__Id = !sys.user.isClinic;

        this.lClient = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Clients_Form);
        this.m.f.l.$holders.clientForm.$view = this.lClient;
        this.fClient = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lClient, 'Form');

        this.lClient.$fields.isUser = true;
        this.lClient.$fields.isUnderGrade = true;
        this.lClient.$fields.showTrader__Id = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id !== null;

        this.lUser = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Users_Form);
        this.lUser.$fields.isNew = true;
        this.lClient.$holders.userForm.$view = this.lUser;
        this.fUser = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lUser, 'Form');

        this._initForm();

        this.m.refresh_OnParseApiResult = (data) => {
            this._initSelects(data);

            if (this.m.data.rClient !== null)
                this.fClient.setValues(this.m.data.rClient);
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);

            // if (data.row !== null)
            //     this.m.f.fields.Clinic__Id.setDisabled(true); 
        };
        this.m.submit_OnSetApiFields = (fields) => {
            // if (sys.user.isClinic) {
            //     fields.row.Clinic__Id = null;
            // } else {
            //     fields.row.Clinic__Id = fields.row.Clinic__Id === '0' ?
            //             null : parseInt(fields.row.Clinic__Id);
            // }

            fields.client = this.fClient.getValues();
            fields.user = this.fUser.getValues();

            delete fields.client.UnderGrade;       
            
            // if (fields.row.Clinic__Id === '0')
            //     fields.row.Clinic__Id = null;

            if (fields.client.Trader__Id === '0')
                fields.client.Trader__Id = null;

            return fields;
        }
        this.m.submit_OnValidator = (result) => {
            this.fClient.setValidator(result.data.validator);
            this.fUser.setValidator(result.data.validator);
        };

        this.$view = this.m;
    }


    _initForm() {
        // this.m.f.fields.Clinic__Id.field('Options', [
        //     {
        //         title: sys.eText('Sys:Options_None'),
        //         value: 0,
        //     },
        // ]);
        // this.m.f.fields.Clinic__Id.elem.addEventListener('change', (evt) => {
        //     this.m.f.l.$fields.shows.Inseminator__Id = 
        //             this.m.f.fields.Clinic__Id.value === '0';
        // });
    }

    _initSelects(data) {
        // let clinicOptions = [];
        // clinicOptions.push({
        //     title: abText.$('Sys:Options_None'),
        //     value: '0',
        // });
        // for (let rClinic of data.rClinics) {
        //     clinicOptions.push({
        //         title: rClinic.Client_Name,
        //         value: rClinic._Id,
        //     });
        // }
        // this.m.f.fields.Clinic__Id.field('Options', clinicOptions);

        let traderOptions = [];
        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator) {
            traderOptions.push({
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Options_None'),
                value: '0',
            });
        }
        for (let rTrader of data.rTraders) {
            traderOptions.push({
                title: rTrader.Name,
                value: rTrader._Id,
            });
        }
        this.fClient.fields.Trader__Id.field('Options', traderOptions);
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isTrader)
            this.m.t.addHiddenColumns([ 'Client_Trader_Name', ]);
        // else if (sys.user.isClinic)
        //     this.m.t.addHiddenColumns([ 'Client_Trader_Name', 'Clinic_Client_Name' ]);

        /* Buttons */
        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields = {
            hrefs: {
                register: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages.download + 'inseminators-register', 
            },
            shows: {
                register: (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web',
            },
        }
        this.lButtons.$elems.register.addEventListener('click', (evt) => {
            evt.preventDefault();
            window.location = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages.download + 'inseminators-register';
        });
        this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        /* / Buttons */

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            for (let i = 0; i < rows.length; i++) {
                rows[i].cols[colRefs.OrdinalNumber].value = i + 1;
                rows[i].cols[colRefs.OrdinalNumber].html = i + 1;
            }
        }

        this.m.t.refresh();

        this.$view = this.m;
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\newReceipt.js
jsLibs.exportScript("core", "./panelDatas/newReceipt", [ "Bull","Cow","Details","Farmer" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-date", "./index", [ { name: "default", alias: "abDate" } ], "ab-date");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");
_jsLib.importDeclaration("spk-tables", "./index", [ { name: "default", alias: "spkTables" } ], "spk-tables");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");
_jsLib.importDeclaration("core", "./tables", [ { name: "default", alias: "tables" } ], "../tables.js");
_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");

_jsLib.importDeclaration("core", "./panelDatas/bulls", [ { name: "*", alias: "bulls" } ], "./bulls.js");
_jsLib.importDeclaration("core", "./panelDatas/cows", [ { name: "*", alias: "cows" } ], "./cows.js");
_jsLib.importDeclaration("core", "./panelDatas/farmers", [ { name: "*", alias: "farmers" } ], "./farmers.js");

let panelName = 'newReceipts';
let panelTitle = 'NewReceipts';

/* export */ class Bull extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.bulls_List = new (_jsLib.import("core", "./panelDatas/bulls", "*", "bulls", "./bulls.js")).List(lb, false, true);

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.bulls_List.m.listeners_Back();
            return true;
        });

        this.bulls_List.lButtons.$fields.shows.register = false;

        /* Associations */
        this.lAssociations = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).NewReceipt_AssociatedBulls);        
        this.tAssociatedBulls = new (_jsLib.import("spk-tables", "./index", "default", "spkTables", "spk-tables")).Table(this.msgs, 
                (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_AssociatedBulls())
            .setNoSort(true)
            .setShowSearch(false)
            .setOnRefresh((rows, colRefs) => {
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.format(rows, colRefs, 'Inb', (col, row) => {
                    col.html = col.value === null ? '-' : col.value.toFixed(2);
                })
            })
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.details`,
                        { cowIds: this.pager.current.args.cowIds,
                        bullId: row.cols[colRefs.Bull__Id].value });
            });
        this.lAssociations.$holders.table.$view = this.tAssociatedBulls;
        this.bulls_List.m.l.$holders.beforeTable.$view = this.lAssociations;
        /* / Associations */

        this.bulls_List.cowIds = _getIdsFromArg(this.pager.current.args.cowIds);

        this.bulls_List.m.l.$fields = {
            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Bull`),
            texts: {
                Buttons_Add: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Buttons_AddBull'),
            },
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.bulls.add`, 
                        { newReceipt_CowIds: this.pager.current.args.cowIds }),
                back: this.pager.getPageUri('lb.subpanels.newReceipt.cow',
                        { newReceipt_FarmerId: this.pager.current.args.farmerId,
                        selectedCows: this.bulls_List.cowIds.length > 1 ? 
                        this.pager.current.args.cowIds : '0' }),
            },
        };

        this.bulls_List.m.listeners_Add = () => {
            if (this.bulls_List.m.t.isSelectable) {
                this.pager.setPage(`lb.subpanels.bulls.add`, { 
                        newReceipt_CowIds: this.pager.current.args.cowIds });
            } else {
                this.pager.setPage(`lb.subpanels.bulls.add`, 
                        { newReceipt_CowIds: this.pager.current.args.cowIds });
            }
        };

        this.bulls_List.m.listeners_Back = () => {
            this.pager.setPage('lb.subpanels.newReceipt.cow',
                    { newReceipt_FarmerId: this.pager.current.args.farmerId,
                    selectedCows: this.bulls_List.cowIds.length > 1 ? 
                    this.pager.current.args.cowIds : '0' });
        };
        
        this.bulls_List.m.t
            .setNoSort(true)
            // .setOrderBy('Name', false)
            .setOnRowClick((row, colRefs) => {
                if (this.bulls_List.m.t.isSelectable) {
                    if (!row.selected) {
                        if (this.bulls_List.m.t.getSelectedRows().length >= 4) {
                            this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                    'Sys:Errors_CannotSelect'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                    'Sys:Errors_TooManyBullsInTheMix'));
                            return;
                        }
                    }

                    row.selected = !row.selected;
                    this._onRowSelected();
                    this.bulls_List.m.t.refreshAllRows();
                } else
                    this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.details`,
                        { cowIds: this.pager.current.args.cowIds,
                        bullId: row.cols[colRefs._Id].value });
            })
            .setOnRowSelected((val, row, colRefs, rowIndex) => {
                if (val) {
                    if (this.bulls_List.m.t.getSelectedRows().length >= 4) {
                        this.msgs.showMessage_Failure((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'Sys:Errors_CannotSelect'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(
                                'Sys:Errors_TooManyBullsInTheMix'));
                        return false;
                    }
                }

                this._onRowSelected();
                return true;
            })
            .setSelectable_SelectedOnTop(true)
            .setSelectable_ShowSelectAll(false);
        this.bulls_List.m.t.refresh();

        this.bulls_List.m.refresh_OnApiResult = (data) => {
            if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isInseminator) {
                this.bulls_List.m.l.$fields.uris.back = 
                        this.pager.getPageUri('lb.subpanels.newReceipt.cow',
                        { farmerId: data.rFarmer._Id, 
                        selectedCows: this.bulls_List.cowIds.length > 1 ? 
                        this.pager.current.args.cowIds : '0' });
                this.bulls_List.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.newReceipt.cow',
                            { farmerId: data.rFarmer._Id,
                            selectedCows: this.bulls_List.cowIds.length > 1 ? 
                            this.pager.current.args.cowIds : '0' });
                };
            } 

            this.lAssociations.$fields.show = data.rAssociatedBulls.length > 0;
            this.tAssociatedBulls.update((_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).parseRows(
                    (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_AssociatedBulls().columns, data.rAssociatedBulls));
        }

        this.$view = this.bulls_List;
    }   

    _onRowSelected() {
        this.bulls_List.m.t.setFilterText('');

        this.bulls_List.lButtons_Select.$fields.Show = this.bulls_List.m.t
                .getSelectedRows().length > 0;

        window.scrollTo(0, 0);
    }
}

/* export */ class Cow extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.cows_List = new (_jsLib.import("core", "./panelDatas/cows", "*", "cows", "./cows.js")).List(lb, false, false, true);

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.cows_List.m.listeners_Back();
            return true;
        });

        this.cows_List.m.l.$fields = {
            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Cow`),
            texts: {
                Buttons_Add: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Buttons_AddCow'),
            },
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.cows.add`, 
                        { farmerId: this.pager.current.args.farmerId, newReceipt: '1' }),
                back: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ? 
                        this.pager.getPageUri('lb.main') : 
                        this.pager.getPageUri('lb.subpanels.newReceipt.farmer')
            },
        },

        this.cows_List.m.listeners_Add = () => {
            if (this.cows_List.m.t.isSelectable) {
               let cowIds = _getSelectedIds(this.cows_List.m.t
                        .getSelectedRows());
               this.pager.setPage(`lb.subpanels.cows.add`, 
                        { farmerId: this.pager.current.args.farmerId, 
                        newReceipt: '1', selectedCows: cowIds.length === 0 ?
                        '-1' : cowIds.join(',') });
            } else {
                this.pager.setPage(`lb.subpanels.cows.add`, 
                        { farmerId: this.pager.current.args.farmerId, 
                        newReceipt: '1' });
            }
        };
        this.cows_List.m.listeners_Back = () => {
            this.pager.setPage((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id !== null ?
                    'lb.main' : 'lb.subpanels.newReceipt.farmer');
        };

        let refresh_SetOnRefresh = this.cows_List.m.refresh_SetOnRefresh;
        this.cows_List.m.refresh_SetOnRefresh = (rows, colRefs) => {
            refresh_SetOnRefresh(rows, colRefs);
            let args_SelectedCows = lb.pager.current.args.selectedCows;
            if (args_SelectedCows !== '0') {
                this.cows_List.mSelect.setActive(true);

                let t = this.cows_List.m.t
                t.setSelectable(true);
                let rows_Length = 9;
                if (args_SelectedCows !== '-1') {
                    let cowIds = args_SelectedCows.split(',');
                    for (let row of rows) {
                        if (cowIds.includes(String(row.cols[colRefs._Id].value))) {
                            row.selected = true;
                            rows_Length++;
                        }
                    }
                }

                this.cows_List.lButtons_Select.$fields.Show = rows_Length > 0;
            }
        };

        this.cows_List.m.t
            .setApiFields(() => {
                return {
                    farmerId: this.pager.current.args.farmerId,
                };
            })
            .setOnRowClick((row, colRefs, rowIndex) => {
                if (this.cows_List.m.t.isSelectable) {
                    row.selected = !row.selected;
                    this._onRowSelected();
                    this.cows_List.m.t.refreshAllRows();
                } else
                    this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.bull`,
                        { cowIds: row.cols[colRefs._Id].value, });
            })
            .setOnRowSelected((val, row, colRefs, rowIndex) => {
                this._onRowSelected();
                return true;
            })
            .setSelectable_SelectedOnTop(true)
            .setSelectable_ShowSelectAll(false);
        this.cows_List.m.t.refresh();

        this.$view = this.cows_List;
    }   

    _onRowSelected() {
        // row.selected = !row.selected;
        this.cows_List.m.t.setFilterText('');
        // this.cows_List.m.t.updateRow_Selected(rowIndex, 
        //     !row.selected); 
        // this.cows_List.m.t.update();

        this.cows_List.lButtons_Select.$fields.Show = this.cows_List.m.t
                .getSelectedRows().length > 0;

        window.scrollTo(0, 0);
    }
}


/* export */ class Details extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.data = null;
        this.lForms = [];
        this.fs = [];
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, 'receipts', 'Receipts', false, true);
        this.m.lContent.$fields.newReceipt = true;
        this.m.lContent.$holders.form((holder) => {
            let l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).NewReceipt_Form);
            this.fs.push(new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(l, 'Form'));
            this.lForms.push(l);
            holder.$view = l;
        });

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.m.listeners_Back();
            return true;
        });

        this.m.lContent.$elems.Next.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.m.submit((result) => {
                this.m.onSubmit(result);
            });
        });

        let fSexedOptions = [
            {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Forms_BullSexed_Conventional'),
                value: '',
            }, {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Forms_BullSexed_SexedX'),
                value: 'X',
            }, {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Forms_BullSexed_SexedY'),
                value: 'Y',
            }
        ];        
        this.m.f.getField('NewReceipt_BullSexed').field('Options', fSexedOptions);
        this.m.f.getField('NewReceipt_BullSexed').value = '';

        this.m.onSubmit = (result) => {
            if (result.success) {
                if ((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native') {
                    let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();

                    if (app.nativeApp.printer !== null) {
                        this.msgs.showConfirmation(
                                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_PrintReceipt_Title'),
                                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_PrintReceipt_Text'),
                                (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), (cResult) => {
                            (async () => {
                                if (cResult) {
                                    let rows_Formatted = [];
                                    for (let row of result.data.rows) {
                                        rows_Formatted.push((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).formatReceiptForPrint(
                                                row));
                                    }

                                    try {
                                        await app.nativeApp.nativeActions.callNative_Async('PrintReceipts',
                                                { printerAddress: app.nativeApp.printer.address,
                                                rows: rows_Formatted, });
                                        
                                    } catch (e) {
                                        console.error('newReceipt -> Printing receipt error.', e);
                                    }
                                }

                                if (await app.isConnectedToInternet_Async())
                                    await app.syncDB_Async();
                                else
                                    this.msgs.hideLoading();
                                    
                                // if (sys.user.isInseminator) {
                                //     this.pager.setPage('lb.subpanels.newReceipt.cow',
                                //             { farmerId: this.data.rCow.Farmer__Id, });
                                // } else
                                this.pager.setPage(`lb.subpanels.receipts.list`);
                            })();
                        });
                    } else {
                        (async () => {
                            if (await app.isConnectedToInternet_Async())
                                await app.syncDB_Async();
                            else
                                this.msgs.hideLoading();
                                
                            // if (sys.user.isInseminator) {
                            //     this.pager.setPage('lb.subpanels.newReceipt.cow',
                            //             { farmerId: this.data.rCow.Farmer__Id, });
                            // } else
                            this.pager.setPage(`lb.subpanels.receipts.list`);
                        })();
                    }
                } else {
                    // if (sys.user.isInseminator) {
                    //     this.pager.setPage('lb.subpanels.newReceipt.cow',
                    //             { farmerId: this.data.rCow.Farmer__Id, });
                    // } else
                    this.pager.setPage(`lb.subpanels.receipts.list`);
                }
            }
        }

        this.m.submit_OnValidator = (result) => {
            if ('rowValidators' in result.data) {
                for (let i = 0; i < result.data.rowValidators.length; i++)
                    this.fs[i].setValidator(result.data.rowValidators[i]);
            }
        }

        this.m.l.$fields.shows.delete = false;

        this.m.f.layout.$fields = {
            isNew: true,
        };

        this.m.l.$fields = {
            texts: {
                Buttons_Submit: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText(`Sys:Buttons_Create`),
                title: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText(`Sys:Titles_NewReceipt_Details`),
            },
            uris: {
                back: this.pager.getPageUri(`lb.subpanels.newReceipt.bull`, 
                        { cowIds: this.pager.current.args.cowIds }),
            },
        };

        this.m.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                    { cowIds: this.pager.current.args.cowIds });
        };

        this.m.refresh_OnParseApiResult = (data) => {
            this.data = data;

            this.m.f.setValues({
                NewReceipt_Date: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getTime(),
            });

            this.m.lContent.$fields.CowInfos = data.rCows;

            for (let i = 0; i < data.rCows.length; i++) {
                this.lForms[i].$fields.rCow = data.rCows[i];
                this.fs[i].setValues({
                    FileNr: '0001',
                    TreatmentNr: data.treatmentNrs_Next[data.rCows[i]._Id],
                    ReinseminationsCount: '00',

                    LastCalving: data.rCows[i].LastCalving,
                });
            }
        };
        this.m.refresh_OnSetApiFields = (fields) => {
            fields.cowIds = 'cowIds' in this.pager.current.args ?
                    _getIdsFromArg(this.pager.current.args.cowIds) : null;
            fields.bullId = Number(this.pager.current.args.bullId);

            return fields;
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.rows = [];
            for (let i = 0; i < this.fs.length; i++) {
                fields.rows.push(this.fs[i].getValues());
                if (i === 0)
                    fields.rows[0]._Id = fields.id;
                else
                    fields.rows[i]._Id = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().dataStore.nextId();
            }

            fields.cowIds = 'cowIds' in this.pager.current.args ?
                    _getIdsFromArg(this.pager.current.args.cowIds) : null;
            fields.bullId = Number(this.pager.current.args.bullId);

            fields.id = null;

            /* Unset */
            delete fields.BullsMix;

            delete fields.row.Cow_Nr;
            delete fields.row.Cow_Name;
            delete fields.row.Cow_Race;
            delete fields.row.Cow_Birth;

            for (let i = 0; i < 5; i++) {
                let bullIndex = i === 0 ? '' : (i + 1);
                delete fields.row[`Bull${bullIndex}_Name`];
                delete fields.row[`Bull${bullIndex}_Nr`];
                delete fields.row[`Bull${bullIndex}_ManufacturerNr`];
                delete fields.row[`Bull${bullIndex}_Race`];
            }

            return fields;
        };

        this.m.refresh();

        this.$view = this.m;
    }
}


/* export */ class Farmer extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.farmers_List = new (_jsLib.import("core", "./panelDatas/farmers", "*", "farmers", "./farmers.js")).List(lb, false);

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.farmers_List.m.listeners_Back();
            return true;
        });

        this.farmers_List.lButtons.$fields = {
            shows: {
                register: false,
            },
        };
        this.farmers_List.m.l.$fields = {
            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$(`Sys:Titles_NewReceipt_Farmer`),
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.farmers.add`, 
                        { newReceipt: '1' }),
                back: this.pager.getPageUri('lb.main'),
            },
        };

        this.farmers_List.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.farmers.add`, { newReceipt: '1' });
        };

        this.farmers_List.m.t
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.cow`,
                        { farmerId: row.cols[colRefs._Id].value, });
            });
        this.farmers_List.m.t.refresh();

        this.$view = this.farmers_List;
    }   
}

function _getIdsFromArg(argStr) {
        let ids_Raw = argStr.split(',');
        let ids = [];
        for (let id_Raw of ids_Raw)
            ids.push(Number(id_Raw));

        return ids;
    }

function _getSelectedIds(rows) {
    let ids = [];
    for (let row of rows)
        ids.push(row._Id);

    return ids;
}

/* JSLib Exports */
_jsLib.export("Bull", Bull);
_jsLib.export("Cow", Cow);
_jsLib.export("Details", Details);
_jsLib.export("Farmer", Farmer); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\receipts.js
jsLibs.exportScript("core", "./panelDatas/receipts", [ "Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-date", "./index", [ { name: "default", alias: "abDate" } ], "ab-date");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("e-tasks", "./index", [ { name: "default", alias: "eTasks" } ], "e-tasks");
_jsLib.importDeclaration("spk-file-upload", "./index", [  ], "spk-file-upload");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");
_jsLib.importDeclaration("core", "./tables", [ { name: "default", alias: "tables" } ], "../tables.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'receipts';
let panelTitle = 'Receipts';


// export class Add extends sys.Module
// {

//     constructor(lb)
//     { super(lb);
//         this.pager.setPage(sys.user.info.Farmer__Id === null ? 
//                 'lb.subpanels.newReceipt.farmer' :
//                 'lb.subpanels.newReceipt.cow', {}, false);
//     }

// }


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form, false);

        this.m.fm.m.lContent.$fields = {
            shows: {
                bull: true,
                bullsMix: true,
                cow: true,
            },
        };

        this.m.fm.m.refresh_OnSetApiFields = (fields) => {
            fields.cowIds = null;
            fields.bullId = null;

            return fields;
        }
        this.m.fm.m.submit_OnSetApiFields = (fields) => {
            fields.cowIds = null;
            fields.bullId = null; 

            if (fields.row.BullsMix) {
                 let noExtraBulls = true;
                for (let i = 1; i < 5; i++) {
                    let bullIndex = i + 1;
                    if (fields.row[`Bull_Nr${bullIndex}`] === '')
                        fields.row[`Bull_Nr${bullIndex}`] = null;
                    else
                        noExtraBulls = false;
                }
                if (noExtraBulls)
                    fields.row.Bull_Nr2 = '';
            } else {
                for (let i = 1; i < 5; i++) {
                    let bullIndex = i + 1;
                    fields.row[`Bull_Nr${bullIndex}`] = null;
                }
            }

            delete fields.row.BullsMix;

            return fields;
        }

        this.m.fm.m.refresh(0);

        this.$view = this.m;
    }
}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);
        let app = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance();

        this.m.f.layout.$fields = {
            nextHeat: '-',
            plannedCalving: '-',

            shows: {
                nr: true,
            },
        };

        this.m.f.getField('BullsMix').elem.addEventListener('change', (evt) => {
            this.m.lContent.$fields.shows.bullsMix = this.m.f
                    .getField('BullsMix').value;
        });

        let fSexedOptions = [
            {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Forms_BullSexed_Conventional'),
                value: '',
            }, {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Forms_BullSexed_SexedX'),
                value: 'X',
            }, {
                title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Forms_BullSexed_SexedY'),
                value: 'Y',
            }
        ];        
        this.m.f.getField('BullSexed').field('Options', fSexedOptions);

        /* Buttons */
        if (!create) {
            this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_Form_Buttons`]);
            this.lButtons.$fields = {
                hrefs: {
                    download: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages.download + 'receipt-image?id=' +
                            this.pager.current.args.id, 
                    downloadSymlek: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages.download + 'receipt-symlek?id=' +
                            this.pager.current.args.id, 
                },
                shows: {
                    download: (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web',
                    downloadSymlek: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator || (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isTrader,
                    print: (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native' ? app.nativeApp.printer !== null : false,
                }
            };

            this.lButtons.$elems.print.addEventListener('click', (evt) => {
                evt.preventDefault();

                app.nativeApp.nativeActions.callNative_Async('PrintReceipts',
                        { printerAddress: app.nativeApp.printer.address,
                        rows: [ (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).formatReceiptForPrint(this.m.data.row) ], });
            });

            this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        }
        /* / Buttons */

        this.m.refresh_OnParseApiResult = (data) => {
            if (data.row !== null) {
                let shows = {
                    submit: true,
                    delete: true,
                };

                this.m.f.setValues({
                    'BullsMix': data.row.Bull_Nr2 !== null || 
                            data.row.Bull_Nr3 !== null ||
                            data.row.Bull_Nr4 !== null ||
                            data.row.Bull_Nr5 !== null,
                });

                if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Administrator__Id === null && 
                        (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Trader__Id === null) {
                    if ((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web') {
                        if (data.row.Downloaded !== null) {
                            shows.submit = false;
                            this.m.f.setDisabled(true);
                            shows.delete = false;
                        }
                    } else if ((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native') {
                        if (data.row._Modified_DateTime !== null) {
                            shows.submit = false;
                            this.m.f.setDisabled(true);
                            shows.delete = false;
                        }
                    }
                }

                this.m.f.layout.$fields.nextHeat = (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date_UTC(
                        data.row.Date + (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).span_Day * 21);
                this.m.f.layout.$fields.plannedCalving = (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).format_Date_UTC(
                        data.row.Date + (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).span_Day * 282);

                this.m.l.$fields.shows = shows;
            }
        };

        this.$view = this.m;
    }
}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle, false)

        if ((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native') {
            this.m.t.addHiddenColumns([
                'Downloaded',
            ]);
        }

        // if (!sys.user.isAdministrator && !sys.user.isTrader) {
        //     this.m.t.addHiddenColumns([
        //         'Clinic_Client_Name',
        //     ]);
        // }

        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isFarmer) {
            this.m.t.addHiddenColumns([
                'Farmer_Client_Name',
                'Farmer_HerdUnderGradeNr', 
                'InseminatorName',
            ]);
        }

        /* Buttons */
        this.lButtons = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields.shows.download = (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web';
        this.lButtons.$fields.shows.register = (_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web';
        this.lButtons.$elems.download.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.downloadNew();
        });
        this.lButtons.$elems.register.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.downloadRegister();
        });
        this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        /* / Buttons */

        /* Header */
        this.lHeader = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`${panelTitle}_List_Header`]);
        this.fHeader = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lHeader, 'Form');

        this._init_Header();

        this.m.l.$holders.header.$view = this.lHeader;
        /* / Header */

        /* Fields */
        if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isFarmer || (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isInseminator) {
            this.m.l.$fields = {
                uris: {
                    add: (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id === null ?
                            this.pager.getPageUri(`lb.subpanels.newReceipt.farmer`) :
                            this.pager.getPageUri(`lb.subpanels.newReceipt.cow`),
                },
            };

            this.m.listeners_Add = () => {
                this.pager.setPage((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.info.Farmer__Id === null ?
                        `lb.subpanels.newReceipt.farmer` :
                        `lb.subpanels.newReceipt.cow`);
            }
        } else
            this.m.l.$fields.shows.add = false;
        /* / Fields */

        /* Filters */
        this._filter_Select('currentMonth', false);
        this.lHeader.$elems.filters_DatesRange.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('datesRange');
        });
        this.lHeader.$elems.filters_CurrentMonth.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('currentMonth');
        });
        this.lHeader.$elems.filters_PreviousMonth.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('previousMonth');
        });
        this.lHeader.$elems.filters_CurrentYear.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('currentYear');
        });
        /* / Filters */

        this.m.refresh_SetApiFields = (fields) => {
            let datesRange = this._filter_GetDatesRange();
            fields.date = datesRange;

            let filters = this._filter_GetFilters();
            fields.filters = filters;

            return fields;
        }

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];

                if ((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'native') {
                    if (row.cols[colRefs._Modified_DateTime].value === null)
                        row.class += ' data-offline';
                    else
                        row.class += ' data-online';
                }

                if (row.cols[colRefs.Farmer_HerdUnderGradeNr].value === null &&
                        row.cols[colRefs.Downloaded].value === null)
                    row.class += ' not-downloaded';

                // if (sys.user.isAdministrator || sys.user.isTrader) {
                    // if (row.cols[colRefs.Downloaded].value === null)
                    //     row.class = 'not-downloaded';
                // } else {
                //     if (row.cols[colRefs.Downloaded_Client].value === null)
                //         row.class = 'not-downloaded';
                // }
            }

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.format(rows, colRefs, 'Nr', (col, row) => {
                col.html = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).formatReceiptNr(col.value);
            });

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.format(rows, colRefs, 'Bull_Name', (col, row) => {
                let name = col.value;
                if (name === '')
                    name = row.cols[colRefs.Bull_Nr].value;
                if (row.cols[colRefs.Bull_Nr2].value !== null ||
                        row.cols[colRefs.Bull_Nr3].value !== null ||
                        row.cols[colRefs.Bull_Nr4].value !== null ||
                        row.cols[colRefs.Bull_Nr5].value !== null) {
                    name += ` (MIX)`;
                }
                col.html = name;
            });

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDate(rows, colRefs, 'Date');
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDate(rows, colRefs, 'Added');

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.format(rows, colRefs, 'Downloaded', (col, row) => {
                col.class = 'text-center';
                if (row.cols[colRefs.Farmer_HerdUnderGradeNr].value === null) {
                    col.class = 'text-center';
                    col.html = '<i class="far fa-circle" />';
                } else {
                    col.class = 'text-center';
                    col.html = col.value !== null ? 
                            '<i class="fa fa-check" />' : 
                            '<i class="fa fa-times" />';
                }
            });
        };
        this.m.t.setOnApiResult((data, apiFields) => {
            let colRefs = this.m.t.columnRefs;
            let table = data.table;
            let table_New = [];

            let dateFrom = apiFields.date.from;
            let dateTo = apiFields.date.to;

            let filterStr = 'od ';
            filterStr += dateFrom === null ? '-' : dateFrom;
            filterStr += ' do '
            filterStr += dateTo === null ? '-' : dateTo;

            this.lHeader.$fields.filterStr = filterStr;
            this.lHeader.$fields.receiptsCount = table.length;

            for (let row of table) {
                if (dateFrom !== null) {
                    if (row[colRefs.Date] < dateFrom)
                        continue;
                }

                if (dateTo !== null) {
                    if (row[colRefs.Date] > dateTo)
                        continue;
                }
                
                table_New.push(row);
            }

            data.table = table_New;

             /* Farmers */
            if (abNative_Platform === 'web') {
                if (!this.tagsInitialized) {
                    this.tags_Trader.removeAllTags();
                    this.tags_Trader.whitelist = data.traders;
                    // this.tags_Inseminator.addTags(data.farmers);

                    this.tags_Inseminator.removeAllTags();
                    this.tags_Inseminator.whitelist = data.inseminators;
                    // this.tags_Inseminator.addTags(data.farmers);

                    this.tags_Farmer.removeAllTags();
                    this.tags_Farmer.whitelist = data.farmers;
                    // this.tags_Farmer.addTags(data.farmers);
                
                    this.tagsInitialized = true;
                }
            }
        });
        this.m.t.setDynamic((_jsLib.import("core", "./App", "default", "App", "../App.js")).Platform === 'web');
        this.m.t.refresh();

        this.$view = this.m;
    }


    downloadFiltered() {
        let fields = {};
        let datesRange = this._filter_GetDatesRange();
        fields.date = datesRange;

        let filters = this._filter_GetFilters();
        fields.filters = filters;

        this.downloadZip('receipts', fields, fields.filters.MarkDownloaded);
    }


    downloadNew() {
        this.downloadZip('receipts-new', {}, true);
    }

    downloadRegister() {
        let datesRange = this._filter_GetDatesRange();
        if (datesRange.from === null || datesRange.to === null) {
            this.msgs.showMessage_Failure('Musisz wybrać zakres dat.');
            return;
        }

        let tableInfo = (_jsLib.import("core", "./tables", "default", "tables", "../tables.js")).tables_Receipts();
        tableInfo = {
            columns: tableInfo.columns,
            orderBy: tableInfo.orderBy,
        };

        let downloadUri = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages[`download`] + 'receipts-register' + 
                '?tableInfo=' + encodeURIComponent(JSON.stringify(tableInfo)) + 
                '&dateFrom=' + datesRange.from + '&dateTo=' + datesRange.to;

        window.location = downloadUri;
    }

    downloadZip(type, api_args, refreshTable) {
        this.msgs.showLoading();

        let api_uri = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages[`api.downloads`] + type;

        let downloading = false;
        (_jsLib.import("e-tasks", "./index", "default", "eTasks", "e-tasks")).start(api_uri, api_args, true, (task, result) => {
            if (!result.isSuccess())
                this.msgs.showMessage_Failure('');

            if ('noReceipts' in result.data) {
                this.msgs.showMessage_Success(
                    (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText('Sys:Notifications_NoReceiptsToDownload'));
                this.msgs.hideLoading();

                return false;
            }

            if (task.info.zip_Ready && !downloading) {
                window.location = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).uris.pages['download'] +
                        'receipts-zip' + '?taskHash=' + task.hash;
                downloading = true;
            }

            if (!task.finished) {
                if (task.info.zip_Ready) {
                    this.msgs.showLoading(
                            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText('Sys:Text_DownloadingFile'));
                } else {
                    this.msgs.showLoading(
                            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).eText('Sys:Text_PreparingFile') + ': ' +
                            (task.info.progress * 100).toFixed(2) + '%');
                }

                return true;
            }

            if (refreshTable)
                this.m.t.refresh();
            else
                this.msgs.hideLoading();

            return false;
        });
    }


    _filter_GetDatesRange() {
        let fHeader_Values = this.fHeader.getValues();
        var date = new Date();

        let datesRange = {
            from: null,
            to: null,
        };

        if (this._filter === 'datesRange') {
            datesRange = {
                from: fHeader_Values.Date_From,
                to: fHeader_Values.Date_To,
            };
        } else if (this._filter === 'currentMonth') {
            datesRange = {
                from: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth(), 1))).getTime() / 1000),
                to: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth() + 1, 0))).getTime() / 1000),
            };
        } else if (this._filter === 'previousMonth') {
            datesRange = {
                from: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth() - 1, 1))).getTime() / 1000),
                to: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth(), 0))).getTime() / 1000),

            };
        } else if (this._filter === 'currentYear') {
            datesRange = {
                from: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        0, 1))).getTime() / 1000),
                to: (_jsLib.import("ab-date", "./index", "default", "abDate", "ab-date")).getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        12, 0))).getTime() / 1000),
            };
        } else
            throw new Error('Unknown filter.');

        // console.log(abDate.format_DateTime(datesRange.from), abDate.format_DateTime(datesRange.to));

        return datesRange;
    }

    _filter_GetFilters() {
        let fHeader_Values = this.fHeader.getValues();

        let filters = {
            Trader__Id: null,
            Inseminator__Id: null,
            Farmer__Id: null,

            NotUnderGrade: true,
            OnlyNew: false,
            MarkDownloaded: false,
        };

        if (fHeader_Values.Filters) {
            if (this.Filters_Type_Active === 'Trader') {
                filters.Trader__Id = this.tags_Trader.value.length === 0 ? 
                        null : Number(this.tags_Trader.value[0].id);
            } else if (this.Filters_Type_Active === 'Inseminator') {
                filters.Inseminator__Id = this.tags_Inseminator.value.length === 0 ? 
                        null : Number(this.tags_Inseminator.value[0].id);
            } else if (this.Filters_Type_Active === 'Farmer') {
                filters.Farmer__Id = this.tags_Farmer.value.length === 0 ? 
                        null : Number(this.tags_Farmer.value[0].id);
            }

            filters.NotUnderGrade = fHeader_Values.NotUnderGrade;
            filters.OnlyNew = fHeader_Values.OnlyNew;
            filters.MarkDownloaded = fHeader_Values.MarkDownloaded;
        }

        return filters;
    }

    _filter_Select(filter, refresh = true) {
        if (this._filter === filter)
            return;

        this._filter = filter;
        this.lHeader.$fields.filters_DatesRange_ActiveClass = filter === 'datesRange' ? 
                'active' : '';
        this.lHeader.$fields.filters_CurrentMonth_ActiveClass = filter === 'currentMonth' ? 
                'active' : '';
        this.lHeader.$fields.filters_PreviousMonth_ActiveClass = filter === 'previousMonth' ? 
                'active' : '';
        this.lHeader.$fields.filters_CurrentYear_ActiveClass = filter === 'currentYear' ? 
                'active' : '';

        this.lHeader.$fields.showDatesRange = this._filter === 'datesRange';

        if (refresh)
            this.m.t.refresh();
    }

    _init_Header() {
        $(this.fHeader.fields.Date_From.elem).on('dp.hide', (evt) => {
            this.m.t.refresh();
        });
        $(this.fHeader.fields.Date_To.elem).on('dp.hide', (evt) => {
            this.m.t.refresh();
        });

        if (abNative_Platform === 'web') {
            this.lHeader.$elems.downloadFiltered.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.downloadFiltered();
            });

            this.tagsInitialized = false;

            this.tags_Trader = new Tagify(this.fHeader.fields.Trader.elem, {
                enforceWhitelist: true,
                mode: 'select',
                whitelist: [],
                    })
                .on('change', (e) => {
                    this.m.t.refresh();
                });
            this.tags_Inseminator = new Tagify(this.fHeader.fields.Inseminator.elem, {
                enforceWhitelist: true,
                mode: 'select',
                whitelist: [],
                    })
                .on('change', (e) => {
                    this.m.t.refresh();
                });
            this.tags_Farmer = new Tagify(this.fHeader.fields.Farmer.elem, {
                enforceWhitelist: true,
                mode: 'select',
                whitelist: [],
                    })
                .on('change', (e) => {
                    this.m.t.refresh();
                });

            this.Filters_Type_Active = '';
            let setFilter = (type) => {
                this.lHeader.$fields.Shows.Farmer = false;
                this.lHeader.$fields.Shows.Inseminator = false;
                this.lHeader.$fields.Shows.Trader = false;

                this.lHeader.$fields.Filters_Farmer_ActiveClass = '';
                this.lHeader.$fields.Filters_Inseminator_ActiveClass = '';
                this.lHeader.$fields.Filters_Trader_ActiveClass = '';

                this.lHeader.$fields.Shows[type] = true;
                this.lHeader.$fields[`Filters_${type}_ActiveClass`] = 'active';
                this.Filters_Type_Active = type;
            }
            this.lHeader.$elems.Filters_Farmer.addEventListener('click', (evt) => {
                evt.preventDefault();
                setFilter('Farmer');
                this.m.t.refresh();
            });
            this.lHeader.$elems.Filters_Inseminator.addEventListener('click', (evt) => {
                evt.preventDefault();
                setFilter('Inseminator');
                this.m.t.refresh();
            });
            this.lHeader.$elems.Filters_Trader.addEventListener('click', (evt) => {
                evt.preventDefault();
                setFilter('Trader');
                this.m.t.refresh();
            });
            setFilter('Trader');

            this.fHeader.fields.Filters.elem.addEventListener('change', (evt) => {
                this.lHeader.$fields.ShowFilters = 
                        this.fHeader.fields.Filters.value;
                this.m.t.refresh();
            });
            this.fHeader.fields.NotUnderGrade.elem.addEventListener('change', (evt) => {
                this.m.t.refresh();
            });
            this.fHeader.fields.OnlyNew.elem.addEventListener('change', (evt) => {
                this.m.t.refresh();
            });
        }
    }

}

/* JSLib Exports */
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\registrations.js
jsLibs.exportScript("core", "./panelDatas/registrations", [ "Add","Edit","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-date", "./index", [  ], "ab-date");
_jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");

_jsLib.importDeclaration("core", "./helper", [ { name: "*", alias: "helper" } ], "../helper.js");
_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./App", [ { name: "default", alias: "App" } ], "../App.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");


let panelName = 'registrations';
let panelTitle = 'Registrations';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.data = null;

        this.l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Register_Edit);

        this.lForm = null;
        this.lForm_Client = null;
        this.lForm_User = null;

        this.f = null;
        this.fClient = null;
        this.fUser = null;

        this.l.$fields = {
            uris: {
                back: lb.pager.getPageUri('lb.subpanels.registrations.list'),
            },
        };
        this.l.$elems.back.addEventListener('click', (evt) => {
            evt.preventDefault();
            lb.pager.setPage('lb.subpanels.registrations.list');
        });

        this.l.$elems.Submit.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._submit();
        });
        this.l.$elems.Reject.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.msgs.showConfirmation((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Confirmations_Delete'), '',
                    (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_Yes'), (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Text_No'), (result) => {
                if (result)
                    this._reject();
            });
        });
        
        this.refresh();

        this.$view = this.l;
    }

    refresh() {
        this.msgs.showLoading();

        (_jsLib.import("core", "./helper", "*", "helper", "../helper.js")).api_Row_Async(panelTitle, { id: Number(this.pager.current.args.id) })
            .then((response) => {
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseRequestResponse(this, response, (result) => {
                    let data = result.data;
                    this.data = data;
                    let row = data.row;

                    this._createLayout(row);

                    let traderOptions = [];
                    if ((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).user.isAdministrator) {
                        traderOptions.push({
                            title: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Options_None'),
                            value: '0',
                        });
                    }
                    for (let rTrader of data.rTraders) {
                        traderOptions.push({
                            title: rTrader.Name,
                            value: rTrader._Id,
                        });
                    }
                    this.fClient.fields.Trader__Id.field('Options', traderOptions);

                    if (row.rFarmer !== null)
                        this.f.setValues(row.rFarmer, true);
                    else if (row.rInseminator !== null)
                        this.f.setValues(row.rInseminator, true);
                    this.fClient.setValues(row.rClient, true);
                    this.fUser.setValues(row.rUser, true);

                    this.msgs.hideLoading();
                });
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure('', e.toString());
                this.msgs.hideLoading();
            });
    }


    _createLayout(rows) {
        if (rows.rFarmer !== null)
            this.lForm = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Farmers_Form);
        else if (rows.rInseminator !== null)
            this.lForm = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Inseminators_Form);
        this.lForm_Client = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Clients_Form);
        this.lForm_User = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Users_Form)

        this.l.$fields = {
            type_Farmer: rows.rFarmer !== null,
            type_Inseminator: rows.rInseminator !== null,
        };

        this.lForm.$fields = {
            isNew: true,
            isUnderGrade: true,
        };
        this.lForm_Client.$fields = {
            showUnderGrade: rows.rFarmer !== null,
            isUnderGrade: rows.rClient.SymlekId !== null,

            isUser: true,
            showTrader__Id: true,
        };

        this.lForm.$holders.clientForm.$view = this.lForm_Client;
        this.lForm_Client.$holders.userForm.$view = this.lForm_User;

        this.f = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lForm, 'Form');
        this.fClient = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lForm_Client, 'Form');
        this.fUser = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lForm_User, 'Form');

        this.lForm_Client.$holders.userForm.$view = this.lForm_User;

        this.fClient.fields.UnderGrade.elem.addEventListener('change', (evt) => {
            this.lForm_Client.$fields.isUnderGrade = 
                    this.fClient.fields.UnderGrade.value; 
            this.lForm.$fields.isUnderGrade = 
                    this.fClient.fields.UnderGrade.value; 
        });
        this.fClient.setValues({
            UnderGrade: rows.rClient.SymlekId !== null,
        });

        this.l.$holders.form.$view = this.lForm;
    }

    _reject() {
        if (this.isLocked())
            return;

        this.lock();
        this.msgs.showLoading();

        let fields = {
            id: this.pager.current.args.id,
        };

        (_jsLib.import("core", "./helper", "*", "helper", "../helper.js")).api_Delete_Async('Registrations', fields)
            .then((response) => {
                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseRequestResponse(this, response, (result) => {
                    if (result.success) {
                        this.pager.setPage(`lb.subpanels.${panelName}.list`);
                    } else {
                        this.msgs.showMessage_Failure(result.message);
                        this.msgs.hideLoading();
                    } 
                });
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure(e.toString());
                this.msgs.hideLoading();
            });
    }

    _submit() {
        if (this.isLocked())
            return;

        this.lock();
        this.msgs.showLoading();

        let fields = {
            id: (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().dataStore.nextId(),
            registrationId: this.pager.current.args.id,
            registrationType: this.data.type,
            row: this.f.getValues(),
            client: this.fClient.getValues(),
            user: this.fUser.getValues(),       
        };

        if (this.data.type === 'Farmer') {
            /* Row */
            fields.row.Clinic__Id = null;

            fields.row.Inseminator__Id = null;

            fields.row.NotificationsEmail = fields.row.HasNotificationsEmail ? 
                    fields.row.NotificationsEmail : null;
            delete fields.row.HasNotificationsEmail;

            /* Client */
            fields.client = this.fClient.getValues();
            fields.client._Id = (_jsLib.import("core", "./App", "default", "App", "../App.js")).GetInstance().dataStore.nextId();
            
            fields.client.Trader__Id = this.fClient.fields.Trader__Id.value === '0' ?
                    null : Number(this.fClient.fields.Trader__Id.value);
            fields.client.SymlekId = fields.client.UnderGrade ? 
                    fields.client.SymlekId : null;

            fields.row.HerdUnderGradeNr = fields.client.UnderGrade ? 
                    fields.row.HerdUnderGradeNr : null;
            delete fields.client.UnderGrade;

            /* User */
            fields.user = this.fUser.getValues();
        } else if (this.data.type === 'Inseminator') {
            fields.row.Clinic__Id = null;

            fields.client = this.fClient.getValues();
            fields.user = this.fUser.getValues();

            delete fields.client.UnderGrade;         
        } else
            throw new Error('Unknown registration type.');

        (_jsLib.import("core", "./helper", "*", "helper", "../helper.js")).api_Update_Async('Registrations', fields)
            .then((response) => {
                this.unlock();

                (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).parseRequestResponse(this, response, (result) => {
                    if (result.success) {
                        this.msgs.showMessage_Success((_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Successes_ClientCreated'),
                                '', () => {
                            this.msgs.showLoading();
                            this.lb.pager.setPage('lb.subpanels.registrations.list');
                        });
                        this.msgs.hideLoading();
                    } else {
                        if ('data' in result) {
                            if (result.data !== null) {
                                if ('validator' in result.data) {
                                    this.f.setValidator(result.data.validator);
                                    this.fClient.setValidator(result.data.validator);
                                    this.fUser.setValidator(result.data.validator);

                                    this.msgs.hideLoading();

                                    return;
                                }
                            }
                        }
            
                        this.msgs.showMessage_Failure('', result.message);
                        this.msgs.hideLoading();
                    } 
                });
            })
            .catch((e) => {
                this.unlock();

                console.error(e);

                this.msgs.showMessage_Failure('', e.toString());
                this.msgs.hideLoading();
                });
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        this.m.l.$fields = {
            shows: {
                add: false,
            },
        };

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.formatDateTime(rows, colRefs, 'DateTime');

            (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).tables.format(rows, colRefs, 'Type', (col, row) => {
                if (col.value === 'Farmer')
                    col.html = (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Titles_Farmer');
                if (col.value === 'Inseminator')
                    col.html = (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Titles_Inseminator');
            });
        }

        this.m.t
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.${panelName}.edit`,
                        { id: row.cols[colRefs.Id].value, });
            });
        this.m.t.refresh();

        this.$view = this.m;
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\panelDatas\traders.js
jsLibs.exportScript("core", "./panelDatas/traders", [ "Add","Edit","Form","List" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");

_jsLib.importDeclaration("core", "./modules", [ { name: "*", alias: "modules" } ], "../modules.js");
_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [  ], "../$layouts/index.js");


let panelName = 'traders';
let panelTitle = 'Traders';


/* export */ class Add extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


/* export */ class Edit extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Edit(lb, panelName, panelTitle, Form);

        this.m.fm.m.l.$fields.shows.delete = true;

        this.user_ManageAccount = new (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).User_ManageAccount(this);

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);
        };

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


/* export */ class Form extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).Form(lb, panelName, panelTitle, create);

        this.lUser = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout($layouts.Users_Form);
        this.lUser.$fields.isNew = create;
        this.m.f.l.$holders.userForm.$view = this.lUser;
        this.fUser = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lUser, 'Form');

        this.m.refresh_OnParseApiResult = (data) => {
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.user = this.fUser.getValues();

            return fields;
        };
        this.m.submit_OnValidator = (result) => {
            this.fUser.setValidator(result.data.validator);
        };

        this.$view = this.m;
    }

}


/* export */ class List extends (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).Module {
    constructor(lb) { super(lb);
        this.m = new (_jsLib.import("core", "./modules", "*", "modules", "../modules.js")).List(lb, panelName, panelTitle)

        this.m.t.refresh();

        this.$view = this.m;
    }

}

/* JSLib Exports */
_jsLib.export("Add", Add);
_jsLib.export("Edit", Edit);
_jsLib.export("Form", Form);
_jsLib.export("List", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\pages\PrivacyPolicy.js
jsLibs.exportScript("core", "./pages/PrivacyPolicy", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [  ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [  ], "spk-forms");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");

_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");

/* export default */ class PrivacyPolicy extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {

    constructor(mMain) {
        super();

        // this.mMain = mMain;
        // this.msgs = mMain.msgs;

        this.l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).PrivacyPolicy);   

        console.log((_jsLib.import("core", "./sys", "default", "sys", "../sys.js")));

        this.$view = this.l;
    }

}

/* JSLib Exports */
_jsLib.export("default", PrivacyPolicy); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\pages\Register.js
jsLibs.exportScript("core", "./pages/Register", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [ { name: "default", alias: "abText" } ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [ { name: "default", alias: "spkForms" } ], "spk-forms");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [ { name: "default", alias: "webABApi" } ], "web-ab-api");

_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");

/* export default */ class Register extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {

    constructor(mMain) {
        super();

        this.mMain = mMain;
        this.msgs = mMain.msgs;

        this.l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Register);
        
        this.lForm = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js"))[`Register_Form`]);
        this.lForm.$fields = {
            texts: {
                submit: (_jsLib.import("ab-text", "./index", "default", "abText", "ab-text")).$('Sys:Buttons_Register'),
            },
        };

        this.f = new (_jsLib.import("spk-forms", "./index", "default", "spkForms", "spk-forms")).Form(this.lForm, 'Form');

        this.l.$holders.form.$view = this.lForm;

        this._initElems();
        this._setType('Farmer');

        this.$view = this.l;
    }

    _initElems() {
        this.lForm.$elems.Farmer.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._setType('Farmer');
        });
        this.lForm.$elems.Inseminator.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._setType('Inseminator');
        });

        this.lForm.$elems.Submit.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._register();
        });

        this.f.fields.UnderGrade.elem.addEventListener('change', (evt) => {
            this.lForm.$fields.IsUnderGrade = this.f.fields.UnderGrade.value; 
        });
    }

    _register() {
        this.msgs.showLoading();
        let row = this.f.getValues();

        if (this._type === 'Farmer' && !row.UnderGrade) {
            row.SymlekId = null;
            row.HerdUnderGradeNr = null;
        }

        (_jsLib.import("web-ab-api", "./index", "default", "webABApi", "web-ab-api")).json(abNative_ApiUri + 'register/register', { 
            type: this._type,
            row: row,
                }, (result) => {
            if (result.isSuccess()) {
                this.f.clear();
                this.l.$fields.formSent = true;
            } else if (result.isFailure()) {
                if ('validatorInfo' in result.data)
                    this.f.setValidator(result.data.validatorInfo)
                else
                    this.msgs.showMessage_Failure(result.message);
            } else 
                this.msgs.showMessage_Failure(result.message);

            this.msgs.hideLoading();
        });
    }

    _setType(type) {
        this.lForm.$fields[`type_Farmer`].class = type === 'Farmer' ? 'active' : '';
        this.lForm.$fields[`type_Inseminator`].class = type === 'Inseminator' ? 'active' : '';

        this.lForm.$fields.isFarmer = type === 'Farmer';

        this.lForm.$fields.showUnderGrade = type === 'Farmer';

        this._type = type;
    }

}

/* JSLib Exports */
_jsLib.export("default", Register); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\pages\Statement.js
jsLibs.exportScript("core", "./pages/Statement", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("ab-text", "./index", [  ], "ab-text");
_jsLib.importDeclaration("spk-forms", "./index", [  ], "spk-forms");
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");
_jsLib.importDeclaration("web-ab-api", "./index", [  ], "web-ab-api");

_jsLib.importDeclaration("core", "./sys", [ { name: "default", alias: "sys" } ], "../sys.js");

_jsLib.importDeclaration("core", "./$layouts/index", [ { name: "default", alias: "$layouts" } ], "../$layouts/index.js");

/* export default */ class Statement extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Module {
    constructor(mMain) {
        super();

        // this.mMain = mMain;
        // this.msgs = mMain.msgs;

        this.l = (_jsLib.import("core", "./sys", "default", "sys", "../sys.js")).createLayout((_jsLib.import("core", "./$layouts/index", "default", "$layouts", "../$layouts/index.js")).Statement);   

        this.$view = this.l;
    }
}

/* JSLib Exports */
_jsLib.export("default", Statement); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\texts\pl.ab-data.js
jsLibs.exportScript("core", "./texts/pl.ab-data", [ "default" ], (_jsLib) => { "use strict"; const lang_PL_ABData = {
    NotChecked: 'To pole musi zostać zaznaczone.',
    NotSet: 'To pole musi zostać wypełnione.',
    NotNull: 'To pole nie może mieć wartości "null".',

    Date_WrongFormat: 'Nieprawidłowy format daty.',
    Date_BelowMinDate: 'Data nie może być wcześniejsza niż {date}.',
    Date_AboveMaxDate: 'Data nie może być późniejsza niż {date}.',

    Email_WrongFormat: 'Nieprawidłowy adres email.',

    Errors_AboveMaxLength: 'Zbyt długi ciąg znaków. Maksymalna długość: {maxLength}.',
    Errors_BelowMinLength: 'Minimalna ilość znaków w tym polu to: {minLength}.',
    Errors_NotAllowedCharacters: 'Pole zawiera niedozwolone znaki: {notAllowedChars}',
    Errors_WrongFormat: 'Nieprawidłowy ciąg znaków. Poprawny format to: {format}',

    Int_NotANumber: 'W tym polu powinna znaleźć się wartość numeryczna.',
    Int_NotAnInt: 'W tym polu powinna znaleźć się liczba całkowita.',
    Int_BelowMin: 'Wartość w tym polu nie może być mniejsza niż {minValue}.',
    Int_AboveMax: 'Wartość w tym polu nie być większa niż {maxValue}.',

    Long_NotANumber: 'W tym polu powinna znaleźć się wartość numeryczna.',
    Long_NotAnInt: 'W tym polu powinna znaleźć się liczba całkowita.',
    Long_BelowMin: 'Wartość w tym polu nie może być mniejsza niż {minValue}.',
    Long_AboveMax: 'Wartość w tym polu nie być większa niż {maxValue}.',

    Radio_WrongValue: 'Nieprawidłowa wartość pola.',  
};
/* export default */ lang_PL_ABData;

/* JSLib Exports */
_jsLib.export("default", lang_PL_ABData); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\texts\pl.js
jsLibs.exportScript("core", "./texts/pl", [ "default" ], (_jsLib) => { "use strict";  const lang_PL = {   
    Aliases_About: 'system',
    Aliases_Add: 'dodaj',
    Aliases_Administrators: 'administratorzy',
    Aliases_Associations: 'kojarzenia',
    Aliases_Backups: 'kopie-zapasowe',
    Aliases_Basic: 'podstawowe',
    Aliases_Bull: 'buhaj',
    Aliases_Bulls: 'buhaje',
    Aliases_Clinics: 'kliniki',
    Aliases_Cow: 'krowa',
    Aliases_Cows: 'krowy',
    Aliases_Details: 'szczegoly',
    Aliases_Edit: 'edytuj',
    Aliases_Farmer: 'hodowca',
    Aliases_Farmers: 'hodowcy',
    Aliases_Inseminators: 'inseminatorzy',
    Aliases_List: 'lista',
    Aliases_NewReceipt: 'nowe-zaswiadczenie',
    Aliases_Receipts: 'zaswiadczenia',
    Aliases_Registrations: 'rejestracje',
    Aliases_Traders: 'handlowcy',

    Associations: 'Kojarzenia',

    Buttons_Activate: 'Aktywuj',
    Buttons_Add: 'Dodaj',
    Buttons_AddBull: 'Dodaj Buhaja',
    Buttons_AddCow: 'Dodaj Krowę',
    Buttons_Associations: 'Kojarzenia',
    Buttons_Bulls: 'Buhaje',
    Buttons_Cows: 'Krowy',
    Buttons_Create: 'Dodaj',
    Buttons_CurrentMonth: 'Bieżący miesiąc',
    Buttons_DatesRange: 'Zakres dat',
    Buttons_Deactivate: 'Dezaktywuj',
    Buttons_Delete: 'Usuń',
    Buttons_DeleteAll: 'Usuń',
    Buttons_Download: 'Pobierz',
    Buttons_DownloadFiltered: 'Pobierz przefiltrowane',
    Buttons_DownloadLastBackup: 'Pobierz najnowszy backup',
    Buttons_DownloadRegister: 'Pobierz rejestr',
    Buttons_DownloadSymlek: 'Plik SYMLEK',
    Buttons_Farmer: 'Hodowca',
    Buttons_Inseminator: 'Inseminator',
    Buttons_MonthCurrent: 'Bieżący miesiąc',
    Buttons_MonthPrevious: 'Poprzedni miesiąc',
    Buttons_Next: 'Dalej',
    Buttons_Print: 'Drukuj',    
    Buttons_Register: 'Zarejestruj się',
    Buttons_Reject: 'Odrzuć',
    Buttons_ResetPassword: 'Reset hasła',
    Buttons_Save: 'Zapisz',
    Buttons_Trader: 'Handlowiec',
    Buttons_Upload: 'Wczytaj',
    Buttons_UploadStrawsCount: 'Wczytaj słomki',
    Buttons_YearCurrent: 'Bieżący rok',

    Confirmations_ClearData: 'Wyczyścić dane?',
    Confirmations_Delete: 'Czy na pewno chcesz usunąć?',
    Confirmations_DeleteSelected: 'Usunąć zaznaczone?',
    Confirmations_LogOut: 'Czy na pewno chcesz się wylogować?',
    Confirmations_PrintReceipt_Title: 'Drukowanie',
    Confirmations_PrintReceipt_Text: 'Czy chcesz wydrukować zaświadczenie?',
    Confirmations_ReportProblem: 'Wyślij dane aplikacji, które pozwolą na analizę problemu, a następnie skontaktuj się z przedstawicielem AG Pokrycia.',

    Errors_Error: 'Wystąpił błąd',
    Errors_CannotFindStrawsBull: 'Nie można znaleźć buhaja',
    Errors_CannotLogIn: 'Nie udało się zalogować',
    Errors_CannotSelect: 'Uwaga',
    Errors_CannotSendProblemReport: 'Nie udało się wysłać raportu dotyczącego błędów.',
    Errors_CannotSynchronizeData_Title: 'Nie można zsynchronizować danych',
    Errors_CannotSynchronizeData: '{error}',
    Errors_DateTooEarly: 'Data nie może być wcześniejsza niż {date}',
    Errors_DateTooLate: 'Data nie może być późniejsza niż {date}',
    Errors_TooManyBullsInTheMix: 'Nie można dodać więcej niż 4 buhajów do MIX.',
    Errors_NoMoreReceiptNrs: 'Brak dostępnych nowych numerów zaświadczeń w trybie offline. Zsynchronizuj aplikację, żeby móc dodać kolejne zaświadczenia.',
    Errors_NoRowsSelected: 'Nie wybrano żadnego wiersza',
    Errors_PasswordCannotBeEmpty: 'Hasło nie może być puste',
    Errors_PasswordsDoNotMatch: 'Podane hasła nie są takie same',
    Errors_Response_CannotParseJSON: 'Błędna odpowiedź serwera',
    Errors_Response_HttpRequestError: 'Błąd połączenia',
    Errors_Response_Other: 'Błąd',
    Errors_Response_CannotParseJSON: 'Błędna odpowiedź serwera',
    Errors_Response_HttpRequestError: 'Błąd połączenia',
    Errors_Response_Other: 'Błąd',
    Errors_Response_ResultError: 'Błąd zapytania',
    Errors_Response_WrongResultFormat: 'Błędny format odpowiedzi serwera',

    Forms_Added_Date_Label: 'Dodano do systemu',
    Forms_Added_Identificator_Label: 'Utworzono przez',
    Forms_Address_Label: 'Adres',
    Forms_Address_Placeholder: 'Adres',
    Forms_Birth_Label: 'Data urodzenia',
    Forms_Birth_Placeholder: 'Data',
    Forms_BullSexed_Label: 'Rodzaj nasienia',
    Forms_BullSexed_Conventional: 'Konwencjonalne',
    Forms_BullSexed_SexedX: 'Seksowane żeńskie',
    Forms_BullSexed_SexedY: 'Seksowane męskie',
    Forms_BullsMix_Label: 'MIX',
    Forms_City_Label: 'Miejscowość',
    Forms_City_Placeholder: 'Miejscowość',
    Forms_Clinic_Label: 'Klinika',
    Forms_Confirmation_Label: 'Zapoznałam/em się z informacją dotyczącą przetwarzania danych osobowych i wyrażam zgodę na przetwarzanie moich danych osobowych przez firmę Alta Polska Sp. z o.o.; ul. Katarzynów 3, 99-400 Łowicz w systemie AG POKRYCIA.Upoważniam firmę Alta POLSKA do utworzenia użytkownika na poniżej wskazane CZYTELNE dane w systemie informatycznym AG POKRYCIA oraz do przekazywania w moim imieniu informacji o zabiegach inseminacyjnych w systemie SYMLEK. Upoważnienie jest ważne do odwołania.',
    Forms_Count_Placeholder: 'Liczba',
    Forms_CowshedNr_Label: 'Numer oborowy',
    Forms_CowshedNr_Placeholder: 'Numer oborowy',
    Forms_Filters: 'Zaawansowane filtry',
    Forms_Genealogy_Nr: 'Numer',
    Forms_Genealogy_Name: 'Nazwa',
    Forms_Phone_Label: 'Telefon',
    Forms_Phone_Placeholder: 'Telefon',
    Forms_Date_Label: 'Data',
    Forms_Date_Placeholder: 'Data',
    Forms_DateFrom_Label: 'Data od',
    Forms_DateFrom_Placeholder: 'od',
    Forms_DateTo_Label: 'Data do',
    Forms_DateTo_Placeholder: 'do',
    Forms_District_Label: 'Powiat',
    Forms_District_Placeholder: 'Powiat',
    Forms_Email_Label: 'Email',
    Forms_Email_Placeholder: 'Email',
    Forms_FileNr_Label: 'Nr kartoteki',
    Forms_FileNr_Placeholder: 'Nr kartoteki',
    Forms_FirstName_Label: 'Imię',
    Forms_FirstName_Placeholder: 'Imię',
    Forms_HerdNr_Label: 'Nr siedziby stada',
    Forms_HerdNr_Placeholder: 'Nr siedziby stada',
    Forms_HerdUnderGradeNr_Label: 'Nr stada pod oceną',
    Forms_HerdUnderGradeNr_Placeholder: 'Nr stada pod oceną',
    Forms_IdentificationNr_Label: 'Numer',
    Forms_IdentificationNr_Placeholder: 'Numer',
    Forms_Inseminator_Label: 'Inseminator',
    Forms_LastCalving_Label: 'Ostatnie wycielenie',
    Forms_LastCalving_Placeholder: 'Data',
    Forms_ManufacturerNr_Label: 'Numer wet. producenta',
    Forms_ManufacturerNr_Placeholder: 'Numer wet. producenta',
    Forms_MarkDownloaded: 'Odznacz jako pobrane',
    Forms_Mix_Label: 'MIX',
    Forms_Name_Label: 'Nazwa',
    Forms_Name_Placeholder: 'Nazwa',
    Forms_NextHeat_Label: 'Następna ruja',
    Forms_NotUnderGrade: 'Uwzględnij poza oceną',
    Forms_Note_Label: 'Notatka',
    Forms_Note_Placeholder: 'Notatka',
    Forms_NotificationsEmail_Label: 'Powiadomienia',
    Forms_NotificationsEmail_Placeholder: 'Email do powiadomień',
    Forms_Nr_Label: 'Nr',
    Forms_Number_Placeholder: 'Numer',
    Forms_OnlyNew: 'Tylko nowe',
    Forms_PlannedCalving_Label: 'Przewidywane wycielenie',
    Forms_PostalCode_Label: 'Kod pocztowy',
    Forms_PostalCode_Placeholder: 'Kod pocztowy',
    Forms_Race_Label: 'Rasa',
    Forms_Race_Placeholder: 'Rasa',
    Forms_ReinseminationsCount_Label: 'Reinseminacja',
    Forms_ReinseminationsCount_Placeholder: 'Reinseminacja',
    Forms_SemenProduction_Label: 'Data produkcji nasienia',
    Forms_SemenProduction_Placeholder: 'Data',
    Forms_ShipTo_Label: 'Ship to',
    Forms_ShipTo_Placeholder: 'Ship to',
    Forms_StrawsConvCount_Label: 'Liczba słomek KONW.',
    Forms_StrawsConvCount_Placeholder: 'Liczba słomek',
    Forms_StrawsSexedCount_Label: 'Liczba słomek SEX',
    Forms_StrawsSexedCount_Placeholder: 'Liczba słomek',
    Forms_SymlekId_Label: 'Symlek ID',
    Forms_SymlekId_Placeholder: 'Symlek ID',
    Forms_Trader_Label: 'Handlowiec',
    Forms_TreatmentDate_Label: 'Data pokrycia',
    Forms_TreatmentNr_Label: 'Nr zabiegu',
    Forms_TreatmentNr_Placeholder: 'Nr zabiegu',
    Forms_UnderGrade_Label: 'Pod oceną',
    Forms_UnderGrade_Placeholder: 'Pod oceną',

    Labels_Password: 'Hasło',
    Labels_NewPassword: 'Nowe hasło',
    Labels_NewPassword_Confirmation: 'Powtórz nowe hasło',

    LoadMore: 'Załaduj więcej',

    Loadings_DBSync: 'Synchronizowanie danych',

    LogIn_LogIn: 'Zaloguj',
    LogIn_Login_Placeholder: 'login',
    LogIn_Password_Placeholder: 'hasło',

    Messages_NoInternetConnection: 'Brak połączenia z internetem.',

    NewPassword_Placeholder: "Nowe hasło...",
    NewPassword_Confirmation_Placeholder: "Powtórz nowe hasło...",
    Notifications_NoReceiptsToDownload: 'Brak zaświadczeń do pobrania',

    Options_None: 'Brak',

    printer_PrinterSet: 'Ustawiono drukarkę',

    RemindPassword: 'Zresetuj hasło',
    RemindPassword_RemindPassword: 'Zresetuj hasło',
    RemindPassword_RemindPassword_Placeholder: 'mail',

    SPKMessages_Close: 'Zamknij',

    Successes_ClientCreated: 'Użytkownik został dodany',
    Successes_Success: 'Sukces',
    Successes_SuccessMessage: 'Zmiany zostały zapisane.',

    TableEmpty: 'Tabela jest pusta',

    TableHeaders_Added: 'Dodano',
    TableHeaders_Birth: 'Data urodzenia',
    TableHeaders_Bull: 'Buhaj',
    TableHeaders_BullName: 'Buhaj',
    TableHeaders_City: 'Miejscowość',
    TableHeaders_Client: 'Klient',
    TableHeaders_Clinic: 'Klinika',
    TableHeaders_Cow: 'Krowa',
    TableHeaders_Cow_FirstName: 'Nazwa',
    TableHeaders_CowshedNr: 'Nr oborowy',
    TableHeaders_Date: 'Data',
    TableHeaders_Downloaded: 'Pobrano',
    TableHeaders_Email: 'Email',
    TableHeaders_Farmer: 'Hodowca',
    TableHeaders_FirstName: 'Nazwa', //imię!
    TableHeaders_HerdUnderGradeNr: 'Nr st. pod oc.',
    TableHeaders_Id: 'ID',
    TableHeaders_Inb: 'Inb',
    TableHeaders_InseminationDate: 'Zabieg',
    TableHeaders_Inseminator: 'Inseminator',
    TableHeaders_Modified_DateTime: 'Data modyfikacji',
    TableHeaders_Name: 'Nazwa',
    TableHeaders_Nr: 'Numer',
    TableHeaders_OrdinalNumber: 'Lp.',
    TableHeaders_Race: 'Rasa',
    TableHeaders_RegistrationType: 'Typ użytkownika',
    TableHeaders_StrawsConvCount: 'Słomki',
    TableHeaders_StrawsConvCount_Client: 'Słomki',
    TableHeaders_StrawsConvCount_Company: 'Słomki - F',
    TableHeaders_StrawsSexedCount: 'Słomki Sex',
    TableHeaders_StrawsSexedCount_Client: 'Słomki Sex',
    TableHeaders_StrawsSexedCount_Company: 'Słomki Sex - F',
    TableHeaders_Symlek: 'Symlek',
    TableHeaders_SymlekId: 'Symlek ID',
    TableHeaders_Trader: 'Handlowiec',

    Text_Bulls: 'Buhaje',
    Text_Company: 'Firma',
    Text_CompanyStraws: 'Słomki stan firmowy',
    Text_DownloadingFile: 'Trwa pobieranie',
    Text_Farmers: 'Hodowcy',
    text_Filter: 'Filtruj',
    Text_LogInMessage: 'Zaloguj się do systemu',
    Text_ManageAccount: 'Zarządzaj kontem',
    Text_No: 'Nie',
    Text_PreparingFile: 'Trwa przygotowywanie pliku',
    Text_Receipts: 'Zaświadczenia',
    text_SelectedBull: 'Wybrany buhaj',
    text_SelectedCows: 'Wybrane krowy',
    text_SelectedFarmer: 'Wybrany hodowca',
    text_SelectedInseminator: 'Inseminator',
    text_SelectedClinic: 'Klinika',
    text_SelectedTrader: 'Przypisany handlowiec',
    text_SelectedUserType: 'Wybrany typ użytkownika',
    Text_Users: 'Użytkownicy',
    Text_Yes: 'Tak',

    Titles_About: 'System',
    Titles_Account: 'Moje Konto',
    Titles_Add: 'Dodaj',
    Titles_Administrators_Create: 'Dodaj Admina',
    Titles_Administrators_Save: 'Edycja',
    Titles_AppId: 'ID Aplikacji: ',
    Titles_AppMessages: 'Wiadomości systemowe',
    Titles_AppVersion: 'Wersja aplikacji',
    Titles_Associations: 'Kojarzenia',
    Titles_BackupFiles: 'Backupy',
    Titles_Bull: 'Buhaj',
    Titles_ClearData_Caption: 'Uwaga',
    Titles_ClearData_Message: 'Wszystkie niezsynchronizowane z systemem dane zostaną usunięte.',
    Titles_Clinics: 'Kliniki',
    Titles_Clinics_Create: 'Dodaj klinikę',
    Titles_Clinics_Save: 'Edycja',
    Titles_Cow: 'Krowa',
    Titles_Details: 'Sczegóły zaświadczenia',
    Titles_Farmers_Create: 'Dodaj Hodowcę',
    Titles_Administrators: 'Administratorzy',
    Titles_Backups: 'Backupy',
    Titles_Basic: 'Podstawowy',
    Titles_Bulls: 'Buhaje',
    Titles_Bulls_Create: 'Dodaj buhaja',
    Titles_Bulls_Save: 'Edycja',
    Titles_BullsMix: 'MIX',
    Titles_ClearData_Shortcut: 'Wyczyść dane',
    Titles_Cows: 'Krowy',
    Titles_Cows_Create: 'Dodaj krowę',
    Titles_CowHistory: 'Historia',
    Titles_Cows_Save: 'Edytuj krowę',
    Titles_DBSchemeVersion: 'Wersja bazy danych',
    Titles_Edit: 'Edycja',
    Titles_Error: 'Błąd',
    Titles_Farmer: 'Hodowca',
    Titles_Farmers: 'Hodowcy',
    Titles_Farmers_Save: 'Edycja',

    Titles_Genealogy: 'Rodowód',
    Titles_Genealogy_F: 'Ojciec',
    Titles_Genealogy_M: 'Matka',
    Titles_Genealogy_: 'Ojciec',
    Titles_Genealogy_F: 'Ojciec',
    Titles_Genealogy_F: 'Ojciec',
    Titles_Genealogy_F: 'Ojciec',
    Titles_Genealogy_F: 'Ojciec',

    Titles_Home: 'Home',
    Titles_Inseminator: 'Inseminator',
    Titles_Inseminators: 'Inseminatorzy',
    Titles_Inseminators_Create: 'Dodaj Inseminatora',
    Titles_Inseminators_Save: 'Edycja',
    Titles_List: 'Lista',
    Titles_LogIn: 'Logowanie',
    Titles_LogOut_Shortcut: 'Wyloguj się',
    Titles_NewReceipt: 'Nowe zaświadczenie',
    Titles_NewReceipt_Bull: 'Wybierz buhaja',
    Titles_NewReceipt_Cow: 'Wybierz krowę',
    Titles_NewReceipt_Details: 'Wypełnij szczegóły',
    Titles_NewReceipt_Farmer: 'Wybierz hodowcę',
    Titles_NewReceipt_Shortcut: 'Dodaj zaświadczenie',
    Titles_Receipts: 'Zaświadczenia',
    Titles_Receipts_Save: 'Edycja',
    Titles_Registrations: 'Rejestracja',
    Titles_Registrations_Edit: 'Edycja',
    Titles_Refresh_Shortcut: 'Odśwież',
    Titles_RemindPassword: 'Przypominanie Hasła',
    Titles_ResetPassword: 'Resetowanie Hasła',
    Titles_RemovePrinter_Shortcut: 'Usuń drukarkę',
    Titles_ReportProblem_Shortcut: 'Zgłoś Problem',
    Titles_SetPrinter_Shortcut: 'Ustaw drukarkę',
    Titles_System: 'AG Pokrycia',
    Titles_Traders: 'Handlowcy',
    Titles_Traders_Create: 'Dodaj Handlowca',
    Titles_Traders_Edit: 'Edycja',
    Titles_Traders_Save: 'Edycja',

    Search_Placeholder: 'szukaj',
    Successes_ProblemReportSent: 'Wysłano raport dotyczący błędów.',

    UserInfo_LogOut: 'Wyloguj się',

    Warnings_Warning: 'Uwaga',
    Warnings_UnsyncedReceipts_Text: 'Na Twoim urządzeniu znajdują się {unsyncedReceiptsCount} niezsynchronizowane kwity. Wyślij dane potrzebne do synchronizacji za pomocą przycisku "Zgłoś Problem" w panelu "System" a następnie skontaktuj się z przestawicielem AG Pokrycia.',
    Warnings_UnsyncedReceipts_Title: 'Uwaga',
    Warnings_UpdateApp: 'Zsynchronizuj aplikację',
    Warnings_UpdateApp_Message: 'Twoja aplikacja nie była synchornizowana od dłuższego czasu. Pamiętaj o połączeniu z internetem w celu przesłania danych do systemu. ',

    Validator_CowNr_Invalid: 'Niepoprawny numer',
    Validator_CowNr_WrongFormat: 'Nieprawidłowy format numeru',
    Validator_CowNr_WrongLength: 'Nieprawidłowa długość numeru',
};
/* export default */ lang_PL;

/* JSLib Exports */
_jsLib.export("default", lang_PL); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\About_Basic.js
jsLibs.exportScript("core", "./$layouts/About_Basic", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class About_Basic extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["$",{"_hide":["IsNative"]},["div",{"class":["card px-2 py-4"]},["div",{"class":["text-justify"]},["div",{"class":["card-body"]},["div",{"class":["alert alert-primary mb-4"]},["h3",{},"Pomoc"],["p",{},"W razie pytań lub wątpliwości dotyczących systemu prosimy o kontakt:",["br",{}],["a",{"href":["mailto:biuro@genex.coop"]},"biuro@genex.coop"]]],["h3",{"class":["py-2"]},"System AG POKRYCIA"],["p",{},"Prosty system służący do rejestracji wykonanego zabiegu inseminacji on-line, dostępny w wersji:"],["ul",{},["li",{},"www"],["li",{},"na smartfon w programie operacyjnym Android, IOS wraz z rekomendowaną drukarką termiczną (dostępna w naszej ofercie sprzedażowej; zapytaj doradcę o szczegóły)."]],["p",{},"Program pozwala na wprowadzanie pokryć inseminowanej sztuki już w oborze."],["p",{},"Istnieje możliwość wczytania nr krów dla wymaganego stada, by w szybki sposób znaleźć inseminowaną sztukę. Po zalogowaniu użytkownik (hodowca/inseminator) ma wgląd do rekomendowanych ( 3 opcje wyboru) buhajów wczytanych na podstawie wykonanego doboru w programie AltaGPS."],["p",{},"Program pozwala na przeglądanie, sortowanie i tworzenie rejestrów ( data zabiegu, hodowca, nr stada, wymagana krowa, buhaj ). Inseminator/hodowca może także prowadzić sobie stany nasienia."],["p",{},"Program jest prosty w użyciu; bardzo intuicyjny."]]],["$",{"_holder":["AppMessages_Web"]}]]],["$",{"_show":["IsNative"]},["button",{"_elem":["SetPrinter"],"_hide":["PrinterSet"],"class":["btn btn-theme-primary py-3 w-100 my-3 mobile-button-solo"]},["i",{"class":["fa fa-print pe-2"]}],"$eText('Sys:Titles_SetPrinter_Shortcut')"],["button",{"_elem":["RemovePrinter"],"_show":["PrinterSet"],"class":["btn btn-secondary py-3 w-100 my-3 mobile-button-solo"]},["i",{"class":["fa fa-print pe-2"]}],"$eText('Sys:Titles_RemovePrinter_Shortcut')"],["hr",{}],["p",{},"W razie pytań lub wątpliwości dotyczących aplikacji prosimy o kontakt:",["br",{}],["a",{"href":["mailto:biuro@altagenetics.pl"]},"biuro@altagenetics.pl"]],["p",{},"$eText('Sys:Titles_AppId')"," ","$AppId",["br",{}],"$eText('Sys:Titles_AppVersion')",": ","$AppVersion",["br",{}],"$eText('Sys:Titles_DBSchemeVersion')",": ","$DBSchemeVersion"],["hr",{}],["button",{"_elem":["ReportProblem"],"class":["btn btn-outline-secondary w-100 my-2"]},"$eText('Sys:Titles_ReportProblem_Shortcut')"],["button",{"_elem":["ClearData"],"class":["btn btn-danger w-100 my-2"]},"$eText('Sys:Titles_ClearData_Shortcut')"],["button",{"_elem":["LogOut"],"class":["btn btn-secondary py-3 w-100 mb-2"]},"$eText('Sys:Titles_LogOut_Shortcut')"],["div",{"class":["alert alert-secondary mb-4"]},["i",{"class":["fas fa-exclamation-triangle pe-1"]}],"$eText('Sys:Titles_ClearData_Caption')",["p",{"class":["lb-alert-hint"]},"$eText('Sys:Titles_ClearData_Message')"]],["$",{"_holder":["AppMessages_Native"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(About_Basic.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", About_Basic); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\About_Basic_AppMessages.js
jsLibs.exportScript("core", "./$layouts/About_Basic_AppMessages", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class About_Basic_AppMessages extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["h5",{"class":["alert alert-primary lb-alert-narrow mb-2"]},"$eText('Sys:Titles_AppMessages')"],["div",{"class":["accordion mb-4"],"id":["_html_AppMessages"]},["div",{"_repeat":["AppMessages:AppMessage"],"class":["accordion-item"]},["h2",{"class":["accordion-header"],"id":["_html_AppMessageHeader_","${AppMessage.Index}"]},["button",{"class":["accordion-button collapsed"],"type":["button"],"data-bs-toggle":["collapse"],"data-bs-target":["#_html_AppMessage_","${AppMessage.Index}"],"aria-expanded":["false"],"aria-controls":["_html_AppMessage_","${AppMessage.Index}"]},"$AppMessage.Title"]],["div",{"id":["_html_AppMessage_","${AppMessage.Index}"],"class":["accordion-collapse collapse"],"aria-labelledby":["_html_AppMessageHeader_","${AppMessage.Index}"],"data-bs-parent":["#_html_AppMessages"]},["div",{"class":["accordion-body"],"_field":["AppMessage.Content"]}]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(About_Basic_AppMessages.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", About_Basic_AppMessages); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Administrators_Form.js
jsLibs.exportScript("core", "./$layouts/Administrators_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Administrators_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"_holder":["userForm"]}]],["$",{"_holder":["user_ManageAccount"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Administrators_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Administrators_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Administrators_Form_Buttons.js
jsLibs.exportScript("core", "./$layouts/Administrators_Form_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Administrators_Form_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["$",{"_holder":["activate"]}]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Administrators_Form_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Administrators_Form_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Associations_List_Buttons.js
jsLibs.exportScript("core", "./$layouts/Associations_List_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Associations_List_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["upload"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-upload me-2"]}],"$eText('Sys:Buttons_Upload')"],["a",{"_elem":["deleteAll"],"href":["#"],"class":["btn btn-danger"]},["i",{"class":["fa fa-times me-2"]}],"$eText('Sys:Buttons_DeleteAll')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Associations_List_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Associations_List_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Backups_Basic.js
jsLibs.exportScript("core", "./$layouts/Backups_Basic", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Backups_Basic extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-sm-6 d-none d-md-block"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-auto"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-light mr-2"]},["i",{"class":["fa fa-chevron-left"]}]]],["div",{"class":["col"]},["h1",{},"$eText('Sys:Titles_BackupFiles')"]]]],["div",{"class":["col-xl-6 col-lg-12 lb-buttons-panel "]},["div",{"class":["btn-group w-100"]},["button",{"_elem":["downloadLast"],"class":["btn btn-success"]},["i",{"class":["fa fa-download"]}," "],"$eText('Sys:Buttons_DownloadLastBackup')"]]]]],["div",{"class":["card px-2 py-4"]},["div",{"_repeat":["files:file"],"class":["col-lg-6"]},["a",{"href":["$file.url"],"class":["alert alert-info w-100 d-block"]},"$file.name"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Backups_Basic.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Backups_Basic); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Bulls_List_Buttons.js
jsLibs.exportScript("core", "./$layouts/Bulls_List_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Bulls_List_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["upload"],"_show":["shows.upload"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-upload me-2"]}],"$eText('Sys:Buttons_Upload')"],["a",{"_elem":["register"],"_show":["shows.register"],"href":["$uris.register"],"class":["btn btn-success"]},["i",{"class":["fa fa-download me-2"]}],"$eText('Sys:Buttons_DownloadRegister')"],["a",{"_elem":["uploadStrawsCount"],"_show":["shows.uploadStrawsCount"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-upload me-2"]}],"$eText('Sys:Buttons_UploadStrawsCount')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Bulls_List_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Bulls_List_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Bulls_Form.js
jsLibs.exportScript("core", "./$layouts/Bulls_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Bulls_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Mix"],"type":["Checkbox"],"label":["$eText('Sys:Forms_Mix_Label')"]}],["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["mt-2"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6"]}],["spk-form-field",{"form":["Form"],"name":["ManufacturerNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_ManufacturerNr_Label')"],"placeholder":["$eText('Sys:Forms_ManufacturerNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6"]}],["$",{"_show":["shows_Mix"]},["spk-form-field",{"form":["Form"],"name":["Nr2"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 2'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 2"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6"]}],["spk-form-field",{"form":["Form"],"name":["Nr3"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 3'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 3"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6"]}],["spk-form-field",{"form":["Form"],"name":["Nr4"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 4'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 4"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6"]}],["spk-form-field",{"form":["Form"],"name":["Nr5"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 5'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 5"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6"]}]],["$",{"_show":["shows_StrawsCount"]},["hr",{}],["spk-form-field",{"form":["Form"],"name":["ClientBull_StrawsConvCount_Client"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_StrawsConvCount_Label')"],"placeholder":["$eText('Sys:Forms_StrawsConvCount_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label text-primary"],"field-class":["col-xl-6"]}],["spk-form-field",{"form":["Form"],"name":["ClientBull_StrawsSexedCount_Client"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_StrawsSexedCount_Label')"],"placeholder":["$eText('Sys:Forms_StrawsSexedCount_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label text-primary"],"field-class":["col-xl-6"]}],["$",{"_show":["eSys.user.isEmployee"]},["hr",{}],["h4",{"class":["px-3 mb-3"]},"$eText('Sys:Text_CompanyStraws')"],["spk-form-field",{"form":["Form"],"name":["ClientBull_StrawsConvCount_Company"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_StrawsConvCount_Label')"],"placeholder":["$eText('Sys:Forms_StrawsConvCount_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label text-primary"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["ClientBull_StrawsSexedCount_Company"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_StrawsSexedCount_Label')"],"placeholder":["$eText('Sys:Forms_StrawsSexedCount_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label text-primary"],"field-class":["col-xl-6 "]}]]],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-secondary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":[""],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Bulls_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Bulls_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Bull_Info.js
jsLibs.exportScript("core", "./$layouts/Bull_Info", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Bull_Info extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["alert alert-secondary"]},["h4",{"class":["mt-0"]},"$name"],["p",{"class":["lb-alert-hint my-0"]},"$eText('Sys:text_SelectedBull')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Bull_Info.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Bull_Info); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Buttons_Delete.js
jsLibs.exportScript("core", "./$layouts/Buttons_Delete", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Buttons_Delete extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["delete"],"href":["#"],"class":["btn btn-danger"]},["i",{"class":["fas fa-trash"]}]," \r\n    ","$eText('Sys:Buttons_Delete')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Buttons_Delete.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Buttons_Delete); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Buttons_Next.js
jsLibs.exportScript("core", "./$layouts/Buttons_Next", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Buttons_Next extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["Next"],"_show":["Show"],"href":["#"],"class":["btn btn-success"]},"$eText('Sys:Buttons_Next')",["i",{"class":["fas fa-arrow-right ms-2"]}]," "]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Buttons_Next.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Buttons_Next); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clients_Form.js
jsLibs.exportScript("core", "./$layouts/Clients_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Clients_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_show":["isUser"]},["$",{"_show":["showTrader__Id"]},["spk-form-field",{"form":["Form"],"name":["Trader__Id"],"type":["Select"],"label":["$eText('Sys:Forms_Trader_Label')"],"class":[""],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["hr",{}]]],["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["ShipTo"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_ShipTo_Label')"],"placeholder":["$eText('Sys:Forms_ShipTo_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"_show":["isUser"],"_holder":["userForm"]}],["spk-form-field",{"form":["Form"],"name":["Address"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Address_Label')"],"placeholder":["$eText('Sys:Forms_Address_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["City"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_City_Label')"],"placeholder":["$eText('Sys:Forms_City_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Phone"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Phone_Label')"],"placeholder":["$eText('Sys:Forms_Phone_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["District"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_District_Label')"],"placeholder":["$eText('Sys:Forms_District_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["PostalCode"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_PostalCode_Label')"],"placeholder":["$eText('Sys:Forms_PostalCode_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"class":["ml-3 mt-4"]},["spk-form-field",{"_show":["showUnderGrade"],"form":["Form"],"name":["UnderGrade"],"type":["Checkbox"],"label":["$eText('Sys:Forms_UnderGrade_Label')"]}]],["div",{"_show":["isUser"]},["spk-form-field",{"_show":["isUnderGrade"],"form":["Form"],"name":["SymlekId"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_SymlekId_Label')"],"placeholder":["$eText('Sys:Forms_SymlekId_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Clients_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Clients_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_Form.js
jsLibs.exportScript("core", "./$layouts/Clinics_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Clinics_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["div",{"_holder":["clientForm"]}],["div",{"_holder":["userForm"]}]],["$",{"_holder":["user_ManageAccount"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Clinics_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Clinics_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_Form_Buttons.js
jsLibs.exportScript("core", "./$layouts/Clinics_Form_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Clinics_Form_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["bulls"],"href":["$hrefs.bulls"],"class":["btn btn-success"]},["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Bulls')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Clinics_Form_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Clinics_Form_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_Info.js
jsLibs.exportScript("core", "./$layouts/Clinics_Info", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Clinics_Info extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["alert alert-secondary"]},["h4",{"class":["mt-0"]},"$row.Client_Name"],["p",{"class":["lb-alert-hint my-0"]},"$eText('Sys:text_SelectedClinic')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Clinics_Info.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Clinics_Info); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Cows_Form.js
jsLibs.exportScript("core", "./$layouts/Cows_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Cows_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["CowshedNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_CowshedNr_Label')"],"placeholder":["$eText('Sys:Forms_CowshedNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["LastCalving"],"type":["Date"],"label":["$eText('Sys:Forms_LastCalving_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Birth"],"type":["Date"],"label":["$eText('Sys:Forms_Birth_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["h5",{"_show":["HasGenealogy"],"class":["alert alert-secondary lb-alert-narrow mt-4"]},"$eText('Sys:Titles_Genealogy')"],["div",{"_show":["HasGenealogy"],"class":["row genealogy-holder"]},["div",{"class":["col-md"]},["div",{"class":["gen-item"]},["div",{"class":["gen-header"]},["i",{"class":["fas fa-mars me-2"]}],"$eText('Sys:Titles_Genealogy_F')"],["spk-form-field",{"form":["Form"],"name":["Genealogy_F_Nr"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Nr')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["spk-form-field",{"form":["Form"],"name":["Genealogy_F_Name"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Name')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["div",{"class":["row g-2 mt-2"]},["div",{"class":["col"]},["div",{"class":["gen-header"]},"O:","$eText('Sys:Titles_Genealogy_F')"],["spk-form-field",{"form":["Form"],"name":["Genealogy_FF_Nr"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Nr')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["spk-form-field",{"form":["Form"],"name":["Genealogy_FF_Name"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Name')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}]],["div",{"class":["col"]},["div",{"class":["gen-header"]},"O:","$eText('Sys:Titles_Genealogy_M')"],["spk-form-field",{"form":["Form"],"name":["Genealogy_FM_Nr"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Nr')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["spk-form-field",{"form":["Form"],"name":["Genealogy_FM_Name"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Name')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}]]]]],["div",{"class":["col-md"]},["div",{"class":["gen-item"]},["div",{"class":["gen-header"]},["i",{"class":["fas fa-venus me-2"]}],"$eText('Sys:Titles_Genealogy_M')"],["spk-form-field",{"form":["Form"],"name":["Genealogy_M_Nr"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Nr')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["spk-form-field",{"form":["Form"],"name":["Genealogy_M_Name"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Name')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["div",{"class":["row g-2 mt-2"]},["div",{"class":["col"]},["div",{"class":["gen-header"]},"M:","$eText('Sys:Titles_Genealogy_F')"],["spk-form-field",{"form":["Form"],"name":["Genealogy_MF_Nr"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Nr')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["spk-form-field",{"form":["Form"],"name":["Genealogy_MF_Name"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Name')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}]],["div",{"class":["col"]},["div",{"class":["gen-header"]},"M:","$eText('Sys:Titles_Genealogy_M')"],["spk-form-field",{"form":["Form"],"name":["Genealogy_MM_Nr"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Nr')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}],["spk-form-field",{"form":["Form"],"name":["Genealogy_MM_Name"],"type":["Input"],"input-type":["Text"],"placeholder":["$eText('Sys:Forms_Genealogy_Name')","..."],"div-class":[""],"label-class":["control-label"],"field-class":[""]}]]]]]]]],["div",{"_show":["shows.cowHistory"]},["h5",{"class":["alert alert-secondary lb-alert-narrow mt-4"]},"$eText('Sys:Titles_CowHistory')"],["div",{"_holder":["cowHistory"]}]],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-secondary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Cows_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Cows_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Cows_Info.js
jsLibs.exportScript("core", "./$layouts/Cows_Info", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Cows_Info extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["alert alert-secondary"]},["h4",{"class":["mt-0"]},"$nrs"],["p",{"class":["lb-alert-hint my-0"]},"$eText('Sys:text_SelectedCows')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Cows_Info.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Cows_Info); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Cows_List_Buttons.js
jsLibs.exportScript("core", "./$layouts/Cows_List_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Cows_List_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["upload"],"_show":["Shows.Upload"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-upload me-2"]}],"$eText('Sys:Buttons_Upload')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Cows_List_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Cows_List_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_Form.js
jsLibs.exportScript("core", "./$layouts/Farmers_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Farmers_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"_show":["shows.Inseminator__Id"],"form":["Form"],"name":["Inseminator__Id"],"type":["Select"],"label":["$eText('Sys:Forms_Inseminator_Label')"],"class":[""],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"_holder":["clientForm"]}],["div",{"_show":["isUnderGrade"]},["spk-form-field",{"form":["Form"],"name":["HerdUnderGradeNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_HerdUnderGradeNr_Label')"],"placeholder":["$eText('Sys:Forms_Number_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]],["spk-form-field",{"form":["Form"],"name":["HerdNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_HerdNr_Label')"],"placeholder":["$eText('Sys:Forms_Number_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"class":["ml-3 mt-4"]},["spk-form-field",{"form":["Form"],"name":["HasNotificationsEmail"],"type":["Checkbox"],"label":["$eText('Sys:Forms_NotificationsEmail_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["checkboxField"]}]],["spk-form-field",{"_show":["shows.NotificationsEmail"],"form":["Form"],"name":["NotificationsEmail"],"type":["Input"],"input-type":["text"],"label":["''"],"placeholder":["$eText('Sys:Forms_NotificationsEmail_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"class":["mg-clear"]}]],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-secondary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Client_Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Client_Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]],["$",{"_holder":["user_ManageAccount"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Farmers_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Farmers_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_Form_Buttons.js
jsLibs.exportScript("core", "./$layouts/Farmers_Form_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Farmers_Form_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["bulls"],"_show":["shows.bulls"],"href":["$hrefs.bulls"],"class":["btn btn-success button-mobile"]},["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Bulls')"],["a",{"_elem":["cows"],"href":["$hrefs.cows"],"class":["btn btn-success button-mobile"]},["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Cows')"],["a",{"_elem":["associations"],"href":["$hrefs.associations"],"class":["btn btn-success button-mobile"]},["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Associations')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Farmers_Form_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Farmers_Form_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_Info.js
jsLibs.exportScript("core", "./$layouts/Farmers_Info", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Farmers_Info extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["alert alert-primary"]},["h4",{},"$row.Client_Name"],["p",{"class":["lb-alert-hint"]},"$eText('Sys:text_SelectedFarmer')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Farmers_Info.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Farmers_Info); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_List_Buttons.js
jsLibs.exportScript("core", "./$layouts/Farmers_List_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Farmers_List_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_show":["shows.register"],"_elem":["register"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-file-alt me-2"]}],"$eText('Sys:Buttons_DownloadRegister')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Farmers_List_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Farmers_List_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Form.js
jsLibs.exportScript("core", "./$layouts/Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["d-md-none lb-title-sm"]},"$texts.title"],["div",{"class":["row no-gutters"]},["div",{"class":["col-lg-6 d-none d-md-block"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-auto lb-back"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-light mr-2"]},["i",{"class":["fa fa-chevron-left"]}]]],["div",{"class":["col lb-title"]},["h1",{},"$texts.title"]]]],["div",{"class":["col-xl-6 col-lg-12 lb-buttons-panel "]},["div",{"class":["btn-group w-100"]},["$",{"_holder":["Buttons_Before"]}],["a",{"_elem":["delete"],"_show":["shows.delete"],"href":[""],"class":["btn btn-danger button-mobile"]},["i",{"class":["fa fa-trash me-2"]}],"$eText('Sys:Buttons_Delete')"],["a",{"_elem":["submit"],"_show":["shows.submit"],"href":["#"],"class":["btn btn-theme-primary button-mobile"]},["i",{"class":["fa fa-save me-2"]}],"$texts.Buttons_Submit"],["$",{"_holder":["Buttons_After"]}]]]]],["div",{"class":["lb-main-hints"]},["$",{"_show":["shows_Infos_Trader"],"_holder":["infos_Trader"]}],["$",{"_show":["shows_Infos_Clinic"],"_holder":["infos_Clinic"]}],["$",{"_show":["shows_Infos_Inseminator"],"_holder":["infos_Inseminator"]}],["$",{"_show":["shows_Infos_Farmer"],"_holder":["infos_Farmer"]}],["$",{"_show":["shows_Infos_Cows"],"_holder":["infos_Cows"]}],["$",{"_show":["shows_Infos_Bull"],"_holder":["infos_Bull"]}]],["div",{"_hide":["noCard"],"class":["card mb-5"]},["div",{"class":["card-body"]},["$",{"_holder":["content"]}]]],["$",{"_holder":["content_NoCard"]}]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\index.js
jsLibs.exportScript("core", "./$layouts/index", [ "$layouts_Class","default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("core", "./$layouts/About_Basic", [ { name: "default", alias: "About_Basic" } ], "./About_Basic.js");
_jsLib.importDeclaration("core", "./$layouts/About_Basic_AppMessages", [ { name: "default", alias: "About_Basic_AppMessages" } ], "./About_Basic_AppMessages.js");
_jsLib.importDeclaration("core", "./$layouts/Administrators_Form", [ { name: "default", alias: "Administrators_Form" } ], "./Administrators_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Administrators_Form_Buttons", [ { name: "default", alias: "Administrators_Form_Buttons" } ], "./Administrators_Form_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Associations_List_Buttons", [ { name: "default", alias: "Associations_List_Buttons" } ], "./Associations_List_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Backups_Basic", [ { name: "default", alias: "Backups_Basic" } ], "./Backups_Basic.js");
_jsLib.importDeclaration("core", "./$layouts/Bull_Info", [ { name: "default", alias: "Bull_Info" } ], "./Bull_Info.js");
_jsLib.importDeclaration("core", "./$layouts/Bulls_Form", [ { name: "default", alias: "Bulls_Form" } ], "./Bulls_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Bulls_List_Buttons", [ { name: "default", alias: "Bulls_List_Buttons" } ], "./Bulls_List_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Buttons_Delete", [ { name: "default", alias: "Buttons_Delete" } ], "./Buttons_Delete.js");
_jsLib.importDeclaration("core", "./$layouts/Buttons_Next", [ { name: "default", alias: "Buttons_Next" } ], "./Buttons_Next.js");
_jsLib.importDeclaration("core", "./$layouts/Clients_Form", [ { name: "default", alias: "Clients_Form" } ], "./Clients_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Clinics_Form", [ { name: "default", alias: "Clinics_Form" } ], "./Clinics_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Clinics_Form_Buttons", [ { name: "default", alias: "Clinics_Form_Buttons" } ], "./Clinics_Form_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Clinics_Info", [ { name: "default", alias: "Clinics_Info" } ], "./Clinics_Info.js");
_jsLib.importDeclaration("core", "./$layouts/Cows_Form", [ { name: "default", alias: "Cows_Form" } ], "./Cows_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Cows_Info", [ { name: "default", alias: "Cows_Info" } ], "./Cows_Info.js");
_jsLib.importDeclaration("core", "./$layouts/Cows_List_Buttons", [ { name: "default", alias: "Cows_List_Buttons" } ], "./Cows_List_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Farmers_Form", [ { name: "default", alias: "Farmers_Form" } ], "./Farmers_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Farmers_Form_Buttons", [ { name: "default", alias: "Farmers_Form_Buttons" } ], "./Farmers_Form_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Farmers_Info", [ { name: "default", alias: "Farmers_Info" } ], "./Farmers_Info.js");
_jsLib.importDeclaration("core", "./$layouts/Farmers_List_Buttons", [ { name: "default", alias: "Farmers_List_Buttons" } ], "./Farmers_List_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Form", [ { name: "default", alias: "Form" } ], "./Form.js");
_jsLib.importDeclaration("core", "./$layouts/Inseminators_Form", [ { name: "default", alias: "Inseminators_Form" } ], "./Inseminators_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Inseminators_Form_Buttons", [ { name: "default", alias: "Inseminators_Form_Buttons" } ], "./Inseminators_Form_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Inseminators_Info", [ { name: "default", alias: "Inseminators_Info" } ], "./Inseminators_Info.js");
_jsLib.importDeclaration("core", "./$layouts/Inseminators_List_Buttons", [ { name: "default", alias: "Inseminators_List_Buttons" } ], "./Inseminators_List_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/List", [ { name: "default", alias: "List" } ], "./List.js");
_jsLib.importDeclaration("core", "./$layouts/Main", [ { name: "default", alias: "Main" } ], "./Main.js");
_jsLib.importDeclaration("core", "./$layouts/Mix", [ { name: "default", alias: "Mix" } ], "./Mix.js");
_jsLib.importDeclaration("core", "./$layouts/NewReceipt_AssociatedBulls", [ { name: "default", alias: "NewReceipt_AssociatedBulls" } ], "./NewReceipt_AssociatedBulls.js");
_jsLib.importDeclaration("core", "./$layouts/NewReceipt_Form", [ { name: "default", alias: "NewReceipt_Form" } ], "./NewReceipt_Form.js");
_jsLib.importDeclaration("core", "./$layouts/PrivacyPolicy", [ { name: "default", alias: "PrivacyPolicy" } ], "./PrivacyPolicy.js");
_jsLib.importDeclaration("core", "./$layouts/Receipts_Form", [ { name: "default", alias: "Receipts_Form" } ], "./Receipts_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Receipts_Form_Buttons", [ { name: "default", alias: "Receipts_Form_Buttons" } ], "./Receipts_Form_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Receipts_List_Buttons", [ { name: "default", alias: "Receipts_List_Buttons" } ], "./Receipts_List_Buttons.js");
_jsLib.importDeclaration("core", "./$layouts/Receipts_List_Header", [ { name: "default", alias: "Receipts_List_Header" } ], "./Receipts_List_Header.js");
_jsLib.importDeclaration("core", "./$layouts/Register", [ { name: "default", alias: "Register" } ], "./Register.js");
_jsLib.importDeclaration("core", "./$layouts/Register_Edit", [ { name: "default", alias: "Register_Edit" } ], "./Register_Edit.js");
_jsLib.importDeclaration("core", "./$layouts/Register_Form", [ { name: "default", alias: "Register_Form" } ], "./Register_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Select", [ { name: "default", alias: "Select" } ], "./Select.js");
_jsLib.importDeclaration("core", "./$layouts/Statement", [ { name: "default", alias: "Statement" } ], "./Statement.js");
_jsLib.importDeclaration("core", "./$layouts/Traders_Form", [ { name: "default", alias: "Traders_Form" } ], "./Traders_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Traders_Info", [ { name: "default", alias: "Traders_Info" } ], "./Traders_Info.js");
_jsLib.importDeclaration("core", "./$layouts/Users_Form", [ { name: "default", alias: "Users_Form" } ], "./Users_Form.js");
_jsLib.importDeclaration("core", "./$layouts/Users_ManageAccount", [ { name: "default", alias: "Users_ManageAccount" } ], "./Users_ManageAccount.js");
_jsLib.importDeclaration("core", "./$layouts/panels_TestPanel", [ { name: "default", alias: "panels_TestPanel" } ], "./panels_TestPanel.js");

/* export */ class $layouts_Class {
    get About_Basic() {
        return (_jsLib.import("core", "./$layouts/About_Basic", "default", "About_Basic", "./About_Basic.js"));
    }
    get About_Basic_AppMessages() {
        return (_jsLib.import("core", "./$layouts/About_Basic_AppMessages", "default", "About_Basic_AppMessages", "./About_Basic_AppMessages.js"));
    }
    get Administrators_Form() {
        return (_jsLib.import("core", "./$layouts/Administrators_Form", "default", "Administrators_Form", "./Administrators_Form.js"));
    }
    get Administrators_Form_Buttons() {
        return (_jsLib.import("core", "./$layouts/Administrators_Form_Buttons", "default", "Administrators_Form_Buttons", "./Administrators_Form_Buttons.js"));
    }
    get Associations_List_Buttons() {
        return (_jsLib.import("core", "./$layouts/Associations_List_Buttons", "default", "Associations_List_Buttons", "./Associations_List_Buttons.js"));
    }
    get Backups_Basic() {
        return (_jsLib.import("core", "./$layouts/Backups_Basic", "default", "Backups_Basic", "./Backups_Basic.js"));
    }
    get Bull_Info() {
        return (_jsLib.import("core", "./$layouts/Bull_Info", "default", "Bull_Info", "./Bull_Info.js"));
    }
    get Bulls_Form() {
        return (_jsLib.import("core", "./$layouts/Bulls_Form", "default", "Bulls_Form", "./Bulls_Form.js"));
    }
    get Bulls_List_Buttons() {
        return (_jsLib.import("core", "./$layouts/Bulls_List_Buttons", "default", "Bulls_List_Buttons", "./Bulls_List_Buttons.js"));
    }
    get Buttons_Delete() {
        return (_jsLib.import("core", "./$layouts/Buttons_Delete", "default", "Buttons_Delete", "./Buttons_Delete.js"));
    }
    get Buttons_Next() {
        return (_jsLib.import("core", "./$layouts/Buttons_Next", "default", "Buttons_Next", "./Buttons_Next.js"));
    }
    get Clients_Form() {
        return (_jsLib.import("core", "./$layouts/Clients_Form", "default", "Clients_Form", "./Clients_Form.js"));
    }
    get Clinics_Form() {
        return (_jsLib.import("core", "./$layouts/Clinics_Form", "default", "Clinics_Form", "./Clinics_Form.js"));
    }
    get Clinics_Form_Buttons() {
        return (_jsLib.import("core", "./$layouts/Clinics_Form_Buttons", "default", "Clinics_Form_Buttons", "./Clinics_Form_Buttons.js"));
    }
    get Clinics_Info() {
        return (_jsLib.import("core", "./$layouts/Clinics_Info", "default", "Clinics_Info", "./Clinics_Info.js"));
    }
    get Cows_Form() {
        return (_jsLib.import("core", "./$layouts/Cows_Form", "default", "Cows_Form", "./Cows_Form.js"));
    }
    get Cows_Info() {
        return (_jsLib.import("core", "./$layouts/Cows_Info", "default", "Cows_Info", "./Cows_Info.js"));
    }
    get Cows_List_Buttons() {
        return (_jsLib.import("core", "./$layouts/Cows_List_Buttons", "default", "Cows_List_Buttons", "./Cows_List_Buttons.js"));
    }
    get Farmers_Form() {
        return (_jsLib.import("core", "./$layouts/Farmers_Form", "default", "Farmers_Form", "./Farmers_Form.js"));
    }
    get Farmers_Form_Buttons() {
        return (_jsLib.import("core", "./$layouts/Farmers_Form_Buttons", "default", "Farmers_Form_Buttons", "./Farmers_Form_Buttons.js"));
    }
    get Farmers_Info() {
        return (_jsLib.import("core", "./$layouts/Farmers_Info", "default", "Farmers_Info", "./Farmers_Info.js"));
    }
    get Farmers_List_Buttons() {
        return (_jsLib.import("core", "./$layouts/Farmers_List_Buttons", "default", "Farmers_List_Buttons", "./Farmers_List_Buttons.js"));
    }
    get Form() {
        return (_jsLib.import("core", "./$layouts/Form", "default", "Form", "./Form.js"));
    }
    get Inseminators_Form() {
        return (_jsLib.import("core", "./$layouts/Inseminators_Form", "default", "Inseminators_Form", "./Inseminators_Form.js"));
    }
    get Inseminators_Form_Buttons() {
        return (_jsLib.import("core", "./$layouts/Inseminators_Form_Buttons", "default", "Inseminators_Form_Buttons", "./Inseminators_Form_Buttons.js"));
    }
    get Inseminators_Info() {
        return (_jsLib.import("core", "./$layouts/Inseminators_Info", "default", "Inseminators_Info", "./Inseminators_Info.js"));
    }
    get Inseminators_List_Buttons() {
        return (_jsLib.import("core", "./$layouts/Inseminators_List_Buttons", "default", "Inseminators_List_Buttons", "./Inseminators_List_Buttons.js"));
    }
    get List() {
        return (_jsLib.import("core", "./$layouts/List", "default", "List", "./List.js"));
    }
    get Main() {
        return (_jsLib.import("core", "./$layouts/Main", "default", "Main", "./Main.js"));
    }
    get Mix() {
        return (_jsLib.import("core", "./$layouts/Mix", "default", "Mix", "./Mix.js"));
    }
    get NewReceipt_AssociatedBulls() {
        return (_jsLib.import("core", "./$layouts/NewReceipt_AssociatedBulls", "default", "NewReceipt_AssociatedBulls", "./NewReceipt_AssociatedBulls.js"));
    }
    get NewReceipt_Form() {
        return (_jsLib.import("core", "./$layouts/NewReceipt_Form", "default", "NewReceipt_Form", "./NewReceipt_Form.js"));
    }
    get PrivacyPolicy() {
        return (_jsLib.import("core", "./$layouts/PrivacyPolicy", "default", "PrivacyPolicy", "./PrivacyPolicy.js"));
    }
    get Receipts_Form() {
        return (_jsLib.import("core", "./$layouts/Receipts_Form", "default", "Receipts_Form", "./Receipts_Form.js"));
    }
    get Receipts_Form_Buttons() {
        return (_jsLib.import("core", "./$layouts/Receipts_Form_Buttons", "default", "Receipts_Form_Buttons", "./Receipts_Form_Buttons.js"));
    }
    get Receipts_List_Buttons() {
        return (_jsLib.import("core", "./$layouts/Receipts_List_Buttons", "default", "Receipts_List_Buttons", "./Receipts_List_Buttons.js"));
    }
    get Receipts_List_Header() {
        return (_jsLib.import("core", "./$layouts/Receipts_List_Header", "default", "Receipts_List_Header", "./Receipts_List_Header.js"));
    }
    get Register() {
        return (_jsLib.import("core", "./$layouts/Register", "default", "Register", "./Register.js"));
    }
    get Register_Edit() {
        return (_jsLib.import("core", "./$layouts/Register_Edit", "default", "Register_Edit", "./Register_Edit.js"));
    }
    get Register_Form() {
        return (_jsLib.import("core", "./$layouts/Register_Form", "default", "Register_Form", "./Register_Form.js"));
    }
    get Select() {
        return (_jsLib.import("core", "./$layouts/Select", "default", "Select", "./Select.js"));
    }
    get Statement() {
        return (_jsLib.import("core", "./$layouts/Statement", "default", "Statement", "./Statement.js"));
    }
    get Traders_Form() {
        return (_jsLib.import("core", "./$layouts/Traders_Form", "default", "Traders_Form", "./Traders_Form.js"));
    }
    get Traders_Info() {
        return (_jsLib.import("core", "./$layouts/Traders_Info", "default", "Traders_Info", "./Traders_Info.js"));
    }
    get Users_Form() {
        return (_jsLib.import("core", "./$layouts/Users_Form", "default", "Users_Form", "./Users_Form.js"));
    }
    get Users_ManageAccount() {
        return (_jsLib.import("core", "./$layouts/Users_ManageAccount", "default", "Users_ManageAccount", "./Users_ManageAccount.js"));
    }
    get panels_TestPanel() {
        return (_jsLib.import("core", "./$layouts/panels_TestPanel", "default", "panels_TestPanel", "./panels_TestPanel.js"));
    }
}
const $layouts = new $layouts_Class();
/* export default */ $layouts

/* JSLib Exports */
_jsLib.export("$layouts_Class", $layouts_Class);
_jsLib.export("default", $layouts); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_Form.js
jsLibs.exportScript("core", "./$layouts/Inseminators_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Inseminators_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["div",{"_holder":["clientForm"]}],["div",{"class":["mg-clear"]}]],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-secondary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Client_Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Client_Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]],["$",{"_holder":["user_ManageAccount"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Inseminators_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Inseminators_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_Form_Buttons.js
jsLibs.exportScript("core", "./$layouts/Inseminators_Form_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Inseminators_Form_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["bulls"],"_show":["shows.bulls"],"href":["$hrefs.bulls"],"class":["btn btn-success"]},["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Bulls')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Inseminators_Form_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Inseminators_Form_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_Info.js
jsLibs.exportScript("core", "./$layouts/Inseminators_Info", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Inseminators_Info extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["alert alert-secondary"]},["h4",{"class":["mt-0"]},"$row.Client_Name"],["p",{"class":["lb-alert-hint my-0"]},"$eText('Sys:text_SelectedInseminator')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Inseminators_Info.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Inseminators_Info); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_List_Buttons.js
jsLibs.exportScript("core", "./$layouts/Inseminators_List_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Inseminators_List_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_show":["shows.register"],"_elem":["register"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-file-alt me-2"]}],"$eText('Sys:Buttons_DownloadRegister')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Inseminators_List_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Inseminators_List_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\List.js
jsLibs.exportScript("core", "./$layouts/List", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class List extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["d-md-none lb-title-sm"]},"$title"],["div",{"class":["row no-gutters"]},["div",{"class":["col-lg-6 d-none d-md-block"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-auto lb-back"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-light mr-2"]},["i",{"class":["fa fa-chevron-left"]}]]],["div",{"class":["col lb-title"]},["h1",{},"$title"]]]],["div",{"class":["col-xl-6 col-lg-12 lb-buttons-panel "]},["div",{"class":["btn-group w-100"]},["$",{"_holder":["Buttons_Before"]}],["a",{"_elem":["add"],"_show":["shows.add"],"href":["$uris.add"],"class":["btn btn-theme-primary"]},["i",{"class":["fa fa-plus me-2"]}],"$texts.Buttons_Add"],["$",{"_holder":["Buttons_After"]}]]]]],["div",{"class":["lb-main-hints"]},["$",{"_show":["shows_Infos_Inseminator"],"_holder":["infos_Inseminator"]}],["$",{"_show":["shows_Infos_Farmer"],"_holder":["infos_Farmer"]}],["$",{"_show":["shows_Infos_Cows"],"_holder":["infos_Cows"]}],["$",{"_show":["shows_Infos_Bull"],"_holder":["infos_Bull"]}]],["div",{"class":["card mb-5"]},["$",{"_holder":["header"]}],["div",{"class":["card-body"]},["$",{"_holder":["beforeTable"]}],["$",{"_holder":["table"]}]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(List.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", List); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Main.js
jsLibs.exportScript("core", "./$layouts/Main", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Main extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["$",{"_holder":["content"]}],["$",{"_holder":["messages"]}]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Main.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Main); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Mix.js
jsLibs.exportScript("core", "./$layouts/Mix", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Mix extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["select"],"href":["#"],"class":["btn btn-success ","?($active ? 'active' : '')"]},"MIX"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Mix.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Mix); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\NewReceipt_AssociatedBulls.js
jsLibs.exportScript("core", "./$layouts/NewReceipt_AssociatedBulls", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class NewReceipt_AssociatedBulls extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["$",{"_show":["show"]},["h4",{"class":["px-2 mt-2"]},["i",{"class":["fa fa-angle-down pe-2"]}],"$eText('Sys:Associations')"],["$",{"_holder":["table"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(NewReceipt_AssociatedBulls.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", NewReceipt_AssociatedBulls); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\NewReceipt_Form.js
jsLibs.exportScript("core", "./$layouts/NewReceipt_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class NewReceipt_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["card mb-2"]},["div",{"class":["card-body"]},["div",{"class":["form form-horizontal"]},["form",{},["h5",{"class":["alert alert-secondary lb-alert-narrow"]},["i",{"class":["fas fa-cow me-2"]}],"$rCow.Nr"],["spk-form-field",{"form":["Form"],"name":["FileNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_FileNr_Label')"],"placeholder":["$eText('Sys:Forms_FileNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["TreatmentNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_TreatmentNr_Label')"],"placeholder":["$eText('Sys:Forms_TreatmentNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["LastCalving"],"type":["Date"],"label":["$eText('Sys:Forms_LastCalving_Label')"],"placeholder":["$eText('Sys:Forms_LastCalving_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["ReinseminationsCount"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_ReinseminationsCount_Label')"],"placeholder":["$eText('Sys:Forms_ReinseminationsCount_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Note"],"type":["TextArea"],"label":["$eText('Sys:Forms_Note_Label')"],"placeholder":["$eText('Sys:Forms_Note_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-primary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(NewReceipt_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", NewReceipt_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\panels_TestPanel.js
jsLibs.exportScript("core", "./$layouts/panels_TestPanel", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class panels_TestPanel extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["h1",{},"Test Panel"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(panels_TestPanel.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", panels_TestPanel); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\PrivacyPolicy.js
jsLibs.exportScript("core", "./$layouts/PrivacyPolicy", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class PrivacyPolicy extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["container mt-2 mb-4"]},["img",{"src":["${base}","res/images/logo.png"],"alt":["AG Pokrycia"],"class":["mt-2 mb-4"]}],["div",{"class":["card"]},["div",{"class":["card-header"]},["h2",{"class":["card-title mb-2"]},["i",{"class":["fas fa-user-lock pe-2"]}],"Polityka Prywatności"]],["div",{"class":["card-body"]},["p",{},"W związku z obowiązywaniem Rozporządzenia Parlamentu Europejskiego i Rady Unii Europejskiej 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (zwanego dalej „RODO”) przekazuję poniższe informacje w wykonując tym samym obowiązek nałożony w treści  art. 13 RODO."],["p",{},"1. Administratorem Państwa danych osobowych jest Alta Polska Sp. z o.o. z siedzibą w Łowiczu pod adresem ul. Katarzynów 3, 99-400 Łowicz, NIP: 834 17 77 372 , REGON :  100020117 (dalej: Administrator)."],["p",{},"2. Z Administratorem możecie się Państwo skontaktować w następujący sposób:",["br",{}],"a. pisemnie: na wskazany powyżej adres",["br",{}],"b. w drodze korespondencji e-mail: biuro@altagenetics.pl"],["p",{},"3. Państwa dane osobowe są przetwarzane przez Administratora w celu:\r\n                a. prawidłowego funkcjonowania systemu informatycznego do wprowadzania zaświadczeń unasienniania pod nazwą AG POKRYCIA  w wersji www oraz w aplikacji google play."],["p",{},"Podanie przez Państwa danych osobowych jest dobrowolne, ale niezbędne dla korzystania z usług świadczonych przez Administratora z uwagi na charakter wykonywanej przez niego działalności gospodarczej oraz charakteru usług; na podstawie otrzymanego Upoważnienia AG POKRYCIA."],["p",{},"4. Podstawą prawną przetwarzania Państwa danych przez Administratora jest:",["br",{}],"a. konieczność przetwarzania do wykonania usługi/umowy,",["br",{}],"b. konieczność przetwarzania wynika z prawnie uzasadnionego celu Administratora,",["br",{}],"c. wyrażona przez Państwo zgoda.",["br",{}]],["p",{},"5. Państwa dane mogą być przekazane dostawcom Administratora np. w zakresie usług IT."],["p",{},"6. Państwa dane są przetwarzane celem realizacji zobowiązań wynikających z pkt 3 powyżej, jak również później aż do okresu przedawnienia ewentualnych roszczeń związanych z wykonaniem usługi, umowy albo do momentu wygaśnięcia obowiązku prawnego Administratora do przechowywania danych."],["p",{},"7. Przysługuje Państwu szereg praw związanych z Państwa danymi osobowymi tj.:",["br",{}],"a. prawo dostępu do Państwa danych osobowych,",["br",{}],"b. prawo usunięcia Państwa danych osobowych,",["br",{}],"c. prawo usunięcia Państwa danych osobowych,",["br",{}],"d. prawo żądania ograniczenia przetwarzania Państwa danych osobowych,",["br",{}],"e. prawo do przeniesienia Państwa danych osobowych,",["br",{}],"f. prawo do wniesienia sprzeciwu wobec przetwarzania Państwa danych osobowych."],["p",{},"Ze wskazanych praw mogą Państwo skorzystać kierując żądanie na adres korespondencyjny oraz e-mailowy Administratora podany w punkcie 2 powyżej.\r\n            Przysługuje Państwu również prawo wniesienia skargi do organu nadzorczego."],["p",{},"8. W chwili gdy Państwa dane osobowe przetwarzane są na podstawie wyrażonej zgody, mają Państwo prawo do cofnięcia zgody w dowolnym momencie."],["p",{},"9. Państwa dane osobowe nie będą przetwarzane w sposób zautomatyzowany, w tym w formie profilowania."]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(PrivacyPolicy.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", PrivacyPolicy); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_Form.js
jsLibs.exportScript("core", "./$layouts/Receipts_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Receipts_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_hide":["newReceipt"],"class":["form form-horizontal"]},["form",{},["spk-form-field",{"_show":["shows.nr"],"form":["Form"],"name":["Nr_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Nr_Label')"],"placeholder":["$eText('Sys:Forms_Nr_Placeholder')"],"div-class":["mt-2 lb-no-label lb-lead"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["$",{"_hide":["isNew"]},["p",{"class":["mt-2"]},"$eText('Sys:Forms_NextHeat_Label')",": ","$nextHeat",["br",{}],"$eText('Sys:Forms_PlannedCalving_Label')",": ","$plannedCalving"]],["div",{"_show":["shows.cow"],"class":["mt-3"]},["h5",{"class":["alert alert-secondary lb-alert-narrow"]},"$eText('Sys:Titles_Cow')"],["spk-form-field",{"form":["Form"],"name":["Cow_Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Cow_Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Cow_Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Cow_Birth"],"type":["Date"],"label":["$eText('Sys:Forms_Birth_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]],["div",{"_show":["shows.bull"],"class":["my-3"]},["div",{"class":["alert alert-secondary lb-alert-narrow"]},["div",{"class":["row g-2"]},["h5",{"class":["col-auto"]},"$eText('Sys:Titles_Bull')"],["div",{"class":["col-auto px-2"]},"|"],["div",{"class":["col"],"style":["padding-top: 2px;"]},["spk-form-field",{"form":["Form"],"name":["BullsMix"],"type":["Checkbox"],"label":["$eText('Sys:Forms_BullsMix_Label')"]}]]]],["spk-form-field",{"form":["Form"],"name":["Bull_Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_FirstName_Label')"],"placeholder":["$eText('Sys:Forms_FirstName_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Bull_ManufacturerNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_ManufacturerNr_Label')"],"placeholder":["$eText('Sys:Forms_ManufacturerNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Bull_Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Bull_Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["$",{"_show":["shows.bullsMix"]},["hr",{}],["spk-form-field",{"form":["Form"],"name":["Bull_Nr2"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 2'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 2"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["hr",{}],["spk-form-field",{"form":["Form"],"name":["Bull_Nr3"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')","+ ' 3'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 3"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["hr",{}],["spk-form-field",{"form":["Form"],"name":["Bull_Nr4"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 4'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 4"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["hr",{}],["spk-form-field",{"form":["Form"],"name":["Bull_Nr5"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"," + ' 5'"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"," 5"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]],["h5",{"class":["alert alert-secondary lb-alert-narrow"]},"$eText('Sys:Titles_Details')"],["spk-form-field",{"form":["Form"],"name":["Date"],"type":["Date"],"label":["$eText('Sys:Forms_TreatmentDate_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label "],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["FileNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_FileNr_Label')"],"placeholder":["$eText('Sys:Forms_FileNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["TreatmentNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_TreatmentNr_Label')"],"placeholder":["$eText('Sys:Forms_TreatmentNr_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["LastCalving"],"type":["Date"],"label":["$eText('Sys:Forms_LastCalving_Label')"],"placeholder":["$eText('Sys:Forms_LastCalving_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["SemenProduction"],"type":["Date"],"label":["$eText('Sys:Forms_SemenProduction_Label')"],"placeholder":["$eText('Sys:Forms_SemenProduction_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["BullSexed"],"type":["Radio"],"label":["$eText('Sys:Forms_BullSexed_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["ReinseminationsCount"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_ReinseminationsCount_Label')"],"placeholder":["$eText('Sys:Forms_ReinseminationsCount_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Note"],"type":["TextArea"],"label":["$eText('Sys:Forms_Note_Label')"],"placeholder":["$eText('Sys:Forms_Note_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-primary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]]]],["$",{"_show":["newReceipt"]},["div",{"class":["card mb-2"]},["div",{"class":["card-body"]},["div",{"class":["form form-horizontal"]},["form",{},["h5",{"class":["alert alert-secondary lb-alert-narrow"]},"$eText('Sys:Titles_Details')"],["spk-form-field",{"form":["Form"],"name":["NewReceipt_Date"],"type":["Date"],"label":["$eText('Sys:Forms_TreatmentDate_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label "],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["NewReceipt_SemenProduction"],"type":["Date"],"label":["$eText('Sys:Forms_SemenProduction_Label')"],"placeholder":["$eText('Sys:Forms_SemenProduction_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["NewReceipt_BullSexed"],"type":["Radio"],"label":["$eText('Sys:Forms_BullSexed_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]]]],["$",{"_repeat":["CowInfos:CowInfo"],"_holder":["form"]}],["div",{"class":["btn-group w-100 mb-5"]},["a",{"_elem":["Next"],"href":["#"],"class":["btn btn-theme-primary"]},["i",{"class":["fas fa-save"]}]," \r\n            ","$eText('Sys:Buttons_Add')"]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Receipts_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Receipts_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_Form_Buttons.js
jsLibs.exportScript("core", "./$layouts/Receipts_Form_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Receipts_Form_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["download"],"_show":["shows.download"],"href":["$hrefs.download"],"class":["btn btn-success"]},["i",{"class":["fa fa-download me-2"]}],"$eText('Sys:Buttons_Download')"],["a",{"_elem":["downloadSymlek"],"_show":["shows.downloadSymlek"],"href":["$hrefs.downloadSymlek"],"class":["btn btn-success"]},["i",{"class":["fa fa-file me-2"]}],"$eText('Sys:Buttons_DownloadSymlek')"],["a",{"_elem":["print"],"_show":["shows.print"],"href":["#"],"class":["btn btn-theme-primary button-mobile"]},["i",{"class":["fa fa-file me-2"]}],"$eText('Sys:Buttons_Print')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Receipts_Form_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Receipts_Form_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_List_Buttons.js
jsLibs.exportScript("core", "./$layouts/Receipts_List_Buttons", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Receipts_List_Buttons extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_show":["shows.register"],"_elem":["register"],"href":["$hrefs.register"],"class":["btn btn-theme-primary"]},["i",{"class":["fa fa-file-alt me-2"]}],"$eText('Sys:Buttons_DownloadRegister')"],["a",{"_show":["shows.download"],"_elem":["download"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-download me-2"]}],"$eText('Sys:Buttons_Download')"]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Receipts_List_Buttons.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Receipts_List_Buttons); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_List_Header.js
jsLibs.exportScript("core", "./$layouts/Receipts_List_Header", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Receipts_List_Header extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-filter-holder alert-primary"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-xl-6"]},["div",{"class":["btn-group w-100"]},["a",{"_elem":["filters_CurrentMonth"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$filters_CurrentMonth_ActiveClass"]},"$eText('Sys:Buttons_CurrentMonth')"],["a",{"_elem":["filters_PreviousMonth"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$filters_PreviousMonth_ActiveClass"]},"$eText('Sys:Buttons_MonthPrevious')"],["a",{"_elem":["filters_CurrentYear"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$filters_CurrentYear_ActiveClass"]},"$eText('Sys:Buttons_YearCurrent')"],["a",{"_elem":["filters_DatesRange"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$filters_DatesRange_ActiveClass"]},"$eText('Sys:Buttons_DatesRange')"]]],["div",{"_show":["showDatesRange"],"class":["col-xl-6"]},["div",{"class":["row no-gutters lb-date-picker"]},["div",{"class":[" col-sm-6"]},["spk-form-field",{"form":["Form"],"name":["Date_From"],"type":["Date"],"label":[""],"placeholder":["$eText('Sys:Forms_DateFrom_Placeholder')"],"field-class":["clickable"]}]],["div",{"class":[" col-sm-6"]},["spk-form-field",{"form":["Form"],"name":["Date_To"],"type":["Date"],"label":[""],"placeholder":["$eText('Sys:Forms_DateTo_Placeholder')"]}]]]],["$",{"_show":["eSys.user.isAdministrator"]},["spk-form-field",{"form":["Form"],"name":["Filters"],"type":["Checkbox"],"label":["$eText('Sys:Forms_Filters')"],"div-class":["mt-2"]}],["div",{"_show":["ShowFilters"]},["div",{"class":["row"]},["div",{"class":["col-xl-6 my-2"]},["div",{"class":["btn-group w-100 mb-1"]},["a",{"_elem":["Filters_Trader"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$Filters_Trader_ActiveClass"]},"$eText('Sys:Buttons_Trader')"],["a",{"_elem":["Filters_Inseminator"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$Filters_Inseminator_ActiveClass"]},"$eText('Sys:Buttons_Inseminator')"],["a",{"_elem":["Filters_Farmer"],"href":["#"],"class":["col btn btn-sm btn-theme-light ","$Filters_Farmer_ActiveClass"]},"$eText('Sys:Buttons_Farmer')"]],["spk-form-field",{"_show":["Shows.Trader"],"form":["Form"],"name":["Trader"],"type":["Input"],"input-type":["text"]}],["spk-form-field",{"_show":["Shows.Inseminator"],"form":["Form"],"name":["Inseminator"],"type":["Input"],"input-type":["text"]}],["spk-form-field",{"_show":["Shows.Farmer"],"form":["Form"],"name":["Farmer"],"type":["Input"],"input-type":["text"]}]],["div",{"class":["col-xl-6 my-2"]},["div",{"class":["row checkbox-list"]},["div",{"class":["col-auto me-2"]},["spk-form-field",{"form":["Form"],"name":["NotUnderGrade"],"type":["Checkbox"],"label":["$eText('Sys:Forms_NotUnderGrade')"]}]],["div",{"class":["col-auto me-2"]},["spk-form-field",{"form":["Form"],"name":["OnlyNew"],"type":["Checkbox"],"label":["$eText('Sys:Forms_OnlyNew')"]}]],["div",{"class":["col"]},["spk-form-field",{"form":["Form"],"name":["MarkDownloaded"],"type":["Checkbox"],"label":["$eText('Sys:Forms_MarkDownloaded')"]}]]],["a",{"_elem":["downloadFiltered"],"href":["#"],"class":["btn btn-sm btn-theme-accent w-100"]},["i",{"class":["fa fa-download me-2"]}],"$eText('Sys:Buttons_DownloadFiltered')"]]]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Receipts_List_Header.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Receipts_List_Header); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Register.js
jsLibs.exportScript("core", "./$layouts/Register", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Register extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["container mt-2 mb-4"]},["img",{"src":["/res/images/logo.png"],"alt":["AG Pokrycia"],"class":["mt-2 mb-4"],"style":["max-width: 240px;"]}],["div",{"class":["card"]},["div",{"class":["card-header"]},["h2",{"class":["card-title mb-2"]},["i",{"class":["fas fa-user-edit pe-3"]}],"Zarejestruj się w systemie AG Pokrycia"]],["div",{"class":["card-body"]},["$",{"_hide":["formSent"]},["div",{"class":["alert alert-primary"]},"Wypełnij formularz w celu założenia konta w systemie. Po aktywacji konta otrzymasz wiadomość z danymi logowania."]],["$",{"_hide":["formSent"],"_holder":["form"]}],["$",{"_show":["formSent"]},["div",{"class":["alert alert-success"]},"Dziękujemy za rejestrację. Zostaniesz powiadomiony mailowo, kiedy Twoje konto zostanie utworzone."]]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Register.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Register); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Register_Edit.js
jsLibs.exportScript("core", "./$layouts/Register_Edit", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Register_Edit extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-sm-6 d-none d-md-block"]},["div",{"class":["row no-gutters"]},["div",{"class":["col-auto"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-light mr-2"]},["i",{"class":["fa fa-chevron-left"]}]]],["div",{"class":["col"]},["h1",{},"$eText('Sys:Titles_Registrations_Edit')"]]]]]],["div",{"class":["card px-2 py-4"]},["div",{"class":["col-xl-6"]},["div",{"class":["alert alert-primary"]},["h4",{"_show":["type_Farmer"],"class":["mt-0"]},"$eText('Sys:Titles_Farmer')"],["h4",{"_show":["type_Inseminator"],"class":["mt-0"]},"$eText('Sys:Titles_Inseminator')"]]],["$",{"_holder":["form"]}],["h4",{"class":["alert alert-secondary mt-5"]},"$eText('Sys:Text_ManageAccount')"],["div",{"class":["container-fluid"]},["div",{"class":["btn-group w-100"],"role":["group"]},["button",{"_elem":["Submit"],"class":["btn btn-theme-primary col-lg-6 d-block"]},"$eText('Sys:Buttons_Create')"],["button",{"_elem":["Reject"],"class":["btn btn-danger col-lg-6 d-block"]},"$eText('Sys:Buttons_Reject')"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Register_Edit.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Register_Edit); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Register_Form.js
jsLibs.exportScript("core", "./$layouts/Register_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Register_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["btn-group mb-3 w-100"],"role":["group"]},["button",{"_elem":["Farmer"],"type":["button"],"class":["btn btn-outline-secondary ","$type_Farmer.class"]},"$eText('Sys:Titles_Farmer')"],["button",{"_elem":["Inseminator"],"type":["button"],"class":["btn btn-outline-secondary ","$type_Inseminator.class"]},"$eText('Sys:Titles_Inseminator')"]],["div",{"class":["form form-horizontal"]},["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["Email"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Email_Label')"],"placeholder":["$eText('Sys:Forms_Email_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["Address"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Address_Label')"],"placeholder":["$eText('Sys:Forms_Address_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["City"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_City_Label')"],"placeholder":["$eText('Sys:Forms_City_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["Phone"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Phone_Label')"],"placeholder":["$eText('Sys:Forms_Phone_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["District"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_District_Label')"],"placeholder":["$eText('Sys:Forms_District_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["PostalCode"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_PostalCode_Label')"],"placeholder":["$eText('Sys:Forms_PostalCode_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["div",{"class":["ml-3 mt-4"]},["spk-form-field",{"_show":["showUnderGrade"],"form":["Form"],"name":["UnderGrade"],"type":["Checkbox"],"label":["$eText('Sys:Forms_UnderGrade_Label')"]}]],["$",{"_show":["?($IsUnderGrade || !$isFarmer)"]},["spk-form-field",{"form":["Form"],"name":["SymlekId"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_SymlekId_Label')"],"placeholder":["$eText('Sys:Forms_SymlekId_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}]],["$",{"_show":["isFarmer"]},["spk-form-field",{"_show":["IsUnderGrade"],"form":["Form"],"name":["HerdUnderGradeNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_HerdUnderGradeNr_Label')"],"placeholder":["$eText('Sys:Forms_Number_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}],["spk-form-field",{"form":["Form"],"name":["HerdNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_HerdNr_Label')"],"placeholder":["$eText('Sys:Forms_Number_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-lg-12 "]}]],["div",{"class":["alert alert-secondary my-4"]},["a",{"href":["${base}","polityka-prywatnosci"],"class":["fw-bold"],"target":["_blank"]},["i",{"class":["far fa-file-alt pe-2"]}],"Polityka Prywatności"],["spk-form-field",{"form":["Form"],"name":["StatementConfirmation"],"type":["Checkbox"],"label":["$eText('Sys:Forms_Confirmation_Label')"],"div-class":["mt-3"],"label-class":["col-lg-12 control-label fw-normal"],"field-class":["checkboxField"]}]],["button",{"_elem":["Submit"],"class":["btn btn-theme-primary w-100"]},"$eText('Sys:Buttons_Register')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Register_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Register_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Select.js
jsLibs.exportScript("core", "./$layouts/Select", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Select extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["a",{"_elem":["select"],"href":["#"],"class":["btn btn-success ","?($active ? 'active' : '')"]},["i",{"class":["fas fa-check-double"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Select.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Select); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Statement.js
jsLibs.exportScript("core", "./$layouts/Statement", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Statement extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["container mt-2 mb-4"]},["img",{"src":["http://localhost/web/res/images/logo.png"],"alt":["AG Pokrycia"],"class":["mt-2 mb-4"]}],["div",{"class":["card"]},["div",{"class":["card-header"]},["h2",{"class":["card-title mb-2"]},["i",{"class":["fas fa-user-check pe-3"]}],"Upoważnienie"]],["div",{"class":["card-body"]},["p",{}]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Statement.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Statement); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Traders_Form.js
jsLibs.exportScript("core", "./$layouts/Traders_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Traders_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["div",{"_holder":["userForm"]}]],["$",{"_holder":["user_ManageAccount"]}]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Traders_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Traders_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Traders_Info.js
jsLibs.exportScript("core", "./$layouts/Traders_Info", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Traders_Info extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"class":["alert alert-secondary"]},["h4",{"class":["mt-0"]},"$row.Name"],["p",{"class":["lb-alert-hint my-0"]},"$eText('Sys:text_SelectedTrader')"]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Traders_Info.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Traders_Info); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Users_Form.js
jsLibs.exportScript("core", "./$layouts/Users_Form", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Users_Form extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["spk-form-field",{"form":["Form"],"name":["Email"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Email_Label')"],"placeholder":["$eText('Sys:Forms_Email_Placeholder')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert alert-secondary mt-4"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":[""],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["mt-3"],"label-class":["col-xl-4 control-label"],"field-class":["col-xl-6 "]}]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Users_Form.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Users_Form); });

// File: ..\..\web\website_tmp\ab-web\web\js-libs\core\$layouts\Users_ManageAccount.js
jsLibs.exportScript("core", "./$layouts/Users_ManageAccount", [ "default" ], (_jsLib) => { "use strict"; _jsLib.importDeclaration("@allblue", "./index", [  ], "@allblue/ts0");;
_jsLib.importDeclaration("spocky", "./index", [ { name: "default", alias: "spocky" } ], "spocky");

/* export default */ class Users_ManageAccount extends (_jsLib.import("spocky", "./index", "default", "spocky", "spocky")).Layout {
    static get Content()             {
        return [["div",{"_show":["show"]},["h4",{"class":["alert alert-secondary mt-5"]},"$eText('Sys:Text_ManageAccount')"],["div",{"class":["container-fluid"]},["div",{"class":["btn-group w-100"],"role":["group"]},["a",{"_elem":["activate_Activate"],"_show":["shows.activate"],"href":["#"],"class":["btn btn-success"]},["i",{"class":["fa fa-check me-2"]}],"$eText('Sys:Buttons_Activate')"],["a",{"_elem":["activate_Deactivate"],"_show":["shows.deactivate"],"href":["#"],"class":["btn btn-danger"]},["i",{"class":["fa fa-times me-2"]}],"$eText('Sys:Buttons_Deactivate')"],["a",{"_elem":["resetPassword"],"href":["#"],"class":["btn btn-theme-primary"]},["i",{"class":["fa fa-sync me-2"]}],"$eText('Sys:Buttons_ResetPassword')"]]]]];
    }

    constructor(defaultFieldValues                   = {}) {
        super(Users_ManageAccount.Content, defaultFieldValues);
    }
}


/* JSLib Exports */
_jsLib.export("default", Users_ManageAccount); });
